export default {
   "account.pnl.profit_and_loss": "Profit and Loss",
   "account.pnl.get_link": "Get public link",
   "account.pnl.display_range": "Display range:",
   "account.pnl.source": "Sources:",
   "account.pnl.display_period": "Display period:",
   "account.pnl.margin": "Margin",
   "account.pnl.mam": "MAM",
   "margin.animation": "Turn ON/OFF animation",
   'margin.entry.team_name_is_required': 'チーム名は必須です。',
   'margin.entry.email' : 'Email',
   'margin.entry.leader_id': 'リーダーID',
   'entry.number_of_request': 'あなたのチームに参加したいユーザーのリクエスト数',
   'margin.entry.maximum_member': '最大数',
   'entry.exception.msg.maximum_team_member': 'チームメンバー数が最大限に達しています。',
   'entry.exception.msg.team_has_maximum_member': 'このチームはメンバー数が最大限に達しています。',
   'entry.team_number': 'エントリーしたチーム数',
   'entry.exception.msg.team_name_already_exists': 'そのチーム名はすでに存在しています。',
   'entry.exception.msg.user_already_entry' : 'すでに参加しています!',
   'entry.exception.msg.margin_balance_not_enough' : '証拠金が足りません!',
   'entry.exception.msg.member_balance_not_enough' : 'このアカウントの証拠金残高が足りません!',
   'entry.msg.register_unsuccessfully' : '登録に失敗しました!',
   'entry.exception.msg.mam_user_join_request' : 'MAMユーザーはコンテストに参加できません!',
   'entry.exception.msg.user_already_create_join_request' : '参加リクエストを送信済みです!',
   'message.response.request_invalid' : '無効なリクエストです。',
   "margin.indicator": "This indicator shows your position in the auto-deleverage queue. If all lights are lit, in the event of a liquidation, your position maybe reduced.",
   'margin.entry.contest_time':'コンテスト期間',
   'margin.entry.contest_name':'コンテスト名',
   'margin.entry.entry_time':'エントリー期間',
   'entry.msg.create_team.success':'チームを作成しました!',
   'entry.msg.cancel.success':'キャンセルされました!',
   'margin.minimum_member':'最低チーム人数',
   'margin.minimum_volume':'最低取引量',
   'margin.entry.contest':'コンテスト',
   'margin.entry.contest_start_at':'開始',
   'margin.entry.contest_end_at':'終了',
   'margin.entry.join_team_modal_title':'チームに参加する',
   'margin.entry.my_team_tab_title':'メンバーリスト',
   'margin.entry.is_leader_span':'リーダーですか?',
   'margin.entry.span_team_leader_email':'Email',
   'margin.entry.submitted_email_title':'Email',
   'margin.entry.team_id': 'チームID',
   'margin.entry.my_request_tab_title':'リクエスト',
   'margin.entry.team_request_tab_title':'リクエスト',
   'margin.entry.team_battle_create_modal_title':'チーム作成',
   'margin.entry.team_name': 'チーム名',
   'margin.entry.team_member_number': 'メンバー数',
   'margin.entry.entry_team_title_table':'エントリーチームリスト',
   'margin.entry.description_title_table':'リストにはコンテストに参加する全てのチームが含まれています。',
   'margin.entry.create_team_button':'新しいチームを作成する',
   'margin.entry.team_entry_tab_title':'エントリーチーム',
   'register.entry': '登録する',
   'entry.number_of_users': 'エントリーしたユーザー',
   'participate.entry': '参加しますか？',
   'participate.entry.note1': 'エントリー期間中、またはコンテスト期間中に出金するとエントリーはキャンセルされます。',
   'participate.entry.note2': 'エントリー期間中に取引を行い必要証拠金を下回った場合、エントリーは自動的にキャンセルされます。（証拠金を追加し、必要証拠金を満たした場合、再度エントリーすることができます。）',
   'participate.entry.note3': 'コンテスト期間中、利用可能残高が必要証拠金を下回った場合でもエントリーはキャンセルされません。',
   'participate.entry.note4': 'エントリー期間中にポジションを持っていて、そのままコンテスト期間に入った場合、コンテスト期間に一度完全にポジションがフラットになった時点からROEが計算されます。',
   'participate.entry.note5': 'コンテスト期間中に取引をしなかったユーザーはエントリーから削除されます。',
   'mam.enable.success': '有効化されました',
   'mam.disable.success': '無効化されました',
   'mam.approve.success': '承認しました',
   'mam.approve.fail': '承認できませんでした!',
   'mam.balance.search': 'Search by MasterId, Amount, Date and Reason',
   'mam.transfer_history': 'MAM Transfer History',
   'mam.transfer_history.nodata':'You have no history.',
   'mam.reason': 'Reason',
   'mam.reason.join': 'User created a request to join MAM fund.',
   'mam.reason.assign': 'User created a request to assign to MAM fund.',
   'mam.reason.revoke': 'User received a revoke amount.',
   'mam.reason.reject': 'MAM master rejected a join / an assign request.',
   'mam.reason.cancel': 'User canceled a join / an assign request.',
   'mam.reason.commission': 'MAM master receive commission fee.',
   'mam.reason.expired': 'User request is expired.',
   'mam.reason.closed': 'MAM fund is closed.',
   'mam.reason.created': 'User created a MAM fund.',
   'mam.execute_im.success': 'Execute immediately successfully!',
   'mam.execute_im.fail': 'Execute immediately fail!',
   'mam.reject.success': '拒否しました!',
   'mam.reject.fail': '拒否に失敗しました!',
   'mam.cancel.success': 'キャンセルしました!',
   'mam.cancel.fail': 'キャンセルできませんでした!',
   'mam.join.success': '参加リクエストが承認されました!',
   'mam.join.fail': '参加できませんでした!',
   'mam.balance.not_enough': '残高が足りません!',
   'mam.revoke.errors.max_amount': 'The revoke amount can be less than or equal to {amount}.',
   'mam.change.performance_fee_fail': 'Change performance fee fail!',
   'mam.change.next_performance_fee_error_max_value': 'Value of next performance fee must be smaller than {MAX_VALUE}.',
   'mam.change.performance_fee_error_max_value': 'Value of performance fee must be smaller than {MAX_VALUE}.',
   'mam.change.performance_fee_error_min_value': 'The minimum next performance fee must be greater than 0.',
   'mam.change.performance_fee_error_required': 'The next performance fee field is required.',
    'mam.create_account.initial_amount.error_min_value':'The initial amount must be greater than {min_amount} BTC.',
    'mam.create_account.performance_fee.error_min_value':'The performance fee must be greater than {min_amount} BTC.',
    'mam.confirm.reject': '拒否しますか？',
    'mam.confirm.approve': '承認しますか？',
    'mam.confirm.execute_im': 'Do you want to execute immediately?',
    'mam.confirm.enable': 'ファンドを有効にしますか？',
    'mam.confirm.create_account': 'アカウントを作成しますか？',
    'mam.confirm.close_account': 'アカウントを閉じますか？',
    'mam.confirm.cancel': 'キャンセルしますか？',
    'mam.msg.join_fund': 'ファンドに参加しました',
    'mam.msg.setting_commission': 'コミッションが設定されました',
    'mam.msg.approve.success': '承認しました',
    'mam.msg.reject.success': '拒否しました',
    'mam.msg.out.success': '正常に終了しました',
    'mam.msg.cancel.success': 'キャンセルしました',
    'mam.msg.assigned.success': '選択したリクエストの作成ができました',
    'mam.msg.revoked.success': 'キャンセルしたリクエストの作成ができました',
    'mam.msg.create_account.success': 'マスターアカウントを作成しました',
    'mam.msg.create_account.fail': 'マスターアカウントを作成できませんでした',
    'mam.type.assign': '指定する',
    'mam.type.revoke': '撤回する',
    'mam.type.join': '参加する',
    'mam.status.submitted': '提出',
    'mam.status.approved': '承認されました',
    'mam.status.rejected': '拒否されました',
    'mam.status.canceled': 'キャンセルしました',
    'mam.status.executed': '約定',
    'mam.cancel': 'キャンセル',
    'mam.revoke_type.profit': '利益',
    'mam.revoke_type.partial': '部分的に約定',
    'mam.revoke_type.all': '全て',
    'mam.empty.commission': 'コミッション履歴はありません',
    'mam.empty.follower': 'フォロワーはいません',
    'mam.unrealised_commission': '未実現コミッション',
    'mam.realised_commission': '実現コミッション',
    'mam.request_history': 'アクセス履歴をリクエストする',
    'mam.date': '日付',
    'mam.detail': '詳細',
    'mam.amount': '数量',
    'mam.account': 'アカウント',
    'mam.fund_id': 'ファンドID',
    'mam.max_drawdown': '最大ドローダウン',
    'mam.fund_capital': '資本金',
    'mam.fund_balance': '資本残高',
    'mam.my_capital_share': 'My capital/share %',
    'mam.capital_share': 'Capital/share %',
    'mam.my_balance': '残高',
    'mam.current_fee': '現在の成果報酬手数料',
    'mam.last_fee': '前回の成果報酬手数料',
    'mam.assign_revoke': 'Assign/Revoke',
    'mam.type': '種類',
    'mam.submited_at': 'Submitted At',
    'mam.amonut': 'Amount',
    'mam.count': 'Count',
    'mam.pending': '保留中',
    'mam.investments': '投資',
    'mam.status': 'ステータス',
    'mam.assigned/revoke': '指定/取り消し',
    'mam.assigned': '指定しました',
    'mam.revoke': '撤回しました',
    'mam.balance': '残高',
    'mam.currency': '通貨',
    'mam.next_period': '次の期間',
    'mam.since': '以来',
    'mam.win_rate': '勝率',
    'mam.performance_fee': '成功報酬',
    'mam.performance_fee_percent': '成果報酬手数料',
    'mam.current_performance_fee': 'Current Performance Fee',
    'mam.next_performance_fee': '次の成果報酬手数料',
    'mam.total_gain': '合計利益',
    'mam.this_month_pnl': '今月の損益',
    'mam.unrealised_pnl': '未実現損益',
    'mam.last_month_pnl': '先月の損益',
    'mam.all_time_pnl': '全期間の損益',
    'mam.created_at': 'Created At',
    'i18n.lang': 'ja',
    'account.api.ip_access_res': 'IPアクセス制限：',
    'account.api.unrestricted': '無制限（安全性が低い）',
    'account.api.not_recommended': '任意のIPアドレスがこのAPIキーを使用してアカウントにアクセスできます（非推奨）',
    'account.api.restrict_access': '信頼できるIPからのアクセスのみに制限する（推奨）',
    'account.api.current_ip': '現在のIPは118.70.190.141です。複数のIPを入力する場合は、カンマを使用して区切ってください',
    'account.api.confirm': '確認する',
    'account.api': 'API',
    'account.api.title_page': 'APIを作成する',
    'account.api.des_title_page': '出金を有効にするには、IPアクセス制限フィルターを申請する必要があります。',
    'account.api.key': 'APIキー',
    "account.api.edit_api": "Edit API",
    "account.api.update_success": "Update successful",
    'account.api.restriction': 'API restrictions',
    "account.api.enable_reading": "Enable Reading",
    "account.api.enable_spot_trading": "Enable Spot Trading",
    "account.api.enable_future_trading": "Enable Future Trading",
    "account.api.enable_withdrawals": "Enable Withdrawals",
    'account.api.input_placeholder': 'APIキーラベルを入力してください',
    'account.api.secret_key': 'シークレットキー',
    'account.api.scan_address': 'アドレスをスキャンする',
    'account.api.option': 'オプション',
    'account.api.permissions.read': '情報を読む',
    'account.api.permissions.withdrawal': '出金を有効にする',
    'account.api.permissions.trading': '取引を有効にする',
    'account.api_description': 'APIキーを作成して、第三者のサイトまたはアプリケーションを介してOG Exchangeのマーケットおよびリアルタイムの取引にアクセス出来ます。',
    'account.api_view_documentation': 'APIドキュメントを見る',
    'account.api_create': 'APIを作成する',
    'account.api.copy': 'コピー',
    'account.api.edit': '編集',
    'account.api.cancel': 'キャンセルする',
    'account.api.save': '保存する',
    'account.api.delete': '削除',
    'account.api.delete_api': 'APIを削除',
    'account.api.delete_api_message_withname': 'APIキー{name}を完全に削除してもよろしいですか？',
    'account.api.delete_api_message_noname': 'このAPIを完全に削除してもよろしいですか？',
    'account.api.create_btn': '新しいキーを作成',
    'account.api.title': 'APIリスト',
    'account.api.delete_all': 'すべてのAPIを削除します',
    'account.api.save_success': '保存されました',
    'account.api.save_fail': 'このAPIキーを保存できません',
    'account.api.delete_fail': 'このAPIを削除できません',
    'account.api.delete_success': '削除しました',
    'account.api.create_success': '新しいAPIを作成しました',
    'account.api.create_new_at_first': 'APIの使用を開始するには新しいキーを作成してください',
    'kyc.id_number_unique': 'パスポート/ ID番号はすでに取得されています。',
    'referral.level1': 'レベル 1',
    'referral.level2': 'レベル 2',
    'referral.level3': 'レベル 3',
    'referral.level4': 'レベル 4',
    'referral.level5': 'レベル 5',
    'referral.rate': 'レート',
    'referral.next_program': '直接紹介者の数が {condition}人以上の場合、以下のようになり還元率が最大 {rate}％になります。',
    'refferal.text27': '発生報酬%',
    "refferal.text28" : "Sotatek will check for duplicate or fake accounts and will not pay out referral bonuses on these accounts. Duplicate or shared finances will result in disqualification." ,
    "refferal.text-notice-import": 'Important Notice',
    "refferal.text-notice-content": 'Sotatek reserves the right to change the terms of the referral program at any time due to changing market conditions, risk of fraud, or any other factors we deem relevant.',
    'notifications.confirmation_reset_password.receiving_text': 'アカウントのパスワード再設定リクエストのため、このメッセージを受信して​​います。',
    'notifications.confirmation_reset_password.please_click': '以下のリンクよりパスワード変更を完了させてください。',
    'notifications.confirmation_reset_password.valid_24h': '上記リンクは24時間有効です。',
    'notifications.confirmation_reset_password.please_confirm': '本メールの受信後、24時間以内にパスワードの再設定を完了してください。',
    'notifications.deposit_withdraw_usd_alerts.hello': 'こんにちは ',
    'window.suffix_title': '取引所',
    'about.about_us': '当社について',
    'about.advantage': '当社の強み',
    'about.coin': '豊富な取り扱いコイン',
    'about.coin_reason': 'BTC、ETH、LTCなど',
    'about.device': '全てのデバイス対応',
    'about.device_reason': '複数の言語での各種サポートが可能',
    'about.envi': '多言語対応',
    'about.envi_reason': 'Web、Android、iOS、モバイルウェブ',
    'about.liqui': '高い流動性',
    'about.liqui_reason': '各業界の豊富なつながりにより高い流動性を実現',
    'about.perform': '高性能',
    'about.perform_reason': '1秒あたり140万の注文を処理可能',
    'about.product': '実績のある製品',
    'about.product_reason': '{APP_NAME}プラットフォームはすでに30以上の取引所に展開されております。全てのデバイス多言語をサポートし、シームレスなユーザーエクスペリエンスを提供しています。',
    'about.resources': '業界とのつながり',
    'about.resources_reason': '経済界、金融界、医学界等の権威に私たちのプラットホームは全面的に支持されています。',
    'about.safe': '安全・安定性',
    'about.safe_reason': '多層、複数クラスタのシステム構造',
    'about.team_strong': '強いチーム',
    'about.team_strong_reason': '私たちのチームメンバーは株式金融界と暗号資産金融界のトップ経験者が集められております。事業スタートアップにも数多く成功しています。',
    'about.tech': '優れた技術',
    'about.tech_reason': '私たちのマッチングエンジンは、1秒あたり140万の注文を処理することができ業界で最速の約定速度を持つ取引所の1つです。',
    'about.tit': 'Launched in 2018 {APP_NAME} is a  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.Ut enim ad minim veniam, qttuis nostrud exercitation ullamco labor ex ea commodo consequat.Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.',
    'account.address_manager': 'アドレス管理',
    'account.address_manager_content': 'アドレス管理で、各出金アドレスにメモを書き込み保存する事ができます。オプションのホワイトリスト機能は、ホワイトリストに登録されたアドレスへの引き出しのみを許可することで、あなたの資金を保護するのに役立ちます。',
    'account.bank': ':0',
    'account.btn_general': '一般',
    'account.btn_pending': '確認中',
    'account.btn_rejected': '非承認',
    'account.btn_unverified': '未承認',
    "account.btn_verify_now": "Verify Now",
    "account.btn_verify_change": "Change Verify",
    'account.btn_uver_bank': '未承認',
    'account.btn_verified': '承認済み',
    'account.btn_verify_bank': '確認',
    'account.button_show': 'もっと見る',
    'account.change': '変更する',
    'account.daily_higher_limit': '上限',
    'account.daily_limit_withdraw': '24時間出金制限',
    'account.date': '日付',
    'account.email_desc': '無効化した場合は、ログイン・出金・入金時に通知されません。',
    'account.device': 'デバイス',
    'account.device_management': 'デバイス管理',
    'account.devices_allowed': 'これらの端末は現在あなたのアカウントにアクセスすることを許可されています。',
    'account.disable': '無効にする',
    "account.cancel": "Cancel",
    'account.email_disable_confirm': '通知受信を無効化してよろしいですか？',
    'account.discount': 'OGEを利用して手数料を支払う',
    'account.enable': '設定',
    'account.error_bank': '*出金やセキュリティの変更に使われます',
    'account.google_auth': 'Google認証システム',
    'account.lost_google_authenticator': 'Google認証を忘れてしまいましたか？',
    'account.google_auth_content': '出金やセキュリティの変更に使われます',
    'account.identity.choose_file': 'ファイルを選択',
    'account.identity.country': '国/地域',
    'account.identity.errors.character_limit': 'この項目には{min}~{max}までの英数字を入力してください',
    'account.identity.errors.exist': 'この身分証明書は既に提出されています',
    'account.identity.errors.format_number': '特殊文字を含まない英数字を9~12桁で入力してください。',
    'account.identity.errors.maxsize': '画像サイズは10MB以内としてください。',
    'account.identity.errors.required': 'この項目の入力は必須です。',
    'account.identity.errors.fullName.required': '氏名の入力は必須です。',
    'account.identity.errors.passportID.required': '「パスポート/IDナンバー」の入力は必須です。',
    'account.identity.errors.id_front.required': '身分証明書の表面/パスポートの表紙が必須項目です。',
    'account.identity.errors.id_back.required': '「身分証明書の裏面/パスポートのデータありページ」の入力は必須です。',
    'account.identity.errors.id_selfie.required': '「身分証明書及びメモと一緒に撮影したセルフィー写真」の入力は必須です。',
    'account.identity.example': '見本',
    'account.identity.female': '女性',
    'account.identity.fullname': '氏名',
    'account.identity.header_identity': '個人',
    'account.identity.header_verification': '本人確認書類',
    'account.identity.identityID': '有効な身分証明書',
    'account.identity.identity_back': '身分証明書の裏面/パスポートのデータありページ',
    'account.identity.identity_cover': '身分証明書の表面/パスポートの表紙',
    'account.identity.identity_front': '身分証明書の表面',
    'account.identity.identity_image_back': '写真は.PNG、.JPG、.JPEG形式で、完全ではっきりと見えることを確認してください。証明書は有効期限内のものが使用できます。',
    'account.identity.identity_valid_card': '有効身分証明書',
    'account.identity.image_identity': 'パスポートをお持ちでない場合は、運転免許証または国民健康保険証の表面の写真をアップロードしてください。',
    'account.identity.image_passport': '画像は.PNG、.JPG、.JPEG形式で提出する必要があります。写真の題目が完全かつ明確に見えるようにしてください。パスポートをお持ちでない場合は、運転免許証または国民ID証明書の表面の写真をアップロードしてください。',
    'account.identity.image_passport_data': '画像は.PNG、.JPG、.JPEG形式で提出する必要があります。写真の題目が完全かつ明確に見えるようにしてください。写真が.PNG、.JPG、.JPEG形式で、完全ではっきりと見えることを確認してください。身分証明書は有効期限内のものが使用できます。',
    'account.identity.male': '男性',
    'account.identity.passport': 'パスポート/IDナンバー',
    'account.identity.selfie': '身分証明書及びメモと一緒に撮影した自分自身の写真（セルフィー）',
    'account.identity.sex': '性別',
    'account.identity.submit': '提出',
    'account.identity.success': '作成されました。',
    'account.identity.update_success': '更新されました。',
    'account.identity.sure_back': '写真が.PNG、.JPG、.JPEG形式で、完全ではっきりと見えることを確認してください。証明書が必ず有効期限内です。',
    'account.identity.sure_front': 'パスポートをお持ちでない場合は、運転免許証または国民健康保険証の表面の写真をアップロードしてください。',
    'account.identity.text_condition': 'アップロードする画像は、顔と各項目の文字が鮮明に確認出来る必要があります。',
    'account.identity.text_date': '本日の日付を記入したメモ',
    'account.identity.text_face': '顔がはっきり見えること',
    'account.identity.text_image': '身分証明書がはっきり見えること',
    'account.identity.text_selfie': '身分証明書の表面を持っているあなたの写真を提供してください。「本人確認書類」と「OG Exchangeと今日の日付を書いた紙」を手に持った状態で、顔全体と書類全体が1つの画像の中に納まるように撮影してください。あなたの顔がはっきりと見えること、そしてすべてのパスポートの詳細がはっきりと読めることを確認してください。',
    'account.identity.text_write': '{APP_NAME}を書いたメモ',
    'account.identity.verification_other': 'この確認オプションは、日本本土以外のすべての国および地域のIDを持つユーザーに適用されます。この確認が処理されるにはあなたの本当の身元を使用してください。あなたの個人情報は安全に保護されます。政府発行の以下のIDが使用できます。',
    'account.identity.verification_other1': '<span>1.</span>パスポート',
    'account.identity.verification_other2': '<span>2.</span>運転免許証',
    'account.identity.verification_other3': '<span>3.</span>政府発行証明書',
    'account.invalid_device': 'あなたはアマンプリで使用したことのないデバイス、またはあなたが長期間使用していないデバイスからサインインしている可能性があります。あなたの安全のために、確認用メールがあなたのメールアドレスに送信しました。',
    'account.ip': 'IP',
    'account.ip_address': 'IPアドレス',
    "account.ip_action": "Action",
    'account.last_login': '最終ログイン',
    'account.last_login_time': '最終ログイン時間',
    'account.line': 'LINE',
    'account.line.desc': 'ログイン、出金、入金時の通知受信する為にアカウントを有効化する',
    'account.location': 'ロケーション',
    'account.login': 'ログインパスワード',
    'account.lv': 'Lv',
    'account.modal.agreement_otp.view_secret_key': '秘密鍵を表示',
    'account.modal.agreement_otp.policy_content_text1': '1',
    "account.modal.agreement_otp.policy_content_text2": "1. Email Subject: Request stop Google Authenticator",
    'account.modal.agreement_otp.policy_content_text3': '2.本文',
    'account.modal.agreement_otp.policy_content_text4': '・本名',
    'account.modal.agreement_otp.policy_content_text5': '・あなたの電話番号',
    'account.modal.agreement_otp.policy_content_text6': '・{APP_NAME}に登録されているメールアドレス',
    'account.modal.agreement_otp.policy_content_text7': '3.添付ファイル',
    'account.modal.agreement_otp.policy_content_text8': '・身分証明書の表面',
    'account.modal.agreement_otp.policy_content_text9': '・身分証明書の裏面',
    'account.modal.agreement_otp.policy_content_text10': '・身分証明書及びメモと一緒にセルフィー',
    'account.modal.agreement_otp.policy_content_text11': '写真が完全ではっきりと見えることを確認してください。',
    'account.modal.agreement_otp.policy_content_text12': '身分証明書の表面を持っているあなたの写真を提供してください。',
    'account.modal.agreement_otp.policy_content_text13': "In the same picture, make a reference to {APP_NAME} and today’s date displayed.",
    'account.modal.agreement_otp.policy_content_text14': 'あなたの顔がはっきりと見えること、そしてすべてのパスポートの詳細がはっきりと読めることを確認してください。',
    'account.modal.agreement_otp.policy_content': '復元コードを忘れてしまい、Google認証を解除できない場合、:<span class="primary-link">{contact_email}</span>までメールでお問い合わせ下さい。',
    'account.modal.agreement_otp.title': '復元コードを忘れてしまった場合',
    'account.modal.cancel_2fa.guide': '<p class="font-18">二段階認証（OTP）を解除する場合、6桁のGoogle認証番号の入力が必要です</p><p class="font-18">携帯電話を紛失した場合やアプリをアンインストールした場合は、代わりに以下のインプットに16桁の回復コードを入力して無効にすることもできます。</p>',
    'account.modal.cancel_2fa.input_blank': 'Google認証OTPコードを入力する必要があります',
    'account.modal.cancel_2fa.otp': 'OTP',
    'account.modal.cancel_2fa.otp_code': '認証番号',
    'account.modal.cancel_2fa.otp_policy': '回復コードを忘れてしまった場合',
    'account.modal.cancel_2fa.otp_restore': '復元コード',
    'account.modal.cancel_2fa.stop_use_otp': '二段階認証を解除',
    'account.modal.cancel_2fa.success': 'OPTが無効です。',
    'account.modal.cancel_2fa.title': 'Google認証を解除する。',
    'account.modal.confirm': '<span class="font-18">確認</span>',
    'account.modal.confirm_trusted_device': '選択した信頼できるデバイスを削除しますか？',
    'account.modal.confirm_registered_email':'You have registered by this email address but the confirmation link is expired. Do you want to resend the confirmation link to your email?',
    'account.modal.date_time_pick.text1': '期間帯:',
    'account.modal.date_time_pick.text2': '過去24時間',
    'account.modal.date_time_pick.text3': '前日',
    'account.modal.date_time_pick.text4': '2週間前',
    'account.modal.date_time_pick.text5': '過去1ヶ月間',
    'account.modal.date_time_pick.text6': '前月',
    'account.modal.date_time_pick.text7': '過去3ヶ月間',
    'account.modal.date_time_pick.text8': 'カスタム（最大範囲3ヶ月）',
    'account.modal.date_time_pick.text9': 'ダウンロード',
    'account.modal.date_time_pick.title': '手数料履歴ダウンロード',
    'account.modal.lost_otp.guide': 'Google認証を解除するには、復元コードを入力する必要があります。',
    'account.modal.lost_otp.otp': 'OTP',
    'account.modal.lost_otp.otp_code': '認証番号',
    'account.modal.lost_otp.otp_policy': '回復コードを忘れてしまった場合',
    'account.modal.lost_otp.otp_restore': '回復コード',
    'account.modal.lost_otp.stop_use_otp': '二段階認証を解除',
    'account.modal.lost_otp.title': '二段階認証を解除',
    'account.ni_bank': 'NI Bank口座',
    'account.no_commission_history': '手数料履歴がありません。',
    'account.no_referral_history': '紹介履歴がありません',
    'account.no_latest_commission': '紹介履歴がありません。',
    'account.otp.authentication_failed': '認証に失敗しました',
    'account.otp.back': '前のステップへ',
    'auth.failed_login': 'ユーザー情報が正しくありません。',
    'account.otp.backup_text1': 'Google認証をリセットするにはサポートチケットを発行する必要があり、処理に少なくとも7日かかります。',
    'account.otp.backup_text2': 'このキーを紙に保存してください。このキーを使用すると、電話を紛失した場合にGoogle認証を回復できます。',
    'account.otp.backup_title': 'ステップ3.復元コードのバックアップ保存',
    'account.otp.enable_des': 'Google認証の設定',
    'account.otp.enable_step1': '1.アプリをダウンロードして下さい',
    'account.otp.enable_step2': '2.QRコードをスキャンして下さい',
    'account.otp.enable_step3': '3.復元コードのバックアップをして下さい',
    'account.otp.enable_step4': '4.Google認証の設定',
    'account.otp.enable_text1': 'アプリをインストールしました',
    'account.otp.enable_text2': 'QRコードをスキャンしました',
    'account.otp.enable_text3': '16桁の復元コードを書き留めました',
    'account.otp.enable_title': 'ステップ4.Google認証の設定',
    'account.otp.install_text': 'Google認証のアプリをインストールしてください',
    "account.otp.sub-install_text": "Get the app",
    'account.otp.install_title': 'ステップ1.アプリのダウンロード',
    'account.otp.next': '次へ',
    'account.otp.qr_text': 'QRコードをスキャンできない場合は、このコードを手動でアプリに入力してください。',
    'account.otp.qt_title': 'ステップ2.QRコードをスキャン',
    'account.otp.success': 'OTPが有効になりました',
    'account.otp.txt_pass': 'ログインパスワード',
    'account.otp.should_enable_first': 'Google認証を有効にする必要があります。',
    'account.phone_number_in_use': 'この電話番号は既に{APP_NAME}のアカウントに関連付けられています。',
    'account.recent_activity': '最近のアクティビティ',
    "account.referral_des":"Invite Friends and Earn Crypto Together",
    "account.referral_content":"Earn {number}% commission on every trade across Spot and Futures",
    'account.referral_code': 'あなたの紹介コード：',
    'account.referral_notification': '友達を{APP_NAME}に紹介すると最大{%}の手数料を得られます。このリンクを共有します。',
    'account.referral_program': 'リファラルプログラム',
    'account.submit': '本人確認書類提出',
    'account.telegram': 'テレグラム',
    'account.telegram.desc': 'ログイン、出金、入金時の通知受信する為にアカウントを有効化する',
    'account.change_verify_kyc': '本人確認書類画面',
    'account.title_device': 'これらの端末は現在あなたのアカウントにアクセスすることを許可されています。',
    'account.tooltip1': 'この機能をオンにすると、あなたのアカウントはホワイトリストへ登録されている出金アドレスにのみ出金することができます。',
    'account.tooltip2': 'この機能をオフにすると、あなたのアカウントはどの出金アドレスにも出金をすることができるようになりますがセキュリティは低下します。',
    "account.turn_on_mode_whitelist": "Once this function is enabled, your account will only be able to withdraw to addresses on your whitelist.",
    "account.turn_off_mode_whitelist": "Once this function is disabled, your account will be able to withdraw to any withdrawal address.",
    'account.white_list': 'ホワイトリスト',
    'account.white_list_off': 'ホワイトリストを無効にする',
    'account.white_list_on': 'ホワイトリストを有効にする',
    'account.withdrawal_address': '出金アドレス管理',
    'account.inactive': 'あなたのアカウントは無効です。',
    'address.add_address': '出金アドレス管理',
    'address.add_success': '作成されました。',
    'address.address': 'アドレス',
    'address.all': 'すべて',
    'address.coin': 'コイン',
    'address.coin_name': 'コイン名',
    "address.confirm_remove_address": "Do you want to delete the selected withdrawal address?",
    'address.date': '日付',
    'address.delete': '削除',
    "address.deleted_success": "Withdrawal address is deleted",
    "address.deleted_sub_success": "Deleted withdrawal address",
    "address.deleted_success_message": "Deleted device",
    'address.errors.address_required': 'アドレスの入力は必須です。',
    'address.errors.blockchain_address': '出金アドレスが無効です。',
    'address.errors.coin_required': 'コインの入力は必須です。',
    'address.errors.exist_withdraw_address': 'このアドレスは既に存在しています。',
    "address.errors.withdraw_address.invalide": "The withdraw address is invalid",
    'address.errors.label_required': 'ラベルの入力は必須です。',
    'address.errors.max_length': '{field}は最大{amount}文字です。',
    'address.errors.min_length': '{field}は{amount}文字以上です。',
    'address.errors.tag_required': '宛先タグの入力は必須です。',
    'address.label': 'ラベル',
    'address.label_hint': 'ラベルは最大20文字です。',
    'address.memo': 'メモ/タグ/...',
    'address.none': 'すべて外す',
    'address.not_whitelisted': 'ホワイトリスト以外',
    'address.only_dis': 'ホワイトリストのアドレスのみを表示します。',
    'address.remove_whitelist': 'ホワイトリストから削除',
    'address.select_coin': 'コインを選択',
    'address.submit': '提出',
    'address.tag': 'タグ',
    'address.tooltip1': 'この機能がオンになっていると、あなたのアカウントはホワイトリストへの登録されている出金アドレスにしか出金することができません。',
    'address.tooltip2': 'この機能がオフになっていると、あなたのアカウントは任意の出金アドレスに出金することができます。',
    'address.turn_off_mode_whitelist': 'この機能をオフにした後、あなたはどの出金アドレスにも出金することができます。オフにしてよろしいですか？',
    'address.turn_on_mode_whitelist': 'この機能をオンにした後、あなたはホワイトリストに登録した出金アドレスにしか出金することができません。オンにしてよろしいですか？',
    'address.turn_on_whitelist': 'ホワイトリスト機能をオンにしてください。',
    'address.update_white_list': 'ホワイトリスト機能をオンにしてください。',
    'address.updated_success': '更新されました。',
    'address.white_list_off': 'ホワイトリストを無効にする',
    'address.white_list_on': 'ホワイトリストを有効にする',
    'address.whitelisted': 'ホワイトリスト',
    'address.withdrawal_address': '出金アドレス管理',
    'address.table.empty_msg': '出金アドレスがありません。',
    'admin.role': '権限',
    'admin.deposit_approved': '入金が完了しました:amountUSD\r\n:time\r\n\r\n{APP_NAME}',
    'admin.deposit_rejected': '入金失敗しました :amountUSD\r\n:time\r\nデータが一致しません。\r\n{APP_NAME}',
    'admin.new_deposit': '新規入金:amountUSD\r\n:time\r\n\r\n{APP_NAME}',
    'admin.new_withdrawal': '新規出金:amountUSD\r\n:time\r\n\r\n{APP_NAME}',
    'admin.withdraw_approved': '出金が完了しました:amountUSD :bankName bank :bankAccount\r\n:time\r\n\r\n{APP_NAME}',
    'admin.withdraw_status_pending': '保留する',
    'admin.withdraw_status_success': '成功',
    'approval_pending': '承認待ち',
    'approval_pending.amount': '数量',
    'approval_pending.approval_request': '承認依頼',
    'approval_pending.created_date': '作成日',
    'approval_pending.currency': '通貨',
    'approval_pending.detail': '詳細',
    'approval_pending.title': '承認待ち',
    'approval_pending.transaction_id': 'トランザクションID',
    'approval_pending.user_name': 'メールアドレス',
    'approval_pending.view': '閲覧',
    'approval_request': '承認依頼',
    'approved_at': '承認時間',
    'approved_by': '承認者',
    'approved_order.amount': '数量',
    'approved_order.btn_detail': '詳細',
    'approved_order.btn_search': '検索',
    'approved_order.btn_view': '閲覧',
    'approved_order.created_date': '作成日',
    'approved_order.currency': '通貨',
    'approved_order.heading_title': '承認済みトランザクション',
    'approved_order.no': 'No',
    'approved_order.transaction_id': 'トランザクションID',
    'approved_order.user_name': 'メールアドレス',
    'approved_order.withdraw_approval': '出金承認者',
    'approved_transaction': '承認済みトランザクション',
    'approved_transaction_page.approved_date': '承認日',
    'approved_transaction_page.administrator_information': '管理者情報',
    'approved_transaction_page.withdrawal_currency': '出金通貨',
    'approved_transaction_page.withdrawal_address': '出金アドレス',
    'approved_transaction_page.country': '国',
    'approved_transaction_page.created_date': '作成日',
    'approved_transaction_page.email': 'メールアドレス',
    'approved_transaction_page.header_title': '[詳細]トランザクション：:transaction_id',
    'approved_transaction_page.quantity': '数量',
    'approved_transaction_page.transaction_id': 'トランザクションID',
    'approved_transaction_page.transaction_detail': 'トランザクション詳細',
    'approved_transaction_page.customer_information': 'お客様情報',
    'approved_transaction_page.transaction_hash': 'トランザクションハッシュ',
    'approved_transaction_page.remark': '備考',
    'approved_transactions': '承認済みトランザクション',
    'auth.confirmation_email_subject': '【{APP_NAME}】{APP_NAME}でアカウントの有効化',
    'auth.email_confirm_success': 'メールアドレスが確認されました。',
    'auth.email_confirmation_code_invalid': 'アクティベーションコードが無効です。',
    'auth.failed': '認証情報が正しくありません。',
    'auth.forgot_password': 'ログインパスワードをお忘れですか？',
    'auth.otp_code_invalid': '無効なGoogle認証コードです。',
    'auth.otp_code_required': 'Google認証コードの入力は必須です。',
    'auth.otp_not_used': '次の認証コードが生成されるまでお待ちください。',
    'auth.send_mail_failed': 'メールの送信できませんでした。もう一度お試しください。',
    'auth.throttle': 'ログイン回数が多すぎます。{seconds}秒後にもう一度お試しください。',
    'bank_setting.bank_setting': '銀行設定',
    'bank_setting.bank_name': '銀行名',
    'bank_setting.bank_branch': '支店名',
    'bank_setting.account_name': '口座名義',
    'bank_setting.account_no': '口座番号',
    'bank_setting.edit': '編集',
    'bank_setting.return': '戻る',
    'bank_setting.save': '保存',
    'bank_setting.error.lose_bank_name': '口座名の入力は必須です。',
    'bank_setting.error.lose_amount': '金額の入力は必須です。',
    'bank_setting.error.lose_bank_branch': '支店名の入力は必須です。',
    'bank_setting.error.lose_account_name': '口座名義の入力は必須です。',
    'bank_setting.error.lose_account_no': '口座番号の入力は必須です。',
    'bank_setting.update_success_msg': '保存されました。',
    'base_deposit_withdraw_title_time': '日時',
    'base_deposit_withdraw_title_email': 'メールアドレス',
    'base_deposit_withdraw_title_transactionId': 'トランザクションID',
    'base_deposit_withdraw_title_currency': '通貨',
    'base_deposit_withdraw_title_amount': '数量／手数料',
    'base_deposit_withdraw_title_status': 'ステータス',
    'change_password_form.confirm': 'セキュリティ上の理由から、セキュリティ方法の変更後24時間は出金できません。',
    'change_password_form.confirm_new_password': '確認用パスワード',
    'change_password_form.confirm_new_password_change': '確認用パスワード',
    'change_password_form.error_confirm': '確認用パスワードが一致しません。',
    'change_password_form.error_duplicated_password': '新しいパスワードは以前のパスワードと異なる必要があります。',
    'change_password_form.error_message': 'パスワードは変更されていません。',
    'common.datatable.data_empty.request_history': 'リクエスト履歴はありません',
    'common.datatable.data_empty.investment': 'You have no current investment.',
    'change_password_form.new_password': '新しいパスワード',
    'change_password_form.new_password_change': '新しいパスワード',
    'change_password_form.old_password': '現在のパスワード',
    'change_password_form.old_password_change': '現在のパスワード',
    'change_password_form.require_confirm': '新しいパスワード（確認）の入力は必須です。',
    'change_password_form.require_new': '新しいパスワードの入力は必須です。',
    'change_password_form.require_old': '現在のパスワードの入力は必須です。',
    'change_password_form.submit_button': '提出',
    "change_password_cancel": "Cancel",
    'change_password_form.submit_button_processing': '処理中',
    'change_password_form.successful_message': 'パスワードが変更されました。',
    'change_password_form.title': 'パスワードの変更',
    'client_download.desktop': 'デスクトップ',
    'client_download.destop_content': '当社のデスクトップクライアントは、円滑で効率的な取引体験を提供するように調整されています。',
    'client_download.more_way': '{APP_NAME}を手に入れるその他の方法',
    'client_download.provide_tool': '私たちはあなたが外出先で取引に必要ないくつかのツールを提供しています',
    'client_download.sp_download': 'スマートフォンアプリ',
    'client_download.track': 'どこにいても取引の確認と管理ができます。',
    'common.refresh': '更新',
    'common.reset': 'Reset',
    'common.geetest.fail': 'キャプチャを入力してください。',
    "common.geetest.expired": "Capcha expired, please login again",
    'common.geetest.loading': 'キャプチャをローディングしています。',
    'common.action.send': '送信',
    'common.action.cancel': 'キャンセルする',
    'common.action.limit_close_position': '指値ポジション決済',
    'common.action.market_close_position': '成行ポジション決済',
    'common.action.no': 'いいえ',
    'common.action.ok': 'OK',
    'common.action.yes': 'はい',
    "common.action.close": "Close",
    "common.action.confirm": "Confirm",
    'common.action.return': '戻る',
    'common.action.save': '保存',
    'common.action.edit': '編集',
    'common.action.enable': '有効',
    'common.action.disable': '無効にする',
    'common.announcements': 'お知らせ',
    'common.begin.trading': '今すぐ取引を開始する！',
    'common.confirm': '確認',
    'common.create_account_amanpuri': 'Exchangeのアカウントを作成する',
    'common.datatable.data_empty': 'オーダー履歴がありません。',
    'common.datatable.empty_data': 'データがありません。',
    'common.datatable.no_data': 'データがありません。',
    'common.exchange.now': '今すぐ取引を開始する！',
    'common.error.required': '{field}の入力は必須です。',
    'common.margin_exchange': 'レバレッジ取引所',
    'common.margin_exchange.desc': '資金効率の良いレバレッジ取引！<br>最大レバレッジ100倍なのでチャンスを逃しません。',
    'common.margin_exchange.title': 'ボードマッチングでの最大１００倍レバレッジ！',
    'common.max': '最大値',
    'common.max_only': '最大値',
    'common.market_info': 'マーケット情報',
    'common.mobile_app': 'モバイルアプリ',
    'common.mobile_app.desc': 'どこにいても取引の確認と管理ができます。',
    'common.mobile_app.title': '外出先で注文や取引の確認が出来ます',
    'common.no_select': 'すべて外す',
    'common.chose_select': '選択',
    'common.order_status.canceled': 'キャンセル',
    'common.order_status.filled': '約定',
    'common.order_status.partial_filled': '部分約定',
    'common.placeholders.email': 'メールアドレス',
    'common.validate.email': 'メールアドレス',
    "common.placeholders.login_password": "Please enter the login password",
    "common.placeholders.authen_code": "Google Authentication Code",
    'common.placeholders.otp': 'Google認証コード',
    "common.placeholders.otp_2": "Authenticator Code",
    'common.placeholders.password': 'パスワード',
    'common.placeholders.referral': 'リファラルID（任意）',
    'common.placeholders.repeat_password': '確認用パスワード',
    'common.placeholders.confirm_password': '確認用パスワード',
    'common.validate.confirm_password': '確認用パスワード',
    'common.processing': '処理中',
    'common.sales_point': '販売所',
    'common.no_file_chosen': 'ファイルが選択されていません',
    'common.sales_point.desc': 'シンプルな価格表示の販売所。簡単な操作で配当の受け取りや取引手数料の半減に使用できる4IREトークンが購入可能。',
    'common.sales_point.title': '未来ある通貨4IREを購入しよう',
    'common.slogan_create_account': '安心・安全のビットコイン取引ならOG Exchange',
    'common.spot_exchange': '現物取引所',
    'common.spot_exchange.desc': 'シンプルな価格表示の販売所。簡単操作で配当の受け取りや取引手数料の半減に使用できる4IREトークンが購入可能。',
    'common.spot_exchange.title': '最も先進的な仮想通貨取引',
    'common.trade_type.buy': '買い',
    'common.trade_type.sell': '売り',
    'common.transaction_status.cancel': 'キャンセル',
    'common.transaction_status.error': 'エラー',
    'common.transaction_status.pending': '保留する',
    'common.transaction_status.rejected': '非承認',
    'common.transaction_status.success': '成功',
    'common.transaction_status.submitted': '提出',
    'common.window_title': '{APP_NAME}',
    'common_action.cancel': 'キャンセルする',
    'common_action.confirm': '確認する',
    'common_action.ok': 'OK',
    'common.date.warning': '日付範囲が無効です。終了日は開始日より過去の日です。',
    'common.alert.create.success': '作成されました。',
    'common.alert.update.success': '更新されました。',
    'common.alert.delete.success': '削除されました。',
    'contact.contact_us': 'お問い合わせ',
    'contact.got_question': '質問がありますか？',
    'contact.message.sendEmailSuccess': 'メールが送信されました。',
    'contact.non_account_related': 'アカウント関連以外のお問い合わせについては、当社のオンラインコミュニティに参加してください。',
    'contact.please': '探しているものは見つかりましたか？',
    'contact.please_check': 'まず公式の{APP_NAME}でよくある質問を確認して、あなたの質問がすでに回答されているかどうかを確認してください',
    'contact.submit_request': '依頼を提出',
    'contact.view_suport': 'サポート書類を見る',
    'currency.fullname.variable': 'currency.{currency_name}.fullname',
    'currency.ada.fullname': 'カルダノ',
    'currency.ada.shortname': 'ADA',
    'currency.amal.fullname': 'OG Exchange',
    'currency.amal.shortname': '4IRE',
    'currency.mgc.fullname': 'マンゴーコイン',
    'currency.mgc.shortname': 'MGC',
    'currency.bch.fullname': 'Bitcoin Cash',
    'currency.bch.shortname': 'BCH',
    'currency.btc.fullname': 'ビットコイン',
    'currency.btc.shortname': 'BTC',
    'currency.eos.fullname': 'EOS',
    'currency.eos.shortname': 'EOS',
    'currency.eth.fullname': 'イーサリアム',
    'currency.eth.shortname': 'ETH',
    'currency.ltc.fullname': 'ライトコイン',
    'currency.ltc.shortname': 'LTC',
    'currency.usdt.fullname': 'USDT',
    'currency.usdt.shortname': 'USDT',
    'currency.tomo.fullname': 'トモチェーン',
    'currency.tomo.shortname': 'TOMO',
    'currency.tusd.fullname': 'TrueUSD',
    'currency.tusd.shortname': 'TUSD',
    'currency.usd.fullname': 'ドル',
    'currency.usd.shortname': 'USD',
    'currency.xlm.fullname': 'ステラ',
    'currency.xlm.shortname': 'XLM',
    'currency.xrp.fullname': 'リップル',
    'currency.xrp.shortname': 'XRP',
    "currency.bnb.fullname": "Binance Coin",
    "currency.bnb.shortname": "BNB",
    "currency.aave.fullname": "Aave Token",
    "currency.aave.shortname": "AAVE",
    "currency.atom.fullname": "Cosmos Token",
    "currency.atom.shortname": "ATOM",
    "currency.doge.fullname": "Dogecoin",
    "currency.doge.shortname": "DOGE",
    "currency.dot.fullname": "Polkadot Token",
    "currency.dot.shortname": "DOT",
    "currency.fil.fullname": "Filecoin",
    "currency.fil.shortname": "FIL",
    "currency.link.fullname": "ChainLink Token",
    "currency.link.shortname": "LINK",
    "currency.mana.fullname": "Decentraland MANA",
    "currency.mana.shortname": "MANA",
    "currency.uni.fullname": "Uniswap",
    "currency.uni.shortname": "UNI",  
    "currency.sol.shortname": "SOL",
    'denial_page.amount': '数量',
    'denial_page.btn_detail': '詳細',
    'denial_page.btn_search': '検索',
    'denial_page.created_date': '作成日',
    'denial_page.currency': '通貨',
    'denial_page.heading_title': '非承認トランザクション',
    'denial_page.no': 'No',
    'denial_page.transaction_id': 'トランザクションID',
    'denial_page.user_name': 'メールアドレス',
    'emails.account': '数量',
    'emails.account_info': '銀行{bank},口座番号{accountNumber},口座名義{name}',
    'emails.amount': '金額：',
    'emails.cannot_click_link': 'リンクをクリックできない場合は、アドレスをコピーしてアドレスバーに貼り付けてください。',
    'emails.confirm_email': 'アカウントを有効にするには、下記のリンクをクリックしてください。あなたのメールを確認することによって、我々はより便利でより安全な仮想通貨取引サービスを皆様に提供できるように努めます。',
    'emails.confirm_kyc': 'あなたのKYCは',
    'emails.date': '時間：',
    'emails.deposit_alerts.text1': '注文を受けました',
    'emails.deposit_alerts.text2': 'あなたから',
    'emails.deposit_alerts.text3': 'この金額は{APP_NAME}のウォレット残高に反映されています。',
    'emails.deposit_alerts.title': '【{APP_NAME}】Refill request has been made',
    'emails.deposit_approved_text1': '{email}様,あなたの入金は承認されました。',
    'emails.deposit_approved_title': '【{APP_NAME}】 入金は完了しました。',
    'emails.deposit_rejected_text1': '{email}様,あなたの入金は失敗しました。',
    'emails.deposit_rejected_text2': '入金規則、アカウント情報、入金コードを確認して、もう一度申請してください。',
    'emails.deposit_rejected_title': '【{APP_NAME}】 入金は失敗しました。',
    'emails.deposit_usd_alerts.account_name': '口座名義',
    'emails.deposit_usd_alerts.account_no': '口座番号',
    'emails.deposit_usd_alerts.amount': '数量',
    'emails.deposit_usd_alerts.bank_branch': '支店名',
    'emails.deposit_usd_alerts.bank_name': '銀行名',
    'emails.deposit_usd_alerts.code': 'コード',
    'emails.deposit_usd_alerts.text1': 'システムはユーザーの再入金を確認するリクエストを受け取りました。',
    'emails.deposit_usd_alerts.text2': 'トランザクション情報',
    'emails.deposit_usd_alerts.title': '新しい再入金リクエスト',
    'emails.hello': 'こんにちは,',
    'emails.kyc_rejected': '拒否されました',
    'emails.kyc_tilte': '【{APP_NAME}】でKYCを確認する',
    'emails.kyc_verified': '承認済み',
    'emails.new_deposit_amount': '数量：',
    'emails.new_deposit_text1': '入金リクエストを受け取りました。',
    'emails.new_deposit_title': '新規入金リクエスト',
    'emails.new_device.text1': 'あなたは最近、新しい端末から{APP_NAME}のアカウントにログインしようとしました。セキュリティ対策として、{APP_NAME}のアカウントへのアクセスを許可する前に追加の確認が必要です。',
    'emails.new_device.text2': 'これが正当な行為である場合は、以下で新しいデバイスを認証できます。',
    'emails.new_login.text1': 'システムは未使用のIPアドレスからアカウントがログインしていることを検出しました。',
    'emails.new_login.text2': 'この操作が自分の操作ではない場合は、そのデバイスを無効にしてすぐにご連絡ください。',
    'emails.new_login.new_ip_title': '【OG Exchange】警告：新しいIPでログインしました。',
    'emails.new_withdrawal_text1': '出金リクエストを受け付けました。',
    'emails.new_withdrawal_title': '新規出金リクエスト',
    'emails.no_reply': 'このメールは自動送信メールです。このメールには返信しないでください。',
    'emails.on': 'オン',
    'emails.say_hello': '{email}様 こんにちは',
    'emails.team': '{APP_NAME}チーム',
    'emails.team_address': '(CO) {APP_NAME} - street xxx',
    'emails.team_inc': '© {APP_NAME} Inc.All rights reserved.',
    'emails.team_inform': 'お知らせします',
    'emails.team_service_center': 'サービスセンター/メールアドレス<a href=\'mailto: :email \' target=\'_blank\'> :email </a> / tel. :phone',
    'emails.team_slogan': '最も優れた仮想通貨取引',
    'emails.thankyou': 'ありがとうございます。',
    'emails.warning': 'この操作が自分の操作ではない場合は、すぐにご連絡ください。',
    'emails.warning_title': '{APP_NAME}セキュリティ警告',
    'emails.welcome': '{APP_NAME}へようこそ',
    'emails.footer.the_best_cryptocurrency': '最も良い仮想通貨取引',
    'emails.footer.service_center': 'サービスセンター',
    'emails.registed.confirmation_email_subject': '【{APP_NAME}】{APP_NAME}でアカウントの有効化',
    'emails.registed.click_on_link': '登録が完了していません。確認を完了するには、以下のリンクをクリックしてください。確認後我々はより便利でより安全な仮想通貨取引サービスをあなたに提供致します。',
    'emails.registed.valid_24h': '上記リンクは24時間有効です。',
    'emails.registed.please_complete': '本メールの受信後、24時間以内にアカウントの確認を完了してください。',
    'emails.registed.thank_you': 'ありがとうございます。',
    'emails.confirmation_reset_password.subject': '【OG Exchange】パスワード再設定',
    'emails.confirmation_reset_password.dear_account': 'Dear ',
    'emails.confirmation_reset_password.receiving_text': 'アカウントのパスワード再設定リクエストを受信したため、このメールを受信して​​います。',
    'emails.confirmation_reset_password.please_click': '以下のリンクよりパスワード変更を完了させてください。',
    'emails.confirmation_reset_password.valid_24h': '上記リンクは24時間有効です。',
    'emails.confirmation_reset_password.please_confirm': '本メールの受信後、24時間以内にパスワードの再設定を完了してください。',
    'emails.confirmation_reset_password.thank_you': 'ありがとうございます。',
    'emails.login_new_device.subject': '【OG Exchange】警告：新しいデバイス承認',
    'emails.login_new_device.dear_account': 'Dear ',
    'emails.login_new_device.attemped_access': 'あなたは最近、新しい端末からOG Exchange取引所のアカウントにログインしようとしました。セキュリティ対策として、OG Exchangeアカウントへのアクセスを許可する前に追加の確認が必要です。 ',
    'emails.login_new_device.email': 'メールアドレス',
    'emails.login_new_device.device': 'デバイス ',
    'emails.login_new_device.time': '日時 ',
    'emails.login_new_device.ip': 'IPアドレス ',
    'emails.login_new_device.legitimate_activity': 'これが正当な行為である場合は、以下で新しいデバイスを認証できます。 ',
    'emails.login_new_device.team': 'OG Exchangeチーム',
    'emails.login_new_device.thank_you': 'ありがとうございます。',
    'emails.confirm_kyc.dear_name': '様 ',
    'emails.confirm_kyc.subject': '【OG Exchange】KYC確認 :status',
    'emails.confirm_kyc.title_header': '【OG Exchange】:status your KYC',
    'emails.confirm_kyc.line_1': 'OG Exchangeサポートです。',
    'emails.confirm_kyc.line_2': 'お待ちいただきありがとうございます。',
    'emails.confirm_kyc.line_3': '本人確認の審査をしていますので、こちらからユーザーページにログインし、審査結果を確認してください。',
    'emails.confirm_kyc.line_4': '身分証明書の送信が必要であることを示すメッセージがマイページの上部に表示されていない場合、あなたの本人確認は正常に完了しました。',
    'emails.confirm_kyc.line_5': 'メッセージがマイページの上部に表示される場合は、不適切な送信または画像エラーのため承認されていません。そのため、本人確認書類をもう一度確認して再提出してください。',
    'emails.confirm_kyc.line_6': '提出された書類が不適切であった理由は確認出来ませんが、不適切となった理由は主に以下になりますので、一度提出した写真が以下に該当しないかどうか確認してください。',
    'emails.confirm_kyc.line_7': '本人確認書類が指定されていない',
    'emails.confirm_kyc.line_8': '身分証明書とセルフィー写真の顔が違う',
    'emails.confirm_kyc.line_9': 'ID SERPHYに提出された文書、取引所名、日付、本人は一緒に表示されません',
    'emails.confirm_kyc.line_10': '正面を向いていない',
    'emails.confirm_kyc.line_11': 'セルフィー写真に「顔全体」が表示されていない（頭全体が表示されていない）',
    'emails.confirm_kyc.line_12': '画像が暗く顔がはっきりしていない',
    'emails.confirm_kyc.line_13': '画像のアップロードに失敗しました',
    'emails.confirm_kyc.line_14': 'ご迷惑をおかけして申し訳ございません。ご協力ありがとうございます。',
    'emails.contact.subject': '【OG Exchange】お問い合わせ',
    'emails.contact.dear_account': 'Dear ',
    'emails.contact.line_1': 'お問い合わせいただきありがとうございます。',
    'emails.contact.line_2': '担当者から再度ご連絡いたします。',
    'emails.received_verify_document.dear_account': 'Dear ',
    'emails.received_verify_document.subject': '【OG Exchange】本人確認書類を受け取りました。',
    'emails.received_verify_document.line_1': 'OG Exchangeを引き続きご支援いただきありがとうございます。',
    'emails.received_verify_document.line_2': '本人確認書類を受け取りました。',
    'emails.received_verify_document.line_3': '提出された書類の順に本人確認書類を審査します。',
    'emails.received_verify_document.line_4': '確認までお待ちください。',
    'emails.received_verify_document.line_5': 'アプリケーションの状態によっては、さらに時間がかかる場合があります。ご理解いただきありがとうございます。',
    'emails.received_verify_document.line_6': 'OG Exchangeの継続的な支援をお願いします。 ',
    'emails.received_verify_document.line_7': 'このメールは当社の送信専用メールアドレスから送信されたものであり、返信することはできません。',
    'emails.withdraw_verify.subject': '【OG Exchange】出金確認',
    'emails.withdraw_verify.line_1': 'Dear ',
    'emails.withdraw_verify.line_2': '次の出金要求があります。',
    'emails.withdraw_verify.line_3': '通貨',
    'emails.withdraw_verify.line_4': '数量',
    'emails.withdraw_verify.line_5': '出金アドレス',
    'emails.withdraw_verify.line_6': '作成日',
    'emails.withdraw_verify.line_7': 'この取引を確認するには、以下のリンクをクリックしてください。',
    'emails.withdraw_verify.line_8': 'ありがとうございます。',
    'emails.withdraw_alerts.subject': '【OG Exchange】出金確認',
    'emails.withdraw_alerts.line_1': 'Dear ',
    'emails.withdraw_alerts.line_2': '次の出金要求が承認されました。',
    'emails.withdraw_alerts.line_3': '通貨',
    'emails.withdraw_alerts.line_4': '数量',
    'emails.withdraw_alerts.line_5': '出金アドレス',
    'emails.withdraw_alerts.line_6': '作成日',
    'emails.withdraw_alerts.line_7': 'ここから出金処理に移ります。',
    'emails.withdraw_alerts.line_8': 'OG Exchange取引所の継続的な支援に感謝します。',
    'emails.withdraw_alerts.line_9': 'このメールは送信専用のメールアドレスから送信されたものです。',
    'emails.withdraw_alerts.line_10': 'したがって、返信しても内容を特定することはできません。  ',
    'emails.withdraw_alerts.line_11': 'ありがとうございます。',
    'emails.withdraw_errors_alerts.subject': '【OG Exchange】出金拒否',
    'emails.withdraw_errors_alerts.line_1': 'こんにちは ',
    'emails.withdraw_errors_alerts.line_2': '次の出金要求が拒否されました。',
    'emails.withdraw_errors_alerts.line_3': '通貨',
    'emails.withdraw_errors_alerts.line_4': '数量',
    'emails.withdraw_errors_alerts.line_5': '出金アドレス',
    'emails.withdraw_errors_alerts.line_6': '作成日',
    'emails.withdraw_errors_alerts.line_7': '不明なエラーが発生したため、要求を拒否しなければなりません。',
    'emails.withdraw_errors_alerts.line_8': '要求を慎重に確認して、もう一度提出してください。',
    'emails.withdraw_errors_alerts.line_9': 'ありがとうございます。',
    'emails.ban_account.subject': '【OG Exchange】アカウントがロックされました',
    'emails.ban_account.dear_name': '親愛なる<strong>：email </ strong>、',
    'emails.ban_account.line_1': 'あなたのアカウントはAmapuri取引所の管理者によりロックされていました。',
    'emails.ban_account.line_2': '現時点ではログインできません。',
    'emails.ban_account.line_3': 'アカウントのロックを解除するには、このリンクまでご連絡ください。',
    'emails.withdraw_alerts.text1': '出金を申請する',
    'emails.withdraw_alerts.text2': '{APP_NAME}のアカウントからの出金リクエストは完了しました。',
    'emails.withdraw_alerts.text3': '確認ステータスをここで追跡できます。',
    'emails.withdraw_alerts.title': '【{APP_NAME}】の出金リクエストは完了しました。',
    'emails.withdraw_errors_alerts.text1': '出金をリクエストしました。',
    'emails.withdraw_errors_alerts.text2': '失敗しました。現在処理中です。私たちからのフィードバックをお待ちください。',
    'emails.withdraw_errors_alerts.title': '【{APP_NAME}】の出金にエラーがあります。',
    'emails.withdraw_usd_alerts.account_name': '口座名義',
    'emails.withdraw_usd_alerts.account_no': '口座番号',
    'emails.withdraw_usd_alerts.amount': '数量',
    'emails.withdraw_usd_alerts.bank_branch': '支店名',
    'emails.withdraw_usd_alerts.bank_name': '銀行名',
    'emails.withdraw_usd_alerts.text1': 'システムはユーザーの出金リクエストを受け付けました。',
    'emails.withdraw_usd_alerts.text2': 'トランザクション情報',
    'emails.withdraw_usd_alerts.title': '新規出金リクエスト',
    'emails.withdrawal_approved_text1': '{email}, あなたの出金リクエストは処理されました。',
    'emails.withdrawal_approved_title': '【{APP_NAME}】 の出金は完了しました。',
    "fee_withdraw": "Fee has changed",
    'limit_withdraw': "The amount you withdraw is more than once allowed",
    'daily_limit_withdraw': "Daily limit has changed",
    'emails.deposit_withdraw_usd_alerts.hello': '<strong>:email</strong>こんにちは',
    'emails.deposit_withdraw_usd_alerts.time': '日時',
    'emails.deposit_withdraw_usd_alerts.deposit.approved.title': '【OG Exchange】入金は完了しました。',
    'emails.deposit_withdraw_usd_alerts.deposit.approved.line_1': 'あなたの入金要求は完了しました。',
    'emails.deposit_withdraw_usd_alerts.deposit.approved.line_2': 'ログインして残高をご確認してください。',
    'emails.deposit_withdraw_usd_alerts.deposit.approved.amount': '入金額',
    'emails.deposit_withdraw_usd_alerts.deposit.rejected.title': '【OG Exchange】 入金は失敗しました。',
    'emails.deposit_withdraw_usd_alerts.deposit.rejected.line_1': 'あなたの入金要求は失敗しました。',
    'emails.deposit_withdraw_usd_alerts.deposit.rejected.line_2': '入金ルール、アカウント情報、入金コードを確認して、もう一度お試しください。',
    'emails.deposit_withdraw_usd_alerts.deposit.rejected.amount': '入金額',
    'emails.deposit_withdraw_usd_alerts.withdrawal.approved.title': '【OG Exchange】出金は完了しました。',
    'emails.deposit_withdraw_usd_alerts.withdrawal.approved.line_1': 'あなたの出金要求は完了しました。',
    'emails.deposit_withdraw_usd_alerts.withdrawal.approved.amount': '出金額',
    'emails.deposit_withdraw_usd_alerts.withdrawal.approved.account_bank': '銀行口座',
    'emails.deposit_withdraw_usd_alerts.withdrawal.approved.account_number': '口座番号',
    'emails.deposit_withdraw_usd_alerts.withdrawal.approved.account_holder': '口座名義',
    'emails.deposit_withdraw_usd_alerts.withdrawal.rejected.title': '【OG Exchange】 出金は失敗しました。',
    'emails.deposit_withdraw_usd_alerts.withdrawal.rejected.line_1': 'あなたの出金要求は失敗しました。',
    'emails.deposit_withdraw_usd_alerts.withdrawal.rejected.line_2': '出金ルール、アカウント情報を確認して、もう一度お試しください。',
    'emails.deposit_withdraw_usd_alerts.withdrawal.rejected.amount': '出金額',
    'emails.deposit_withdraw_usd_alerts.withdrawal.rejected.account_bank': '銀行口座',
    'emails.deposit_withdraw_usd_alerts.withdrawal.rejected.account_number': '口座番号',
    'emails.deposit_withdraw_usd_alerts.withdrawal.rejected.account_holder': '口座名義',
    'exchange.basic.chart.btn_add_chart': 'チャートを追加',
    'exchange.basic.chart.buy_order': '買い注文',
    'exchange.basic.chart.candle': 'ローソク足',
    'exchange.basic.chart.depth': 'デプス',
    'exchange.basic.chart.msg_close_chart': 'このチャートを閉じてよろしいですか？',
    'exchange.basic.chart.price': '価格',
    'exchange.basic.chart.sell_order': '売り注文',
    'exchange.basic.label_hour': '時',
    'exchange.basic.label_minute': '分',
    'exchange.basic.time.hour': '{number}時間',
    'exchange.basic.time.hours': '{number}時間',
    'exchange.basic.time.minute': '{number}分間',
    'exchange.basic.time.minutes': '{number}分間',
    'exchange.basic.time.one_day': '1日',
    'exchange.basic.time.one_month': '1ヶ月',
    'exchange.basic.time.one_week': '1週間',
    'exchange.basic.trading_page.change_24h': '前日比',
    'exchange.basic.trading_page.confirm': '確認する',
    'exchange.basic.trading_page.evaluation_amount': '評価',
    'exchange.basic.trading_page.high': '高',
    'exchange.basic.trading_page.high_24h': '24h高値',
    'exchange.basic.trading_page.holding_balance': '残高',
    'exchange.basic.trading_page.last_price': '直近の価格',
    'exchange.basic.trading_page.low': '低',
    'exchange.basic.trading_page.low_24h': '24h安値',
    'exchange.basic.trading_page.total_purchase_amount': '購入',
    'exchange.basic.trading_page.volume': '出来高',
    'exchange.basic.trading_page.volume_24h': '24時間出来高',
    'exchange.basic.trading_page.yeild': '歩留まり',
    'exchange.basic.trading_page.yeild_tooltip.row1': '1.USD換算値に基づきます。',
    'exchange.basic.trading_page.yeild_tooltip.row2': '2.BTC、ETHマーケットもUSD値に換算されます。',
    'exchange.basic.trading_page.yeild_tooltip.row3': '3.入出金の場合、入金および出金時の現在の米ドルに基づいて、入金は「買い」とみなされ、出金は「売り」とみなされます。',
    'exchange.basic.trading_page.yeild_tooltip.row4': '4.歩留まり=（評価額 - 購入合計数量）÷購入合計数量×100',
    'exchange.basic.trading_page.yeild_tooltip.row5': '5.売却資産は計算に含まれていません。現在保有している資産のみが対象となります。',
    'exchange.basic.trading_page.yeild_tooltip.row6': '6.この収益率は、投資の絶対的な範囲を表すものではありません。投資目的のためだけに参考として使用してください。',
    'favourite.market_price.change': '変更する',
    'favourite.market_price.coin': '名称',
    'favourite.market_price.current_price': '直近の価格',
    'favourite.market_price.favorites': 'お気に入り',
    'favourite.market_price.percent_day_before': '± %',
    'favourite.market_price.transaction_amount': '出来高',
    'favourite.market_price.volume': 'Vol',
    'fee_guide.actual_purcharse': '実際の購入数量',
    'fee_guide.actual_sell': '実際の売り',
    'fee_guide.commission_rate': '取引高別の手数料率',
    'fee_guide.commission_tip1': '{APP_NAME}では、上記の取引高に応じて異なる手数料が適用されます。手数料の評価は変更されることがあります',
    'fee_guide.commission_tip2': '出来高ランキングが1日1回実施されます。',
    'fee_guide.commission_tip3': 'メイカー/テイカー共に手数料率は同じです。',
    'fee_guide.example': '例：',
    'fee_guide.fee': '手数料',
    'fee_guide.fomula_actual_pucharse': ' =約定した数量 (1 BTC) - 1 BTC x 手数料 (0.15%) = 0.9985 BTC',
    'fee_guide.for_example': '例：',
    'fee_guide.formula_actual_sell': ' =約定した数量 (1 BTC)',
    'fee_guide.formula_fee': ' =約定した数量 (1 BTC) - 1 BTC x 手数料 (0.15%) = 0.9985 BTC',
    'fee_guide.formula_sell_fee': ' =約定した数量 (1 BTC) x 価格（5,000,000 USD）x 手数料（0.15%） = 7,500 USD',
    'fee_guide.formula_subtotal': ' =約定した数量 (1 BTC) x 価格（5,000,000 USD）= 5,000,000 USD',
    'fee_guide.formula_transaction_value': ' =約定した数量 (1 BTC) x 価格（5,000,000 USD）- 手数料（5,000 USD）',
    'fee_guide.last_30_days': '過去30日間',
    'fee_guide.less_than': '未満',
    'fee_guide.level_name': 'レベル：',
    'fee_guide.level_title': '現在のレベルは',
    'fee_guide.rating': 'レベル',
    'fee_guide.subtotal': '合計USD（取引値）',
    'fee_guide.text13': 'メイカー/テイカー共に手数料率は同じです。',
    'fee_guide.text14': '買い注文の場合は、購入数量より手数料分が差し引かれた数量が口座に反映されます。',
    'fee_guide.text15': '売り注文の場合は、売却した合計金額より手数料率を引いた数量が口座に反映されます。',
    'fee_guide.text16': '買い注文：１BTCの価格が5,000,000USDで約定した場合（手数料0.15%）',
    'fee_guide.text20': '売り注文：１BTCの価格が5,000,000USDで約定した場合（手数料0.15%）',
    'fee_guide.text24': '実際の手数料、手数料の半額などはトレード画面で確認できます。',
    'fee_guide.title': '手数料',
    'fee_guide.transaction_fee': '取引手数料の計算方法',
    'fee_guide.transaction_value': 'USD支払（取引値）',
    'funds.action.deposit': '入金',
    'funds.action.placeholder_input_coin': 'コインのキーワードを入力してください',
    "fund.action.chain_name": "Chain Name",
    'funds.action.withdraw': '出金',
    'funds.balances.amount_is_positive': '数量の入力は0以上です。',
    'funds.balances.amount_over_0': '最少額は0より大きくなければなりません。',
    'funds.balances.amount_can_not_greater_than_available_balance': '利用可能残高は十分ではありません。',
    'funds.balances.amount_can_not_greater_than_available_dividend_balance': '利用可能な配当残高が足りません。.',
    'funds.balances.amount_can_not_greater_than_available_main_balance': '利用可能なウォレット残高が足りません',
    'funds.balances.amount_can_not_greater_than_exchange_available_balance': 'ウォレット残高が足りません',
    'funds.balances.amount_can_not_greater_than_exchange_available_balance_without_orderbook': '利用可能なウォレット残高が不足しています。',
    'funds.balances.amount_can_not_greater_than_margin_available_balance': '利用可能な証拠金が足りません',
    'funds.balances.approx': '約4IRE値',
    'funds.balances.assign': '割り当て',
    'funds.balances.avaliable_balance': '利用可能な残高',
    'funds.balances.available_airdrop_balance': '利用可能な配当残高',
    'funds.balances.balance': 'ウォレット',
    "funds.balances.balance_spot": "Balance",
    'funds.balances.convert_small_balance_success': '残高を交換しました。',
    'funds.balances.curency': '通貨',
    'funds.balances.exchange_available_balance': '取引可能な残高',
    'funds.balances.available': 'Available',
    'funds.balances.action': 'Action',
    'funds.balances.total_spot_balance': 'Total Spot Balance',
    'funds.balances.total_futures_balance': 'Total Futures Balance',
    'funds.balances.exchange_balance': '取引残高',
    "funds.balances.spot_balance": "Spot Balance",
    'funds.balances.airdrop_balance': '配当ウォレット',
    'funds.balances.estimated_airdrop_value': '保有率：',
    'funds.balances.unlock_date': 'ロック解除日',
    'funds.balances.lock_balance': 'ロックアップ中の残高',
    'funds.balances.no_data': '資金がありません。',
    'funds.balances.btc_value': 'BTC値',
    'funds.balances.convert_to_amal': 'OGEへ交換',
    'funds.balances.convert_sm_balance': '少額残高を4IREへ交換',
    'funds.balances.coin': 'コイン',
    'funds.balances.deposit': '仮想通貨の入金',
    'funds.balances.estimated_value': '総資産(BTC換算)',
    'funds.balances.from': 'から',
    'funds.balances.hide': '非表示',
    'funds.balances.hide_small_assets': '少額資産を非表示',
    'funds.balances.interval': '間隔',
    'funds.balances.in_order': '約定待ち',
    'funds.balances.in_use': '使用中',
    'funds.balances.infomation': '情報',
    'funds.balances.main_account': 'ウォレット',
    "funds.balances.margin_balance": "Futures Balance",
    'funds.balances.mam_balance': 'MAM残高',
    'funds.balances.min_amount_is_invalid': '数量は0.00000001以上でなければなりません。',
    'funds.balances.name': '氏名',
    'funds.balances.show_all': '全て表示',
    'funds.balances.small_balance': '少額残高',
    'funds.balances.small_balance_notice': 'BTC値が{amount}未満',
    'funds.balances.hide_small_balance': '少額残高を隠す',
    "funds.balances.hide_small_balance_spot": "Hide Small Balance",
    "funds.balances.hide_small_balance_spot_tooltip": "Balances valued less than 0.001 BTC",
    'funds.balances.P_L': 'P/L',
    'funds.balances.revoke': '取り消す',
    'funds.balances.to': 'まで',
    "funds.header":"Wallet Overview",
    'funds.balances.tranfer': '振替',
    'funds.balances.transfer': '振替',
    'funds.balances.transfer_balance_fails': '残高を転送できません。',
    'funds.balances.airdrop_has_disable': '配当は終了しました、配当ウォレットに送金することはできません',
    'funds.balances.transfer_balance_success': '残高の転送は完了しました。',
    'funds.balances.total_balance': '合計残高',
    'funds.balances.total_airdrop_balance': '合計残高',
    'funds.balances.withdrawal': '出金',
    'funds.balances.suspend': '一時停止',
    'funds.balances.trade': '取引',
    'funds.balances.withdrawal_limit_24': '24h最大出金可能金額',
    'funds.convert_to_amal': 'OGEへ交換',
    'funds.deposit.available_balance': '利用可能残高',
    'funds.deposit.choice': '選択',
    'funds.deposit.coppy_address': 'アドレスをコピー',
    'funds.deposit.copy_error': 'コピーにエラーがあります',
    'funds.deposit.copy_success': 'コピーしました。',
    'funds.deposit.copy_tag': 'タグをコピー',
    'funds.deposit.deposit_address': '{coin}入金アドレス',
    'funds.deposit.deposit_tag': '{coin}入金タグ',
    'funds.deposit.history': '履歴',
    'funds.deposit.important.text1': '<span class=\'icon-favorites-2\'></span>これは{name}（ERC20）の入金アドレスです。OMNI {name}をこのアドレスに入金しないでください。',
    'funds.deposit.important.text2': '<span class="icon-favorites-2"></span>こちらの入金アドレスに:nameのみを送付してください。このアドレスに他の通貨を送ると、入金取引が失われる可能性があります。',
    'funds.deposit.in_order': '約定待ち',
    'funds.deposit.not_arrive': '入金できませんでした',
    'funds.deposit.no_data': '入金履歴がありません。',
    'funds.deposit.show_qr': 'QRコードを表示',
    'funds.deposit.tips.text1': 'ご注意',
    'funds.deposit.tips.text2': '{name}は{count}のネットワークを確認後すぐに入金されます。',
    'funds.deposit.tips.text3': '入金した後は、<a class="link-primary" href="/funds/history-wallet?type=deposit" target="_blank">history</a>ページで進捗状況を追跡できます。',
    'funds.deposit.title_page': 'コイン入金',
    'funds.deposit.tooltip': 'あなたの入金が長期間到着しない場合はブロックチェーンの混雑または不完全な取引が原因である可能性があります。 <a class=\'link-primary\' href="#">More Reference</a>',
    'funds.deposit.total_balance': '合計残高',
    'funds.deposit.view_all': '全てを表示',
    'funds.deposit.what': '{name}は何ですか。',
    'funds.deposit_usd.cancel_deposit_usd': 'キャンセルする',
    'funds.deposit_usd.deposit_amount': '入金額',
    'funds.deposit_usd.deposit_note': '以下の情報に従って送金してください。この金額を確認しあなたのアカウントに振り込みます。',
    'funds.deposit_usd.errors.min_amount': '最少額は{min_amount}より大きくなければなりません。',
    'funds.deposit_usd.errors.required': 'デポジット{field}の入力は必須です。',
    'funds.deposit_usd.guide.text1': '1.入金金額は同じ金額を送金してください。',
    'funds.deposit_usd.guide.text10': '4.支払いが遅れる場合は、弊社のカスタマーサポートにご連絡ください。',
    'funds.deposit_usd.guide.text11': '必要な入金金額と振込金額が異なる場合、または入金コードの入力を忘れた場合は、サポートセンターにリクエストを送信してください。',
    'funds.deposit_usd.guide.text12': '※銀行システムのチェックイン期間中は出金が制限されます。',
    'funds.deposit_usd.guide.text2': '入金数量が実際の入金数量と異なる場合入金は処理されません。',
    'funds.deposit_usd.guide.text3': '2.必ず「入金コード」を入力してください。',
    'funds.deposit_usd.guide.text4': '入金するときは入金コードを入力してください。入金コードのみを使用しそれ以外は使用しないでください。入金コードを入力しないと、入金処理が遅れることがあります。',
    'funds.deposit_usd.guide.text7': '3.入金は最大10分以内に処理されます。',
    'funds.deposit_usd.guide.text8': '・通常の状況では入金を処理するために約3〜5分かかります。',
    'funds.deposit_usd.guide.text9': '入金の処理されたら通知します。',
    'funds.deposit_usd.notes': '備考',
    'funds.deposit_usd.other_deposit': '他の取引をする',
    'funds.deposit_usd.pending_transaction.account_name': '口座名義',
    'funds.deposit_usd.pending_transaction.account_no': '口座番号',
    'funds.deposit_usd.pending_transaction.amount': '数量',
    'funds.deposit_usd.pending_transaction.bank_branch': '支店名',
    'funds.deposit_usd.pending_transaction.bank_name': '銀行名',
    'funds.deposit_usd.pending_transaction.code': 'コード',
    'funds.deposit_usd.submit_deposit_usd': '提出',
    'funds.deposit_usd.success_message': '取引作成は完了しました。',
    'funds.deposit_usd.transaction_history_table.account': '数量',
    'funds.deposit_usd.transaction_history_table.amount': '数量',
    'funds.deposit_usd.transaction_history_table.bank': '銀行',
    'funds.deposit_usd.transaction_history_table.code': 'コード',
    'funds.deposit_usd.transaction_history_table.status': 'ステータス',
    'funds.deposit_usd.transaction_history_table.time': '日時',
    'funds.history.address': 'アドレス',
    'funds.history.amount': '数量',
    'funds.history.coin': 'コイン',
    'funds.history.date': '日付',
    'funds.history.deposit': 'コイン入金',
    'funds.history.export_complete_deposit_history': '入金履歴をダウンロード',
    'funds.history.export_complete_withdraw_history': '出金履歴をダウンロード',
    'funds.history.from': 'から',
    'funds.history.history': '履歴',
    'funds.history.infomation': '情報',
    'funds.history.status': 'ステータス',
    'funds.history.tag': 'タグ',
    'funds.history.to': 'まで',
    'funds.history.transaction_history': '入出金履歴',
    "funds.history.spot_overview": "Spot",
    "funds.history.future_overview": "Futures",
    'funds.history.txid': 'Txid',
    'funds.history.withdrawal': '出金',
    'funds.select_coin': ':actionにコイン/トークンを選択',
    'funds.withdraw_usd.account_info': '口座情報',
    'funds.withdraw_usd.account_name': '口座名義',
    'funds.withdraw_usd.account_no': '口座番号',
    'funds.withdraw_usd.amount': '数量',
    'funds.withdraw_usd.available': '利用可能',
    'funds.withdraw_usd.bank_branch': '支店名',
    'funds.withdraw_usd.bank_info': '銀行情報',
    'funds.withdraw_usd.bank_name': '銀行名',
    'funds.withdrawals.add_new_address': '下記に新しい出金先アドレスを入力してください',
    'funds.withdrawals.add_whitelist_address': 'ホワイトリストのアドレスがありません。あなたのアドレスを{APP_NAME}で管理してください。',
    'funds.withdrawals.amount': '数量',
    'funds.withdrawals.available_balance': '利用可能残高',
    'funds.withdrawals.choice': '選択',
    'funds.withdrawals.no_data': '出金履歴がありません。',
    'funds.withdrawals.no_usd_data': 'USDの出金履歴がありません。',
    'funds.withdrawals.confirm_otp': 'OTPの確認',
    'funds.withdrawals.confirm_withdraw': '出金の確認',
    'funds.withdrawals.did_not_receive_the_mail': 'メールが受信できない場合',
    'funds.withdrawals.empty_whitelist.address_management': 'アドレス管理',
    'funds.withdrawals.empty_whitelist.text': 'ホワイトリストのアドレスがありません。',
    'funds.withdrawals.error_message.address_not_exist_in_whitelist': 'このアドレスはホワイトリストアドレスにありません。',
    'funds.withdrawals.error_message.amount_withdraw_is_positive': '出金数量は正数でなければなりません。',
    'funds.withdrawals.error_message.minimum_withdraw': 'あなたの出金は最小単位よりも少ないです。',
    'funds.withdrawals.error_message.not_enough_balance': '取引をするのに必要な残高がありません。',
    'funds.withdrawals.error_message.over_daily_limit': '1日あたりの限度額を出金しました。',
    'funds.withdrawals.error_message.over_limit': '限度額を出金しました。',
    'funds.withdrawals.error_message.over_one_time_limit': '1回あたりの限度額を超過出金しました。',
    'funds.withdrawals.error_message.withdraw_is_blocking': '出金がブロックされました。',
    'funds.withdrawals.errors.account_no_length': '無効な口座番号です。',
    'funds.withdrawals.errors.blockchain_address': '出金アドレスが無効です。',
    'funds.withdrawals.errors.exist_withdraw_address': 'このアドレスは既に存在しています。',
    "funds.withdrawals.errors.invalid": "The withdrawal address is not valid",
    'funds.withdrawals.errors.max_balance': 'ウォレットの残高が十分ではありません。',
    'funds.withdrawals.errors.max_once_amount': '出金金額が1回の最大数量を超えています。',
    'funds.withdrawals.errors.min_amount': '出金の最少額は{min_amount}です。',
    'funds.withdrawals.errors.not_allowed_withdraw': 'あなたのセキュリティレベルは出金することを許可されていません。',
    'funds.withdrawals.errors.otp_length_digits': 'Google認証コードは6桁でなければなりません。',
    'funds.withdrawals.errors.otp_length_6_digits': '認証コードは6桁でなければなりません。',
    'funds.withdrawals.errors.otp_required': '認証コードの入力は必須です。',
    'funds.withdrawals.errors.required': '入金の入力は必須です。',
    'funds.withdrawals.history': '履歴',
    'funds.withdrawals.important.text1': '重要',
    'funds.withdrawals.important.text2': '最少額の出金',
    'funds.withdrawals.important.text3': 'クラウドファウンディングやICOに対し当取引所から直接送金した場合、そこで購入したトークンの受け取りができなくなる恐れがございますので、ご遠慮ください。当社は当社以外からのトークン受け取りに関するトラブルについては、一切の責任を負いかねます。',
    'funds.withdrawals.in_order': '約定待ち',
    'funds.withdrawals.input_address_error': '無効なアドレス',
    'funds.withdrawals.loading': '処理中',
    'funds.withdrawals.submit': '提出',
    'funds.withdrawals.success_message': '取引作成は完了しました。',
    'funds.withdrawals.tips.text1': 'ご注意',
    'funds.withdrawals.tips.text2': '出金リクエストを送信した場合、確認メールが送られるので確認リンクをクリックしてください。',
    'funds.withdrawals.tips.text3': '入金した後は、<a style="color: #2e9bdb;font-weight: bold;" href="/funds/history-wallet?type=withdraw" target="_blank">history</a>ページで進捗状況を追跡できます。',
    'funds.withdrawals.title_page': 'コイン出金',
    "funds.withdrawals.title_chain_name": "Chain Name",
    'funds.withdrawals.tooltip': 'メールが見つからない場合は、迷惑メールや他のフォルダを確認してみてください。',
    'funds.withdrawals.total_balance': '合計残高',
    'funds.withdrawals.transaction_fee': '取引手数料',
    'funds.withdrawals.use_a_new_address': '新しいアドレスを使用',
    'funds.withdrawals.view_all': '全てを表示',
    'funds.withdrawals.what': ':nameは何ですか。',
    'funds.withdrawals.withdrawal_address': '出金アドレス',
    'funds.withdrawals.withdrawal_limit_24': '24時間出金制限',
    'funds.withdrawals.withdrawal_placeholder_address': 'アドレス',
    'funds.withdrawals.withdrawal_placeholder_available': '利用可能',
    'funds.withdrawals.withdrawal_placeholder_label': 'ラベル',
    'funds.withdrawals.xrp_tag': '出金タグ',
    'funds.withdrawals.you_will_get': '受け取る金額',
    'funds.disable_coin_msg': '本機能は無効になっていますのでアップグレードをお待ち下さい。',
    "funds.spot_esstimate": "Estimated Total Spot Balance",
    "funds.futures_esstimate": "Estimated Total Futures Balance",
    'landing.banner.desc': '資金効率の良いレバレッジ取引！<br>最大レバレッジ100倍なのでチャンスを逃しません。',
    'landing.banner.title.span': 'Smart Bitcoin -',
    'landing.banner.title.text': 'Smart Choice on Your Future ',
    "landing.banner.title.sub": "Buy, sell and market digital assets at exchange Sotatek",
    "landing.signup": "Sign up with Email or Phone",
    "landing.sub.button": 'or',
    "landing.log_in": "Log in and Start Trading",
    "landing.tab_Spot": "Spot",
  "landing.tab_Futures": "Futures",
    "landing.info_title": "Why Sotatek?",
    "landing.info_title_sub_high": "High Security",
    "landing.info_content_high": "We protect mobile users data as well as the web and use all security's best practices",
    "landing.info_title_sub_inter": "Intuitive Interface",
    "landing.info_content_inter": "Simple to use and quickly make the most critical actions for crypto: buy, transfer and trade.",
    "landing.info_title_sub_chat": "Chat Support",
    "landing.info_content_chat": "24/7 live chat support in the app will help you find a solution to your problems.",
    "landing.title_market": "Markets",
    "landing.content_market": "Crypto assets overview",
    "landing.title_spot": "Spot",
    "landing.content_spot": "A crypto market where you can buy and sell cryptocurrencies for immediate delivery with real-time price.",
    "landing.title_future": "Futures",
    "landing.content_future": "An agreement contract for you to own, with the power of buying or selling a specific cryptocurrency at a later date.",
    "landing.title_saving": "Saving",
    "landing.content_saving": "Earn a passive crypto income with your deposited cryptocurrencies.",
    "landing.title_staking": "Staking",
    "landing.content_staking": "Way to put your crypto to work and earn rewards on it.",
    "landing.title_copy": "Copytrade",
    "landing.content_copy": "Copy and get your profit.",
    "landing.title_market": "Markets",
    "landing.content_market": "Crypto assets overview",
    "landing.title_spot": "Spot",
    "landing.content_spot": "A crypto market where you can buy and sell cryptocurrencies for immediate delivery with real-time price.",
    "landing.title_future": "Futures",
    "landing.content_future": "An agreement contract for you to own, with the power of buying or selling a specific cryptocurrency at a later date.",
    "landing.title_saving": "Saving",
    "landing.content_saving": "Earn a passive crypto income with your deposited cryptocurrencies.",
    "landing.title_staking": "Staking",
    "landing.content_staking": "Way to put your crypto to work and earn rewards on it.",
    "landing.title_copy": "Copytrade",
    "landing.sub_info_1":"Trade Anywhere",
    'landing.change': '前日比',
    'landing.chart.change': '変更する',
    'landing.chart.last_price': '直近の価格',
    'landing.clients_download': 'ダウンロード',
    'landing.clients_text1': '{APP_NAME}を取得するその他の方法',
    'landing.clients_text2': '私たちはあなたが外出先で取引に必要ないくつかのツールを提供しています',
    'landing.coin': 'コイン',
    'landing.coin_markets': '{coin}マーケット',
    'landing.favorites': 'お気に入り',
    'landing.high': '高値',
    'landing.last_price': '直近の価格',
    'landing.low': '安値',
    'landing.pair': '取引ペア',
    'landing.price': '価格',
    'landing.register': '今すぐ登録',
    'landing.gotrade': '取引を行う',
    'landing.slogan': 'Exchange the World',
    'landing.volume': '24時間出来高',
    'landing.current_rate': '現在の<br/>レート',
    "landing.market.title": "Markets",
    "landing.title_volume" : "Top Volume Coin",
    "landing.title_listing" : "New Listing",
    "landing.title_gainer": "Top Gainer Coin",
    "landing.title_loser": "Top Loser Coin",
    "landing.title_Spot": "Spot",
    "landing.title_Futures": "Futures",
    "landing.title_Favorites": "Favorites",
    'login.active_device_failed': '認証リンクが無効または期限切れです。',
    'login.active_device_success': '新しいデバイスの認証に成功しました。<br/>もう一度ログインしてみてください。<p></p><p style="color: #12575f; font-size:14px">Device: <strong style="font-family :"Roboto-Bold", sans-serif">:platform :operating_system</strong></p><p style="color: #12575f; font-size:14px">IP address: <strong style="font-family :"Roboto-Bold", sans-serif">:latest_ip_address</strong> </p>',
    'login.confirm_failed': '確認リンクが無効または期限切れです。',
    'login.confirm_email_failed': 'そのメールアドレスを持つユーザーが見つかりません。',
    'login.confirm_success': 'メールアドレスが確認されました。',
    'login.dont_has_account': 'アカウントを登録しますか。',
    'login.forgot': 'ログインパスワードをお忘れですか',
    'login.sub_title': '訪れているサイトが下記URLで正しいことを確認してください。',
    'login.title': 'ログイン',
    'login.title_otp': 'Google認証システム',
    'login.resend_confirm_mail_success': '<strong title=":email">:email</strong>に確認メールを再送信しました',
    'm_account.btn_continue': 'わかりました。続けます。',
    'm_account.change_pass': 'パスワード変更',
    'm_account.gg_auth': 'Google認証システム',
    'm_account.go_pc': 'Google認証システムの設定を完了するには、{APP_NAME}にアクセスしてください。',
    'm_account.id': 'ID',
    'm_account.identity_auth': '識別認証',
    'm_account.language': '言語',
    'm_account.logout': 'ログアウト',
    'm_account.lv': 'Lv',
    'm_account.referral.commission': '発生した報酬',
    'm_account.referral.commission_rate': '発生報酬%：',
    'm_account.referral.count': 'No.',
    'm_account.referral.detail': 'プログラム詳細',
    'm_account.referral.detail_notice': '{APP_NAME}は、市況の変化、詐欺のリスク、または当社が関連すると判断したその他の要因により紹介プログラムの条件を変更する権利を有します。',
    'm_account.referral.estimate': '予想報酬額',
    'm_account.referral.get_link': '1.リンクを取得する',
    'm_account.referral.info_get_link': '紹介リンクとQRコードの確認',
    'm_account.referral.info_invite': '紹介リンクもしくは、QRコード経由で登録した友達が取引を行うことで報酬を受け取ることができます。',
    'm_account.referral.info_reward': 'リアルタイムで最大40％の報酬を受け取ることができます。',
    'm_account.referral.invite': '2.友達を招待',
    'm_account.referral.line1': '2018/05/19 0:00 AM (UTC)現在有効',
    'm_account.referral.line2': '紹介プログラムから受け取る報酬は、最初は20％に設定されます。{100}人以上の友人を紹介したカウントの場合、この割合は40％に増加します。',
    'm_account.referral.line3': '紹介されたユーザーが有効な取引をすると、手数料一部がリアルタイムであなたの{APP_NAME}アカウントに反映されます。',
    'm_account.referral.line4': 'あなたが紹介できる友達の数に制限はありませんが、紹介プログラムの規約は運営チームが調整または変更できる権利を有します。',
    'm_account.referral.line5': '紹介される人はあなたの紹介リンク、QRコードまたは紹介IDを通してサインアップしなければなりません。',
    'm_account.referral.line6': '{APP_NAME}は重複登録や偽アカウントによる不正登録をチェックし、これらのアカウントに紹介料を支払いません。重複または共有された情報がある場合は失格になります。',
    'm_account.referral.my_referral': 'MYリファラル',
    'm_account.referral.notice': '* 重要なお知らせ：',
    'm_account.referral.referral_friend': '紹介した友達',
    'm_account.referral.referral_id': 'MYリファラルID：',
    'm_account.referral.referral_link': 'リファラルリンク：',
    'm_account.referral.reward': '3.報酬を獲得',
    'm_account.referral.text29': '友達を招待する時はQRコードスキャンしてもらい報酬を獲得してください。',
    'm_account.referral.title': '紹介プログラム',
    'm_account.title': '{APP_NAME}のカスタマーサポートを含め、Google認証コードは誰にも開示しないでください。',
    'm_account.title_identity': '関連する設定を完了するには、{APP_NAME} のWebサイト（www.mango.com）にアクセスしてください。',
    'm_account.unverified': '未承認',
    'm_account.verified': '承認済み',
    'm_common.action.cancel': 'キャンセルする',
    'm_common.action.confirm': '確認する',
    'm_common.action.more': 'もっと見る',
    'm_common.action.off': 'OFF',
    'm_common.action.on': 'ON',
    'm_common.time.hour': '{number}時間',
    'm_common.time.hours': '{number}時間',
    'm_common.time.label_minute': '分',
    'm_common.time.minute': ':number分間',
    'm_common.time.minutes': ':number分間',
    'm_exchange.chart.amount': '数量',
    'm_exchange.chart.buy': '買',
    'm_exchange.chart.candle': 'ローソク足',
    'm_exchange.chart.charts': 'チャート',
    'm_exchange.chart.depth': 'デプス',
    'm_exchange.chart.high': '高',
    'm_exchange.chart.low': '低',
    'm_exchange.chart.market_trade_history': 'マーケットの取引履歴',
    'm_exchange.chart.price': '価格',
    'm_exchange.chart.sell': '売',
    'm_exchange.chart.time': '日時',
    'm_exchange.chart.trade_detail': '取引詳細',
    'm_exchange.chart.trade_history': '取引履歴',
    'm_exchange.chart.volume': 'Vol',
    'm_exchange.open_order.open_order': '注文一覧',
    'm_exchange.trade.available': '利用可能',
    'm_exchange.trade.buy': '買',
    'm_exchange.trade.sell': '売',
    'm_exchange.trade.trade': '取引',
    'm_funds.coin_info.available': '利用可能',
    'm_funds.coin_info.deposit': 'コイン入金',
    'm_funds.coin_info.estimate': '予測',
    'm_funds.coin_info.go_to_trade': '取引を行う',
    'm_funds.coin_info.in_order': '約定待ち',
    'm_funds.coin_info.total': '合計',
    'm_funds.coin_info.withdraw': '出金',
    'm_funds.current': '現在',
    'm_funds.deposit.save_qr_code': 'QRコードの保存',
    'm_funds.deposit.select_coin': 'コインを選択',
    'm_funds.deposit_usd.available_balance': '利用可能残高',
    'm_funds.deposit_usd.deposit_amount': '入金額',
    'm_funds.deposit_usd.deposit_usd_tab': 'USD入金',
    'm_funds.deposit_usd.errors.required': '入金の入力は必須です。',
    'm_funds.deposit_usd.guide.text1': '1.入金数量と同じく送金してください。',
    'm_funds.deposit_usd.guide.text10': '4.支払いが遅れる場合は、弊社のカスタマーサポートにご連絡ください。',
    'm_funds.deposit_usd.guide.text11': '必要な入金数量と振込数量が異なる場合、または入金コードを入力し忘れた場合は、サポートセンターにリクエストを送信してください。',
    'm_funds.deposit_usd.guide.text12': '※銀行システムのチェックイン期間中は、出金が制限されます。',
    'm_funds.deposit_usd.guide.text2': '・入金数量が実際の入金数量と異なる場合、入金は処理されません。',
    'm_funds.deposit_usd.guide.text3': '2.必ず「入金コード」を入力してください。',
    'm_funds.deposit_usd.guide.text4': '・入金するときは、転送内容として入金コードを入力してください。転送内容として入金コードのみを使用し、それ以外は使用しないでください。入金コードを入力しないと、入金処理が遅れることがあります。',
    'm_funds.deposit_usd.guide.text7': '3.入金は最大10分以内に処理されます。',
    'm_funds.deposit_usd.guide.text8': '・通常の状況では、入金を処理するために約3〜5分かかります。',
    'm_funds.deposit_usd.guide.text9': '入金が処理されたら、あなたに通知します。',
    'm_funds.deposit_usd.history_tab': '履歴',
    'm_funds.deposit_usd.in_order': '約定待ち',
    'm_funds.deposit_usd.notes': 'ご注意',
    'm_funds.deposit_usd.submit_deposit_usd': '提出',
    'm_funds.deposit_usd.total_balance': '合計残高',
    'm_funds.deposit_usd.transaction_history_table.cancel': 'キャンセルする',
    'm_funds.deposit_usd.transaction_history_table.no': 'No',
    'm_funds.deposit_usd.transaction_history_table.text1': 'キャンセルしてよろしいですか？',
    'm_funds.deposit_usd.transaction_history_table.yes': 'はい',
    'm_funds.transaction_history.deposit_history': '入金履歴',
    'm_funds.transaction_history.no_deposit_history': '入金履歴がありません。',
    'm_funds.transaction_history.no_withdraw_history': '出金履歴がありません。',
    'm_funds.transaction_history.withdraw_history': '出金履歴',
    'm_funds.withdraw_usd.history_tab': '履歴',
    'm_funds.withdraw_usd.limit_and_notice': '制限 & 通知',
    'm_funds.withdraw_usd.withdraw_usd_tab': 'USD出金',
    'm_funds.withdrawals.but_withdraw': '出金',
    'm_funds.withdrawals.but_withdrawal': '出金',
    'm_funds.withdrawals.errors.required': 'この項目の入力は必須です。',
    'm_funds.withdrawals.fee': '手数料',
    'm_funds.withdrawals.limit_and_notice': '指値&通知',
    'm_funds.withdrawals.limit_and_notice_modal.in_use': '使用中',
    'm_funds.withdrawals.limit_and_notice_modal.title': '指値&通知',
    'm_funds.withdrawals.limit_and_notice_modal.withdrawal_limit_24': '24時間出金制限',
    'm_funds.withdrawals.notes': '<span>最少額の出金: {min} {coin}</span>',
    'm_funds.withdrawals.notes2': 'クラウド ファウンディングやICOに対し当取引所から直接送金した場合、そこで購入したトークンの受け取りができなくなる恐れがございますので、ご遠慮ください。当社は当社以外からのトークン受け取りに関するトラブルについては、一切の責任を負いかねます。',
    'm_funds.withdrawals.notes3': '出金要求を送信された場合、確認メールが送られますので確認リンクをクリックしてください。',
    'm_funds.withdrawals.select_coin': 'コインを選択',
    'm_funds.withdrawals.withdrawal_amount': '出金額',
    'm_landing.change_24h': '前日比',
    'm_landing.deposit': 'コイン入金',
    'm_landing.gainers': '利益者',
    'm_landing.losers': '損失者',
    'm_landing.more': 'もっと見る',
    'm_landing.support': 'サポート',
    'm_landing.top24btc': 'BTCの24時間出来高トップ',
    'm_landing.withdraw': '出金',
    'm_menu.deposits': '入金',
    'm_menu.home': 'ホーム',
    'm_menu.language': '言語',
    'm_menu.markets': 'マーケット',
    'm_order_history.avg': '平均',
    'm_order_history.conditions': '条件',
    'm_order_history.more': 'もっと見る',
    'm_order_history.trade_detail': '取引詳細',
    'm_order_history.trading_price': '取引価格',
    'm_pair_navigation.change_24h': '前日比',
    'm_pair_navigation.last_price': '直近の価格',
    'm_pair_navigation.name': '氏名',
    'm_pair_navigation.vol': 'Vol',
    'm_salespoint.buy_history': '購入履歴',
    'm_margin.trade_history': '取引履歴',
    'm_margin.order_history': '注文履歴',
    'm_margin.contracts': '契約',
    'menu.about': '基本情報',
    'menu.account': '数量',
    "menu.preferences": 'Preferences',
    "menu.notifications": 'Notifications',
    "menu.notification_language": 'Notification Language',
    "menu.sub_notification_language": 'Email and app push notification language settings.',
    "menu.onsite_notification": 'On-site Notifications',
    "menu.sub_onsite_notification": 'Once enabled, you will receive relevant notifications within the app and website.',
    "menu.maket_email": "Marketing Emails",
    "menu.sub_maket_email": "Select whether you want to receive marketing emails from us.",
    "menu.default": 'Default',
    "menu.activities_trade": 'Activities,Trade Notification, System Messages',
    "menu.on": 'On',
    "menu.kyc_status": "KYC Status",
    "menu.kyc_status_verified": "Verified",
    "menu.kyc_status_unverified": "Unverified",
    'menu.address': 'アドレス管理',
    'menu.api': 'API',
    'menu.apply_to_list': 'リストへ追加',
    'menu.balances': '残高',
    'menu.change_password': 'パスワード変更',
    'menu.contact': 'お問い合わせ',
    'menu.demo': 'デモ',
    'menu.deposit_usd': 'USD入金',
    'menu.deposits': '入金',
    'menu.estimated_value': '総資産(BTC換算)',
    'menu.exchange': '取引所',
    'menu.fees': '取引手数料',
    'menu.funds': '資産',
    'menu.history': '履歴',
    'menu.history_title': '履歴',
    'menu.info': '情報',
    'menu.join_us': 'Join us',
    'menu.margin_exchange': 'レバレッジ取引所',
    'menu.lang.en': '英語',
    'menu.lang.ja': '日本語',
    'menu.lang.vis': 'Visayan',
    'menu.lang.il': 'Ilocano',
    'menu.lang.tl': 'Tagalog',
    'menu.login': 'ログイン',
    'menu.logout': 'ログアウト',
    'menu.news': '最新情報',
    'menu.one_day': '1日',
    'menu.one_month': '1月',
    'menu.one_week': '1週',
    'menu.open_orders': '注文一覧',
    'menu.or': 'or',
    'menu.order_history': '注文履歴',
    'menu.privacy': 'プライバシーポリシー',
    'menu.register': '登録',
    'menu.sales_point': '販売所',
    'menu.support': 'サポート',
    'menu.support_withdrawal': '出金ガイド',
    'menu.spot_exchange': '現物取引所',
    'menu.terms': '利用規約',
    'menu.three_months': '3月',
    'menu.trade_history': '取引履歴',
    'menu.transaction_history': '入出金履歴',
    'menu.wallet': 'ウォレット',
    'menu.withdraw_usd': 'USD출금',
    'menu.withdrawals': 'コイン出金',
    "menu.off": 'Off',
    "security.2fa": "Two-Factor Authentication (2FA)",
    "security.google_authenticator": "Google Authenticator",
    "security.sub_google_authenticator": "Protect your account and transactions",
    "security.addvanced_security": "Advanced Security",
    "security.change_password": "Change Password",
    "security.phone_number": "Phone Number",
    "security.sub_change_password": "Login password is used to log in to your account",
    "security.withdrawal_whitelist": "Withdrawal Whitelist",
    "security.sub_withdrawal_whitelist": "Once this function is enabled, your account will only be able to withdraw to addresses on your whitelist",
    "security.address_management": "Address Management",
    "security.anti_phishing_code": "Anti-Phishing Code",
    "security.sub_anti_phishing_code": "Protect your account from phishing attempts and ensure that your notification emails are from Sotatek only",
    "security.sub_phone_number": "Use your phone number to protect your account and transactions.",
    "security.devices_activities": "Devices and Activities",
    "security.device_management": "Device Management",
    "security.sub_device_management": "Manage devices allowed to access your acoount.",
    "security.account_activity": "Account Activity",
    "security.manage": "Manage",
    "security.more": "More",
    'messages.error.balance_insufficient': '残高が足りません。',
    'messages.error.buy.empty_base_price': '買い注文ストップ価格を入力してください。',
    'messages.error.buy.empty_limit': '買い注文指値の価格を入力してください。',
    'messages.error.buy.empty_price': '買い注文の価格を入力してください。',
    'messages.error.buy.empty_quantity': '買い注文の数量を入力してください。',
    'messages.error.empty_total': '合計の入力は必須です。',
    'messages.error.minimum_base_price': 'ストップ価格は、{minimum}以上でなければなりません。',
    'messages.error.minimum_limit': '指値価格は、{minimum}以上でなければなりません。',
    'messages.error.minimum_price': '価格は、{minimum}以上でなければなりません。',
    'messages.error.minimum_quantity': '数量は、{minimum}以上でなければなりません。',
    'messages.error.minimum_quantity_convert': '{underlying_asset} amount must be higher than {minimum}.',
    'messages.error.minimum_total': '合計は、{minimum}以上でなければなりません。',
    'messages.error.minimum_total_convert': '{quote_asset} amount must be higher than {minimum}.',
    'messages.error.sell.empty_base_price': '売り注文ストップ価格を入力してください。',
    'messages.error.sell.empty_limit': '売り注文指値の価格を入力してください。',
    'messages.error.sell.empty_price': '売り注文の価格を入力してください。',
    'messages.error.sell.empty_quantity': '売り注文の数量を入力してください。',
    'messages.insufficient_balance': '残高は十分ではありません。',
    'messages.error.balance_insufficient1': '残高が足りません。取引口座にコインを振替えて下さい。',
    'messages.error.balance_insufficient_convert': 'Your balance is insufficient. Please check again',
    'enable_trading.validation.insufficient_balance': '残高が足りません。取引口座にコインを振替えて下さい。',
    'messages.send_contact_success': 'メールが送信されました。メールが送信されました。',
    'messages.send_contact_wrong_data': 'データが正しくありません。',
    'messages.sesstion_terminated': '他のデバイスまたはブラウザからこのアカウントにログインしたため、現在のセッションは終了します。',
    'messages.successful_login': '{APP_NAME}ログイン:email\r\n :deviceからログイン\r\n:time',
    'messages.unauthorize': '非承認',
    'messages.your_otp_code': '認証コードは{otp}です。',
    'messages.disable_coin_msg': '本機能は無効になっていますのでアップグレードをお待ち下さい。',
    'modal_trading_pair_information.amount_limit': '数量制限',
    'modal_trading_pair_information.btn_cancel': 'キャンセル',
    'modal_trading_pair_information.btn_submit': '提出する',
    'modal_trading_pair_information.day': '日',
    'modal_trading_pair_information.days': '日',
    'modal_trading_pair_information.fee': '手数料',
    'modal_trading_pair_information.market_price': '相場',
    'modal_trading_pair_information.minimum_amount': 'Amount Precision',
    'modal_trading_pair_information.minimum_total': 'Total Precision',
    'modal_trading_pair_information.pair': 'ペア',
    'modal_trading_pair_information.popup_title': '取引ペア情報',
    'modal_trading_pair_information.precision': 'Price Precision',
    'modal_trading_pair_information.time_reset': '時間リセット',
    'modal_trading_pair_information.total_limit': '合計制限',
    'modal_trading_pair_information.trading_fee': '取引手数料',
    'modal_trading_pair_information.trading_limit': '取引制限',
    'modal_trading_pair_information.trading_pair': '取引ペア',
    'order.open_order.no_data': '現在注文はありません。',
    'order.open_order.no_data.all': '注文はありません。',
    "order.open_order.no_data.all_sub_message":"You currently have no open orders to cancel",
    'order.open_order.no_data.limit': '指値注文はありません。',
    "order.open_order.no_data.limit_sub_message":"You currently have no open limit orders to cancel",
    'order.open_order.no_data.stop_limit': 'ストップ指値注文はありません。',
    "order.open_order.no_data.stop_limit_sub_message": "You currently have no open stop limit orders to cancel",
    'order.open_order.no_data.market': '成行注文はありません。',
    "order.open_order.no_data.market_sub_message":"You currently have no open market orders to cancel",
    'order.open_order.no_data.stop_market': 'ストップ成行注文はありません。',
    "order.open_order.no_data.stop_market_sub_message":"You currently have no open stop market orders to cancel",
    'order.open_order.action': 'アクション',
    'order.open_order.amount': '数量',
    'order.open_order.cancel': 'キャンセルする',
    'order.open_order.cancel_all': 'すべてをキャンセル',
    'order.open_order.cancel_all_message': '全ての注文を取り消しますか？',
    "order.open_order.cancel_all_title":"Cancel All Orders",
    'order.open_order.cancel_limit_orders': '指値注文のキャンセル',
    'order.open_order.cancel_market_orders': '成行注文のキャンセル',
    'order.open_order.cancel_stop_market_orders': 'ストップ成行注文のキャンセル',
    'order.open_order.cancel_stop_limit_orders': 'ストップ指値注文のキャンセル',
    'order.open_order.cancel_limit_price_message': '全ての指値注文を取り消しますか？',
    "order.open_order.cancel_limid_price_title": "Once you confirm, all open stop limit orders will be cancelled",
    'order.open_order.cancel_one_message': 'この注文を取り消しますか？',
    "order.open_order.cancel_one_title": "Cancel order?",
    'order.open_order.cancel_order_success': '注文はキャンセルされました。',
    'order.open_order.match_order_success': '注文は約定しました。',
    'order.open_order.cancel_orders_success': '注文はキャンセルされました。',
    'order.open_order.cancel_stop_limit_order': 'ストップ指値注文のキャンセル',
    'order.open_order.cancel_stop_limit_price_message': '全てのストップ指値注文を取り消しますか？',
    "order.open_order.cancel_stop_limit_price_message":
    "Once you confirm, all open stop limit orders will be cancelled",
  "order.open_order.cancel_stop_limit_price_title": "Cancel All Stop Limit Orders",
  "order.open_order.cancel_limit_order_title":"Cancel All Limit Orders",
  "order.open_order.cancel_limit_order_message":"Once you confirm, all open limit orders will be cancelled",
  "order.open_order.cancel_market_orders_title": "Cancel All Market Orders",
  "order.open_order.cancel_market_orders_message": "Once you confirm, all open market orders will be cancelled",
  "order.open_order.cancel_stop_market_orders_title": "Cancel All Stop Market Orders",
  "order.open_order.cancel_stop_market_orders_message": "Once you confirm, all open stop market orders will be cancelled",
  "order.open_order.cancel_stop_market_order": "Cancel Stop Market Order",
  "order.open_order.cancel_stop_market_price_message": "Do you want to cancel all Stop Market Orders?",
    'order.open_order.cancel_stop_market_order': 'ストップ成行注文のキャンセル',
    'order.open_order.cancel_stop_market_price_message': '全てのストップ成行注文を取り消しますか？',

  "order.open_order.cancel_stop_market_price_title":"Cancel All Market Orders",
    'order.open_order.date': '日付',
    'order.open_order.deposit': 'コイン入金',
    'order.open_order.empty_open_order': '現在出されている注文はありません',
    'order.open_order.filled': '約定',
    'order.open_order.hide_other_pairs': '他のペアを非表示にする',
    'order.open_order.hide_small_assets': '少額資産の非表示',
    'order.open_order.infomation': '情報',
    'order.open_order.limit_order': '指値注文',
    'order.open_order.market': '成行注文',
    'order.open_order.open_order': '注文一覧',
    'order.open_order.pair': 'ペア',
    'order.open_order.price': '価格',
    'order.open_order.side': '方向',
    "order.open_order.exec_type": "Exec Type",
    "trade.exec_type_sell" : "Trading",
    "trade.exec_type_buy" : "Trading",
    "trade.exec_type_trading" : "Trading",
    "trade.exec_type_funding" : "Funding",
    'order.open_order.stop_limit_order': 'ストップ指値注文',
    'order.open_order.total': '合計',
    'order.open_order.trigger_conditions': 'トリガー条件',
    'order.open_order.type': '種別',
    'order.open_order.withdrawal': '出金',
    'order.open_order.withdrawal_limit_24': '24時間出金制限',
    'order.order_book.amount': '数量',
    'order.order_book.decimals': '小数桁',
    'order.order_book.orderBook': 'Order Book',
    'order.order_book.price': '価格',
    'order.order_book.total': '合計',
    'order.order_form.amount': '数量',
    'order.order_form.balance': '{param}残高',
    'order.order_form.buy': '買',
    'order.order_form.limit': '指値注文',
    'order.order_form.market': 'マーケット',
    'order.order_form.stop_limit': 'ストップ指値注文',
    'order.order_form.stop_market': 'ストップ成行注文',
    'order.order_form.limited_price': '指値',
    'order.order_form.login': 'ログイン',
    'order.order_form.or': 'or',
    'order.order_form.price': '価格',
    'order.order_form.register': '登録',
    'order.order_form.sell': '売',
    'order.order_form.stop': 'ストップ',
    'order.order_form.stop_limit_tooltip': 'ストップ指値注文は、価格が指定されたトリガー価格に達すると、その価格で指値注文を出す注文方法です。',
    'order.order_form.stop_market_tooltip': 'ストップ成行注文は、価格が指定されたトリガー価格に達すると、その価格で成行注文を出す注文方法です。',
    'order.order_form.success': '{trade_type}注文作成が完了しました!',
    'order.order_form.total': '合計',
    "order.order_form.trade": "to start trading",
    'order.order_form.limit_tooltip': 'Limit order<br>' +
        '                To buy or sell a coin once the\n' +
        '                price reaches a specified price.',
    'order.order_form.market_tooltip': 'Market order<br> Immediately matched to the best available market price.',
    'order.order_form.view_more': 'もっと見る',
    'order.order_form.available': 'Available',
    'circuit_breaker.blocking': 'この取引ペアは制限されています。',
    'circuit_breaker.unblocking': 'この取引ペアは制限されていません。',
    'circuit_breaker.remain_second_text': 'サーキットブレーカーによって取引が制限されています。 {分}分で制限の解除をします。',
    'beta_tester.header': 'β版テスター参加希望',
    'beta_tester.content': '当バージョンはベータ版となります。<br>ベータ版の利用を希望するユーザーは以下の内容を確認しチェックボックスにチェックを入れ管理者に申請をしてください。<br>※ベータ版のため一部機能に不具合が出る可能性があります。不具合を見つけた場合、管理人に直ちに報告ください。<br><a href ="mailto: kim@demo.io">kim@demo.io</a>',
    'beta_tester.dont_show_again': '今後表示しない',
    'beta_tester.ignore_tester': 'テスターを無視',
    'beta_tester.agree_term': '弊社の利用規約を同意してください！\r\n',
    'beta_tester.ok': 'OK',
    'beta_tester.or': 'または',
    'beta_tester.cancel': 'キャンセルする',
    'beta_tester.validate.agree_term': '利用規約に同意してください',
    'beta_tester.register_success': 'ベータテスターへ登録の成功',
    'beta_tester.register_fail': 'ベータテスターへ登録の失敗',
    'beta_tester.disable_by_beta_tester': '取引するためにはベータテスターになってください',
    'beta_tester.wait_admin_verify.header': '管理者の承認待ち',
    'beta_tester.wait_admin_verify.content': '管理者によるベータテスターの認証をお待ちください。',
    'order.order_history.action': 'アクション',
    'order.order_history.no_data': '注文履歴がありません。',
    'order.order_history.all': 'すべて',
    'order.order_history.amount': '数量',
    'order.order_history.average': '平均',
    'order.order_history.buy': '買',
    'order.order_history.cancel': 'キャンセルする',
    'order.order_history.cancel_all': 'すべてをキャンセル',
    'order.order_history.coin': 'コイン',
    'order.order_history.date': '日付',
    "order.order_history.date_to": "To",
    'order.order_history.deposit': 'コイン入金',
    'order.order_history.empty_order_history': '注文履歴がありません。',
    'order.order_history.export_complete_order_history': '注文履歴をダウンロード',
    'order.order_history.export_complete_order_history_tooltip': '6ヶ月分の注文履歴をダウンロード',
    'order.order_history.export_complete_trade_history': '取引履歴をダウンロード',
    'order.order_history.export_complete_trade_history_tooltip': '6ヶ月分の取引履歴をダウンロード',
    'order.order_history.fee': '手数料',
    'order.order_history.filled': '約定',
    'order.order_history.hide_all_canceled': '全てのキャンセルを非表示にする',
    'order.order_history.infomation': '情報',
    'order.order_history.limit_order': '指値注文',
    'order.order_history.market': 'マーケット',
    'order.order_history.order_history': '注文履歴',
    'order.order_history.pair': 'ペア',
    'order.order_history.price': '価格',
    'order.order_history.reset': 'リセット',
    'order.order_history.search': '検索',
    'order.order_history.sell': '売',
    'order.order_history.side': 'サイド',
    'order.order_history.status': 'ステータス',
    'order.order_history.stop_limit_order': 'ストップ指値注文',
    'order.order_history.total': '合計',
    'order.order_history.trigger_conditions': 'トリガー条件',
    'order.order_history.type': '種別',
    'order.order_history.withdrawal': '出金',
    'order.order_history.withdrawal_limit_24': '24時間出金制限',
    'order.order_trade_form.order': '注文',
    'order.order_trade_form.trades': '取引',
    "order.order_trade_form.price": "価格",
    "order.order_trade_form.size": "サイズ",
    "order.order_trade_form.time": "時間",
    'order.recent_trades.market': 'マーケット',
    'order.recent_trades.recent_trades': '最近の取引',
    'order.recent_trades.yours': 'あなたの',
    'order.trade_history.action': 'アクション',
    'order.trade_history.no_data': '取引履歴がありません。',
    'order.trade_history.all': 'すべて',
    'order.trade_history.amount': '数量',
    'order.trade_history.average': '平均',
    'order.trade_history.buy': '買',
    'order.trade_history.cancel': 'キャンセルする',
    'order.trade_history.cancel_all': 'すべてをキャンセル',
    'order.trade_history.coin': 'コイン',
    'order.trade_history.date': '日付',
    'order.trade_history.deposit': 'コイン入金',
    'order.trade_history.export_complete_trade_history': '取引履歴をエクスポート',
    'order.trade_history.fee': '手数料',
    'order.trade_history.filled': '約定',
    'order.trade_history.hide_all_canceled': '全てのキャンセルを隠す',
    'order.trade_history.infomation': '情報',
    'order.trade_history.limit_order': '指値注文',
    'order.trade_history.market': 'マーケット',
    'order.trade_history.my_history': '私の注文履歴',
    'order.trade_history.pair': 'ペア',
    'order.trade_history.price': '価格',
    'order.trade_history.reset': 'リセット',
    'order.trade_history.search': '検索',
    'order.trade_history.sell': '売',
    'order.trade_history.side': 'サイド',
    'order.trade_history.status': 'ステータス',
    'order.trade_history.stop_limit_order': 'ストップ指値注文',
    'order.trade_history.total': '合計',
    'order.trade_history.trade_history': '取引履歴',
    'order.trade_history.trigger_conditions': 'トリガー条件',
    'order.trade_history.type': '種別',
    'order.trade_history.withdrawal': '出金',
    'order.trade_history.withdrawal_limit_24': '24時間出金制限',
    'order_mobile.charts': 'チャート',
    'order_mobile.group': 'グループ',
    'order_mobile.max_amount': '最大数量',
    'order_mobile.open_order': '注文一覧',
    'order_mobile.total': '合計',
    'order_mobile.trade': '取引',
    'passwords.password': 'パスワードは6文字以上で確認用パスワードと一致する必要があります。',
    'passwords.reset': 'パスワードが再設定されました。ログインできます。',
    'passwords.sent': 'パスワード再設定リンクをメールで送信しました。',
    'passwords.token': 'このパスワード再設定トークンは無効です。',
    'passwords.user': 'そのメールアドレスを持つユーザーが見つかりません。',
    'refferal.alert': 'ログインしていません。ログインしてあなたの友達とシェアしてください。',
    'refferal.alert_bank_account_content': 'NI Bank口座確認の前に<span style="color: #f29600;">KYC</span>を提出してください。銀行口座の確認には、あなたのKYC情報を使います。',
    'refferal.confirm_bank_account_content': 'NI Bank口座をまだ持っていません。口座を開設してください。',
    'refferal.confirm_bank_account_title': 'KYC情報を使用して、NI BankのUSD出金を確認しますか？',
    'refferal.get_rewards': '報酬を獲得',
    'refferal.login': 'ログイン',
    'refferal.not_on_site': '{APP_NAME}にまだありません。',
    'refferal.register': '登録',
    'refferal.copy_link': 'リンクをコピー',
    'refferal.text1': 'リファラルリンクとQRコードの確認',
    'refferal.text10': '紹介した友達',
    'refferal.text11': '日付',
    'refferal.text12': 'プログラム詳細',
    'refferal.text13': '{effectTime}(UTC)現在有効',
    'refferal.text14': '紹介プログラムから受け取る報酬は最初は20％に設定されます。100人以上紹介したアカウントの場合、この割合は40％に増加します。',
    'refferal.text15': '紹介される人が取引を完了すると、手数料が即座にあなたの{APP_NAME}アカウントに送付され、元の手数料が支払われたトークン/暗号通貨で支払われます。',
    'refferal.text16': 'あなたが紹介できる友達の数に制限はありませんが、紹介プログラムの規約は運営側がいつでも調整または変更できる権利を有します。',
    'refferal.text18': '紹介される人はあなたの紹介リンク、QRコードまたは紹介IDを通してサインアップしなければなりません。',
    'refferal.text19': '{APP_NAME}は重複登録や偽アカウントによる不正登録をチェックし、これらのアカウントに紹介料を支払いません。重複または共有された情報がある場合は失格になります。',
    'refferal.text2': '友達を招待する',
    'refferal.text20': '* 重要なお知らせ：',
    'refferal.text21': '{APP_NAME}は、市況の変化、詐欺のリスク、または当社が関連すると判断したその他の要因により、いつでも紹介プログラムの条件を変更する権利を有します。',
    'refferal.text22': '発生報酬',
    'refferal.text23': '<br/>発生報酬',
    'refferal.text60': '報酬額<br/> Margin Exchange',
    'refferal.text24': '報酬履歴',
    'refferal.text25': 'コピーしました。',
    'refferal.text26': '出力',
    'refferal.text3': '紹介リンクもしくは、QRコード経由で登録した友達が取引を行うと報酬を受け取ることができる',
    'refferal.text4': '報酬を貰う',
    'refferal.text5': 'リアルタイムで最大{value}％の報酬を受け取ることができます。',
    'refferal.text6': 'MY紹介者ID',
    'refferal.text7': '発生報酬%：',
    'refferal.text8': '紹介リンク',
    'refferal.text9': '共有：',
    'refferal.title': '紹介プログラム',
    'refferal.title1': 'リンクを取得する',
    'refferal.top': 'No.',
    'register.error_terms': '利用規約同意の入力は必須です。',
    'register.has_account': 'すでにアカウントをお持ちの場合',
    'register.sub_title': 'アカウントを登録する',
    'register.success': '<span>おめでとうございます。 </span><strong>:email</strong> <p>メールボックスをチェックしてアカウントを確認してください。</p>',
    'register.terms_1': '利用規約に同意します。',
    'register.terms_2': '条項',
    'register.title': '登録',
    'register.sendConfirmEmail': '確認メールを送信',
    'register.congratulation': 'Congratulation',
    'reset_passsword_complete': 'パスワード再設定は完了しました。',
    'reset_password.resetted_password': 'パスワードが再設定されました。これでログインできます。',
    'reset_password.send_mail_title': 'パスワード再設定メールを送信',
    'reset_password.send_mail_title_2': 'パスワード再設定メールが送信されました。',
    'reset_password.sent_mail': '<strong style="line-height:25px;color: #333;font-size:16px;font-weight:400 ">登録したメールアドレスにパスワード再設定メールが送信されました。</strong> <br> メールの指示に従って、受信してから24時間以内にパスワードを再設定してください。',
    'reset_password.sent_mail_2': 'メール受信後の24時間以内にURLにアクセスし、パスワードを再設定ください。',
    'reset_password.sub_title_1': 'メールアドレスを入力してください。',
    'reset_password.sub_title_2': '新しいパスワードを入力してください。',
    'reset_password.submit_btn': '提出',
    'reset_password.back_to': 'Back to',
    'reset_password.title': 'パスワード再設定',
    'reset_password.title_forgot': 'パスワードをお忘れの方',
    'policy.title': 'OG Exchangeプライバシーポリシー',
    'policy.last_revised': '[Last revised: 24 May 2018]',
    'policy.content_general': 'このプライバシーポリシーは、OG Exchange LLC（「OG Exchange」）が<a href="{APP_URL}">{APP_HOST}</a>  Webサイトから取得したユーザー情報を収集、使用、共有、および保護する方法について説明します。 「私たち」、および「私たちの」という用語は、OG Exchangeおよびその関連会社を指します。 ユーザーに特定の個人情報を要求するのは、法律でこの情報を収集することが義務付けられているか、特定の目的に関連しているためです。お客様が当社に提供する必要のない情報は、任意で提供されます。これらの情報を提供するかどうかを選択しない場合、すべてのサービスにアクセスまたは利用できない場合があります。<br>サイトを使用することにより、お客様はこのプライバシーポリシーに記載されているデータの取り扱いに同意するものとします。場合によっては、法律または個人データの収集および使用慣行の変更を反映するために、OG Exchangeはこのプライバシーポリシーを改訂することがあります。このプライバシーポリシーに重大な変更が加えられた場合、その変更はサイトに投稿することで発表されます。このプライバシーポリシーに記載されていない目的で情報を使用する場合は使用前に、お客様の同意を求めます。',
    'policy.information_amanpuri_collects': '・保管する情報の種類',
    'policy.information_amanpuri_collects_intro': 'OG Exchangeのサービスに登録して使用するときに収集する情報の種類をについて',
    'policy.information_amanpuri_collects_content': '・登録時に当社に提供する情報<br>OG Exchangeアカウントを作成すると、連絡先情報（電子メールアドレス、名前、パスワード）を含む個人情報が提供されます。<br>・ユーザーIDの認証時に収集する情報<br>Anti-Money Laundering（AML）、Know-Your-Customer（KYC）、Counter Terrorist Financing（CTF）などの世界的な業界規制基準に準拠するために、OG ExchangeはユーザーアカウントにID認証を要求します。 これには、正式な身分証明書の収集が必要です。<br>・お客様が当社のサービスを使用する際に収集する情報',
    'policy.service_usage_information': '・サービス利用情報',
    'policy.service_usage_information_content': 'OG Exchangeプラットフォームを使用することにより、アクセス日時、デバイスの識別、オペレーティングシステム、ブラウザの種類、IPアドレスなどの使用に関連する追跡情報も監視および収集します。この情報は、OG Exchangeまたはサードパーティのサービスを通じて直接取得できます。このサービス使用状況データは、システムがすべてのプラットフォームのユーザーがアクセスできるようにし、犯罪捜査中に支援できるようにするためにシステムを支援します。',
    'policy.transaction_information': '・取引情報',
    'policy.transaction_information_content': 'すべての個人および企業のユーザーアカウントについて、預金のスナップショット、口座残高、取引履歴、引き出し、注文アクティビティ、配布履歴などの取引情報を収集します。この取引データは、ユーザーの詐欺防止のための疑わしい取引活動、および訴訟の解決のために監視されます。',
    'policy.why_collects': '・なぜOG Exchangeがこの情報を収集するのか',
    'policy.why_collects_title_1': 'それはサービスを提供および維持するためです。',
    'policy.why_collects_content_1': '収集した情報を使用してサービスを提供し、ユーザーの身元を確認します。<br>デバイスのCookieに保存されているIPアドレスと一意の識別子を使用して、ユーザーの身元を認証し、サービスを提供します。当社の法的義務とシステム要件により、身分証明書、連絡先情報、取引関連情報などのデータなしに出金制限の無いサービスを提供することはできません。',
    'policy.why_collects_title_2': '・ユーザーを保護するために',
    'policy.why_collects_content_2': '収集した情報を使用して、プラットフォーム、ユーザーのアカウント、アーカイブを保護します。 IPアドレスとCookieデータを使用して、スパム、フィッシング、分散型サービス拒否（DDoS）攻撃などの自動化された悪用から保護します。<br>疑わしい行動を早期に検出し、不正行為や悪意のある人物による資金の損失を防ぐことを目的に、取引活動を分析します。',
    'policy.why_collects_title_3': '・法的および規制要件を順守するため',
    'policy.why_collects_content_3': 'OG Exchangeで保存するデータのプライバシーとセキュリティを尊重することは、規制、政府の要求、およびユーザーが生成した問い合わせを順守するためのアプローチを示しています。当社は、訴訟ケースチームによる審査および/またはユーザーからの事前の同意なしに、個人情報を第三者ソースに開示または提供しません。',
    'policy.why_collects_title_4': '・サイトのパフォーマンスを測定するため',
    'policy.why_collects_content_4': 'データを積極的に測定および分析し、サービスの使用方法を理解しています。このレビュー活動は、プラットフォームのパフォーマンスを継続的に改善し、ユーザーエクスペリエンスの問題を解決するために、運用チームによって実施されます。 システムのアクティビティ情報とユーザーとのコミュニケーションを継続的に監視し、問題を探して迅速に修正します。',
    'policy.why_collects_title_5': 'ユーザーとのコミュニケーション',
    'policy.why_collects_content_5': 'ユーザーと直接通信するために電子メールアドレスなどのユーザー個人情報を収集する必要がある、ユーザーからの作業指示を解決し、ログイン、取引、セキュリティなどの関連アクティビティなどユーザーに直接に通知できるようにします。個人情報を提供しない場合、ユーザーから送信されたリクエスト、質問、お問い合わせに対応することができません。すべての通信は機密情報として保持され、正確性について社内でレビューされます',
    'policy.why_collects_title_6': '利用規約およびその他の契約を実施するため',
    'policy.why_collects_content_6': '当社は、ユーザーに対して潜在的な違反を防ぐために常にレビューを行うことが重要です。ユーザーの利益を保護するため、サードパーティとの契約を慎重に実施し、利用規約の違反を真剣に調査します。 OG Exchangeは、利用規約に違反するユーザーにサービスを提供しない権利を留保します。',
    'policy.how_protect': 'OG Exchangeがユーザーデータを保護する方法',
    'policy.how_protect_intro': 'OG Exchangeは、ユーザー情報が失われたり、悪用されたり、改ざんされたりしないように、複数のセキュリティ対策を実装しています。 データセキュリティ対策には、PCIスキャン、セキュアソケットレイヤー暗号化技術(SSL)、匿名性、内部データアクセス制限、およびオフィスとアーカイブへの厳格なアクセス制限が含まれますが、これらに限定されません。 ただし、インターネット上の電子ストレージの形式では、100％の情報セキュリティを保証できません。 したがって、個人情報を保護するために、独立なセキュリティ対策を講じることをお勧めします。 <br>個人情報、特にアカウントまたはパスワード情報が漏洩した疑いがある場合は、すぐにアカウントを凍結し、OG Exchangeカスタマーサービスに連絡してください。',
    'policy.contact_us': '・あなたと通信するため→当社へのお問い合わせ（BitMEXでは「Getting in touch with us」）',
    'policy.contact_us_intro': 'メールアドレスなどの収集された個人情報を使用して、チケットでカスタマーサポートを提供する際にユーザーと直接やり取りしたり、ログイン、トランザクション、セキュリティに関する情報をお客様に提供します。',
    'terms.title': '利用規約',
    'terms.introduce_1': 'OG Exchange は利用者（ユーザー）によるデジタル資産の取引機会および関連サービスを提供し、ウェブサイト <a href=\'{APP_URL}\'>{APP_URL}</a> を運営します（以下「本ウェブサイト」といいます）。本ウェブサイトはデジタル取引専用または関連するサービスを提供するプラットフォームです（以下「本サービス」といいます）。本規約を簡潔に記述するために、本規約でOG Exchangeおよび本ウェブサイトを「OG Exchange」または他の適切な第一人称と併称します。本ウェブサイトにログインするすべての自然人またはその他の主体は、本ウェブサイトのユーザーです。本規約を簡潔に記述するために、ユーザーおよびOG Exchangeを「両当事者」と総称し、ユーザーまたはOG Exchangeをそれぞれ「当事者」と呼びます。<br>そしてOG Exchangeが提供する全てのサービスを「当該サービス」と呼びます。',
    'terms.introduce_2': 'デジタル資産取引は非常にリスクが高く、多くの方々に適するものではありません。ユーザーはデジタル資産への投資の一部あるいは全部を損なう可能性があることを認識し、しっかりと理解した上で損失に耐えうる自身の限度を考慮して投資額を決定しなければなりません。さらに、上記リスク以外に予測できないリスクもあります。よって、ユーザーはデジタル資産の売買に関する判断を下す前に、財務状況および上記リスクを考慮し、慎重に判断しなければなりません。そして、これによりすべての損失はユーザーの自己負担となり、OG Exchangeはいかなる場合においても責任を負いません。',
    'terms.term_1.title': '第1条 規約総則',
    'terms.term_1.content_1_1': '1.1本ウェブサイトが提供するサービスを利用されるユーザーは、必ず本規約の全文をお読み下さい。ご不明な点またはその他疑義がある場合は専門弁護士にご相談ください。本規約の条項および随時変更される内容について同意しない場合は当該サービスの利用を直ちに停止し、本ウェブサイトへのログインを停止してください。本ウェブサイトにログインし、または本サービスを利用、その他同様の活動を行った場合、ユーザーは本規約のすべての条項、条件（本ウェブサイトが随時変更された内容などを含む）など全ての内容を理解し完全に同意したものとみなします。',
    'terms.term_1.content_1_2': '1.2本ウェブサイトの要件に従い、関連情報を記入し、その他の関連手続きを経て、登録を完了したユーザーが本ウェブサイトの会員（以下、「会員」という）になります。登録の手続きで、「同意する」ボタンをクリックすると、ユーザーが電子署名によりOG Exchangeと契約を結んだものとみなされます。<br/>また、本ウェブサイトを利用する際に、「同意する」ボタン、または類似するボタンをクリックする場合、本ウェブサイトが許可する方で実際に当該サービスを利用する場合、ユーザーは本規約のすべての条項の内容を理解し、完全に同意したものとみなされます。この場合、手書きの署名がない場合でも、本規約がユーザーに与える法的拘束力には影響されないものとします。',
    'terms.term_1.content_1_3': '1.3本ウェブサイトの会員になると、会員アカウントとそれに対応するパスワードを受け取ります。そのパスワードは、会員自身が適切に保管するものです。当該アカウントで行われたすべての活動や出来事に対する法的な責任はすべて会員にあり、OG Exchangeは一切の責任を負いません。',
    'terms.term_1.content_1_3_1': '一般ユーザーは、このウェブサイトを通じてデジタル資産を取引することはできません。また、このウェブサイトのメンバーにならない限り、このウェブサイトの規則と規則に従ってメンバーに提供されるサービスにアクセスすることはできません。ユーザーがこのウェブサイトのメンバーではない場合、このウェブサイトの使用に関する規則および規制を閲覧ページへのアクセスする権利があります。',
    'terms.term_1.content_1_4': '1.4本ウェブサイトの会員として登録し、本ウェブサイトが提供するいかなるサービスおよび機能を利用すると、ユーザーは本規約を読み、理解したこととみなされます。同時に下記条項にも同意したものとみなされます。',
    'terms.term_1.content_1_4_1': '1.4.1本規約にあるすべての条項の制約を引き受けます。',
    'terms.term_1.content_1_4_2': '1.4.2ユーザーは、適用される法律により要求された条件に達したことを確認し、本ウェブサイトでデジタル資産取引を利用される場合は十分な能力を有していることをご確認ください。',
    'terms.term_1.content_1_4_3': '1.4.3ユーザーは、本規約に基づく取引に関連するすべてのデジタル資産が合法的に取得され、ユーザー本人が所有することを承諾します。',
    'terms.term_1.content_1_4_4': '1.4.4ユーザーは、自身の取引および非取引活動に起因する損害や利益、関連する責任を負うものとし、OG Exchangeはこれらについて一切の責任を負いません。',
    'terms.term_1.content_1_4_5': '1.4.5登録する際に提供した情報が真実かつ正確であることを確認したものとみなします。',
    'terms.term_1.content_1_4_6': '1.4.6納税のための取引利益の申告を含み、関連するすべて法律を遵守することに同意したものとみなします。',
    'terms.term_1.content_1_4_7': '1.4.7本規約は、ユーザーとOG Exchangeとの間の権利と義務を約束するものであり、本ウェブサイトのユーザー間および本ウェブサイトのユーザーと他のウェブサイト間のデジタル資産の取引による法的関係および法的紛争に関わりません。',
    'terms.term_2.title': '第2条 本規約の変更',
    'terms.term_2.content_2_1': 'OG Exchangeは、本規約を随時変更し、変更内容をユーザーに別途通知するものではなく、本ウェブサイトにおいてアナウンスの形式で公表する権利を有します。改訂された日付は、本規約の最初のページに表示されます。改訂された規約内容は、ウェブサイト上で発表された直後に有効となります。OG Exchangeは、ユーザーが本規約を随時閲覧し、変更された日付および変更内容について確認することを推奨します。ユーザーが変更内容に同意しない場合は、本サービスの利用を直ちに停止するものとします。本サービスを引き続き利用する場合は、改訂された規約に同意したものとみなします。',
    'terms.term_3.title': '第3条　登録',
    'terms.term_3.title_1': '3.1登録の資格',
    'terms.term_3.content_3_1_1': 'ユーザーは、登録手続きを完了する際、または本サービスを本ウェブサイトで許可されるその他の方法で利用する場合、適用される法律により本規約に署名する能力を有する自然人、法人またはその他組織であることを確認するものとします。登録に「同意する」ボタンをクリックすると、ユーザー自身が本規約の内容に同意のうえ、ログインし、あるいは当該ユーザーの許可を持つ代理人が当該ユーザーに代わり、本規約の内容に同意のうえ、本ウェブサイトに登録し、当該サービスを利用したものとみなします。ユーザーが上記の能力を持つ自然人、法人またはその他組織ではない場合、ユーザーとユーザーの代理人はこれにより一切の結果を引き受けなければなりません。また、OG Exchangeは当該アカウントの削除もしくは永久停止、当該ユーザーと当該ユーザーの許可を持つ代理人の責任を追及する権利を有します。',
    'terms.term_3.content_3_1_2': 'また、ユーザーは過去および現在、反社会的勢力又はこれに準ずるものではないことを表明し、かつ将来にわたっても該当しないことを確約します。資金提供その他を通じて反社会的勢力等の維持、運営に協力又は関与していないこと、将来にわたって行わないことを表明し、保証するものとします。',
    'terms.term_3.title_2': '3.2登録の目的',
    'terms.term_3.content_3_2_1': 'ユーザーは、適用される法律または規制に違反したり、本ウェブサイトでのデジタル資産取引の秩序を侵害することが本ウェブサイトでの登録目的ではないことを確認し、これを承諾したものとします。',
    'terms.term_3.title_3': '3.3登録プロセス',
    'terms.term_3.content_3_3_1': '3.3.1ユーザーは、本ウェブサイトの新規ユーザー登録ページの要件に従い、有効な電子メールアドレス、携帯電話番号、およびその他の情報を提供することに同意するものとします。また、ユーザーから提供あるいは確認された電子メールアドレス、携帯電話番号、または本ウェブサイトに許可された他の方法を利用し、本ウェブサイトにログインすることができます。ユーザーは必要な場合、関連する管轄区域に適用される法律および規制の要件に従い、本名および身分証明資料などの適用法、規則、プライバシー規約、およびマネーロンダリング防止条項によって要求される情報を提供しなければなりません。また、ユーザーの登録データが適切かつ詳細かつ正確になるように、常に最新の情報に更新しなければなりません。すべてのデータはユーザーにより入力されたものが、そのまま登録情報として参照されます。ユーザーは、これらの情報の真実性、完全性および正確性について責任を負い、直接または間接的な損失およびそれに起因する不利な結果についても責任を負うものとします。',
    'terms.term_3.content_3_3_2': '3.3.2ユーザーが所在する主権国または地域の法律、規則、命令およびその他の規制文書のいずれかに、携帯電話アカウントが実名に基づいている必要がある場合、ユーザーは実名登録手続きに合格した携帯電話番号を登録に提供することに同意するものとします。規制に応じてこのような携帯電話番号を提供しない場合、これにより直接的または間接的な損失およびこれに起因する損害がすべてユーザー負担になるものとします。',
    'terms.term_3.content_3_3_3': '3.3.3必要な登録情報を法的に完全かつ有効な方法で提供し、確認を通過した後、ユーザーは本ウェブサイトのアカウントとパスワードを取得する権利を有します。そのようなアカウントとパスワードを取得することにより、ユーザー登録は成功したものとみなされ、ユーザーはその正会員として本ウェブサイトにログインすることができます。',
    'terms.term_3.content_3_3_4': '3.3.4ユーザーは、本ウェブサイトから送信された本ウェブサイトの管理および操作に関連して電子メールあるいはショートメッセージを受け取ることに同意するものとします。',
    'terms.term_3.title_4': '3.4パスワードおよびユーザー ID の管理',
    'terms.term_3.content_3_4_1': '3.4パスワードおよびユーザー ID の管理',
    'terms.term_3.content_3_4_2': '3.4パスワードおよびユーザー ID の管理',
    'terms.term_3.content_3_4_3': '3.4パスワードおよびユーザー ID の管理',
    'terms.term_4.title': '第4条　サービス',
    'terms.term_4.content_4_0': '本ウェブサイトは、ユーザーが本ウェブサイトを通じてデジタル資産取引活動（デジタル資産取引などを含みますが、これらに限定されない）にオンライン取引プラットフォームのサービスのみを提供しています。本ウェブサイトは、買い手または売り手としてデジタル資産の取引には参加していません。',
    'terms.term_4.title_1': '4.1サービスの範囲',
    'terms.term_4.content_4_1_1': '4.1.1ユーザーは、本ウェブサイトでのデジタル資産商品のリアルタイムの相場および取引情報を閲覧し、本ウェブサイトを通じてデジタル資産取引の指令を提出し、デジタル資産取引を完了する権利を有します。',
    'terms.term_4.content_4_1_2': '4.1.2ユーザーは、本ウェブサイトに掲載された活動ルールに従い、本ウェブサイトが開催するウェブサイトの活動に参加する権利を有します。',
    'terms.term_4.content_4_1_3': '4.1.3本ウェブサイトがユーザーに提供することを約束するその他のサービス。',
    'terms.term_4.title_2': '4.2サービスルール',
    'terms.term_4.content_4_2_0': 'ユーザーは、本ウェブサイトにおいて下記のサービスルールを遵守することを約束するものとします。',
    'terms.term_4.content_4_2_1': '4.2.1ユーザーは、適用される法律、規則、およびポリシー要件の条項を遵守し、アカウント内のすべてのデジタル資産の出処の合法性を保証し、本ウェブサイト上で、あるいは本ウェブサイトを利用した違法行為、またはその他の本ウェブサイトおよび第三者の利益を損害する活動を行うことができません。例えば、法律に違反すること、規制に違反すること、他人の権利および利益を侵害する情報の送受信、または本ウェブサイトの許可を得ない本ウェブサイトの電子メールヘッダーのメッセージ利用または偽造をすることができません。',
    'terms.term_4.content_4_2_2': '4.2.2ユーザーは、適用される法律および規制を遵守し、本ウェブサイトのアカウントおよびログインパスワード、取引パスワード、アカウント登録時に関連付けられている携帯電話番号を正しく利用し、保管するものとします。本ウェブサイトのアカウント、ログインパスワード、取引パスワード、ユーザーの携帯電話に送信された認証コードを利用した一切の操作、およびそれに起因する結果についてのすべての責任はユーザーが負うものとします。本ウェブサイトのアカウント、ログインパスワード、取引パスワード、または携帯電話の認証コードが不正な第三者に利用された場合、またはアカウントのセキュリティに関連するその他の問題を明らかにする場合、ユーザーは迅速かつ有効な方法で、本ウェブサイトと連絡を取り、当該アカウントへのサービスを一時的に停止させるように要求してください。本ウェブサイトは、合理的な時間内にユーザーの要望に応じて行動する権利を有します。しかし、本ウェブサイトは、ユーザーが負担する可能性のある損失を含み、またこれらに限定されることなく、行為が行われる前に生じた全ての結果に対する一切の責任を負うものではありません。ユーザーは、本ウェブサイトのアカウントを本ウェブサイトの許可を得ずに、本ウェブサイトのアカウントを第三者に譲渡、貸与、移転、担保設定、その他処分することはできません。',
    'terms.term_4.content_4_2_3': '4.2.3ユーザーは、自身のアカウントとパスワードを利用し、それにより発生する一切の活動（情報の開示、情報のリリース、オンライン上で「同意する」ボタンをクリック承認、提出された各種規約、オンライン上での規約更新、またはサービスを継続に購入することなどを含むがこれらに限定されない）に責任を負うことについて同意するものとします。',
    'terms.term_4.content_4_2_4': '4.2.4本ウェブサイトでデジタル資産を取引する際、悪意を持って妨害したり、取引注文を混乱させることはできません。ユーザーは、技術的手段で本ウェブサイトの正常な運営を妨害し、またはその他の手段を利用して、他のユーザーのサービス利用の妨げをすることはできません。ユーザーは、偽りの事実を偽造することなど、本ウェブサイトに対し悪意をもってビジネス上で誹謗することはできません。',
    'terms.term_4.content_4_2_5': '4.2.5オンライン取引に関連し、他のユーザーとの間に紛争が発生した場合、法的執行機関および政府機関以外から情報提供を求めることはできません。',
    'terms.term_4.content_4_2_6': '4.2.6本ウェブサイトによって提供されるサービスを利用する際にユーザーに係るハードウェア、ソフトウェア、それに付随するすべての税金、およびすべての手数料はユーザーの負担となります。',
    'terms.term_4.content_4_2_7': '4.2.7ユーザーは、本ウェブサイト上で随時公表される本規約およびその他サービス条件および運用ルールを遵守しなければなりません。ユーザーは、いつでも本サービスの利用を終了する権利を有するものとします。',
    'terms.term_4.title_3': '4.3プロダクトルール',
    'terms.term_4.content_4_3_1': '4.3.1暗号通貨の間の取引に関するルール',
    'terms.term_4.content_4_3_1_0': 'ユーザーは、本ウェブサイトにログインし、本ウェブサイトを通じて通貨取引を行う際、下記取引ルールを遵守することに同意します。',
    'terms.term_4.content_4_3_1_1': '4.3.1.1取引情報の参照',
    'terms.term_4.content_4_3_1_1.introduce': '本ウェブサイト上の通貨取引情報を参照する際に、（価格、出来高、取扱手数料、売買表示などを含みますがこれらに限定されません）取引情報のすべての内容を閲読し、それに含まれるすべてを受容した上で、取引ボタンをクリックし取引を続行することができます。',
    'terms.term_4.content_4_3_1_2': '4.3.1.2注文を提出する',
    'terms.term_4.content_4_3_1_2.introduce': '取引情報を閲読かつ確認した後、取引注文を提出することができます。取引注文を提出した後、本ウェブサイトが該当する取引を仲介することに承認したものとみなされます。本ウェブサイトは事前に通知することなく、委任された価格に合致する取引注文がある場合、自動的にマッチングし、取引を完了させます 。',
    'terms.term_4.content_4_3_1_3': '4.3.1.3取引詳細の参照',
    'terms.term_4.content_4_3_1_3.introduce': 'Buy history 及びTrade historyにおいて取引明細で対応する取引記録を参照し、確認することができます。',
    'terms.term_4.content_4_3_1_4': '4.3.1.4取引注文のキャンセルおよび変更<br>ユーザーは、取引が完了する前に取引注文をいつでもキャンセルまた変更する権利を有します。',
    'terms.term_5.title': '第5条　本ウェブサイトの権利と義務',
    'terms.term_5.content_5_1': '5.1本規約で合意された登録資格がない場合、本ウェブサイトは登録を拒否する権利を有するものとします。既に登録を完了された場合、当ウェブサイトは当該会員のアカウントを取り消す権利を有し、ユーザーまたはユーザーの権限を持つ代理人に責任を追及する権利を留保します。さらに、本ウェブサイトは他の状況で登録申請を受け入れるか否かを決定する権利を留保します。',
    'terms.term_5.content_5_2': '5.2本ウェブサイトは、アカウントの利用者がそのアカウントの初期登録者ではないことが判明した場合、そのアカウントへのアクセスを一時停止または終了する権利を有するものとします。',
    'terms.term_5.content_5_3': '5.3テクニカルテストまたは人工サンプリングにより、本ウェブサイトに提供される情報に誤りがある、または不完全であると合理的に疑われる場合、本ウェブサイトは、情報の修正または更新を要求する権利を有し、またはサービスの提供を終了する権利を有します。',
    'terms.term_5.content_5_4': '5.4本ウェブサイトは、本ウェブサイトに表示された情報が、明らかに誤りであると発覚した場合、修正する権利を有します。',
    'terms.term_5.content_5_5': '5.5本ウェブサイトは、本サービスを随時変更、中断または終了する権利を留保します。ユーザーに事前に通知なく、本サービスの変更および提供を停止することができます。本ウェブサイトが提供されるサービスの1つまたは複数を終了する場合、終了はウェブサイト上での終了発表日に効力を発します。',
    'terms.term_5.content_5_6': '5.6本ウェブサイトは、本ウェブサイトの正常な運営を確保するために必要な技術的手段及び管理措置を講じ、必要かつ信頼できる取引環境及び取引サービスを提供し、デジタル資産取引の秩序を維持するものとします。',
    'terms.term_5.content_5_7': '5.7本ウェブサイトは、技術を強化し、セキュリティ対策を強化することにより、ユーザーのデジタル資産のセキュリティを確保し、ユーザーのアカウントに対して予測可能なセキュリティリスクを事前に通知する義務を負うものとします。',
    'terms.term_5.content_5_8': '5.8本ウェブサイトは、ユーザーが所在する主権国または地域の法律、規則、命令およびその他の規制文書に従い、ユーザーにより多くの情報またはデータを要求し、合理的に地元の基準の要件を満たすための措置を講じる権利を留保します。ユーザーはそのような措置に適切な援助を提供する義務を負うものとします。本ウェブサイトは、ユーザーが所在する主権国または地域の法律、規則、命令及びその他の規制文書に従い、ユーザーへ本サービスの一部、全部を停止または永久に終了する権利を有します。',
    'terms.term_6.title': '第6条　損害賠償',
    'terms.term_6.content_6_1': '6.1いかなる場合においても、ユーザーの直接的損害に対するOG Exchangeの賠償責任は、本サービスの3ヶ月間の利用による総費用を超えないものとします。',
    'terms.term_6.content_6_2': '6.2本規約または適用される法律または行政規則に違反した場合は、ユーザーが少なくとも200万米ドルの賠償金を支払うものとし、その違反に関連するすべての費用（弁護士費用などを含む）を負担するものとします。それらの補償費用が実際の損失をカバーできない場合は、ユーザーがその差額を補うものとします。',
    'terms.term_7.title': '第7条　差止救済を求める権利',
    'terms.term_7.content_7_0': 'ユーザーと私たちは、規約違反及び規約違反の可能性があることに対し、一般慣習法上の救済策が私たちの損失をカバーできないことを認識しています。したがって、規約違反または規約違反の可能性がある場合、違約していない当事者は、差止救済ならびに一般慣習法または衡平法で認められているその他の救済措置を求める権利を有するものとします。',
    'terms.term_8.title': '第8条　免責事項',
    'terms.term_8.content_8_1': '8.1ユーザーはいかなる状況においても、以下のいずれの事由についてもOG Exchangeが責任を負わないことを理解し、同意するものとします。',
    'terms.term_8.content_8_1_1': '8.1.1収益の損失について、OG Exchangeは一切の責任を負いません。',
    'terms.term_8.content_8_1_2': '8.1.2取引利益または規約上の損失について、OG Exchangeは一切の責任を負いません。',
    'terms.term_8.content_8_1_3': '8.1.3業務の中断について、OG Exchangeは一切の責任を負いません。',
    'terms.term_8.content_8_1_4': '8.1.4予期できる通貨の損失について、OG Exchangeは一切の責任を負いません。',
    'terms.term_8.content_8_1_5': '8.1.5情報の損失について、OG Exchangeは一切の責任を負いません。',
    'terms.term_8.content_8_1_6': '8.1.6チャンスの喪失、ビジネス上の名誉または名誉への損害について、OG Exchangeは一切の責任を負いません。',
    'terms.term_8.content_8_1_7': '8.1.7データの損傷または損失について、OG Exchangeは一切の責任を負いません。',
    'terms.term_8.content_8_1_8': '8.1.8代替製品またはサービスの購入費用について、OG Exchangeは一切の責任を負いません。',
    'terms.term_8.content_8_1_9': '8.1.9侵害（過失を含む）、規約違反またはその他の原因に起因する間接的、特別または付帯的な損失、損害について、その損失または損害が合理的に予見されるかどうかにかかわらず、そのような損失または損害の可能性が事前に通知されるかどうかにかかわらず、OG Exchangeは一切の責任を負いません。',
    'terms.term_8.content_8_1_10': '8.1.1から8.1.9は互いに独立しています。',
    'terms.term_8.content_8_2': '8.2ユーザーは、以下の事象のいずれかによって引き起こされたいかなる損害に対しても、OG Exchangeが責任を負いかねることを理解し、同意するものとします。',
    'terms.term_8.content_8_2_1': '8.2.1ユーザーの特定の取引が重大な違法または規約違反であると疑われ、これに正当な理由がある場合、OG Exchangeは一切の責任を負いません。',
    'terms.term_8.content_8_2_2': '8.2.2本ウェブサイト上でのユーザーの行為が違法または不適切であると疑われ、これに正当な理由がある場合、OG Exchangeは一切の責任を負いません。',
    'terms.term_8.content_8_2_3': '8.2.3本ウェブサイトで購入したサービスを通じ、データ、情報の取得、取引等の行為、またこれに代わる行為により生じる費用および損失について、OG Exchangeは一切の責任を負いません。',
    'terms.term_8.content_8_2_4': '8.2.4本サービスを誤解する場合、OG Exchangeは一切の責任を負いません。',
    'terms.term_8.content_8_2_5': '8.2.5 OG Exchangeに起因するものではなく、本サービスに関連するその他の損失について、OG Exchangeは一切の責任を負いません。',
    'terms.term_8.content_8_3': '8.3情報ネットワーク機器のメンテナンス、情報ネットワークの接続障害、コンピューター、通信またはその他のシステムのエラー、電力障害、天候、予期せぬ事故、罷業、労働争議、暴動、反乱、騒動、生産性や生産材料の不足、火事、洪水、暴風、爆破、戦争、銀行や他の関係各所によるミス、デジタル資産市場の崩壊、政府の規制、司法機関または行政機関の措置など、その他OG Exchangeが管理できない行為、OG Exchangeの制御不能の状態、または第三者の原因に起因するサービスの不提供、またはサービス提供が延期される場合、またそれにより生じる損失について、OG Exchangeは一切の責任を負いません。',
    'terms.term_8.content_8_4': '8.4本ウェブサイトはウェブサイトに含まれるすべての情報、プログラム、テキストなどが完全に安全であること、またはあらゆるウイルス、トロイの木馬などの悪意のあるプログラムによる干渉や破壊に影響されないことが確保できません。そのため、本ウェブサイトへのログイン、本サービスの利用、プログラム、情報およびデータのダウンロード、およびその利用は、ユーザーの個人的判断であるとみなされます。それにより、ユーザーは発生する可能性があるすべてのリスクおよびそれに起因する損失を負担するものとします。',
    'terms.term_8.content_8_5': '8.5OG Exchangeは、本ウェブサイトにリンクされた第三者のウェブサイトのあらゆる情報、製品、業務、およびOG Exchangeに属さない他のあらゆる形態のコンテンツに関連して、いかなる保証や約束も行っておりません。<br>第三者のウェブサイトによって提供されるあらゆるサービス、情報、および製品を利用することは、ユーザーの個人的判断であるとみなされます。そのため、ユーザーはそれにより生じるすべての責任を引き受けるものとします。',
    'terms.term_8.content_8_6': '8.6 OG Exchangeは、本ウェブサイトによって提供されるサービスの利用に関する明示的または黙示的な保証行うものではありません（適用性、誤りまたは漏れのない可能性、一貫性、正確性、妥当性および特定用途への適用性を含みますがこれらに限定されません）。さらに、OG Exchangeは本サービスに関する技術および情報の有効性、正確性、妥当性、品質、安定性、完全性および適時性に関する保証を行うものではありません。本ウェブサイトにログインするか、本サービスを利用するかは、ユーザーの個人的判断であるため、ユーザーはそのような判断から生じるすべてのリスクと可能性のある損失を負担するものとします。OG Exchangeは、デジタル資産の市場、価値および価格に関連して明示的または黙示的な保証を行うものではありません。ユーザーはデジタル資産市場が不安定であり、資産の価格と価値が随時に変動するまたは崩壊する可能性があることを理解し、デジタル資産の取引はユーザーの個人的な自由意思および決定に基づいていることであるため、それにより生じるすべてのリスクおよび可能性のある損失を負担するものとします。',
    'terms.term_8.content_8_7': '8.7本規約に約束された保証および承諾は、本規約および本ウェブサイトを通じてOG Exchangeが提供するサービスに関連して行った唯一の保証および陳述であり、他の方法で生じる全ての保証および約束（書面でも言葉でも、明示的にも黙示的にも）を取って代わるものとします。書面でも言葉でも、明示的にも黙示的にも、これらの保証および声明はすべて、OG Exchangeの約束および承諾のみを表明し、第三者の遵守を保証するものではありません。',
    'terms.term_8.content_8_8': '8.8 OG Exchangeは、本規約に含まれていないが、最大の範囲で法律に適用、損害賠償責任を制限、免除または相殺する権利を放棄しません。',
    'terms.term_8.content_8_9': '8.9ユーザーは登録した以上、OG Exchangeが本規約に記載されたルールに従い、あらゆる操作を行えることに同意したものとみなされます。ユーザーは、それにより生じる全てのリスクについて、責任を負うものとします。',
    'terms.term_9.title': '第9条　規約の解除',
    'terms.term_9.content_9_1': '9.1本ウェブサイトは本規約の条項に従い、ユーザーのアカウントを取り消す権利を有します。また、本規約はアカウントの取消日をもって終了します。',
    'terms.term_9.content_9_2': '9.2本ウェブサイトは本規約の条項に従い、すべてのサービスを終了する権利を有します。本規約は、本ウェブサイトでのすべてのサービスの終了日をもって終了します。',
    'terms.term_9.content_9_3': '9.3本規約が解除された後、ユーザーは本ウェブサイトに元のサービスを提供させ、義務を履行させる権利を有しません。（ウェブサイトでユーザーのアカウントの情報を保留するサービス、またユーザーに元のアカウントでの情報を知らせるサービス、およびユーザーや第三者にいかなる閲覧されずまた送信されず情報の転送サービスなどを含みますが、これらに限定されません。）',
    'terms.term_9.content_9_4': '9.4本規約の終了は、規約に違反していない当事者が規約を違反する当事者へ他の責任を追及することに影響しません。',
    'terms.term_10.title': '第10条　知的財産権',
    'terms.term_10.content_10_1': '10.1本ウェブサイトで含まれる全ての知的な成果（ウェブサイトのロゴ、データベース、Webサイトのデザイン、テキストとグラフィックス、ソフトウェア、写真、ビデオ、音楽、音およびこれらの組合せなどを含みますが、これらに限定されません。ソフトウェアのコンパイル、関連するソースコードとソフトウェア（アプレットとスクリプトを含む）の知的財産の権利は本ウェブサイトが所有しています。ユーザーは上記のコンテンツをビジネス上の目的で複製、複写、改変、第三者への送信、または利用することができません。',
    'terms.term_10.content_10_2': '10.2本ウェブサイトの名称に含まれるすべての権利（ビジネス上の信用、標章、およびロゴを含みますが、これらに限定されません）は、OG Exchangeが所有しています。',
    'terms.term_10.content_10_3': '10.3ユーザーがこの規約に同意すると、本ウェブサイトに掲載される様々な形式の著作権、（複製権、発行権、レンタル権、展示権、パフォーマンスの権利、上映権、放送権、情報の普及の権利、撮影権、改編権、翻訳権、編集権を含みますが、これに限定されません）、または他の著作権者に属する移転できる権利を無料に本ウェブサイトに譲渡するとみなされます。本ウェブサイトは以上の権益が侵されるとき、独自に侵害者へ法律訴訟を起こし、すべての賠償を得る権利を有します。本規約はユーザーが本ウェブサイトで発表した全ての著作権法に保護されるものに対して効力を発します。ユーザーが発表する内容は本規約にサインする時点に関わらず制約の対象となります。',
    'terms.term_10.content_10_4': '10.4ユーザーは本ウェブサイトを利用する際、本ウェブサイトまたは他人の知的財産権を不正に使用または処分することはできません。ユーザーは本ウェブサイトに発表された情報をいかなる形式でも他のウェブサイト（及びメディア）へ投稿また授権することができません。',
    'terms.term_10.content_10_5': '10.5本ウェブサイトへアクセスし、また本サービスを利用する際、ユーザーへいかなる知的財産権も譲渡することとみなされません。',
    'terms.term_11.title': '第11条　その他',
    'terms.term_11.content_11_1': '11.1分離可能性',
    'terms.term_11.content_11_1_1': '本規約でいずれかの条項が管轄権のある裁判所により執行不能、無効、違法であることが判明された場合、残りの全ての条項の有効性には影響しません。',
    'terms.term_11.content_11_2': '11.2エージェント以外の関係',
    'terms.term_11.content_11_2_1': '本規約のいかなる条項にもOG Exchangeがユーザーの代理人、受託者またはその他代理人となる意味は一切ありません。本規約には別になる他の規定が存在します。',
    'terms.term_11.content_11_3': '11.3棄権について',
    'terms.term_11.content_11_3_1': 'OG Exchange及びユーザーは本規約を違反したことによる責任を追う権利を放棄する場合、他の背約責任を追う権利を放棄するわけではありません。また、権利や救済を全く行使していない場合も権利または救済の行使を放棄することではありません。',
    'terms.term_11.content_11_4': '11.4タイトル',
    'terms.term_11.content_11_4_1': 'すべてのタイトルは規約を簡潔に説明するために使用され、規約条件の内容または範囲を拡大することに使用されるものではありません。',
    'terms.term_12.title': '第 12 条 禁止行為',
    'terms.term_12.content_12_1': '1.登録ユーザーは、本サービスの利用にあたり、以下の各号のいずれかに該当する行為をしてはなりません。',
    'terms.term_12.content_12_1_1': '1・当社、または本サービスの他の利用者その他の第三者の知的財産権または肖像権を侵害する行為（かかる侵害を直接または間接に惹起する行為を含みます。）',
    'terms.term_12.content_12_1_2': '２・当社の事前の承諾なしに当社が著作権を含む知的財産権や肖像権を有するものを商用利用する行為や第三者へ転載等を行う行為',
    'terms.term_12.content_12_1_3': '３・当社、当社関係会社その他当社に関連する者または本サービスの他の利用者その他の第三者のプライバシーの権利、名誉、その他の権利または利益を侵害する行為（かかる侵害を直接または間接に惹起する行為を含みます。）',
    'terms.term_12.content_12_1_4': '４・詐欺行為、無限連鎖講等の開設や勧誘、違法な物品・サービス等の購入・販売、犯罪による収益の移転またはそれに基づくサービス利用を行う行為',
    'terms.term_12.content_12_1_5': '５・犯罪行為に関連する行為または公序良俗に反する行為',
    'terms.term_12.content_12_1_6': '６・異性等交際に関する情報を送信する行為',
    'terms.term_12.content_12_1_7': '７・広告配信等の他の登録ユーザーに対する勧誘行為（但し、当社が認める場合を除きます。）',
    'terms.term_12.content_12_1_8': '８・法令または当社もしくは登録ユーザーが所属する業界団体の内部規則に違反する行為',
    'terms.term_12.content_12_1_9': '９・仮想通貨の二重譲渡に該当する行為またはこれを試みる行為',
    'terms.term_12.content_12_1_10': '１０・コンピューター・ウィルスその他の有害なコンピューター・プログラムを含む情報を送信する行為または当社の管理するシステム、サーバー，ネットワークその他の機能を破壊もしくは妨害し，または，不必要に過度の負担をかける行為',
    'terms.term_12.content_12_1_11': '１１・本サービスに関連する、または当社が管理するシステム、サーバー、ネットワークその他のエラー，バグ，セキュリティーホール，その他瑕疵を利用する行為',
    'terms.term_12.content_12_1_12': '１２・本サービスに関し利用しうる情報を改ざんする行為',
    'terms.term_12.content_12_1_13': '１３・当社が定める一定のデータ容量以上のデータを送信する行為',
    'terms.term_12.content_12_1_14': '１４・当社による本サービスの運営を妨害するおそれのある行為',
    'terms.term_12.content_12_1_15': '１５・リプレイアタック（リプレイ攻撃）等により登録ユーザー、当社または当社関係会社の資産を故意に盗む行為',
    'terms.term_12.content_12_1_16': '１６・風説や事実と異なることを流布し、偽計または威力等を用いて当社の信用を毀損する行為または恐喝行為',
    'terms.term_12.content_12_1_17': '１７・同一人物が複数のアカウントを作成する行為',
    'terms.term_12.content_12_1_18': '１８・複数人物が一アカウントを利用する行為または登録ユーザー本人以外の第三者にアカウントを利用させる行為',
    'terms.term_12.content_12_1_19': '１９・他人（仮説人を含む）の名義をもってアカウントを開設もしくは開設を試みる行為、またはアカウントに係る登録情報の全部または一部につき、当社に虚偽の情報を提供する行為',
    'terms.term_12.content_12_1_20': '２０・事前に当社から書面による同意を得た場合を除き、本サービスの利用等により得た情報等を利用する等して、第三者へ本サービスと同一（仮想通貨売買取引や仮想通貨の移転もしくは決済または価格情報等の配信を含むがそれに限らない。）もしくは類似のサービスを自ら提供し、もしくは第三者へサービスや物品等を提供する等の商用目的で利用し、または子会社その他の自己の支配下にある第三者にそれらを行わせる行為',
    'terms.term_12.content_12_1_21': '２１・取引所における相場操縦的行為もしくは公正な価格形成を阻害する行為',
    'terms.term_12.content_12_1_22': '２２・登録ユーザー本人以外の第三者より登録ユーザーアカウントへ金銭の受入れまたは第三者へ登録ユーザーアカウントより金銭の払出を行う行為。（但し、事前に当社より明示的に許可された場合を除きます。）',
    'terms.term_12.content_12_1_23': '２３・その他、当社が不適切と判断する行為',
    'terms.term_12.content_12_2': '12.2.当社は、本サービスにおける登録ユーザーが前項各号のいずれかに該当し、または該当するおそれがあると当社が判断した場合には、当社の裁量で、登録ユーザーに事前に通知することなく、当該登録ユーザーが送信した情報の全部もしくは一部の削除、当該登録ユーザーの登録の取消もしくは利用の一時停止、または、当該登録ユーザーの保有する仮想通貨等（他通貨に交換している場合は当社が定める交換レートに基づき計算された相当額）の没収等の措置をとることができるものとします。その際、当社は登録ユーザーから受領した書類等を返還する義務を負わないものとします。当社は、本項に基づき当社が行った措置によって登録ユーザーに生じた損害について一切の責任を負いません。',
    'terms.term_12.content_12_3': '12.3.第 1 項各号のいずれかの行為を行った場合、当社は登録ユーザーに対し当社にて定める違約金を請求することがあります。',
    'terms.term_13.title': '第13条　規約の有効になる時点と解釈',
    'terms.term_13.content_13_1': '13.1本規約は、ユーザーが本ウェブサイトのログインページで同意ボタンをクリックの上、ログインの手続きを済まし、本ウェブサイトのアカウントとパスワードを得た後有効になります。本規約はユーザーとウェブサイトに拘束力があります。',
    'terms.term_13.content_13_2': '13.2本規約の最終的な解釈権は本ウェブサイトに所有されます。',
    'terms.term_13.content_13_2_0_1': '重要なお知らせ',
    'terms.term_13.content_13_2_0_2': 'OG Exchangeは以下のようにユーザーの皆さんへお知らせします。',
    'terms.term_13.content_13_2_1': '1.デジタル資産自体は、いかなる金融機関や政府にも裏書きされません。デジタル資産市場は完全に新しく、明確的、安定した予期が備わっていません。',
    'terms.term_13.content_13_2_2': '2.デジタル資産取引は相場の値上がり幅および値下がり幅に制限されず、24時間持続で行えるため、リスクは非常に高くなります。',
    'terms.term_13.content_13_2_3': '3.デジタル資産取引は、各国の法律、規制および規制文書の制定または改正により、随時中断または禁止される可能性があります。',
    'terms.term_13.content_13_2_4': '4.OG Exchangeはアメリカ合衆国、キューバ、イラン、北朝鮮、クリミア、スーダン、シリア、バングラデシュ、ボリビア、エクアドル、キルギスタンのユーザーにサービスを提供していません。',
    'terms.term_end_note.title': '3.4パスワードおよびユーザー ID の管理',
    'terms.term_end_note.content_1': '3.4パスワードおよびユーザー ID の管理',
    'terms.term_end_note.content_2': '3.4パスワードおよびユーザー ID の管理',
    'terms.term_end_note.content_3': '3.4パスワードおよびユーザー ID の管理',
    'terms.term_end_note.content_4': '3.4パスワードおよびユーザー ID の管理',
    'sendConfirmEmail': '確認メールを送信',
    'service_center.send_contact_subject': '{APP_NAME}に連絡先を送信',
    'shared_components.alert.error': 'エラー',
    'shared_components.alert.primary': '情報',
    'shared_components.alert.success': '成功',
    'shared_components.alert.warning': '警告',
    'shared_components.common.confirmation_modal.awesome': '良かった',
    'shared_components.common.confirmation_modal.danger': '危険',
    'shared_components.common.confirmation_modal.info': '情報',
    'shared_components.common.confirmation_modal.warning': '警告',
    'shared_components.google_authentication_modal.lost_code': 'Google認証を忘れましたか？',
    'shared_components.google_authentication_modal.otp_code_invalid': 'Google認証コードは無効です。',
    'shared_components.google_authentication_modal.submit_button': '提出',
    'shared_components.google_authentication_modal.title': 'Google認証システム',
    'shared_components.pagination.next': '次へ',
    'shared_components.pagination.pre': '前へ',
    'sales_point.sales_point': '販売所',
    'sales_point.title': '4IRE設定',
    'sales_point.price_setting': '価格設定',
    'sales_point.total_amal_sold': '売った総4IRE',
    'sales_point.currency': '通貨',
    'sales_point.total_received': '受け取った総数',
    'sales_point.price_setting.default_price': 'デフォルト価格',
    'sales_point.price_setting.presenter': '紹介した方の価格',
    'sales_point.price_setting.presentee': '紹介された方の価格',
    'sales_point.price_setting.total_supply': '提供可能4IRE総数量',
    'sales_point.price_setting.remaining_supply': '4IREの総残高',
    'sales_point.indeicates_required': '「*」は入力必須項目です。',
    'sales_point.price_setting.amal_btc': '4IRE/BTC',
    'sales_point.price_setting.amal_eth': '4IRE/ETH',
    'sales_point.price_setting.asterisk': '*',
    'sales_point.price_setting.usd': 'USD',
    'sales_point.price_setting.amal': '4IRE',
    'sales_point.edit': '編集',
    'sales_point.submit': '提出する',
    'sales_point.return': '戻る',
    'sales_point.update_success_msg': '更新されました。',
    'sales_point.error.lose_default_price': 'デフォルト価格の入力が必須です。',
    'sales_point.error.lose_presenter': '紹介した方の価格の入力が必須です。',
    'sales_point.error.lose_persentee': '紹介された方の価格の入力が必須です。',
    'sales_point.error.lose_total_supply': '提供可能4IRE総数量の入力が必須です。',
    'sales_point.error.price_persenter': '紹介した方の価格が0より大きくなければなりません。',
    'sales_point.error.price_persentee': '紹介された方の価格が0より大きくなければなりません。',
    'sales_point.error.price_default_price': 'デフォルト価格が0より大きくなければなりません。',
    'sales_point.error.price_total_supply': '提供可能4IRE総数量が0より大きくなければなりません。',
    'masterdata.text': 'マスターデータが変更されました。</br>ページをリロードしてください。',
    'unregistered_session.login': 'ログイン',
    'unregistered_session.text': 'セッションが切れています。もう一度ログインしてください。',
    'validation.messages._default': '{0}値が無効です。',
    'validation.messages.after': '{0}は{1}より大きくなければなりません。',
    'validation.messages.after2': '{0}は{1}以上でなければなりません。',
    'validation.messages.alpha_dash': '{0}には、英数字とハイフン、下線を含めることができます。',
    'validation.messages.alpha_num': '{0}には、英数字のみを含めることができます。',
    'validation.messages.alpha_spaces': '{0}には、英字とスペースのみを含めることができます。',
    'validation.messages.alpha': '{0}には、英字のみを含めることができます。',
    'validation.messages.before': '{0}は{1}より小さくなければなりません。',
    'validation.messages.before2': '{0}は{1}以下でなければなりません。',
    'validation.messages.between': '{0}は{1}から{2}までなければなりません。',
    'validation.messages.confirmed': '{0}の確認が一致しません。',
    'validation.messages.credit_card': '{0}項目が無効です。',
    'validation.messages.date_between': '{0}は{1}から{2}までなければなりません。',
    'validation.messages.date_format': '{0}は{1}形式でなければなりません。',
    'validation.messages.decimal': '{0}は数字で、少数点以下{1}桁を含めることができます。',
    'validation.messages.digits': '{0}は数字で、{1}桁を含まなければなりません。',
    'validation.messages.dimensions': '{0}は、{1}ピクセル×{2}ピクセルでなければなりません。',
    'validation.messages.email': '{0}は有効なメールアドレスでなければなりません。',
    'validation.messages.ext': '{0}は有効なファイルでなければなりません。',
    'validation.messages.image': '{0}は画像でなければなりません。',
    'validation.messages.in': '{0}は有効な値でなければなりません。',
    'validation.messages.integer': '{0}は整数でなければなりません。',
    'validation.messages.ip': '{0}は有効なIPアドレスでなければなりません。',
    'validation.messages.length': '{0}の文字数は:1桁でなければなりません。',
    'validation.messages.length2': '{0}の文字数は{1}から{2}までなければなりません。',
    'validation.messages.max': '{0}は{1}文字以下でなければなりません。',
    'validation.messages.max_value': '{0}は{1}以下でなければなりません。',
    'validation.messages.mimes': '{0}には有効なファイルタイプが必要です。',
    'validation.messages.min': '{0}は{1}文字以上でなければなりません。',
    'validation.messages.min_value': '{0}は{1}以上でなければなりません。',
    'validation.messages.not_in': ':0は有効な値でなければなりません。',
    'validation.messages.numeric': '{0}には、数字のみを含めることができます。',
    'validation.messages.regex': '{0}の形式が無効です。',
    'validation.messages.required': '{0}項目の入力は必須です。',
    'validation.messages.size': '{0}サイズは{1}以内としてください。',
    'validation.messages.url': '{0}は有効なURLではありません。',
    'validation.accepted': '{attribute}は受け入れられなければなりません。',
    'validation.active_url': '{attribute}は有効なURLではありません。',
    'validation.after': '{attribute}は{date}より大きい日付でなければなりません。',
    'validation.after_or_equal': '{attribute}は{date}以降の日付でなければなりません。',
    'validation.alpha': '{attribute}には文字のみを含めることができます。',
    'validation.alpha_dash': '{attribute}には文字、数字、ハイフンのみを含めることができます。',
    'validation.alpha_num': '{attribute}には文字と数字のみを含めることができます。',
    'validation.array': '{attribute}は配列でなければなりません。',
    'validation.attributes.account_name': '口座名義',
    'validation.attributes.account_number': '口座番号',
    'validation.attributes.bank_id': '銀行',
    'validation.attributes.base_price': 'ストップ価格',
    'validation.attributes.date_of_birth': '生年月日',
    'validation.attributes.new_password': '新しいパスワード',
    'validation.attributes.otp_recovery_code': '認証コード',
    'validation.attributes.recovery_code': '復元コード',
    'validation.attributes.password': 'パスワード',
    'validation.attributes.quantity': '数量',
    'validation.attributes.wallet_address': 'ウォレットアドレス',
    'validation.attributes.withdrawal_address': '出金アドレス',
    'validation.attributes.authentication_code': '認証コード',
    'validation.before': '{attribute}は{date}より小さい日付でなければなりません。',
    'validation.before_or_equal': '{attribute}は{date}以前の日付でなければなりません。',
    'validation.between.array': '{attribute}は{min}から{max}件である必要があります。',
    'validation.between.file': '{attribute}は{min}から{max}キロバイトまでなければなりません。',
    'validation.between.numeric': '{attribute}は{min}から{max}までなければなりません。',
    'validation.between.string': '{attribute}は{min}から{max}文字までなければなりません。',
    'validation.boolean': '{attribute}はtrueまたはfalseでなければなりません。',
    'validation.confirmed': '{attribute}の確認が一致しません。',
    'validation.correct_otp': '認証コードは正しくありません。',
    'validation.custom.agree_term.required': '利用規約を読み、同意する必要があります。',
    'validation.custom.attribute-name.rule-name': 'お客様のメッセージ',
    'validation.custom.base_price.min': 'ストップ価格は、{min}以下でなければなりません',
    'validation.custom.base_price.precision': 'ストップ価格は{precision}桁でなければなりません',
    'validation.custom.id_back.image': 'ファイルは画像でなければなりません。',
    'validation.custom.id_back.mimes': 'ファイルは{values}形式のファイルでなければなりません。',
    'validation.custom.id_front.image': 'ファイルは画像でなければなりません。',
    'validation.custom.id_front.mimes': 'ファイルは:values形式のファイルでなければなりません。',
    'validation.custom.id_selfie.image': 'ファイルは画像でなければなりません。',
    'validation.custom.id_selfie.mimes': 'ファイルは:values形式のファイルでなければなりません。',
    'validation.custom.image': 'ファイルは画像でなければなりません。',
    'validation.custom.image.mimes': 'ファイルは{values}形式のファイルでなければなりません。',
    'validation.custom.password.confirmed': 'パスワードは確認用パスワードと一致する必要があります。',
    'validation.custom.password.correct_password': 'パスワードが正しくありません。',
    'validation.custom.password.min': 'パスワードは大文字、小文字、数字を含む8文字以上で、確認用パスワードと一致しなければなりません。',
    'validation.custom.password.regex': 'パスワードは大文字、小文字、数字を含む8文字以上で、確認用パスワードと一致しなければなりません。',
    'validation.custom.price.min': '価格は最低{min}でなければなりません',
    'validation.custom.price.precision': 'ストップ価格は{precision}の桁でなければなりません',
    'validation.custom.quantity.min': '数量は{min}以上でなければなりません',
    'validation.custom.quantity.precision': '数量は{precision}桁でなければなりません',
    'validation.custom.total.min': '合計は最低{min}でなければなりません',
    'validation.custom.total.precision': '合計は{precision}桁でなければなりません',
    'validation.date': 'attribute}は有効な日付ではありません。',
    'validation.date_format': '{attribute}がフォーマット:formatと一致しません。',
    'validation.different': '{attribute}と{other}は異なる必要があります。',
    'validation.digits': '{attribute}は{min}桁でなければなりません。',
    'validation.digits_between': '{attribute}は{min}から{max}の数字でなければなりません。',
    'validation.dimensions': '{attribute}の画像サイズが無効です。',
    'validation.distinct': '{attribute}の値が重複しています。',
    'validation.email': '{attribute}は有効なメールアドレスでなければなりません。',
    'validation.exists': '選択された{attribute}は無効です。',
    'validation.file': '{attribute}はファイルでなければなりません。',
    'validation.filled': '{attribute}の入力は必須です。',
    'validation.image': '{attribute}は画像でなければなりません。',
    'validation.in': '選択された:attributeは無効です。',
    'validation.in_array': '{attribute}は{other}に存在しません。',
    'validation.integer': '{attribute}は整数でなければなりません。',
    'validation.ip': '{attribute}は有効なIPアドレスでなければなりません。',
    'validation.ipv4': '{attribute}は有効なIP4アドレスでなければなりません。',
    'validation.ipv6': '{attribute}は有効なIP6アドレスでなければなりません。',
    'validation.is_withdrawal_address': '{attribute}が無効です。',
    'validation.json': '{attribute}は有効なJSON文字列である必要があります。',
    'validation.max.array': '{attribute}は{max}を超えられません。',
    'validation.max.file': '{attribute}は{max}キロバイト以下でなければなりません。',
    'validation.max.numeric': '{attribute}は{max}より大きくすることはできません。',
    'validation.max.string': '{attribute}は{max}文字以下にする必要があります。',
    'validation.mimes': '{attribute}は{values}型のファイルでなければなりません。',
    'validation.mimetypes': ':attributeは:values型のファイルでなければなりません。',
    'validation.min.array': '{attribute}には{min}以上が必要です。',
    'validation.min.file': '{attribute}は{min}キロバイト以上でなければなりません。',
    'validation.min.numeric': '{attribute}は{min}以上でなければなりません。',
    'validation.min.string': '{attribute}は{min}文字以上でなければなりません。',
    'validation.min_value': '{attribute}は{min}以上でなければなりません。',
    'validation.not_in': '選択された:attributeは無効です。',
    'validation.numeric': '{attribute}は数字でなければなりません。',
    'validation.otp': '認証に失敗しました。',
    'validation.otp_not_used': '次の認証コードが生成されるまでお待ちください。',
    'validation.otp_or_google_auth_required': 'Google認証コードを入力する必要があります',
    'validation.otp_incorrect': '認証コードは正しくありません。',
    'validation.password_white_space': 'パスワードに空白を含まないでください。',
    'password_white_space': 'パスワードに空白を含まないでください。',
    'validation.precision': '{attribute}の値は{precision}桁でなければなりません',
    'validation.present': '{attribute}は必須です。',
    'validation.regex': '{attribute}の形式が無効です。',
    'validation.required': '{attribute}の入力は必須です。',
    'validation.required_if': '{other}が{value}の場合{attribute}の入力は必須です。',
    'validation.required_unless': '{attribute} は{other} が{values}でなければ必須です。',
    'validation.required_with': '{attribute}は{values}が入力されている場合は必須です',
    'validation.required_with_all': ':valuesが存在している場合、:attributeの入力は必須です。',
    'validation.required_without': '{attribute}は{values}が入力されていない場合は必須です',
    'validation.required_without_all': '{attribute}は{values}が入力されていない場合は必須です',
    'validation.same': '{attribute}は{other}と同じ場合のみ有効です',
    'validation.size.array': '{attribute}は{size}個のみ有効です',
    'validation.size.file': '{attribute}は{size}KBのみ有効です',
    'validation.size.numeric': '{attribute}は{size}のみ有効です',
    'validation.size.string': '{attribute}は{min}文字以上のみ有効です',
    'validation.string': '{attribute}は文字列のみ有効です',
    'validation.timezone': '{attribute}正しいタイムゾーンのみ有効です',
    'validation.unique': '{attribute}は既に存在します。',
    'validation.unique_email': 'このEmailは既に使用されています',
    'validation.unique_referrer_code': '無効なリファラルコードです。',
    'validation.unique_withdrawal_address_in_user': 'この出金アドレスは既に存在しています。',
    'validation.uploaded': '{attribute}アップロードに失敗しました。',
    'validation.url': ':attributeの形式が無効です。',
    'validation.verified_email': 'メールはまだ確認されていません。',
    'validation.verify_otp_or_google_auth': 'Google認証コードを正しく入力する必要があります',
    'validation.verify_otp_recovery_code': '{attribut}が正しくありません。',
    'validation.verify_otp_recovery_code_with_auth': ':attributeが正しくありません。',
    'validation.authen_code_required': '認証コードの入力は必須です。',
    'validation.unverified_email': 'アカウントを有効化するためにメールを確認してください',
    'withdraw_guide.currency': '通貨',
    'withdraw_guide.deposit_fee': '入金手数料',
    'withdraw_guide.email': 'メール確認',
    'withdraw_guide.gauthen': 'Google認証システム',
    'withdraw_guide.fee': '手数料',
    'withdraw_guide.fee_withdrawal': '出金手数料',
    'withdraw_guide.free': '無料',
    'withdraw_guide.gotp': 'Google OTP',
    'withdraw_guide.identity_verification': '本人確認',
    'withdraw_guide.level': '各レベル',
    'withdraw_guide.level_name': 'レベル',
    'withdraw_guide.level_title': '現在の認証レベル',
    'withdraw_guide.limit_tip1': '出金制限は認証レベルによって異なります。',
    'withdraw_guide.limit_tip2': '市場の状況および関連銀行（銀行）の規制によっては、上記の出金制限は予告なしに変更されることがあります。',
    'withdraw_guide.limit_tip3': '不正な取引が疑われる場合、出金は制限されることがあります。',
    'withdraw_guide.limit_tip4': '出金手数料は、通貨の金額にかかわらず、固定金額で請求されます。',
    'withdraw_guide.limit_tip5': '仮想通貨を出金する場合、実際の手数料はブロックチェーンに応じて表示される手数料と変わることがあります。',
    'withdraw_guide.limit_title1': '1.認証レベルによる出金制限',
    'withdraw_guide.limit_title2': '2.入出金手数料および出金の最少金額',
    'withdraw_guide.minimum_withdrawal': '出金の最少金額',
    'withdraw_guide.one_day': '1日',
    'withdraw_guide.one_time': '1回',
    'withdraw_guide.phone': '電話認証',
    'withdraw_guide.security_method': '認証方法',
    'withdraw_guide.support_withdrawal': '入出金の方法',
    'withdraw_guide.usd': 'USD',
    'trade_type.buy': '買',
    'trade_type.sell': '売',
    'common.message.network_error': 'サーバに接続できません。',
    'common.status.expired': '期限切れ',
    'common.status.new': '新しい',
    'common.status.success': '成功',
    'common.status.pending': '保留する',
    'common.status.cancel': 'キャンセル',
    'common.status.error': 'エラー',
    'common.status.untriggered': 'トリガーされていない',
    'common.search': '検索',
    'common.action.confirm': '確認する',
    'common.action.reject': '拒否する',
    'common.kyc.pending': '保留する',
    'common.kyc.verified': '承認済み',
    'common.order_status.pending': '保留する',
    'common.empty_data': 'データがありません。',
    'menu.orders.orders': '注文',
    'menu.orders.open_order': '注文一覧',
    'menu.orders.order_history': '注文履歴',
    'menu.orders.trade_history': '取引履歴',
    'menu.notices': '通知',
    'menu.email_marketing': 'メールマーケティング',
    'menu.home': 'ホーム',
    'usd_transaction.time': '日時',
    'usd_transaction.user': 'メールアドレス',
    'usd_transaction.user1': 'ユーザー',
    'usd_transaction.account': '数量',
    'usd_transaction.account_name': '口座名義',
    'usd_transaction.bank_name': '銀行',
    'usd_transaction.bank_branch': '支店',
    'usd_transaction.status': 'ステータス',
    'usd_transaction.amount': '数量',
    'transactions.deposit_usd.yes': 'はい',
    'transactions.deposit_usd.no': 'いいえ',
    'transactions.deposit_usd.confirm': 'この取引を承認しますか？',
    'transactions.deposit_usd.reject': 'この取引を拒否しますか？',
    'transactions.withdrawal.send': 'この取引を送信しますか？',
    'transactions.withdrawal.cancel': 'この取引を取り消しますか？',
    'kyc.list': 'KYC一覧',
    'kyc.input_search': '検索',
    'kyc.created_at': '日時',
    'kyc.email': 'メールアドレス',
    'kyc.name': '氏名',
    'kyc.country': '国',
    'kyc.id_number': 'パスポート/IDナンバー',
    'kyc.status': 'ステータス',
    'kyc.gender': '性別',
    'kyc.id_front': '身分証明書の表面/パスポートの表紙',
    'kyc.id_back': '身分証明書の裏面/パスポートのデータありページ',
    'kyc.id_selfie': '身分証明書及びメモと一緒に撮影した自分自身の写真（セルフィー）',
    'kyc.btn_detail': '詳細',
    'kyc.btn_verify': '確認',
    'kyc.btn_reject': '拒否する',
    'kyc.notice_verify_confirm': 'このKYCを承認しますか？',
    'kyc.notice_reject_confirm': 'このKYCを拒否しますか？',
    'kyc.detail_kyc': 'KYC詳細',
    'kyc.msg_verified': 'KYCは管理者により承認されます。情報を変更できません。',
    'kyc.msg_verified.successfully': '確認されました。',
    'kyc.msg_rejected.successfully': '拒否されました。',
    'user.id': 'ID',
    'user.user': 'メールアドレス',
    'user.user_information': 'ユーザー情報',
    'user.date': '日付',
    'user.email': 'メールアドレス',
    'user.fee_level': '手数料レベル',
    'user.security_level': 'セキュリティレベル',
    'user.max_security_level': '最大セキュリティレベル',
    'user.referrer_code': 'リファラルコード',
    'user.referrer_mail': 'リファラルメール',
    'user.type': '種別',
    'user.status': 'ステータス',
    'user.group': 'グループ',
    'user.memo': 'メモ',
    'user.normal': '一般',
    'user.bot': 'bot',
    'user.inactive': '無効',
    'user.active': '有効',
    'user.save': '保存する',
    'user.edit': '編集',
    'user.device': 'デバイス',
    'user.recent_activity': '最近のアクティビティ',
    'mam.manage_sub_orders': 'サブ注文管理',
    'mam.mam_funds': '資産',
    'mam.create_master_account': 'マスターアカウントを作成する',
    'mam.create_account': 'アカウントを作成する',
    'mam.close_account': 'アカウントを閉じる',
    'mam.create': '作成',
    'mam.id': 'ID:',
    'mam.show_pending_only': '保留中のみを表示する',
    'mam.initial_amount': 'Initial amount (BTC)',
    'mam.initial_amount_note_1': '* Only top 10 traders on margin\'s leaderboard (both by notional or ROE) can open a fund.',
    'mam.initial_amount_note_2': '* If you want to open a fund account, you need to join your own fund. Minimum amount is 0.5 BTC.',
    'mam.initial_amount_note_3': '* If the trading on the fund account is loss-making, you will suffer losses as well. However, the bigger master capital is the more attractive fund looks for potential followers.',
    'mam.join': '参加',
    'mam.joined_date': '参加日',
    'mam.join_fund': '参加資金',
    'mam.overview': '概要',
    'mam.followers': 'フォロワー',
    'mam.commission_history': '手数料履歴',
    'mam.create_close_master': 'Create/Close Master Account',
    'mam.follower_id': 'フォロワーID',
    'mam.total_capital': '資金合計',
    'mam.total_balance': 'Total Balance',
    'mam.high_watermark': 'ハイウォーターマーク',
    'mam.unrelised_pnl': '未実現損益',
    'mam.joined_at': '参加',
    'mam.interval': 'Interval',
    'mam.entry_capital': '参入資産',
    'mam.exit_capital': '退出資産',
    'mam.entry_balance': '参入資産',
    'mam.exit_balance': '退出資産',
    'mam.commission': 'Commission',
    'mam.assigned_amount': '指定金額',
    'mam.current_investment': '現在の投資',
    'mam.requests': 'リクエスト',
    'mam.report': '報告書',
    'mam.find': '探す',
    'mam.note': 'ノート',
    'mam.request_to_join': '参加を申請する',
    'mam.fund_not_exist': 'ファンドが無効です',
    'mam.revokable_amount': '無効にできる金額',
    'mam.freeze_time': '今月は凍結されています。あなたのリクエストは来月執行されます。',
    'user.action.add_to_group': 'グループへ追加',
    'user.action.delete_from_group': 'グループから削除',
    'user.alert.no_user_selected': 'ユーザーを1名以上選択してください。',
    'user.alert.no_group_selected': 'グループを1つ以上選択してください。',
    'device_management.title_device_management': 'デバイス管理',
    'user.succes': '更新されました。',
    'user.user_setting': 'ユーザ設定',
    'notice.edit_title_page': '通知更新',
    'notice.new_title_page': '通知作成',
    'notice.title': 'タイトル',
    'notice.date': '日付',
    'notice.search': '検索',
    'notice.reset': 'リセット',
    'notice.new': '新しい',
    'notice.support': 'サポートリンク',
    'notice.start': '開始',
    'notice.end': '終了',
    'notice.edit': '編集',
    'notice.delete': '削除',
    'notice.start_at': '開始',
    'notice.end_at': '終了',
    'notice.banner': 'バナー',
    'notice.submit': '提出',
    'notice.cancel': 'キャンセルする',
    'notice.confirm': '確認する',
    'notice.search_by_title': 'タイトルによる検索',
    'notice.choose_file': 'ファイルを選択',
    'notice.delete_data': 'この通知を削除しますか？',
    'notice.submit_data': 'この通知を提出しますか？',
    'notice.errors.required': 'この項目の入力は必須です。',
    'notice.errors.title.required': 'タイトルの入力は必須です。',
    'notice.errors.support_url.required': 'サポートリンクの入力は必須です。',
    'notice.errors.banner_url.required': 'バンナーの入力は必須です。',
    'notice.errors.maxsize': '画像サイズは10MB以内としてください。',
    'notice.errors.date': '終了日は開始日より後の日付を設定してください。',
    'notice.noticeEdit': '通知編集',
    'notice.banner_url': 'バナー',
    'notice.validate.image_type': '.jpg、.jpeg、.pngの拡張子であるファイルが必須です。',
    'orders.open_order.open_order': '注文一覧',
    'orders.open_order.date': '日付',
    'orders.open_order.pair': 'ペア',
    'orders.open_order.search_by_email': 'メールで検索',
    'orders.open_order.search': '検索',
    'orders.open_order.reset': 'リセット',
    'orders.open_order.time': '日時',
    'orders.open_order.trade_id': '取引ID',
    'orders.open_order.order_id': 'オーダー ID',
    'orders.open_order.email': 'メールアドレス',
    'orders.open_order.price': '価格',
    'orders.open_order.filled': '約定',
    'orders.open_order.fee': '手数料',
    'orders.open_order.total': '合計',
    'orders.open_order.type': '種別',
    'orders.open_order.action': 'アクション',
    'orders.open_order.amount': '数量',
    'orders.open_order.trigger_condition': 'トリガー条件',
    'orders.open_order.status': 'ステータス',
    'orders.open_order.average': '平均',
    'orders.open_order.side': 'サイド',
    'orders.open_order.buy': '買',
    'orders.open_order.sell': '売',
    'orders.open_order.all': 'すべて',
    'orders.open_order.trade_history': '取引履歴',
    'orders.open_order.index': 'No.',
    'orders.open_order.view_detail': '詳細を表示',
    'orders.open_order.market': 'マーケット',
    'orders.order_history.order_history': '注文履歴',
    'orders.order_history.date': '日付',
    'orders.order_history.pair': 'ペア',
    'orders.order_history.search_by_email': 'メールで検索',
    'orders.order_history.search': '検索',
    'orders.order_history.reset': 'リセット',
    'orders.order_history.time': '日時',
    'orders.order_history.trade_id': '取引ID',
    'orders.order_history.order_id': 'オーダー ID',
    'orders.order_history.email': 'メールアドレス',
    'orders.order_history.price': '価格',
    'orders.order_history.filled': '約定',
    'orders.order_history.fee': '手数料',
    'orders.order_history.total': '合計',
    'orders.order_history.type': '種別',
    'orders.order_history.action': 'アクション',
    'orders.order_history.amount': '数量',
    'orders.order_history.trigger_condition': '約定条件',
    'orders.order_history.status': 'ステータス',
    'orders.order_history.average': '平均',
    'orders.order_history.side': 'サイド',
    'orders.order_history.buy': '買',
    'orders.order_history.sell': '売',
    'orders.order_history.all': 'すべて',
    'orders.order_history.hide_all_canceled': '全てのキャンセルを隠す',
    'orders.order_history.trade_history': '取引履歴',
    'orders.order_history.index': 'No.',
    'orders.order_history.view_detail': '詳細',
    'orders.order_history.market': 'マーケット',
    'orders.trade_history.trade_history': '取引履歴',
    'orders.trade_history.date': '日付',
    'orders.trade_history.pair': 'ペア',
    'orders.trade_history.search_by_email': 'メールで検索',
    'orders.trade_history.search': '検索',
    'orders.trade_history.reset': 'リセット',
    'orders.trade_history.time': '日時',
    'orders.trade_history.trade_id': '取引ID',
    'orders.trade_history.original_buy_order_id': '元の購入注文ID',
    'orders.trade_history.buyer_email': '購入者のメールアドレス',
    'orders.trade_history.original_sell_order_id': '元の売却注文ID',
    'orders.trade_history.seller_email': '売却者のメールアドレス',
    'orders.trade_history.price': '価格',
    'orders.trade_history.filled': '約定',
    'orders.trade_history.buy_fee': '購入の手数料',
    'orders.trade_history.sell_fee': '売却の手数料',
    'orders.trade_history.total': '合計',
    'orders.trade_history.market': 'マーケット',
    'orders.trade_history.all': 'すべて',
    'email.modal': 'このメールマーケティングを提出しますか？',
    'email.edit_title_page': 'メールマーケティング編集',
    'email.new_title_page': 'メールマーケティング作成',
    'email.send_title_page': 'メール送信',
    'email.new': 'メールマーケティング作成',
    'email.title': 'タイトル',
    'email.content': 'コンテンツ',
    'email.submit_data': '本当に提出しますか？',
    'email.delete_data': '削除しますか？',
    'email.send_all': '全ユーザーへ送信',
    'email.list_user': 'リスト上のユーザーへ送信',
    'email.send': '送信',
    'email.errors.title.required': 'タイトルの入力は必須です。',
    'email.errors.content.required': '内容の入力は必須です。',
    'withdraw_fee_setting.title': '出金手数料の設定',
    'withdraw_fee_setting.daily_limit': '一日の制限',
    'withdraw_setting.change_confirm': '出金手数料を変更しますか？',
    'withdraw_fee_setting.disable_confirm': '出金を無効にしますか？',
    'withdraw_fee_setting.disable_all_confirm': '全ての出金を無効にしますか？',
    'withdraw_fee_setting.enable_confirm': '出金を有効にしますか？',
    'withdraw_fee_setting.enable_all_confirm': '出金を有効にしますか？',
    'withdraw_fee_setting.disable_deposit_confirm': '入金を無効にしますか？',
    'withdraw_fee_setting.disable_all_deposit_confirm': '全ての入金を無効にしますか？',
    'withdraw_fee_setting.enable_deposit_confirm': '入金を有効にしますか？',
    'withdraw_fee_setting.enable_all_deposit_confirm': '全ての入金を有効にしますか？',
    'withdraw_fee_setting.update_success_msg': '更新されました。',
    'withdraw_fee_setting.disable_success_msg': '無効になりました！',
    'withdraw_fee_setting.disable_all_success_msg': '全て無効になりました！',
    'withdraw_fee_setting.enable_success_msg': '有効になりました！',
    'withdraw_fee_setting.enable_all_success_msg': '全て有効になりました！',
    'withdraw_fee_setting.withdraw_setting': '出金の設定',
    'withdraq_fial_popup_confirmation_label': 'この取引を承認しますか？',
    'currency.amal': '4IRE',
    'salespoint.balances': '残高',
    'salespoint.bonus': 'ボーナス',
    'salespoint.buy': '買',
    'salespoint.buy_history': '購入履歴',
    'salespoint.buy_history.amount': '数量',
    'salespoint.buy_history.amal': '4IRE',
    'salespoint.buy_history.bonus': 'ボーナストークン',
    'salespoint.buy_history.currency': '通貨',
    'salespoint.buy_history.time': '日時',
    'salespoint.buy_history.cash_back': '紹介料',
    'salespoint.buy_history.email': 'メールアドレス',
    'salespoint.buy_success': '注文は完了しました！',
    'salespoint.buy_fail': '注文は失敗しました！',
    'salespoint.export_complete_buy_history': '完全な4IRE履歴を抽出',
    'salespoint.export_complete_buy_history_tooltip': '6ヶ月間の購入履歴を抽出する',
    'salespoint.login': 'ログイン',
    'salespoint.or': 'or',
    'salespoint.register': '登録',
    'salespoint.to_trade': '取引する',
    'salespoint.total_remaining_supply': '4IREの総残高',
    'margin.positions': 'オープンポジション',
    'margin.close_positions': '決済済みポジション',
    'margin.active_orders': 'アクティブな注文',
    'margin.funding_8_hours': '8時間ごと',
    'margin.active_order': '有効なアクティブオーダーがありません',
    'margin.stops': 'ストップ',
    'margin.fills': '約定',
    'margin.order_history': '注文履歴',
    'margin.balance': '残高',
    'margin.isolated_balance': '分離残高',
    'margin.cross_equity': 'クロスエクイティ',
    'margin.unrealised_pnl': '未実現損益',
    'margin.cross_margin': 'クロス証拠金',
    'margin.order_margin': 'オーダー証拠金',
    'margin.available_balance': '利用可能残高',
    "margin.close_position_at": "Close Order at",
    'margin.symbol': 'シンボル',
    'margin.symbol.btc': 'BTC',
    'margin.symbol.eth': 'ETH',
    'margin.symbol.eth.coinname': 'イーサリアム',
    'margin.symbol.btc.coinname': 'ビットコイン',
    'margin.symbol.ada.coinname': 'カルダノ',
    'margin.symbol.bch.coinname': 'Bitcoin Cash',
    'margin.symbol.eos.coinname': 'EOS',
    'margin.symbol.ltc.coinname': 'Litecoin',
    'margin.symbol.trx.coinname': 'TRON',
    'margin.symbol.xrp.coinname': 'リップル',
    'margin.symbol.usd.coinname': 'USD',
    'margin.symbol.xbtusd': 'XBTUSD',
    'margin.symbol.xbt7d_u105': 'XBT7D_U105',
    'margin.symbol.xbt7d_d95': 'XBT7D_D95',
    'margin.symbol.xbtu19': 'XBTU19',
    'margin.symbol.ethusd': 'ETHUSD',
    'margin.symbol.btcusd': 'BTCUSD',
    'margin.symbol.ada': 'ADA',
    'margin.symbol.bch': 'BCH',
    'margin.symbol.eos': 'EOS',
    'margin.symbol.ltc': 'LTC',
    'margin.symbol.trx': 'TRX',
    'margin.symbol.xrp': 'XRP',
    'margin.instrument.guide': '{symbol} ({coinname}) ガイド',
    'margin.positions_symbol': 'マーク',
    'margin.contract.label.bitcoin_index_minute': 'ビットコインインデックス　1分毎の価格',
    'margin.bitcoin_index_minute': 'Bitcoin Index 1-Minute Price',
    'margin.size': 'サイズ',
    'margin.value': '価値',
    'margin.entry': '参入',
    'margin.minimum_amount': 'Minimum Amount',
    'margin.exit': '退出',
    'margin.entry_price': '参入価格',
    'margin.close_price': '退出価格',
    'margin.mark_price': 'マークプライス',
    'margin.liq_price': '清算価格',
    'margin.margin': '証拠金',
    'margin.unrealised_PNL': '未実現損益 (ROE %)',
    'margin.realised_PNL': '実現損益',
    'margin.close': '決済',
    'margin.market': 'マーケット',
    'margin.last_price': '直近の価格',
    'margin.bid_price': 'Bid価格',
    'margin.ask_price': 'Ask価格',
    'margin.open_value': 'オープンバリュー',
    'margin.contract_value': '契約価額',
    'margin.expiry_date': '有効期限',
    'margin.prev_price_24h': '前24hの価格',
    'margin.last_change': '24h変更率%',
    'margin.reference': '参照資料',
    'margin.reference_symbol': '参照銘柄',
    'margin.qty': '数量',
    'margin.order_price': '注文価格',
    'margin.filled': '約定',
    'margin.remaining': '残り',
    'margin.order_value': '注文価額',
    'margin.fill_price': '約定価格',
    'margin.type': '種別',
    'margin.status': 'ステータス',
    'margin.time': '日時',
    'margin.cancel': 'キャンセルする',
    'margin.confirm': '確認する',
    'margin.stop_price': 'ストップ価格',
    'margin.trigger_price': 'トリガー価格',
    'margin.exec_qty': '執行数量',
    'margin.exec_price': '注文価格',
    'margin.order_id': 'オーダーID',
    'margin.orders': '注文',
    'margin.trades': '取引',
    'margin.limit': '指値',
    'margin.stop_limit': 'ストップ指値',
    'margin.stop_market': 'ストップ成行',
    'margin.trailing_stop': 'トレーリングストップ',
    'margin.take_profit_market': '利食い成行注文',
    'margin.take_profit_limit': '利食い指値注文',
    'margin.oco': 'OCO',
    'margin.ifd': 'IFD',
    'margin.limit_id': '指値_{id}',
    'margin.stop_limit_id': 'ストップ指値_{id}',
    'margin.quantity': '数量',
    "margin.fee_rate": "Fee Rate",
    'margin.limit_price': '指値価格',
    'margin.trail_value': 'トレイル値',
    'margin.buy_long': '購入/買う',
    'margin.sell_short': '売り/売り',
    'margin.buy_market': '成行買い注文',
    'margin.sell_market': '成行売り注文',
    'margin.set_buy_stop': '買いストップ',
    'margin.sell_buy_stop': '売りストップ',
    'margin.btn_buy_limit': '購入/買う',
    'margin.btn_buy_market': '買い成行注文',
    'margin.btn_buy_stop_limit': '逆指値買い設定',
    'margin.btn_buy_stop_market': '逆指値買い設定',
    'margin.btn_buy_trailing_stop': '逆指値買い設定',
    'margin.btn_buy_take_profit_market': '利食い買い注文',
    'margin.btn_buy_take_profit_limit': '利益確定買い',
    'margin.btn_buy_oco': '購入/買う',
    'margin.btn_buy_ifd': '購入/買う',
    'margin.btn_sell_limit': '売り/売り',
    'margin.btn_sell_market': '売り成行注文',
    'margin.btn_sell_stop_limit': 'ストップ注文売り',
    'margin.btn_sell_stop_market': '逆指値売り設定',
    'margin.btn_sell_trailing_stop': '逆指値売り設定',
    'margin.btn_sell_take_profit_market': '利食い売り注文',
    'margin.btn_sell_take_profit_limit': '利益を売り',
    'margin.btn_sell_oco': '売り/売り',
    'margin.btn_sell_ifd': '売り/売り',
    'margin.buy': '買',
    'margin.sell': '売',
    'margin.trigger': 'トリガ',
    'margin.cost': 'コスト',
    'margin.mark': 'マークプライス',
    'margin.last': 'ラストプライス',
    'margin.index': 'インデックス',
    'margin.close_on_trigger': 'トリガ時に決済',
    'margin.post_only': 'Post-Only',
    'margin.hidden': '非表示',
    'margin.reduce_only': '減少限定',
    'margin.display_qty': '数量を表示',
    'margin.your_position': '現行のポジション',
    'margin.contracts': '契約',
    'margin.contract.perpetual': '無期限',
    'margin.roe': 'ROE',
    'margin.risk_limit': 'リスク制限',
    'margin.leverage': 'レバレッジ',
    'margin.maximum_leverage': '最大レバレッジ',
    'margin.pricing_source_details': '価格データに使用されるソース',
    'margin.buy_sell_information_limit': 'クリックすると、{symbol}契約の​​{side}{type}注文を{price}で{quantity}枚を注文します。正常に執行された場合、ポジションは{positionSize}から{afterPositionSize}になります。<br> <br>約定後の推定清算価格は{liquidationPrice}になります。',
    'margin.buy_sell_information_market': 'クリックすると、{symbol}契約の{side}{type}注文を成行で{quantity}枚注文します。正常に執行された場合、ポジションサイズは{positionSize}から{afterPositionSize}になります。<br> <br>約定後の推定清算価格は{liquidationPrice}になります。',
    'margin.buy_sell_information_stop_limit': 'クリックすると、{symbol}契約の{side}{type}注文を{price}で{quantity}枚注文します。 {stopPrice}以上の{triggerType}でトリガします。正常に執行された場合、ポジションサイズは{positionSize}から{afterPositionSize}になります。　　　　　',
    'margin.buy_sell_information_stop_market': 'クリックすると、{symbol}契約の{side}{type}注文を{quantity}枚注文します。{stopPrice}以上の{triggerType}でトリガします。正常に執行された場合、ポジションサイズは{positionSize}から{afterPositionSize}になります。　　　　　',
    'margin.buy_sell_information_trailing_stop': 'マーケットで{数量}契約{シンボル}の{side} {type}注文を送信するためにクリックしてください。 {stopPrice}以上の{triggerType}で実行します。正常に実行された場合、これはあなたのポジションサイズを{positionSize}から{afterPositionSize}契約に変更します。',
    'margin.buy_sell_information_take_profit_limit': '{price}で{quantity}契約{symbol}の​​{side} {type}注文を送信するためにクリックします。 {stopPrice}以上の{triggerType}で実行されます。正常に実行された場合、これはポジションサイズを{positionSize}から{afterPositionSize}に変更します。',
    'margin.buy_sell_information_take_profit_market': 'マーケットで{数量}契約{シンボル}の{side} {type}注文を送信するためにクリックしてください。 {stopPrice}以上の{triggerType}で実行します。正常に実行された場合、これはあなたのポジションサイズを{positionSize}から{afterPositionSize}契約に変更します。',
    'margin.buy_sell_information_oco': 'OCO注文：One-Cancels-the-Other orderの略で、2つの注文を同時に出して一方の注文が成立した際にもう一方の注文が自動的にキャンセルされる注文パターンです。',
    'margin.buy_sell_information_ifd': 'IFDは一度に2つの注文を出して最初の注文が約定したら2つめの注文が自動的に発注される注文パターンです。',
    'margin.perpetual_contract_tooltip': 'これは決済期限のない無期限契約です。',
    'margin.contract_guide_tooltip': '{symbol}の​​ルートシンボルは{rootSymbol}です。クリックするとシリーズガイドを表示できます。',
    'margin.index_price_tooltip': 'インデックス価格：これは原資産の価格です。',
    'margin.mark_price_tooltip': 'マークプライス：現在のマークプライスです。',
    'margin.cost_tooltip': 'コスト：{cost}BTCです。この注文を執行するコスト（証拠金）です。選択した証拠金および（該当する場合）現在のポジションが含まれます。ポジションの減少には証拠金を必要としません。',
    'margin.order_value_tooltip': '注文価額：{orderValue}BTCです。この注文の合計想定価値です。',
    'margin.avai_balance_tooltip': '利用可能残高：{avaiBalance}BTCです。注文に利用可能な残高です。',
    'margin.post_only_tooltip': 'Post-Only注文はマーケットで即時に執行されません。メーカー手数料を確保するために使用します。執行待ち注文を対象に注文すると、執行されずにキャンセルされます。',
    'margin.hidden_tooltip': '非表示注文はオーダーブックに表示されない注文です。',
    'margin.display_qty_tooltip': '完全に非表示にする注文は「ゼロ（0）」に設定します。注文合計高未満の額に設定するとアイスバーグ注文を作ることができます。',
    'margin.reduce_only_tooltip': 'Reduce-Onlyオーダーはポジションを減らすだけでポジションを増やしません。このオーダーがポジションを増やす場合、修正されるかキャンセルされます。',
    'margin.time_in_force_tooltip': 'この注文の有効期限です。デフォルトは「Good Till Cancel」です。「Immediate Or Cancel」に設定している場合、未約定の残りのポジションは割当後即刻キャンセルされます。「Fill Or Kill」に設定している場合、全数量を即刻約定可能な場合のみ注文が執行されます。',
    'margin.trigger_tooltip': 'このストップをトリガーする価格の選択：<br> <br>最終価格：OG Exchangeの最終取引価格<br>インデックス価格：参照取引の最終価格<br>マーク価格：OG Exchangeの価格をマーク（インデックス+基準）」',
    'margin.close_trigger_tooltip': 'チェックが入っている場合、決済注文になります。決済注文はポジションを減らすのみで増やすことはありません。決済注文がトリガーされたときにアカウントの利用可能残高が不足している場合、注文はキャンセルされるか修正されます。 <br> <br>他のオープンオーダーに関係なく、ストップによってポジションは確実に減少します。',
    'margin.wallet_balance_tooltip': 'ウォレット残高 = (入金 - 出金 + 実現損益).',
    'margin.unrealised_pnl_tooltip': '未実現損益: すべてのオープンポジションの現在の損益',
    'margin.cross_equity_tooltip': 'クロスエクイティ: 取引所内の総資産。クロスエクイティ =（ウォレット残高 - オーダー中の証拠金 + 未実現損益）',
    'margin.isolated_balance_tooltip': '分離残高: 分離ポジションでのあなたの証拠金',
    'margin.cross_margin_tooltip': 'クロスマージン: クロスポジションでのあなたの証拠金',
    'margin.order_margin_tooltip': '注文証拠金: オープンオーダーを維持するために取引所に保持しなければならない最小エクイティ。保有するすべてのオープンオーダーの価額を選択したレバレッジで割った金額です。',
    'margin.available_balance_tooltip': '新規ポジションに利用可能な証拠金。利用可能残高 =（証拠金残高 - 注文証拠金 - ポジション証拠金）',
    'margin.24h_turnover_tooltip': '過去24時間以内の契約取引額。',
    'margin.open_value_tooltip': '既存の先物またはオプション契約の合計価額。',
    'margin.funding_rate_tooltip': 'ここに表示されている数値は、次の資金調達までの予測資金調達率です。マイナスの場合、売り持ち側が買い持ち側に支払います。',
    'margin.contract_value_tooltip': '単一契約の現在値。',
    'margin.your_position_tooltip': 'レバレッジの調整をすることができます。割当済みの証拠金のみが変動します。',
    'margin.roe_tooltip': 'ROE（株主資本利益率）です。',
    'margin.position_symbol_tooltip': 'このポジションが表す契約のティッカーシンボル。',
    'margin.last_price_tooltip': 'この契約の直近取引価格',
    'margin.last_price_24h_tooltip': '24時間前の最終取引価格',
    'margin.last_change_tooltip': '過去24時間の価格変動率',
    'margin.reference_tooltip': '満期時に決済価格の計算に使用される取引所',
    'margin.reference_symbol_tooltip': '期限切れ時に決済価格を計算するために使用される取引所',
    'margin.instrument_mark_price_tooltip': 'この契約の表示価格です。損益と証拠金の計算に使用されます。',
    'margin.bid_price_tooltip': 'この契約のベストビッド（売り）価格',
    'margin.ask_price_tooltip': 'この契約のベストアスク（買い）価格',
    'margin.expiry_date_tooltip': '当該契約の取引終了日時',
    'margin.limit_order_tooltip': '指値注文とは所定の価格以上で売買する最も一般的なタイプの注文です。',
    'margin.market_order_tooltip': '成行注文は市場に発注する最速の方法です。執行時に記録されているもっとも有利な価格で執行されます。レイテンシーによって予想より有利または不利な価格を得る結果が生じる場合があることに注意が必要です。',
    'margin.stop_limit_order_tooltip': 'A Stop Limit Order is like a Stop Order, but allows you to set the price of the order once your Stop Price is triggered. Use this as an alternative to Stop orders if you wish to control your exit.<br/>Note that, if your triggered order does not match against any orders in the book, your position may order_remain open. Set a deep price for best results.',
    'margin.stop_market_order_tooltip': 'A Stop Order is an order that does not enter the order book until the market reaches a certain Trigger Price. Traders use this type of order for two main strategies:<br/>1. As a risk-management tool to limit losses on existing positions <br/>2. As an automatic tool to enter the market at a desired entry point without manually waiting for the market to place the order.<br/>A Stop Order will become a Market Order when the Stop Price is reached.<br/>',
    'margin.trailing_stop_order_tooltip': 'A Trailing Stop Order is similar to a Stop Market Order, whereby you specify the Trailing Value differential to the Trigger Price, and if triggered then a Market Order will be placed.<br/>Note, a positive Trail Value indicates a trailing Buy whilst a negative Trail Value indicates a trailing Sell.',
    'margin.take_profit_limit_order_tooltip': 'A Take Profit Limit Order can be used to set a target price on a position. It is like a Stop, but triggers are set in the opposite direction.<br/>Use this to exit a position in profit, or to set an entry point for a new position.',
    'margin.take_profit_market_order_tooltip': 'A Take Profit Order can be used to set a target price on a position. It is like a Stop, but triggers are set in the opposite direction.<br/>Use this to exit a position in profit, or to set an entry point for a new position. A Take Profit Order becomes a Market Order once triggered.',
    'margin.order_quantity_tooltip': 'オーダー中の契約の数量',
    'margin.order_price_tooltip': '指値価格',
    'margin.order_filled_tooltip': '約定済みの契約枚数です。売買された注文に含まれる契約の枚数。注文が完了すると数量と等しくなります。',
    'margin.order_remaining_tooltip': '注文で売買待ちになっている契約の枚数。',
    'margin.order_value_contract_tooltip': '指値で注文での契約の想定価値',
    'margin.order_filled_price_tooltip': 'この注文で約定した平均価格',
    'margin.order_type_tooltip': '注文タイプ。オーダーパネルで利用可能な注文タイプを確認できます。',
    'margin.order_status_tooltip': '注文のステータス。注文が「新規」「部分約定済み」「約定済み」「キャンセル済み」であるかが分かります。「新規」のトリガー注文は、「トリガー待ち」と「トリガー済み」の2タイプがあります。「トリガー待ち」の場合、注文はオーダーブックにはまだ記載されていなく、当初証拠金は使用されていません。「トリガー済み」になると、注文リストにも表示されます。',
    'margin.order_time_tooltip': '注文の送信時間または最終変更時間です。マッチング時間の優先順位の判断に使用します。',
    'margin.order_executed_quantity_tooltip': 'この注文の執行で売買された契約の枚数。これは注文数量以下です。',
    'margin.order_executed_price_tooltip': 'この注文で執行した価格。この価格は注文価格より高くなることがあります。',
    'margin.value_tooltip': 'この執行で売買された契約の価額',
    'margin.stop_price_tooltip': 'ストップ注文でトリガーされオーダーブックに注文が記録される価格です。ストップ注文売りでは、契約の現在価格がストップ価格を割り込むとストップ注文がトリガーされます。ストップ注文買いでは、現在価格がストップ価格を突破するとストップ注文がトリガーされます。　',
    'margin.position_size_tooltip': 'この商品の現在のポジション。プラスの場合はロング、マイナスの場合はショートとなります。',
    'margin.position_value_tooltip': 'このポジションの現在の想定価値',
    'margin.position_entry_price_tooltip': 'Average executed buy/sell price for your current long/short position.',
    'margin.position_mark_price_tooltip': 'この契約の最新のマーク価格です。損益と証拠金の計算に使用される価格で、価格操作を回避するために直近価格と異なる場合があります。決済には影響しません。',
    'margin.position_liq_price_tooltip': '契約のマークプライスがこの価格を割り込む（ロング）か、この価格を突破（ショート）するとポジションは清算されます。',
    'margin.position_margin_tooltip': '各ポジションでロックされている証拠金です。ポジションで分離マージンがある場合、証拠金が減るためこの数値が下がり、実行するレバレッジは上昇します。注文パネルのレバレッジスライダーでポジションに割り当てる証拠金を調整して下さい。',
    'margin.position_unrealised_pnl_tooltip': 'この契約の未実現損益',
    'margin.position_lastest_realised_tooltip': 'This is your raw realised PNL since the last RealisedPNL wallet entry, which happens daily. When not hovering, we show realised PNL since opening the position.',
    'margin.trigger_price_tooltip': '原資産契約のマークプライスまたは直近価格。逆指値とこの価格を比較して、ストップ注文がトリガーされるレベルまでの間隔を判断します。',
    'margin.position_realised_pnl_tooltip': 'このポジションの構築時以降の実現損益。',
    'margin.cross': 'クロス',
    'margin.contract_details': '契約の詳細',
    'margin.pricing_source': '価格設定元',
    'margin.amanpuri_index': 'アマンプリインデックス',
    'margin.amanpuri_index_price': 'アマンプリインデックス価格',
    'margin.24h_volume': '24時間取引数量',
    'margin.open_interest': '建玉残高',
    'margin.funding_rate': '資金調達率',
    'des.des_spot_leaderboard': '現物取引リーダーボードランキングには、{start}から{end}までのデータのみが表示されます。',
    'title.Spot_Exchange_Leaderboard': '現物取引リーダーボード',
    'leaderboard.top_25_traders_by_vol': '取引量上位25名のトレーダー',
    'table.trading_volume': '取引量',
    'table.email': 'メールアドレス',
    'menu.leader_board': 'リーダーボード',
    'margin.in_hour': '{0}時間{1}分{2}秒',
    'margin.more_details': '詳細…',
    'margin.price': '価格',
    'margin.total': '合計',
    'margin.instruments': '商品',
    'margin.indices': 'インデックス',
    'margin.timestamp': 'タイムスタンプ',
    'margin.funding_interval': 'Funding Interval',
    'margin.funding_rate_daily': 'Funding Rate Daily',
    'margin.wallet_balance': 'ウォレット残高',
    'margin.settled_price': '決済価格',
    'margin.option_strike_price': 'オプションの権利行使価格',
    'margin.option_underlying_price': '原資産価格',
    'margin.profit_loss': '利益/損失',
    'margin.target_price': '目標価格',
    'margin.liquidation_price': '清算価格',
    'margin.position': 'ポジション',
    'margin.contract': '契約',
    'margin.cont': 'Cont',
    'margin.side': 'サイド',
    'margin.long': 'ロング',
    'margin.short': 'ショート',
    'margin.exit_price': '退出価格',
    'margin.roe_percent': 'ROE (%)',
    'margin.isolated': '分離',
    'margin.profit_loss_percent': '利益/損失 %',
    'margin.entry_value': '参入価額',
    'margin.exit_value': '退出価額',
    'margin.min_leverage_error': '値は{leverage}より小さくすることはできません。',
    'margin.max_leverage_error': '値は{leverage}を超えることはできません。',
    'margin.reduce_only_error': '{symbol}のオーダーを送信できませんでした：注文条件は”決済”または”減少”ですが、{quantity}を注文しています。現在のポシションは{current_qty}です。',
    'margin.add_margin_successful': 'マージンを追加しました！',
    'margin.remove_margin_successful': 'マージンを削除しました！',
    'margin.add_remove_max': 'Maximum',
    'margin.current_qty': '現在の数量',
    'margin.resulting_qty': '結果の数量',
    'margin.wallet': 'ウォレット',
    'margin.buy_limit': '指値注文買い',
    'margin.sell_limit': '指値注文売り',
    'margin.insufficient_vailable_balance': '注文できませんでした。合計証拠金 {cost} BTCは、利用可能残高の{availableBalance} BTCを超えています。',
    'margin.contract_of_symbol_at_limit_price': '{limitPrice}で{symbol}の{quantity} {contract}。',
    'margin.contract_of_symbol_at_market': '{Market}で{symbol}の{quantity} {contract}。',
    'margin.contract_of_symbol_at_limit_price_oco': '{stopPrice}で{symbol}の{quantity} {contract}。',
    'margin.contract_of': '契約',
    'margin.contracts_of': '契約',
    'margin.at': 'で',
    'margin.and': 'と',
    'margin.do_not_show_again': '再度表示しない',
    'margin.grouping': 'グループ化 {value}',
    'margin.note': '注意',
    'margin.alert_close_trigger_checked': 'このストップオーダーは、「トリガ時に決済注文」オンにして。クロスオーダーはポジションを縮小するだけで拡大することはできません。トリガ時に決済注文がオンされたときにアカウントの利用可能残高が不足している場合、他のBTCUSDオーダーはキャンセルまたは修正されます。これは、ストップが期待どおりに行われるようにするためのデフォルトの動作です。',
    'margin.alert_close_trigger_uncheck': 'このストップオーダーには「トリガ時に決済注文」オンしてありません。この注文がポジシションをオープンまたは拡大する可能性があり、他の注文がこのトリガ時に決済注文に利用可能残高を使う場合、それは実行されません。これを予期していなかった場合は、戻って「トリガ時に決済注文」を選択してください。',
    'margin.index_price': 'インデックス価格',
    'margin.and_below': '以下',
    'margin.and_above': '以上',
    'margin.trailing_stop_offset': 'トレーリンググストップオフセット',
    'margin.currently': '現在',
    'margin.ge_equal': '>=',
    'margin.le_equal': '<=',
    'margin.buy_take_profit_limit': '利食い指値買い注文',
    'margin.sell_take_profit_limit': '利食い指値売り注文',
    'margin.buy_take_profit_market': '利食い成行買い注文',
    'margin.sell_take_profit_market': '利食い成行売り注文',
    'margin.position_after_ex': '約定後のポシションサイズ',
    'margin.est_liqui_price': '推定清算価格',
    'margin.est_mark_price': '表記価格/概算清算差額',
    'margin.order.error.cost_gt_balance': '注文できませんでした。合計証拠金 {cost} BTCは、利用可能残高の{availableBalance} BTCを超えています。',
    'margin.order.error.join_funds_empty': '選択したサブアカウントは空白です！',
    'margin.order.succes.limit_market': '{price}で{symbol} の{side} {quantity} {contract}',
    'margin.contract.pluralization': '契約 | 契約',
    'margin.order.succes.stop_limit_market': '{side} {quantity} {contract} of {symbol} at {price}.<br />トリガー: {trigger} @ {trigger_price} {condition}.',
    'margin.order.succes.trailing_stop': '{side} {quantity} {contract} of {symbol} at {price}.<br />トレーリングストップオフセット: {trail_value} (Currently {triggerPrice})',
    'margin.order.succes.take_profit_limit_market': '{side} {quantity} {contract} of {symbol} at {price}.<br />トリガー: {trigger} @ {trigger_price} {condition}.',
    'margin.order.submitted': 'オーダー発注済み',
    'margin.order.filled': '約定した注文',
    'margin.order.success.limit_market.filled': '{symbol}を{price}で{quantity}枚売却しました。 この注文は完全に約定しました。',
    'margin.order.success.limit_market.partial_filled': '{symbol}を{price}で{quantity}枚売却しました。',
    'margin.position.liquid': 'ポジションは清算されました。',
    'margin.position.liquid.mes': '{symbol}のポジションは清算されました。',
    'margin.order.canceled': '注文をキャンセルしました。',
    'margin.order.canceled_success': '注文はキャンセルされました！',
    'margin.order.succes.close_positions': '{side} {quantity}枚の決済しました。',
    'margin.order.succes.head_model_positions': '{quantity}枚のポジションを決済しますか？',
    'margin.order.succes.content_model_positions': '<span class = "{class}"> {side} </ span> {quantity} {price} {market}での{symbol}の契約。',
    'margin.order.succes.bottom_model_positions_close': '約定するとポジション全体が決済されます。',
    'margin.order.succes.bottom_model_positions_market': '利用可能な市場価格でポジション全体を決済します。',
    'margin.symbol.guide_title': '{coinname} シリーズ ({symbol}) ガイド',
    'margin.init_margin': '最小当初証拠金',
    'margin.maint_margin': '最小維持証拠金',
    'margin.entry_taker_fee': '参入テイカー手数料',
    'margin.exit_taker_fee': '退出テイカー手数料',
    'margin.funding_base_symbol': '資金調達ベース記号',
    'margin.funding_quote_symbol': '資金調達クォート記号',
    'margin.funding_premium_symbol': '資金調達プレミアム記号',
    'margin.funding_interval_time': '{h}時間ごと',
    'margin.funding_timestamp': '資金調達タイムスタンプ',
    'margin.indicative_funding_rate': '指標的な資金調達率',
    'margin.adl_enabled': 'ADL有効（オートデレバレッジ）',
    'margin.adl_enabled.desc': 'はい：この契約はきわめて投機的でありADL（オートデレバレッジ）によって損失を管理します。',
    'margin.mark_method': 'マーク方法',
    'margin.fair_price': 'FairPrice',
    'margin.fair_basis': '公正ベーシス',
    'margin.fair_basis_rate': '公正ベーシスレート',
    'margin.fair_method': '公正な方法',
    'margin.fair_method.desc': 'この金融商品の公正ベーシスは資金調達率（年率）を計算して決められます。',
    'margin.risk_step': 'リスクステップ',
    'margin.turnover24h': '24時間の出来高',
    'margin.24hturnover': '24時間の出来高',
    'margin.total_volume': '総取引量',
    'margin.total_roe': 'Total ROE',
    'margin.type.desc': '{settle_currency}建てで決済し、{quote_currency}で見積もります。',
    'margin.contract_size': '契約サイズ',
    'margin.contract_dont_settle': 'この契約は無期限で決済期限はありません。',
    'margin.contract_has_settle': 'この契約は{time}時点の{settlement_index}インデックスの値で決済されます。',
    'margin.settlement': '決済',
    'margin.noSettlement_history': '決済履歴はありません',
    'margin.no_funding_history': '資金調達履歴はありません',
    'margin.commission': '発生報酬',
    'margin.commission.desc': '手数料については詳細をご覧ください。',
    'margin.min_increment': '価格の最小増加単位',
    'margin.max_price': '最高値',
    'margin.max_order_qty': '最大注文数量（枚数）',
    'margin.lot_size': 'ロットサイズ',
    'margin.contract_calculations': '契約計算',
    'margin.multiplier': '乘数',
    'margin.bitcoin_multiplier': '1米ドルあたりのビットコイン乗数',
    'margin.symbol_value': '{symbol} 値',
    'title.settlement': '決済',
    'title.then': 'それから',
    'title.or': 'or',
    'margin.symbol_contract_value': '{symbol} 契約価額',
    'margin.btc.eth_contract_value.desc': '乗数*先物価格 * 1 ETH',
    'margin.btc.btc_contract_value.desc': '乗数/ BTCUSD価格',
    'margin.usd.eth_contract_value.desc': 'BTC契約価額 *  BTCUSD',
    'margin.usd.btc_contract_value.desc': '1 USD',
    'margin.eth.pnl_calculation': '#契約数 * 乗数 *（参入価格 - 退出価格）',
    'margin.btc.pnl_calculation': '# 契約*乗数*（1 /入口価格-1 /出口価格）',
    'margin.pnl_calculation': '損益計算（PNL）',
    'margin.symbol_value.desc.eth.btc': 'ETHUSD価格 * ビットコイン乗数',
    'margin.symbol_value.desc.eth.usd': 'BTC価額 * BTC現物価格',
    'margin.symbol_value.desc.eth.eth': 'BTC　価格 / .ETHBTCスポット価格',
    'margin.bitcoin_pnl_calculation': 'ビットコイン損益計算（PNL）',
    'margin.bitcoin_pnl_calculation.desc': '（ETHUSD退出価格 - ETHUSD参入価格）* ビットコイン乗数 * ＃契約枚数',
    'margin.formula': '公式',
    'margin.formula.i': 'I = ( Q - B ) / T',
    'margin.formula.f': 'F = P + Clamp( I - P, -0.05%, 0.05% )',
    'margin.result': '結果',
    'margin.sub_account': 'サブアカウント',
    'margin.sub_account.manage_allocation': '分配管理',
    'margin.sub_account.id': 'ID',
    'margin.sub_account.name': '氏名',
    'margin.sub_account.is_active': 'アクティブ',
    'margin.sub_account.real_balance': '残高',
    'margin.sub_account.enable': '有効化',
    'margin.sub_account.disable': '無効化',
    'margin.sub_account.lot_percent': '%Lot',
    'margin.sub_account.allocation_method': '分配方法',
    'mam.allocation.lot': 'ロット配分',
    'mam.allocation.percent': '分配率　',
    'mam.allocation.balance': '残高分配',
    'mam.allocation.equity': '配当資産分配',
    'margin.order_history.no_data': '取引履歴はありません',
    'margin.add_remove_margin': 'ポシションマージンの追加/削除',
    'margin.add_margin': '証拠金を追加',
    'margin.remove_margin': '証拠金を削除',
    'margin.your_current_position': '現在のポシション',
    'margin.currently_assigned_margin': '現在割り当てられている証拠金',
    'margin.available_margin': '利用可能な証拠金',
    'margin.available_margin_1': '利用可能な証拠金',
    'margin.add': '追加',
    'margin.remove': '削除する',
    'margin.required': '証拠金は必須項目です。',
    'margin.insufficient': '証拠金が足りません。',
    'margin.cannot_add': '証拠金を追加できませんでした。',
    'margin.adjust_risk_limit': '{contract}リスク制限を調整する',
    'margin.des_risk_limit': 'OG Exchangeは、スライディングスケールのリスク制限機能を採用しています。 BTCUSDでは、基本リスク限度は{base} BTCです。<br/>ポジションサイズが<strong> {step} BTC </ strong>増加するごとに、メンテナンスおよび初期マージン<br/>要件が<strong>増加します。 {stepPercent}％</ strong>。',
    'margin.des_more_risk_limit': '詳細については、<a href="{link}">リスク制限のドキュメント</a>をご覧ください。',
    'margin.change_risk_limit': 'リスク制限の変更 (BTC)',
    'margin.maintenance_margin': '維持証拠金',
    'margin.initial_margin': '初期マージン',
    'margin.current': '現在',
    'margin.new': '新しい',
    'site_setting.android_app_link': 'アンドロイド版アプリ　リンク',
    'site_setting.site_email': 'メールアドレス',
    'site_setting.app_name': 'アプリ名',
    'site_setting.short_name': 'ショート名',
    'site_setting.copyright': '版権',
    'site_setting.facebook_icon': 'Facebookアイコン',
    'site_setting.facebook_link': 'Facebook リンク',
    'site_setting.ios_app_link': 'iOSアプリリンク',
    'site_setting.language': '言語',
    'site_setting.site_phone_number': '電話番号',
    'site_setting.phone_number': '電話番号',
    'site_setting.phone_number_valid': '電話番号は文字 \'+\'と国別コードで始まり、長さは7〜15桁の間でなければなりません。',
    'site_setting.site_setting': 'サイト設定',
    'site_setting.twitter_icon': 'Twitterアイコン',
    'site_setting.twitter_link': 'Twitterリンク',
    'site_setting.update_success_msg': '更新されました。',
    'site_setting.youtube_icon': 'Youtubeアイコン',
    'site_setting.youtube_link': 'Youtubeリンク',
    'site_setting.name': 'テキスト',
    'site_setting.icon': 'ファイル',
    'site_setting.icon_hover': 'テキスト',
    'site_setting.link': 'テキスト',
    'site_setting.general': '一般',
    'site_setting.mobile_application': 'モバイルアプリケーション',
    'site_setting.name_table': '氏名',
    'site_setting.icon_table': 'アイコンクラス',
    'site_setting.icon_hover_table': 'アイコンホバー',
    'site_setting.type_table': '種別',
    'site_setting.link_table': 'リンク',
    'site_setting.add_row_table': '+ 行を追加',
    'site_setting.status_table': 'ステータス',
    'site_setting.social_network.title': 'ソーシャルネットワーク',
    'site_setting.social_network.confirm_remove': 'ソーシャルネットワークを削除しますか？',
    'site_setting.social_network.create_success': 'ソーシャルネットワークが追加されました。',
    'site_setting.social_network.update_success': 'ソーシャルネットワークが更新されました。',
    'site_setting.social_network.remove_success': 'ソーシャルネットワークが削除されました。',
    'site_setting.social_network.errors.required.name': '名前の入力は必須項目です',
    'site_setting.social_network.errors.required.link': 'リンクの入力は必須です。',
    'site_setting.social_network.errors.required.icon_class': 'アイコンクラスの入力は必須項目です。',
    'site_setting.social_network.errors.required.type': 'タイプの入力は必須項目です。',
    'site_setting.social_network.errors.required.phone_number': '電話番号の入力は必須です。',
    'trading_fee_setting.fee_maker': 'メイカー手数料',
    'trading_fee_setting.fee_taker': 'テイカー手数料',
    'trading_fee_setting.coin_hodling': '{COIN_HOLDING}保有',
    'trading_fee_setting.msg_coin_holding': '保有するコインの設定は、各レベルごとに増やす必要があります。',
    'trading_fee_setting.id': 'ID',
    'trading_fee_setting.coin': 'コイン',
    'trading_fee_setting.trading_fee_setting': '手数料',
    'trading_fee_setting.trading_feeSetting': '取引手数料設定',
    'trading_fee_setting.trading_withdrawFeeSetting': '出金手数料設定',
    'trading_fee_setting.update_confirm': '取引手数料を変更しますか？',
    'trading_fee_setting.update_success_msg': '更新されました。',
    'trading_fee_setting.trading_selectMarket': '市場選択',
    'button.done': '済み',
    'button.reset': 'リセット',
    'user_setting.coin': 'コイン',
    'user_setting.id': 'Id',
    'user_setting.blockchain_address': 'ブロックチェーンアドレス',
    'user_setting.balance': '残高',
    'user_setting.available_balance': '利用可能残高',
    'user_setting.confirm_off_otp': 'OTPを無効にしますか？',
    'user_setting.confirm_on_otp': 'OTPを有効にしますか？',
    'user_setting.update_otp_msg': 'OTP設定の更新に成功しました！',
    'user_setting.confirm_disable_account': 'アカウントを無効にしますか？',
    'user_setting.disable_account_success_msg': 'アカウントを無効にしました！',
    'user_setting.confirm_enable_account': 'アカウントを有効にしますか？',
    'user_setting.enable_account_success_msg': 'アカウントを有効にしました！',
    'not_found.title': 'ページが見つかりません。',
    'not_found.text1': '探しているページが見つかりません。',
    'not_found.text2': '前のページに戻るか、アマンプリのホームページにアクセスするか、またはアマンプリのサポートチームに連絡して下さい。',
    'not_found.landing': 'ランディング',
    'login.admin': 'ログインアドミン',
    'login.email': 'メールアドレス',
    'login.email2': 'メールアドレス',
    'user.referrer': 'リファラル',
    'user.otp': 'OTP',
    'email.errors.required': 'すべてのユーザー又はユーザー一覧へ送信する必要があります',
    'email.email': 'メールアドレス',
    'email.email_title': 'こちらはタイトルです。',
    'email.email_content': 'こちらはコンテンツです。',
    'email.status': 'ステータス',
    'email.message': 'メッセージ',
    'email.fail': '失敗',
    'exchange_balance.available_balance': '利用可能残高',
    'exchange_balance.exchange_balance': '取引残高',
    'exchange_fee.level': 'レベル',
    'withdraw_setting.disable_all': '全てを無効にする',
    'withdraw_setting.enable_all': '全てを有効にする',
    'withdraw_setting.enable': '設定',
    'withdraw_setting.disable': '無効',
    'withdraw_fee_setting.id': 'ID',
    'withdraw_fee_setting.currency': '通貨',
    'withdraw_fee_setting.limit': '指値',
    'withdraw_fee_setting.fee': '手数料',
    'withdraw_fee_setting.is_visible': '表示する',
    'withdraw_fee_setting.minium_withdrawal': '出金の最少額',
    'withdraw_setting.id': 'ID',
    'withdraw_setting.enable_confirm': '出金を有効にしますか？',
    'withdraw_setting.enable_all_confirm': '出金を有効にしますか？',
    'withdraw_setting.disable_deposit_confirm': '入金を無効にしますか？',
    'withdraw_setting.disable_all_deposit_confirm': '全ての入金を無効にしますか？',
    'withdraw_setting.enable_deposit_confirm': '入金を有効にしますか？',
    'withdraw_setting.enable_all_deposit_confirm': '全ての入金を有効にしますか？',
    'withdraw_setting.name': '氏名',
    'withdraw_setting.deposit': 'コイン入金',
    'withdraw_setting.withdraw': '出金',
    'withdraw_setting.update_success_msg': '更新されました。',
    'withdraw_setting.disable_success_msg': '無効になりました！',
    'withdraw_setting.disable_all_success_msg': '全て無効になりました！',
    'withdraw_setting.enable_success_msg': '有効になりました！',
    'withdraw_setting.enable_all_success_msg': '全て有効になりました！',
    'withdraw_setting.withdraw_setting': '出金設定',
    'withdraw_setting.disable_confirm': '出金を無効にしますか？',
    'withdraw_setting.disable_all_confirm': '全ての出金を無効にしますか？',
    'user.login_history': '履歴',
    'trezor_address_for_deposit': '入金のトレザーアドレス',
    'trezor_device': 'トレザーデバイス',
    'trezor_device.created_at': '作成時間',
    'trezor_device.device_id': 'デバイスID',
    'trezor_device.device_name': 'デバイス名',
    'trezor_device.disable': '無効',
    'trezor_device.enable': '設定',
    'trezor_device.model': 'モデル',
    'trezor_device.register_new_device': '新しいデバイスを登録',
    'trezor_device.title': 'トレザーデバイス',
    'trezor_device_information': 'トレザーデバイスの情報',
    'trezor_label': 'TREZOR ラベル',
    'trezor_path_for_deposit': '出金のトレザーパス',
    'trezor_wallet': 'トレザーウォレット',
    'trezor_wallet.address': 'アドレス',
    'trezor_wallet.balance': '残高',
    'trezor_wallet.currency': '通貨',
    'trezor_wallet.details': '詳細',
    'trezor_wallet.device': 'デバイス',
    'trezor_wallet.device_name': 'デバイス名',
    'trezor_wallet.path': 'パス',
    'trezor_wallet.summary': '概要',
    'trezor_wallet.title': 'トレザーウォレット',
    'trezor_wallet.total_wallet': 'トータルウォレット',
    'trezor.landing.title': 'あなたの取引が社会支援に！',
    'modal.trezor_device_information': 'トレザーデバイスの情報',
    'trezor.landing.desc': '弊社では特にこちらの支援に力を入れてまいります。<br/>弊社はSDGs支援企業として利益の一部を支援のために使います。あなたがOG Exchangeを利用することで学校が設立されたり飢餓が救われたりするでしょう。',
    'trezor.landing.title1': '高度なAPI',
    'trezor.landing.desc1': '弊社の取引エンジンは、投資銀行やヘッジファンドで使用されている物のと同じテクノロジーを使用して構築しています。',
    'modal.device_name': 'デバイス名',
    'modal.device_id': 'デバイスID',
    'modal.model': 'Model',
    'datatable_empty': '利用可能なデータがありません。',
    'datatable_search_empty': '検索に一致する結果がありません。',
    'wallet.create_receive_address.currency': '通貨',
    'wallet.create_receive_address.currency_list': '通貨一覧',
    'wallet.create_receive_address.generate_address': 'アドレス作成',
    'wallet.create_receive_address.the_number_of_remaining': '残りの数',
    'wallet.create_receive_address.title': '受け取りアドレスを作成',
    'wallet.create_receive_address.get_req_success': 'アドレス作成に成功しました！',
    'wallet.create_receive_address.return_req_leave': '退出しますか？',
    'wallet.create_receive_address.address': '{coin_name} アドレス ',
    'wallet.create_receive_address.coin_title': '{coin_full_name} ({coin_name}) 受け取りアドレスを作成する',
    'wallet.create_receive_address.total_number': '総数',
    'wallet.create_receive_address.lose_address': '{field} の入力は必須です。',
    'receive_address_creation': 'アドレス作成を受ける',
    'receive_address_creation.warning_text': '入力は整数で、0より大きくなければなりません。',
    'receive_address_creation.author': '著者',
    'receive_address_creation.input_contents_to_be_created': '入力した内容が作成されました。',
    'receive_address_creation.number_created': '番号を作成しました。',
    'receive_address_creation.please_do_not_use_trezor_for_transmission': 'トレザーで送信しないでください。',
    'receive_address_creation.start_creating': '作成する',
    'receive_address_creation.title': 'アドレス作成を受ける',
    'receive_address_creation.trezor_label': 'TREZOR ラベル',
    'user_wallet': 'ユーザーウォレット',
    'user_wallet.address': 'アドレス',
    'user_wallet.available_balance': '利用可能残高',
    'user_wallet.balance': '残高',
    'user_wallet.currency': '通貨',
    'user_wallet.details': '詳細',
    'user_wallet.device_name': 'デバイス名',
    'user_wallet.path': 'パス',
    'user_wallet.summary': '概要',
    'user_wallet.title': 'ユーザーウォレット',
    'user_wallet.total_wallet': 'トータルウォレット',
    'user_wallet.total_wallet_2': 'トータルウォレット',
    'user_wallet.user_name': 'メールアドレス',
    'coin_information.btn_back': '戻る',
    'coin_information.btn_choose_file': 'ファイルを選択',
    'coin_information.btn_next': '次へ',
    'coin_information.contact_address': 'コントラクトアドレス',
    'coin_information.decimals': '小数桁',
    'coin_information.explorer': 'Explorer',
    'coin_information.heading_title': '新しいERC20の登録',
    'coin_information.icon': 'アイコン',
    'coin_information.image_note': '.pngの拡張子でファイルが必須です。',
    'coin_information.required_confirmations': '承認回数',
    'coin_information.tab_title': 'トークンの情報',
    'coin_information.token': 'トークン',
    'coin_information.token_name': 'トークン名',
    'coin_information.type': '種別',
    'validation.is_contract_address': '無効なコントラストアドレスです。',
    'trading_information.btn_back': '戻る',
    'trading_information.btn_delete': '削除',
    'trading_information.btn_edit': '編集',
    'trading_information.btn_next': '次へ',
    'trading_information.btn_register_trading_pair': '取引ペアを登録する',
    'trading_information.delete_msg': '成功',
    'trading_information.fee': '手数料',
    'trading_information.heading_title': '新しいERC20登録',
    'trading_information.market_price': 'マーケットプライス',
    'trading_information.minimum_amount': '最少額',
    'trading_information.minimum_total': '最小合計',
    'trading_information.pair': 'ペア',
    'trading_information.trading_information': '取引情報',
    'withdrawal_information.back': '戻る',
    'withdrawal_information.currency': '通貨',
    'withdrawal_information.day': '日',
    'withdrawal_information.days': '日',
    'withdrawal_information.fee': '手数料',
    'withdrawal_information.heading_title': '新ERC20登録',
    'withdrawal_information.limit': '指値',
    'withdrawal_information.minimum_withdrawal': '最低出金枚数',
    'withdrawal_information.next': '次へ',
    'withdrawal_information.tab_title': '出金情報',
    'withdrawal_information.time_reset': '時間リセット',
    'review_register_erc_2_0.*_check_register_erc20_information': '* 登録 erc20 情報',
    'review_register_erc_2_0.amount_limit': '数量制限',
    'review_register_erc_2_0.btn_back': '戻る',
    'review_register_erc_2_0.btn_register': '新規登録',
    'review_register_erc_2_0.contract_address': 'コントラクトアドレス',
    'review_register_erc_2_0.currency': '通貨',
    'review_register_erc_2_0.days': '日',
    'review_register_erc_2_0.decimals': '小数桁',
    'review_register_erc_2_0.error_msg': '設定中にエラーが発生しました。 もう一度登録してください。',
    'review_register_erc_2_0.explorer': 'エクスプローラ',
    'review_register_erc_2_0.fee': '手数料',
    'review_register_erc_2_0.icon': 'アイコン',
    'review_register_erc_2_0.limit': '指値',
    'review_register_erc_2_0.market_price': '相場',
    'review_register_erc_2_0.minimum_amount': '最少額',
    'review_register_erc_2_0.minimum_total': '最小合計',
    'review_register_erc_2_0.minimum_withdrawal': '最少額の出金',
    'review_register_erc_2_0.pair': 'ペア',
    'review_register_erc_2_0.precision': '精度',
    'review_register_erc_2_0.register_new_erc20': '新ERC20登録',
    'review_register_erc_2_0.required_confirmations': '確認必須',
    'review_register_erc_2_0.time_reset': '時間リセット',
    'review_register_erc_2_0.token': 'トークン',
    'review_register_erc_2_0.token_information': 'トークンの情報',
    'review_register_erc_2_0.token_name': 'トークン名',
    'review_register_erc_2_0.total_limit': '合計制限',
    'review_register_erc_2_0.trading_fee': '取引手数料',
    'review_register_erc_2_0.trading_limit': '取引制限',
    'review_register_erc_2_0.trading_pair': '取引ペア',
    'review_register_erc_2_0.type': '種別',
    'review_register_erc_2_0.withdrawal_information': '出金情報',
    'review_register_erc_2_0.success_msg': '登録が完了しました！',
    'remittance_complete_registration': '送金登録済',
    'remittance_ordered.amount': '数量',
    'remittance_ordered.btn_detail': '詳細',
    'remittance_ordered.btn_search': '検索',
    'remittance_ordered.currency': '通貨',
    'remittance_ordered.execution_date': '実施日',
    'remittance_ordered.heading_title': '送金済みトランザクション',
    'remittance_ordered.no': 'No',
    'remittance_ordered.transaction_id': 'トランザクションID',
    'remittance_ordered.user_name': 'メールアドレス',
    'remittance_ordered.withdraw_approval': '出金承認者',
    'remittance_transaction_page.administrator_information': '管理者情報',
    'remittance_transaction_page.withdrawal_currency': '出金通貨',
    'remittance_transaction_page.withdrawal_address': '出金アドレス',
    'remittance_transaction_page.transaction_detail': 'トランザクション詳細',
    'remittance_transaction_page.customer_information': 'お客様情報',
    'remittance_transaction_page.transaction_hash': 'トランザクションハッシュ',
    'remittance_transaction_page.remark': '備考',
    'remittance_transaction_page.approved_date': '承認日',
    'remittance_transaction_page.approved_by': '承認者',
    'remittance_transaction_page.country': '国',
    'remittance_transaction_page.created_date': '作成日',
    'remittance_transaction_page.sent_at': '送金時間',
    'remittance_transaction_page.sent_by': '送金者',
    'remittance_transaction_page.email': 'メールアドレス',
    'remittance_transaction_page.header_title': '[詳細]トランザクション：:transaction_id',
    'remittance_transaction_page.quantity': '数量',
    'remittance_transaction_page.transaction_id': 'トランザクションID',
    'remittance_transactions': '送金トランザクション',
    'remitted_transaction': '送金したトランザクション',
    'erc20_loading_modal.create_account_message': 'アカウント作成....',
    'erc20_loading_modal.create_migration_message': 'Create Migration ....',
    'erc20_loading_modal.done_message': '完了....',
    'erc20_loading_modal.loading_message': 'ローディング....',
    'erc20_loading_modal.set_market_price_message': 'マーケットプライス設定....',
    'erc20_loading_modal.update_masterdata_message': 'マスターデータ更新....',
    'eth_wallet_information': 'ETHウォレット情報',
    'user_not_confirmed.amount': '数量',
    'user_not_confirmed.btn_search': '検索',
    'user_not_confirmed.created_date': '作成日',
    'user_not_confirmed.currency': '通貨',
    'user_not_confirmed.no': 'No',
    'user_not_confirmed.title': 'ユーザー未確認',
    'user_not_confirmed.transaction_id': 'トランザクションID',
    'user_not_confirmed.user_name': 'メールアドレス',
    'user_not_confirmed.user_not_confirmed': 'ユーザー未確認',
    'pending_transaction_page.approved_date': '承認日',
    'pending_transaction_page.back': '戻る',
    'pending_transaction_page.birthdate': '生年月日',
    'pending_transaction_page.country': '国',
    'pending_transaction_page.created_date': '作成日',
    'pending_transaction_page.customer_information': 'お客様情報',
    'pending_transaction_page.detail': '明細',
    'pending_transaction_page.email': 'メールアドレス',
    'pending_transaction_page.header_title': '[詳細]トランザクション：{transaction_id}',
    'pending_transaction_page.name': '氏名',
    'pending_transaction_page.open_notification_rejected': 'トランザクションは拒否されました。',
    'pending_transaction_page.open_notification_verified': 'トランザクションは承認されました。',
    'pending_transaction_page.quantity': '数量',
    'pending_transaction_page.reject': '非承認',
    'pending_transaction_page.remarks': '＜備考＞',
    'pending_transaction_page.tel': 'Tel',
    'pending_transaction_page.transaction': 'トランザクション',
    'pending_transaction_page.transaction_detail': 'トランザクション詳細',
    'pending_transaction_page.transaction_id': 'トランザクションID',
    'pending_transaction_page.trezor_address_for_deposit': '入金のトレザーアドレス',
    'pending_transaction_page.trezor_path_for_deposit': '出金のトレゾールパス',
    'pending_transaction_page.verify': '確認',
    'pending_transaction_page.withdrawal_address': '出金アドレス',
    'pending_transaction_page.withdrawal_currency': '出金通貨',
    'pending_transaction_page.field_require': '入力必須項目',
    'rejected_transaction_page.administrator_information': '管理者情報',
    'rejected_transaction_page.withdrawal_currency': '出金通貨',
    'rejected_transaction_page.withdrawal_address': '出金アドレス',
    'rejected_transaction_page.transaction_detail': 'トランザクション詳細',
    'rejected_transaction_page.customer_information': 'お客様情報',
    'rejected_transaction_page.transaction_hash': 'トランザクションハッシュ',
    'rejected_transaction_page.remark': '備考',
    'rejected_transaction_page.country': '国',
    'rejected_transaction_page.created_date': '作成日',
    'rejected_transaction_page.email': 'メールアドレス',
    'rejected_transaction_page.header_title': '[詳細]トランザクション：:transaction_id',
    'rejected_transaction_page.quantity': '数量',
    'rejected_transaction_page.reject_by': '拒否者',
    'rejected_transaction_page.reject_date': '拒否日',
    'rejected_transaction_page.transaction_id': 'トランザクションID',
    'transactions_pending': 'ペンディングトランザクション',
    'transactions_history': '入出金履歴',
    'salespoint.buy_history.buy_history': '購入履歴',
    'salespoint.buy_history.date': '日付',
    'salespoint.buy_history.pair': 'ペア',
    'salespoint.buy_history.coin': 'コイン',
    'salespoint.buy_history.all': 'すべて',
    'salespoint.buy_history.search_by_email': 'メールで検索',
    'salespoint.buy_history.search': '検索',
    'salespoint.buy_history.reset': 'リセット',
    'salespoint.buy_history.buyer_email': 'メールアドレス',
    'cold_wallet_setting.title_page': 'コールドウォレット設定',
    'cold_wallet_setting.receive_title': '受信アドレス',
    'cold_wallet_setting.btc_address': 'BTCアドレス',
    'cold_wallet_setting.bch_address': 'BCHアドレス',
    'cold_wallet_setting.eth_address': 'ETH/ERC20アドレス',
    'cold_wallet_setting.xrp_address': 'XRPアドレス',
    'cold_wallet_setting.ltc_address': 'LTCアドレス',
    'cold_wallet_setting.eos_address': 'EOSアドレス',
    'cold_wallet_setting.ada_address': 'ADAアドレス',
    'cold_wallet_setting.usdt_address': 'USDTアドレス',
    'cold_wallet_setting.usd_address': 'USDアドレス',
    'cold_wallet_setting.address': '{currency} アドレス',
    'cold_wallet_setting.min_balance': '最低残高',
    'cold_wallet_setting.max_balance': '最高残高',
    'cold_wallet_setting.notification_title': 'お知らせ',
    'cold_wallet_setting.holder_email': 'コールドウォレット所有者のメールアドレス',
    'cold_wallet_setting.holder_name': 'コールドウォレット所有者の名前',
    'cold_wallet_setting.holder_mobile': 'コールドウォレット所有者の電話番号',
    'cold_wallet_setting.address.invalid': 'アドレスが無効です。',
    'cold_wallet_setting.xrp.sub_address_placeholder': 'XRP Tag (Optional)',
    'cold_wallet_setting.eos.sub_address_placeholder': 'EOS Tag (Optional)',
    'permission.role.required': ':Role の入力は必須です。',
    'funds.transaction_history.no_deposit_data': '入金履歴がありません。',
    'funds.transaction_history.no_withdraw_data': '出金履歴はありません。',
    'barstyle_chart.save_chart': 'Save Chart',
    'barstyle_chart.load_chart': 'Load Chart',
    'barstyle_chart.bars': 'Bars',
    'barstyle_chart.candles': 'Candles',
    'barstyle_chart.hollow_candles': 'Hollow Candles',
    'barstyle_chart.heikin_ashi': 'Heikin Ashi',
    'barstyle_chart.line': 'line',
    'barstyle_chart.area': 'Area',
    'withdraw_setting.currency': '通貨',
    'menu.user_group_setting': 'グループ設定',
    'group_setting.date': '日付',
    'group_setting.search_by_name': '名前で検索する',
    'group_setting.search': '済み',
    'group_setting.reset': 'リセット',
    'group_setting.add_new': 'グループに追加',
    'group_setting.name': '氏名',
    'group_setting.memo': 'メモ',
    'group_setting.delete_data': 'このグループを削除しますか？',
    'group_setting.edit': 'グループ編集',
    '_validation.precision': '{attribute}の精度は{precision}でなければなりません',
    '_validation.accepted': '{attribute}は受け入れられなければなりません。',
    '_validation.active_url': '{attribute}は有効なURLではありません。',
    '_validation.after': '{attribute}は{date}より大きい日付でなければなりません。',
    '_validation.after_or_equal': '{attribute}は{date}以降の日付でなければなりません。',
    '_validation.alpha': '{attribute}には文字のみを含めることができます。',
    '_validation.alpha_dash': '{attribute}には、文字、数字、ダッシュ、およびアンダースコアのみを含めることができます。',
    '_validation.alpha_num': '{attribute}には文字と数字のみを含めることができます。',
    '_validation.array': '{attribute}は配列でなければなりません。',
    '_validation.before': '{attribute}は{date}より小さい日付でなければなりません。',
    '_validation.before_or_equal': '{attribute}は{date}以前の日付でなければなりません。',
    '_validation.between.numeric': '{attribute}は{min}から{max}までなければなりません。',
    '_validation.between.file': '{attribute}は{min}から{max}キロバイトまでなければなりません。',
    '_validation.between.string': '{attribute}は{min}から{max}文字までなければなりません。',
    '_validation.between.array': '{attribute}は{min}から{max}件のある必要があります。',
    '_validation.boolean': '{attribute}はtrueまたはfalseでなければなりません。',
    '_validation.confirmed': '{attribute}の確認が一致しません。',
    '_validation.date': '{attribute}は有効な日付ではありません。',
    '_validation.date_format': '{attribute}がフォーマット{format}と一致しません。',
    '_validation.different': '{attribute}と{other}は異なる必要があります。',
    '_validation.digits': '{attribute}は{min}桁でなければなりません。',
    '_validation.digits_between': '{attribute}は、{min}から{max}の数字でなければなりません。',
    '_validation.dimensions': '{attribute}の画像サイズが無効です。',
    '_validation.distinct': '{attribute}の値が重複しています。',
    '_validation.email': '{attribute}項目は有効なメールアドレスでなければなりません。',
    '_validation.exists': '選択された{attribute}は無効です。',
    '_validation.file': '{attribute}はファイルでなければなりません。',
    '_validation.filled': '{attribute}の入力は必須です。',
    '_validation.gt.numeric': '{attribute}は{value}より大きくなければなりません。',
    '_validation.gt.file': '{attribute}は{value}キロバイトより大きくなければなりません。',
    '_validation.gt.string': '{attribute}は{value}文字より大きくなければなりません。',
    '_validation.gt.array': '{attribute}には{value}項目以上が必要です。',
    '_validation.gte.numeric': '{attribute}は{value}以上である必要があります。',
    '_validation.gte.file': '{attribute}は{value}キロバイト以上でなければなりません。',
    '_validation.gte.string': '{attribute}は{value}文字以上でなければなりません。',
    '_validation.gte.array': '{attribute}は{value}以上の項目を持たなければなりません。',
    '_validation.image': '{attribute}は画像でなければなりません。',
    '_validation.in': '選択された{attribute}は無効です。',
    '_validation.in_array': '{attribute}は{other}には存在しません。',
    '_validation.integer': '{attribute}は画像でなければなりません。',
    '_validation.ip': '{attribute}は有効なIPアドレスでなければなりません。',
    '_validation.ipv4': '{attribute}は有効なIP4アドレスでなければなりません。',
    '_validation.ipv6': '{attribute}は有効なIP6アドレスでなければなりません。',
    '_validation.json': '{attribute}は有効なJSON文字列である必要があります。',
    '_validation.lt.numeric': '{attribute}は{value}より小さくなければなりません。',
    '_validation.lt.file': '{attribute}は{value}キロバイト未満でなければなりません。',
    '_validation.lt.string': '{attribute}は{value}文字以下でなければなりません。',
    '_validation.lt.array': '{attribute}の項目数は{value}以下でなければなりません。',
    '_validation.lte.numeric': '{attribute}の項目数は{value}以下でなければなりません。',
    '_validation.lte.file': '{attribute}は{value}キロバイト以下でなければなりません。',
    '_validation.lte.string': '{attribute}は{value}文字以下でなければなりません。',
    '_validation.lte.array': '{attribute}は{value}個を超えてはいけません。',
    '_validation.max.numeric': '{attribute}は{max}より大きくてはいけません。',
    '_validation.max.file': '{attribute}は{max}キロバイト以下でなければなりません。',
    '_validation.max.string': '{attribute}は、{max}文字以下にする必要があります。',
    '_validation.max.array': '{attribute}には、{max}個を超えてはできません。',
    '_validation.mimes': '{attribute}は{values}型のファイルでなければなりません。',
    '_validation.mimetypes': '{attribute}は{values}型のファイルでなければなりません。',
    '_validation.min.numeric': '{attribute}は{min}以上でなければなりません。',
    '_validation.min.file': '{attribute}は{min}キロバイト以上でなければなりません。',
    '_validation.min.string': '{attribute}は{min}文字以上でなければなりません。',
    '_validation.min.array': '{attribute}には{min}件以上が必要です。',
    '_validation.not_in': '選択された{attribute}は無効です。',
    '_validation.not_regex': '{attribute}の形式が無効です。',
    '_validation.numeric': '{attribute}は数字でなければなりません。',
    '_validation.present': '{attribute}はtrueまたはfalseでなければなりません。',
    '_validation.regex': '{attribute}の形式が無効です。',
    '_validation.required': '{attribute}の入力は必須です。',
    '_validation.required_if': '{other}が{value}の場合、{attribute}の入力は必須です。',
    '_validation.required_unless': '{other}が{values}に含まれていない限り、{attribute}の入力は必須です。',
    '_validation.required_with': '{values}が存在している場合、{attribute}の入力は必須です。',
    '_validation.required_with_all': '{values}が存在している場合、{attribute}の入力は必須です。',
    '_validation.required_without': '{values}が存在しない場合、{attribute}の入力は必須です。',
    '_validation.required_without_all': '{values}が存在しない場合、{attribute}の入力は必須です。',
    '_validation.same': '{attribute}と{other}は一致する必要があります。',
    '_validation.size.numeric': '{attribute}は{size}である必要があります。',
    '_validation.size.file': '{attribute}は{size}キロバイトでなければなりません。',
    '_validation.size.string': '{attribute}は{size}文字でなければなりません。',
    '_validation.size.array': '{attribute}には{size}項目を含める必要があります。',
    '_validation.string': '{attribute}は文字列でなければなりません。',
    '_validation.timezone': '{attribute}は有効なゾーンでなければなりません。',
    '_validation.unique': '{attribute}は既に使用されています。',
    '_validation.uploaded': '{attribute}はアップロードに失敗しました。',
    '_validation.url': '{attribute}の形式が無効です。',
    '_validation.old_password': '{attribute}が正しくありません。',
    '_validation.no_space': '{attribute}に空白を含めることはできません。',
    '_validation.valid_ethereum_address': '{attribute}は有効なEthereumアドレスでなければなりません。',
    '_validation.valid_bitcoin_address': '{attribute}は有効なBitcoinアドレスでなければなりません。',
    '_validation.valid_tetherus_address': '{attribute}は有効なTetherUSアドレスでなければなりません。',
    '_validation.verified_email': 'アカウントを有効化するためにメールを確認してください',
    '_validation.unverified_email': 'アカウントを有効化するためにメールを確認してください',
    '_validation.unregistered_email': '{attribute}が登録されています。',
    '_validation.is_not_temp_email': '{attribute}は使い捨てのメールです',
    '_validation.send_verify_user': '{attribute}が無効です。',
    '_validation.email_reset_password_exists': '入力したメールアドレスは存在しません',
    '_validation.voucher_existed': 'すみません。コードが存在しません',
    '_validation.voucher_is_expired': 'すみません。コードは期限切れです',
    '_validation.unique_voucher': 'すみません。コードが使用されました',
    '_validation.is_invalid_otp_code': 'OTPコードが無効です',
    '_validation.unique_metadata_bounty': 'リンクは既に使用されています。',
    '_validation.unique_currency_address': 'アドレスは既に使用されています。',
    '_validation.email_active': 'あなたのアカウントはロックされています。',
    '_validation.password_white_space': 'パスワードに空白を含まないでください。',
    '_validation.correct_password': 'パスワードが一致しませんでした。',
    '_validation.google_authentication_code_valid': 'Google認証コードが無効です',
    '_validation.is_invalid_google_authenticator_code': 'Google認証コードが無効です',
    '_validation.email_change_unregistered': '登録されたメールアドレス',
    '_validation.email_change_not_pending': '登録されたメールアドレス',
    '_validation.blockchain_address': '{attribute}が無効です。',
    '_validation.law_accepted': '「いいえ」を選択した場合は登録できません',
    '_validation.otp_not_used': '次の認証コードが生成されるまでお待ちください。',
    '_validation.is_contract_address': 'コントラクトアドレスが無効です。',
    '_validation.unregistered_token': 'トークンは既に使用されています。',
    '_validation.unregistered_token_name': 'トークン名は既に使用されています。',
    '_validation.unregistered_coin_name': 'トークン名は既に存在しています。',
    '_validation.unregistered_contract_address': 'コントラクトアドレスは既に存在しています。',
    '_validation.custom.referral_id.exists': '紹介コードが無効です。',
    '_validation.custom.base_price.min': 'ストップ価格は、{min}以上でなければなりません。',
    '_validation.custom.base_price.precision': 'ストップ価格は{precision}の精度でなければなりません',
    '_validation.custom.quantity.min': '数量は、{min}以上でなければなりません。',
    '_validation.custom.quantity.precision': '金額の値は{precision}でなければなりません',
    '_validation.custom.total.min': '合計は最低{min}でなければなりません',
    '_validation.custom.total.precision': '合計は{precision}の値でなければなりません',
    '_validation.custom.price.min': '価格は最低{min}でなければなりません',
    '_validation.custom.price.precision': 'ストップ価格は{precision}の値でなければなりません',
    '_validation.custom.google_authenticator_code.length': 'Google認証コードが6桁でなければなりません。',
    '_validation.custom.tel.numeric': '数字を入力してください',
    '_validation.custom.zip_code.numeric': '数字を入力してください',
    '_validation.attributes.email': 'メールアドレス',
    '_validation.attributes.user_id': 'ユーザーID',
    '_validation.attributes.password': 'パスワード',
    '_validation.attributes.repeat_password': 'パスワードの再入力',
    '_validation.attributes.new_password': '新しいパスワード',
    '_validation.attributes.confirm_new_password': '新しいパスワード（確認）',
    '_validation.attributes.agree': '同意する',
    '_validation.attributes.google_authenticator_code': 'Google認証コード',
    '_validation.attributes.recovery_code': '回復コード',
    '_validation.attributes.confirm_email': '確認メール',
    '_validation.attributes.blockchain_address': 'ブロックチェーンアドレス',
    '_validation.attributes.transaction_explorer': 'トランザクションエクスプローラ',
    '_validation.attributes.minium_quantity': '最小数量',
    '_validation.attributes.minium_amount': '最少額',
    '_validation.attributes.minium_total': '最小合計',
    '_validation.attributes.total_limit': '合計制限',
    '_validation.attributes.amount_limit': '数量制限',
    '_validation.attributes.minium_withdrawal': '最少出金枚数',
    '_validation.attributes.zip_code': 'Zipコード',
    '_validation.attributes.state_region': '州／地域',
    '_validation.attributes.building_room': 'ビル／ルーム',
    '_validation.attributes.coin_name': '名',
    '_validation.attributes.token_name': 'トークン名',
    '_validation.attributes.precision': '精度',
    '_validation.attributes.contract_address': 'コントラクトアドレス',
    '_validation.attributes.coin': 'コイン',
    '_validation.attributes.token': 'トークン',
    '_validation.attributes.icon': 'アイコン',
    '_validation.attributes.time_reset': '時間リセット',
    '_validation.attributes.market_price': 'マーケットプライス',
    '_validation.attributes.minimum_amount': '最少額',
    '_validation.attributes.minimum_total': '最小合計',
    '_validation.attributes.minimum_withdrawal': '最少額の出金',
    '_validation.attributes.limit': '指値',
    '_validation.attributes.fee': '手数料',
    '_validation.attributes.pair': 'ペア',
    '_validation.attributes.name': '名',
    '_validation.attributes.send_confirmer': '承認者',
    '_validation.attributes.tx_hash': 'トランザクションのハッシュ',
    'emails.kyc_notification.subject': '【{app_name}】KYC確認 - {date}',
    'emails.kyc_notification.name': '{name}様',
    'emails.kyc_notification.text1': '当社のサービスをご利用いただきありがとうございます。',
    'emails.kyc_notification.text2': 'OG Exchangeのサポートです。',
    'emails.kyc_notification.text3': 'お待たせしました。',
    'emails.kyc_notification.text4': '本人確認の審査をしていますので、こちらからユーザーページにログインし、審査結果を確認してください。',
    'emails.kyc_notification.text5': '身分証明書の送信が必要であることを示すメッセージがマイページの上部に表示されていない場合、あなたの本人確認は正常に完了しました。',
    'emails.kyc_notification.text6': 'メッセージがマイページの上部に表示される場合は、不適切な送信または画像エラーのため承認されていません。そのため、本人確認書類をもう一度確認して再提出してください。',
    'emails.kyc_notification.text7': '提出された書類が不適切であった理由は確認出来ませんが、不適切となった理由は主に以下になりますので、一度提出した写真が以下に該当しないかどうか確認してください。',
    'emails.kyc_notification.text8': '本人確認書類が指定されていない',
    'emails.kyc_notification.text9': '身分証明書とセルフィー写真の顔が違います。',
    'emails.kyc_notification.text10': 'セルフィーで提出された文書、取引所名、日付、本人は一緒に表示されません',
    'emails.kyc_notification.text11': '正面を向いていない',
    'emails.kyc_notification.text12': 'セルフィー写真に「顔全体」が表示されていない（頭全体が表示されていない）',
    'emails.kyc_notification.text13': '中国とアメリカの住居',
    'emails.kyc_notification.text14': '画像が暗く顔がはっきりしていない',
    'emails.kyc_notification.text15': '画像のアップロードに失敗しました',
    'emails.kyc_notification.text16': 'ご迷惑をおかけして申し訳ございません。ご協力ありがとうございます。',
    'emails.approved_notification.subject': '【{app_name}】出金は承認されました。 - {date}',
    'emails.approved_notification.name': '{name}こんにちは',
    'emails.approved_notification.text1': '次の出金要求が承認されました。',
    'emails.approved_notification.text2': '通貨',
    'emails.approved_notification.text3': '数量',
    'emails.approved_notification.text4': '宛先アドレス',
    'emails.approved_notification.text5': '要求日',
    'emails.approved_notification.text6': 'ここから出金処理に移ります。',
    'emails.approved_notification.text7': 'OG Exchangeを引き続きご支援いただきありがとうございます。',
    'emails.approved_notification.text8': '3.4パスワードおよびユーザー ID の管理',
    'emails.approved_notification.text9': '3.4パスワードおよびユーザー ID の管理',
    'emails.approved_notification.text10': '3.4パスワードおよびユーザー ID の管理',
    'emails.approved_notification.text11': '3.4パスワードおよびユーザー ID の管理',
    'emails.approved_notification.text12': '3.4パスワードおよびユーザー ID の管理',
    'excel.account_registrant.no': 'No',
    'excel.account_registrant.file_name': 'アカウント登録者',
    'excel.account_registrant.already': '済',
    'excel.account_registrant.not_yet': '未',
    'excel.account_registrant.mail_address': 'メールアドレス',
    'excel.account_registrant.mail_auth': '認証',
    'excel.account_registrant.registered_information': '登録情報',
    'excel.account_registrant.registered_date': '登録日',
    'excel.account_registrant.last_login': '最終ログイン',
    'excel.registered_person.no': 'No',
    'excel.registered_person.file_name': '登録者',
    'excel.registered_person.mail_address': 'メールアドレス',
    'excel.registered_person.name': '氏名',
    'excel.registered_person.tel': '電話番号',
    'excel.registered_person.country': '国',
    'excel.registered_person.upload_at': 'アップロード日',
    'excel.registered_person.last_login': '最終ログイン',
    'excel.id_registrant.no': 'No',
    'excel.id_registrant.file_name': 'KYC登録者',
    'excel.id_registrant.country_name': '国',
    'excel.id_registrant.name': '氏名',
    'excel.id_registrant.tel': '電話番号',
    'excel.id_registrant.mail_address': 'メールアドレス',
    'excel.id_registrant.created_at': '作成日',
    'excel.id_registrant.updated_at': 'アップロード日',
    'excel.id_registrant.last_login': '最終ログイン',
    'excel.payment_history.file_name': '支払履歴',
    'excel.payment_history.id': 'トランザクションID',
    'excel.payment_history.user_name': 'ユーザー名',
    'excel.payment_history.currency': '通貨',
    'excel.payment_history.amount': '数量',
    'excel.payment_history.created_at': '作成日',
    '_auth.failed': 'ユーザーID又はパスワードは正しく入力されませんでした。',
    '_auth.throttle': 'ログイン回数が多すぎます。{seconds}秒後にもう一度お試しください。',
    '_auth.ip_verify': 'このIPアドレスがあなたのアカウントにアクセスできるようにメールを確認してください。',
    '_pagination.previous': '前へ',
    '_pagination.next': '次へ',
    '_passwords.password': 'パスワードは6文字以上で、確認と一致する必要があります。',
    '_passwords.reset': 'パスワードが再設定されました。',
    '_passwords.sent': 'パスワード再設定リンクをメールで送信しました。',
    '_passwords.token': 'このパスワード再設定トークンは無効です。',
    '_passwords.user': 'そのメールアドレスを持つユーザーが見つかりません。',
    'account.identity.errors.status_pendding': '管理者の確認を待ちます。',
    'address.add_whitelist': 'ホワイトリストへ追加する',
    "address.enable_whitelist": "Enable Whitelist",
    "address.disable_whitelist": "Disable Whitelist",
    'common.create.success': '作成されました。',
    'common.update.success': '更新されました。',
    'common.delete.success': '削除されました。',
    'messages.user_cannot_withdraw_fiat': 'Google認証を有効にして、管理者からKYCの承認を受けてください。',
    'messages.error': 'エラー',
    'messages.primary': 'メイン',
    'messages.success': '成功',
    'messages.info': '情報',
    'messages.warning': '警告',
    'messages.user_must_enable_google_auth': 'Google認証を有効にする必要があります。',
    'sales_point.error.lose_persentor': '紹介された方の価格の入力が必須です。 ',
    'sales_point.error.price_persentor': '紹介した方の価格が0より大きくなければなりません。',
    'validation.custom.banner_url.image': 'ファイルは画像でなければなりません。',
    'validation.custom.banner_url.mimes': 'ファイルは:values形式のファイルでなければなりません。',
    'validation.custom.new_password.min': 'パスワードは大文字、小文字、数字を含む8文字以上で、確認用パスワードと一致しなければなりません。',
    'validation.custom.new_password.regex': 'パスワードは大文字、小文字、数字を含む8文字以上で、確認用パスワードと一致しなければなりません。',
    'validation.valid_currency_address': '出金アドレスが無効です。',
    'validation.user_id_coin_wallet': 'このアドレスは既に存在しています。',
    'validation.user_id_coin_wallet_2': 'アドレスはすでに存在しています。',
    'validation.check_exist_email': 'アカウントを有効化するためにメールを確認してください',
    'messages.ban_account': 'あなたのアカウントは変更されました。',
    'cold_wallet_setting.btc_address.required': 'BTCアドレスの入力は必須です。',
    'cold_wallet_setting.btc_min_balance.required': 'この項目の入力は必須です。',
    'cold_wallet_setting.btc_max_balance.required': 'この項目の入力は必須です。',
    'cold_wallet_setting.bch_address.required': 'BCHアドレスの入力は必須です。',
    'cold_wallet_setting.bch_min_balance.required': 'この項目の入力は必須です。',
    'cold_wallet_setting.bch_max_balance.required': 'この項目の入力は必須です。',
    'cold_wallet_setting.eth_address.required': 'ETHアドレスの入力は必須です。',
    'cold_wallet_setting.eth_min_balance.required': 'この項目の入力は必須です。',
    'cold_wallet_setting.eth_max_balance.required': 'この項目の入力は必須です。',
    'cold_wallet_setting.xrp_address.required': 'XRPアドレスの入力は必須です。',
    'cold_wallet_setting.xrp_sub_address.required': 'XRPサブアドレスの入力は必須です。',
    'cold_wallet_setting.xrp_min_balance.required': 'この項目の入力は必須です。',
    'cold_wallet_setting.xrp_max_balance.required': 'この項目の入力は必須です。',
    'cold_wallet_setting.ltc_address.required': 'LTCアドレスの入力は必須です。',
    'cold_wallet_setting.ltc_min_balance.required': 'この項目の入力は必須です。',
    'cold_wallet_setting.ltc_max_balance.required': 'この項目の入力は必須です。',
    'cold_wallet_setting.eos_address.required': 'EOSアドレスの入力は必須です。',
    'cold_wallet_setting.eos_sub_address.required': 'EOSサブアドレスの入力は必須です。',
    'cold_wallet_setting.eos_min_balance.required': 'この項目の入力は必須です。',
    'cold_wallet_setting.eos_max_balance.required': 'この項目の入力は必須です。',
    'cold_wallet_setting.ada_address.required': 'ADAアドレスの入力は必須です。',
    'cold_wallet_setting.ada_min_balance.required': 'この項目の入力は必須です。',
    'cold_wallet_setting.asa_max_balance.required': 'この項目の入力は必須です。',
    'cold_wallet_setting.usdt_address.required': 'USDTアドレスの入力は必須です。',
    'cold_wallet_setting.usdt_min_balance.required': 'この項目の入力は必須です。',
    'cold_wallet_setting.usdt_max_balance.required': 'この項目の入力は必須です。',
    'group_setting.error.exist': 'グループ名が重複になっています。',
    'account.discount_percent': '({percent} 割引)',
    'address.cancel_success': 'キャンセルしました。',
    'funds.balances.default_balance': '0',
    'funds.balances.you_have_selected_coin': '<span class=\'coin-count\'>{coin}</span>コインを選択しました。',
    'funds.depositUSD.no_data': 'USDの入金履歴はありません。',
    'funds.deposit.tips.text4': '{name}は{count}のネットワークを確認後すぐに入金されます。',
    'funds.withdrawals.errors.blockchain_address_exists': 'このアドレスは既に存在しています。',
    'funds.withdrawals.errors.blockchain_address_sub_address_exists': '出金アドレス又はタグ/メモ/...が既に存在しています。',
    'funds.withdrawals.errors.kyc': 'Google認証を有効にして、管理者からKYCの承認を受けてください。',
    'funds.withdrawals.confirm_withdrawal': '出金取引を確認しました。',
    'funds.withdrawals.no_memo': 'メモがありません',
    'menu.investments': '投资',
    'menu.request': '申請',
    'menu.investors': '投資者',
    'menu.lang.mn': '日本語',
    'menu.lang.ko': '韓国語',
    'menu.lang.zh': '中国語',
    'menu.lang.acr.en': 'EN',
    'menu.lang.acr.mn': 'MN',
    'menu.lang.acr.ko': 'KO',
    'menu.lang.acr.zh': 'ZH',
    'menu.lang.acr.ja': 'JA',
    'menu.lang.acr.ru': 'RU',
    'menu.lang.acr.vi': 'VI',
    'menu.mam': 'MAM',
    'register.success_2': '<div><p style=\'line-height: 28px;color: #333;font-size: 14px;margin: 0;text-overflow: ellipsis;white-space: nowrap;overflow: hidden;\'>確認メールが <span title={email}>{email}</span>に送信されました。</div><div>指示に従って登録を完了してください。</p></div>',
    "register.success_3": "You have been successfully registered. To activate your account check your email and confirm your registration.",
    'register.title_2': 'メール再送信',
    'register.title_3': '受信できない場合は次の操作を行ってください：',
    'register.paragraph_1': '登録したメールアドレスが正しいことを確認してください。',
    'register.paragraph_2': '迷惑メールやその他のフォルダを確認してください。',
    'register.paragraph_3': 'メールアドレスのホワイトリストを設定します。',
    'register.paragraph_4': 'メールクライアントが正常に動作していることを確認してください。',
    'withdraw_guide.partner': 'パートナー（お問い合わせ）',
    'withdraw_guide.contract_admin': 'カスタマーサポートへ連絡する',
    'withdraw_guide.kyc': 'KYC確認',
    'withdraw_guide.verf_doc': 'KYC認証',
    'common.action.approve': '承認',
    'salespoint.amal': '4IRE',
    'salespoint.enter_amount': '数量を入力してください',
    'salespoint.login_or_register': '<a href="{login}">取引にログイン</a> or <a href="{register}">登録する</a>',
    'menu_bottom.withdrawals_guide': '出金ガイド',
    'menu_bottom.terms_of_service': '利用規約',
    'menu_bottom.api_document': 'APIドキュメント',
    'menu_bottom.faq': 'FAQ',
    "menu_bottom.leverage_reference": "Leverage Reference",
    'menu_bottom.white_paper': 'ホワイトペーパー',
    'title.settlement_history_table': '決済履歴表',
    'title.des.this_list_contains': 'このリストには過去の決済が網羅されています。',
    'search.placeholder.click_values_below_to_fillter': '以下の値をクリックするとフィルタリングされます。',
 "Over_one_time_limit" : "The amount you withdraw is more than once allowed.",
    'button.clear': 'クリア',
    'button.save_as_CSV': 'CSV形式で保存',
    'table.timestamp': 'タイムスタンプ',
    'table.symbol': 'マーク',
    'table.settlement_type': '決済タイプ',
    'table.settled_price': '定価',
    'table.option_strike_price': 'オプションの権利行使価格',
    'title.daily_insurance_fund_balance': '保険基金の日々の残高',
    'title.des.daily_insurance_fund_balance': 'OG Exchangeでは、保険基金を使用して、取引ポジションの レバレッジの自動解消 を防いでいます。この基金は、レバレッジ自動解消システムに引き継がれる前に、未約定の清算注文を取りまとめます。<br/> <br/>保険基金は、特定のポジションの破産価格より有利な価格で清算注文が市場で執行可能な場合、清算によって増大します。<br/><br/>保険基金の現在残高および過去の残高は、下記で見ることができます。',
    'table.wallet_balance': 'ウォレットの残高',
    'title.funding_history_table': '資金調達履歴表',
    'title.header_form.futures_guide': '先物ガイド',
    'leaderboard.top_25_traders_by_notional': '想定でのトップ25トレーダー',
    'leaderboard.top_25_traders_by_roe': 'ROEでのトップ25トレーダー',
    "leaderboard.top_25_traders_by_roe_entry": "Top 25 Traders by ROE (Entry)",
    "leaderboard.top_25_teams_by_roe_entry": "Top 25 Teams by ROE (Entry)",
    'leaderboard.top_25_traders_by_volume': 'トップ25取引量ランキング',
    'table.profit': '利益',
    'table.volume': '出来高',
    'title.des.referrence.btc': '<ul class = "list_link_head clearfix" style = "list-style-type：disc; padding-left：25px;"> <li> <a href="#how_is_the_perpetual_contract_quoted"> BTCUSD無期限契約の見積り方法</ a > </ li> <li> <a href="#margin_and_leverage">マージンとレバレッジ</a> </ li> <li> <a href="#price_index">価格指数</a> </ li> <li> <a href="#marking_and_settlement">マーキングと決済</a> </ li> </ ul>',
    'title.how_is_the_perpetual_contract_quoted': '{symbol}無期限契約のクォート方法',
    'title.des.how_is_the_btc_perpetual_contract_quoted': '<p> BTCUSD契約の基本価格は<a href="{BTCIndex}"> BTCインデックスです。</a> Bitstamp、Coinbase Pro、OKCoin、GEMINI、Kraken USD BTC / USDでの価格と同じ加重インデックスです。基本契約とスワップ契約は米ドルで見積もられます。マージンとPNLはビットコインで計算されています。</ p>',
    'title.des.how_is_the_btc_perpetual_contract_quoted2': '<p>ビットコイン/米ドル価格が上昇して利益を得たいトレーダーは、BTCUSD契約を購入します。逆に、価格が下がると思われる場合は、契約を売却します。</ p>',
    'title.btc.margin_and_leverage.desc': '<p>すべてのマージンはビットコインを使うため、トレーダーはビットコインを使用して契約売買することができます。 BTCUSD契約は、最大100倍の高いレバレッジがあります。  </ p> <p>たとえば、価値100ビットコインの契約を購入するには、初期のマージンとして1ビットコインのみが必要です。 </ p>',
    'title.btc.price_index.desc': '<p> <a href="{BTCIndex}"> OG Exchange BTCインデックス</a>は現在、<a href="{BTCUSDPerpetualContract}"> BTCUSD永久契約</a>およびBTC先物契約に使用されています。 </ p> <p>構成要素に関する情報については、<a href="{BTCCompositeIndexBreakdown}#composite-index-breakdown"> .BTC総合インデックスの内訳</a>を参照してください。</ p> < p>この時点で、重みは等しくなっています。将来、このインデックスを調整する可能性があります。調整は十分な通知で行われます。</ p>',
    'title.btc.marking_and_settlement.desc': '<p> BTCUSD契約は無期限であるため、決済期限はありません。未実現PNLおよび清算目的のマーキングは、公正価格マーキングシステムに従って行われます。</ p> <p>注：この商品は無期限な契約であるため、8時間ごとに資金調達が行われます。詳細については、無期限契約ガイドの<a href="{perpetualContractsGuide}#funding">資金調達セクション</a>をご覧ください。現在のレートについては、<a href = "{BTCUSDContractSpecifications}"の資金調達計算をご覧ください。 BTCUSD契約仕様</a>。</ p> <p> <strong> BTCUSD取引例</ strong> </ p> <blockquote style = "font-size：14px; font-style：italic;"> <p >トレーダーは600 BTCの価格でBTCUSDの100 BTCをロングします。彼はロング100 BTC * 600米ドル= 60,000契約です。数日後、契約の価格は700米ドルに上昇します。</ p> <p>トレーダーの利益は、<strong> 60,000 * 1 *（1/600-1/700）= 14.286 BTC </ strong>になります。 </ p> <p>もし価格が500米ドルに下がった場合、トレーダーの損失は<strong> 60,000 * 1 *（1/600-1/500）= -20 BTC </ strong>になります。契約の<em>逆および非線形</ em>の性質により、損失は大きくなります。逆に、トレーダーがショット場合、価格が下がった場合、上がった場合の損失よりもトレーダーの利益が大きくなります。</ p> </ blockquote> </ div>',
    'title.contract_specification': '契約仕様書',
    'title.contract.description.futures_contract': '<a href="{contractSpecifications}">{symbol}</a> は<a href = "{routerIndex}"> {settlementIndex}インデックス</a>に基づく<base_underlying} / {quote_currency}先物契約です。各契約には、ビットコインでの価格に等しい値があります。この契約は投機に理想的です。',
    'title.description': '説明',
    'title.full_contract_details': '契約の詳細',
    'common.the_base_currency_is_symbol': '基軸通貨は{symbol}です',
    'common.the_quote_currency_is_symbol': '決済通貨は{symbol}です',
    'title.des.description': '<a href="{contractSpecifications}"> {symbol} </a>は、<a href="{routerIndex}"> {base_underlying}インデックス</a>で価格設定された{base_underlying} / {quote_currency}永久契約です。各契約はビットコインの{contract_value}の価値があります。<br/>資金は{funding_interval}時間ごとに支払われ、受け取られます。次の支払いは{nextDate}です。<br/><a href="{contractSpecifications}"> {symbol} </a>はプレミアムインデックスを使用して資金調達率を計算します。基礎となる金利は、<a href="{routerFBase}"> {funding_base_index}インデックス</a>と<a href="{routerFQuote}"> {funding_quote_index}インデックス</a>を使用して計算します。それにプレミアムレートは <a href="{routerFPremium}"> {funding_premium_index}インデックス</a>を使用して計算します。これらは最終資金調達率の計算に使用されます。<br/>今日、ロングは{fundingRate}％を支払い、ショートは{date}に{fundingRate}％を受け取ります。OG Exchangeは、資金の支払いと受け取りに手数料を請求しません。',
    'title.funding_calculation': '資金調達率の計算',
    'title.des.funding_calculation': '資金調達率の詳細については、<a href="{perpetualGuide}">無期間ガイド</a>をご覧ください。',
    'title.des.bitcoin_series_eth_guide': '<p> Ethereumは、スマート契約を実行する分散型プラットフォームです。ダウンタイム、検閲、詐欺、またはサードパーティの干渉の可能性なしに、完全にブロックチェーンでのプログラムしたどおりに実行されるアプリケーション。 このプロジェクトは、<a href="https://www.ethereum.org/foundation"> Ethereum Foundation </a>によって開発されています。 Ethereum通貨は、通貨コードETHで表され、一般的にEtherと呼ばれます。 ETHとEthereumプロジェクトの詳細については、<a href="https://www.ethereum.org/">こちら</a>をご覧ください。</ p> <p>トレーダー向けアマンプリは現在2種類のETH派生製品を提供しています。 1番目はEther / Bitcoin（ETH / BTC）<a href="{futuresGuide}"> 先物契約 </a>の形式であり、2番目はEther / USD（ETH / USD）< a href = "{perpetualContractsGuide}">無期間契約</a>の形式です。</ p>',
    'title.des.referrence.eth': '<ul class = "list_link_head clearfix" style = "list-style-none; padding-left：25px;"> <li> <a href="#Futures-Contracts">先物契約</a> <ul style="list-style-type: disc; padding-left: 25px;"> <li><a href="#How-Are-ETHBTC-Futures-Quoted"> ETHBTC先物はどのようにクォートされますか</a> </ li> <li> <a href="#Margin-and-Leverage">マージンとレバレッジ</a> </ li> <li> <a href="#Settlement">決済</a> </ li> <li> <a href="#ETHBTC-Futures-Contract-Example"> ETHBTC先物契約の例</a> </ li> </ ul> </ li> <li> <a href = "＃Perpetual-Contracts ">無期限契約</a> <ul style =" list-style-type：disc; padding-left：25px; "> <li> <a href ="＃How-Is-The-ETHUSD-Perpetual-Contract- Quoted "> ETHUSD無期限契約の見積り方法</a> </ li> <li> <a href="#Perpetual-Margin-and-Leverage">マージンとレバレッジ</a> </ li> <li> <a href="#Perpetual-Settlement">結算</a> </ li> <li> <a href="#ETHUSD-Perpetual-Contract-Example"> ETHUSD無期限契約の例</a> <ul style="list-style-type: '- '; padding-left: 25px;"> <li><a href="#Trade-Inception">取引の開始</a> </ li> <li> <a href="#Trade-Expiry">取引の終了</a> </ li> < / ul> </ li> </ ul> </ li> </ ul>',
    'title.des.how_is_the_eth_perpetual_contract_quoted': '<p> ETH先物の基礎となるのは、Poloniex、Kraken、OG ExchangeのETH / BTC為替レートです<a href="{OG ExchangeETHIndex}"> ETHBTCインデックス</a>に先物はビットコインで見積もられ、すべてのマージンとPNLの計算はビットコインで行われます。</ p>',
    'title.des.how_is_the_eth_perpetual_contract_quoted2': '<p> ETHの価格が上昇すると考えるトレーダーは、先物契約を買います。逆に、価格が下がると考えるトレーダーは先物契約を売ります。</ p>',
    'title.eth.margin_and_leverage.future.desc': '<p>すべてのマージンはビットコインを使うため、トレーダーはビットコインを使用して契約売買することができます。 ETH先物契約には最大50倍のレバレッジがあります。 </ p> <p>たとえば、価値50ビットコインの契約を購入するには、初期のマージンとして1ビットコインのみが必要です。 </ p>',
    'title.eth.marking_and_settlement.desc': '<p> ETH先物契約は、<a href="{ETHBTC30MIndex}"> ETHBTC30Mインデックス価格で決済します</a>決済は決済月の最後の金曜日に行われます。</ p>',
    'title.des.eth_future_contract_example': '<blockquote style="font-size: 14px; font-style: italic;"> <p>トレーダーは、ETH先物契約の10 BTCを買いたいと考えています。 ETHU18（2018年9月に期限切れになるETH先物契約）は0.0500 BTCで取引されます。レバレッジは50倍なので、トレーダーはこの取引に0.2 BTCのマージンしか必要ありません。</ p> <p>ただしトレーダーは200個契約を購入する必要があります：<code> 10 BTC /（0.0500 BTC * 1）</ code>。< / p> <p>数日後、価格は0.0550 BTCに上昇し、トレーダーはすべての契約を販売しましたら、</ p> <p>発生した利益は次のようになります。<code> 200 * 1 *（0.0550-0.0500） = 1 BTC </ code> </ p> </ blockquote>',
    'title.eth.margin_and_leverage.perpetual.desc': '<p>すべてのマージンはビットコインを使うため、トレーダーはビットコインを使用して契約売買することができます。ETHUSD無期限契約は、最大50倍のレバレッジがあります。  </ p> <p>たとえば、価値50ビットコインの契約を購入するには、初期のマージンとして1ビットコインのみが必要です。 </ p>',
    'title.eth.perpetual_settlement.desc': '<p> ETHUSD契約は無期限であるため、決済期限はありません。未実現PNLおよび清算目的のマーキングは、公正価格マーキングシステムに従って行われます。</ p> <p>注：この製品は無期限な契約であるため、8時間ごとに資金調達が行われます。詳細については、無期限契約ガイドの<a href="{perpetualContractsGuide}#funding">資金調達セクション</a>をご覧ください。現在の料金については、<a href="{ETHUSDContractSpecifications}">の資金調達計算をご覧ください。 ETHUSD契約仕様</a>。</ p>',
    'title.symbol_perpetual_contract_example': '{symbol} 無期限契約の例',
    'title.des.eth_perpetual_contract_example': '<blockquote style = "font-size：14px; font-style：italic;"> <pre style = "padding-bottom：20px; padding-top：20px; color：＃31708f; background-color：＃d9edf7;"> <code> OG Exchangeデリバティブ：ETHUSD無期限スワップ</br>契約：10,000 </br> 1米ドルあたりのビットコイン乗数：0.000001 BTC </br> BTCスポット価格：$ 10,000 </br> ETHUSDスワップ価格：$ 500 </br> ETHBTCスポット価格：0.05 BTC</br></code></pre> <h5 id="Trade-Inception" style="font-weight: 700; font-size: 15px; font-style: italic; margin: 15px 0 7px;">取引開始</ h5> <p>ジェウォンとワンは、ETHUSD無期限スワップを10,000契約で取引します。ジェウォンは買う、ワンは売る。 1米ドルの変化ごとに、契約は0.000001 BTCを支払います。これはビットコイン乗数と呼ばれます。</ p> <p>両サイドは50倍のレバレッジを使用できることに同意します。つまり、取引を開始するために2％の初期マージンをアマンプリに送ります。ビットコインのマージンを計算するには、まずETHUSD Quanto Swapのビットコイン値を計算します。</ p> <p> <code> BTC値= ETHUSD価格*ビットコイン乗数*＃契約</ code> </ p> <p> <code> 5 BTC = $ 500 * 0.000001 BTC * 10,000 </ code> </ p> <p> <code>初期ビットコインマージン= 5 BTC * 2％= 0.1 BTC </ code> </ p> <p>それに両方とも、ETHの条件で与えられたETHUSD価格を考えるのが好きです。 OG Exchange ポシション板では、ETHの条件で現在のポジションの値を表示できます。</ p> <p> <code> ETH値= BTC値/ ETHBTCスポット価格</ code> </ p> <p > <code> 100 ETH = 5 BTC / 0.05 BTC </ code> </ p> <p> ETHUSDの価格が変化したとき、またはETHBTCのスポット価格が変化したときに、ETHの値が変化することがあります。 Quanto微分の唯一の固定数は乗数です。 ETHUSD、BTC、ETHBTCの価格が変わると、ETHとUSDの値が変わります。</p> <h5 style="font-weight: 700; font-size: 15px; font-style: italic; margin: 15px 0 7px;" id="Trade-Expiry">取引の期限切れ</ h5> <p> ETHUSDスワップ価格が505ドルに上昇しました。ジェウォンとワンのビットコインPNLを計算しましょう。</ p> <p> <code>ビットコインPNL =（ETHUSD出口価格– ETHUSDエントリー価格）*ビットコイン乗数*＃契約</ code> </ p> <p> <code>ジェウォンビットコインPNL =（$ 505-$ 500）* 0.000001 BTC * +10,000 = 0.05 BTC利益</ code> </ p> <p> <code> Wang Bitcoin PNL =（$ 505-$ 500）* 0.000001 BTC * -10,000 = 0.05 BTC 損失 </ code> </ p> <p> PNLに影響する唯一の変数は動いてるETHUSD価格で、 BTCもETHBTC為替レートも、どちらのトレーダーのPNLにも影響しません。</ p> </ blockquote>',
    'title.des.bitcoin_series_ada_guide': '<p> OG Exchangeでは、ADAデリバティブ商品は<a href="{futuresGuide}"> 先物契約 </a>の形式であり、トレーダーはCardano / Bitcoin（ADA / BTC）の将来為替レート価値を推測できます。  トレーダーは、Bitcoinをマージンとして必要とするだけで、先物契約を取引するCardanoは必要ありません。</ p>',
    'title.des.referrence.ada': '<div class="staticContent seriesGuideADA "> <div class="table-of-contents"><ul class="list_link_head clearfix" style="list-style-type: disc; padding-left: 25px;"><li><a href="#How-Are-ADA-Futures-Quoted">ADA先物はどのようにクオートされますか？</a> </ li> <li> <a href="#Margin-and-Leverage">マージンとレバレッジ</a> </ li> <li> <a href="#Settlement">決算</a> </ li> </ ul> </ div> <p> </ p> <h3 id = " How-Are-ADA-Futures-Quoted "> <a class="header-anchor" href="#How-Are-ADA-Futures-Quoted"> ADA先物はどのようにクオートされますか</a> </ h3> < p> ADA先物の基礎となるのは、<a href="/margin-exchange/contracts/indices-data/ADA"> ADAインデックス</a>に記録されているADA / BTC為替レートです。先物はビットコインで使用され、すべてのマージンとPNLの計算はビットコインで行われます。</ p> <div class = "table_detail_contracts"> <table class = "table"> <thead> <tr> <th> </ th> <th>契約計算</ th> </ tr> </ thead> <tbody> <tr> <td>乗数</ td> <td> 1 </ td> </ tr> <tr> <td> BTC契約値</ td> <td>乗数*先物価格* 1 ADA </ td> </ tr> <tr> <td> USD契約値</ td> <td> BTC契約値* BTCUSD </ td> < / tr> <tr> <td> PnL計算</ td> <td>＃契約* 乗数 *（出口価格-入口価格）</ td> </ tr> </ tbody> </ table> </ div> <h3 id = "Margin-and-Leverage"> <a class="header-anchor" href="#Margin-and-Leverage">マージンとレバレッジ</a> </ h3> <p>すべてのマージンがビットコインを利用するので、トレーダーはビットコインのみを使用して契約を買ったり売ったりすることできます。 ADA先物契約は、最大20倍のレバレッジができます。</ p> <p>たとえば、10ビットコイン相当の契約を購入するには、0.5ビットコインの初期証拠金のみが必要です。</ p> <h3 id = "Settlement "> <a class="header-anchor" href="#Settlement">決済</a> </ h3> <p> ADA先物契約は、<a href =" / margin-exchange / contracts / indices -data / ADA30M "> ADA30Mインデックス価格</a>。</ p> <p> <strong>取引の例</ strong> </ p> <blockquote> <p>トレーダーはADAの先物契約を10 BTC買いたい場合、ADAJ18（毎月のADA先物契約）は、0.10 BTCで取引されます。レバレッジは20倍なので、トレーダーはこの取引に0.5 BTCのマージンのみ必要があります。</ p> <p>トレーダーは100契約を購入する必要があります：<strong> 10 BTC /（0.10 BTC * 1）</ strong>。< / p> <p>数日後、価格は0.15 BTCに上昇し、トレーダーはすべての契約を売却します。</ p> <p>トレーダーの利益計算は次のようになります。<strong> 100 * 1 *（0.15-0.10） = 5 BTC </ strong> </ p> </ blockquote> </ div>',
    'title.des.referrence.bch': '<div class = "staticContent seriesGuideBCH"> <div class = "table-of-contents"> <ul class = "list_link_head clearfix" style = "list-style-type：disc; padding-left：25px;"> <li > <a href="#How-Are-BCH-Futures-Quoted"> BCH先物はどのようにクオートされますか？</a> </ li> <li> <a href="#Margin-and-Leverage">マージンとレバレッジ</a> </ li> <li> <a href="#Settlement">決済</a> </ li> </ ul> </ div> <p> </ p> <h3 id = " How-Are-BCH-Futures-Quoted "> <a class="header-anchor" href="#How-Are-BCH-Futures-Quoted"> BCH先物はどのようにクオートされますか？</a> </ h3> < p> BCH先物の基礎は、<a href="/margin-exchange/contracts/indices-data/BCH"> BCHインデックス</a>に記録されているBCH / BTC為替レートです。先物はビットコインで使用され、すべてのマージンとPNLの計算はビットコインで行われます。</ p> <div class = "table_detail_contracts"> <table class = "table"> <thead> <tr> <th> </ th> <th>契約計算</ th> </ tr> </ thead> <tbody> <tr> <td>乗数</ td> <td> 1 </ td> </ tr> <tr> <td> BTC契約値</ td> <td>乗数*先物価格* 1 BCH </ td> </ tr> <tr> <td> USD契約値</ td> <td> BTC契約値* BTCUSD </ td> < / tr> <tr> <td> PnL計算</ td> <td>＃契約 *乗数*（出口価格-入口価格）</ td> </ tr> </ tbody> </ table> </ div> <h3 id = "Margin-and-Leverage"> <a class="header-anchor" href="#Margin-and-Leverage">マージンとレバレッジ</a> </ h3> <p>すべてのマージンがビットコインを利用するので、トレーダーはビットコインのみを使用してこの契約を買ったり売ったりすることできます。 BCH先物契約は最大20倍のレバレッジができます。</ p> <p>たとえば、10ビットコイン相当の契約を購入するには、0.5ビットコインの初期証拠金のみが必要です。</ p> <h3 id = "Settlement "> <a class="header-anchor" href="#Settlement">決済</a> </ h3> <p> BCH先物契約は、<a href =" / margin-exchange / contracts / indices -data / BCH30M "> BCH30Mインデックス価格</a>。</ p> <p> <strong>取引例</ strong> </ p> <blockquote> <p>トレーダーはBCHの10 BTCの先物契約を買いたい場合、 BCHX17（毎月のBCH先物契約）は、0.10 BTCで取引されます。レバレッジは20倍なので、トレーダーはこの取引に0.5 BTCのマージンのみ必要です。</ p> <p>トレーダーは100契約を購入する必要があります：<strong> 10 BTC /（0.10 BTC * 1）</ strong>。< / p> <p>数日後、価格は0.15 BTCに上昇し、トレーダーはすべての契約を売却します。</ p> <p>トレーダーの利益決算は次のようになります。<strong> 100 * 1 *（0.15-0.10） = 5 BTC </ strong> </ p> </ blockquote> </ div>',
    'title.des.referrence.eos': '<div class = "staticContent seriesGuideEOS"> <div class = "table-of-contents"> <ul class = "list_link_head clearfix" style = "list-style-type：disc; padding-left：25px;"> <li > <a href="#How-Are-EOS-Futures-Quoted"> EOS先物はどのようにクオートされますか？</a> </ li> <li> <a href="#Margin-and-Leverage">マージンとレバレッジ</a> </ li> <li> <a href="#Settlement">決済</a> </ li> </ ul> </ div> <p> </ p> <h4 id = " How-Are-EOS-Futures-Quoted "> <a class="header-anchor" href="#How-Are-EOS-Futures-Quoted"> EOS先物はどのようにクオートされますか</a> </ h4> < p> EOS先物の基礎となるのは、<a href="/margin-exchange/contracts/indices-data/EOS"> EOSインデックス</a>に記録されているEOS / BTC為替レートです。先物はビットコインで使用され、すべてのマージンとPNLの計算はビットコインで行われます。</ p> <div class = "table_detail_contracts"> <table class = "table"> <thead> <tr> <th> </ th> <th>契約計算</ th> </ tr> </ thead> <tbody> <tr> <td>乗数</ td> <td> 1 </ td> </ tr> <tr> <td> BTC契約値</ td> <td>乗数*先物価格* 1 EOS </ td> </ tr> <tr> <td> USD契約値</ td> <td> BTC契約値* BTCUSD </ td> < / tr> <tr> <td> PnL計算</ td> <td>＃契約 *乗数*（出口価格-入口価格）</ td> </ tr> </ tbody> </ table> </ div> <p> </ p> <p> EOSの価格が上昇すると考えるトレーダーは、先物契約を購入します。逆に、価格が下がると考えるトレーダーは先物契約を売ります。</ p> <h4 id = "Margin-and-Leverage"> <a class = "header-anchor" href = "＃Margin-and-Leverage" >マージンとレバレッジ</a> </ h4> <p>すべてのマージンはビットコインで使用されます。つまり、トレーダーはビットコインのみを使用してこの契約を買ったり売ったりすることができます。 EOS先物契約は、最大20倍のレバレッジを備えています。</ p> <p>たとえば、10ビットコイン相当の契約を購入するには、0.5ビットコインの初期マージンのみが必要です。</ p> <h4 id = "Settlement "> <a class="header-anchor" href="#Settlement">決済</a> </ h4> <p> EOS先物契約は、<a href =" / margin-exchange / contracts / indices -data / EOS30M "> EOS30Mインデックス価格</a>。決済は、決済月の最後の金曜日に行われます。</ p> <p> <strong>取引の例</ strong> </ p> <blockquote> <p>トレーダーは、10 BTCのEOS先物契約を買いたい場合、0.0200 BTCで取引されます。レバレッジは20倍なので、トレーダーはこの取引に0.5 BTCのマージンしか必要としません。</ p> <p>トレーダーは500契約を購入する必要があります：<strong> 10 BTC /（0.0200 BTC * 1）</ strong> < / p> <p>数日後、価格は0.0250 BTCに上昇し、トレーダーはすべての契約を販売します。</ p> <p>トレーダーの利益決算んは次のようになります。<strong> 500 * 1 *（0.0250-0.0200） = 2.5 BTC </ strong> </ p> </ blockquote> </ div>',
    'title.des.referrence.ltc': '<div class = "staticContent seriesGuideLTC"> <div class = "table-of-contents"> <ul class = "list_link_head clearfix" style = "list-style-type：disc; padding-left：25px;"> <li > <a href="#How-Are-LTC-Futures-Quoted"> LTC先物はどのようにクオートされますか</a> </ li> <li> <a href="#Margin-and-Leverage">マージンとレバレッジ</a> </ li> <li> <a href="#Settlement">決済</a> </ li> </ ul> </ div> <p> </ p> <h4 id = " How-Are-LTC-Futures-Quoted "> <a class="header-anchor" href="#How-Are-LTC-Futures-Quoted"> LTC先物はどのようにクオートされますか</a> </ h4> < p> LTC先物の基礎は、<a href="/margin-exchange/contracts/indices-data/LTC"> LTCインデックス</a>に記録されているLTC / BTC為替レートです。先物はビットコインで使用され、すべてのマージンとPNLの計算はビットコインで行われます。</ p> <div class = "table_detail_contracts"> <table class = "table"> <thead> <tr> <th> </ th> <th>契約計算</ th> </ tr> </ thead> <tbody> <tr> <td>乗数</ td> <td> 1 </ td> </ tr> <tr> <td> BTC契約値</ td> <td>乗数*先物価格* 1 LTC </ td> </ tr> <tr> <td> USD契約値</ td> <td> BTC契約値* BTCUSD </ td> < / tr> <tr> <td> PnL計算</ td> <td>＃契約 *乗数*（出口価格-入口価格）</ td> </ tr> </ tbody> </ table> </ div> <p> </ p> <p> LTCの価格が上昇すると考えるトレーダーは、先物契約を買います。逆に、価格が下がると考えるトレーダーは先物契約を売ります。</ p> <h4 id = "Margin-and-Leverage"> <a class = "header-anchor" href = "＃Margin-and-Leverage" >マージンとレバレッジ</a> </ h4> <p>すべてのマージンはビットコインで使用されます。つまり、トレーダーはビットコインのみを使用してこの契約を買ったり売ったりすることが長できます。 LTC先物契約は最大33倍のレバレッジができます。</ p> <p>たとえば、10ビットコイン相当の契約を購入するには、0.3ビットコインの初期証拠金のみが必要です。</ p> <h4 id = "Settlement "> <a class="header-anchor" href="#Settlement">決済</a> </ h4> <p> LTC先物契約は、<a href =" / margin-exchange / contracts / indices -data / LTC30M "> LTC30Mインデックス価格</a>。決済は、決済月の最後の金曜日に行われます。</ p> <p> <strong>取引の例</ strong> </ p> <blockquote> <p>トレーダーは、10 BTCのLTC先物契約を買いたい場合は、 LTCM17（2017年6月に期限が切れるLTC先物契約）は0.0200 BTCで取引されています。レバレッジは33倍なので、トレーダーはこの取引に0.3 BTCのマージンしか必要としません。</ p> <p>トレーダーは500の契約を購入する必要があります：<strong> 10 BTC /（0.0200 BTC * 1）</ strong> < / p> <p>数日後、価格は0.0250 BTCに上昇し、トレーダーはすべての契約を販売します。</ p> <p>トレーダーの利益決算は次のようになります。<strong> 500 * 1 *（0.0250-0.0200） = 2.5 BTC </ strong> </ p> </ blockquote> </ div>',
    'title.des.referrence.trx': '<div class = "staticContent seriesGuideTRX"> <div class = "table-of-contents"> <ul class = "list_link_head clearfix" style = "list-style-type：disc; padding-left：25px;"> <li > <a href="#How-Are-TRON-Futures-Quoted"> TRON先物はどのようにクオートされますか？</a> </ li> <li> <a href="#Margin-and-Leverage">マージンとレバレッジ</a> </ li> <li> <a href="#Settlement">和解</a> </ li> </ ul> </ div> <p> </ p> <h4 id = " How-Are-TRON-Futures-Quoted "> <a class="header-anchor" href="#How-Are-TRON-Futures-Quoted"> TRON先物はどのようにクオートされますか</a> </ h4> < p> TRON先物の​​基礎は<a href="/margin-exchange/contracts/indices-data/TRX"> TRXインデックス</a>に記録されているTRX / BTC為替レートです。先物はビットコインで引用され、すべてのマージンとPNLの計算はビットコインで行われます。</ p> <div class = "table_detail_contracts"> <table class = "table"> <thead> <tr> <th> </ th> <th>契約計算</ th> </ tr> </ thead> <tbody> <tr> <td>乗数</ td> <td> 1 </ td> </ tr> <tr> <td> BTC契約値</ td> <td>乗数*先物価格* 1 TRX </ td> </ tr> <tr> <td> USD契約値</ td> <td> BTC契約値* BTCUSD </ td> < / tr> <tr> <td> PnL計算</ td> <td>＃契約 *乗数*（出口価格-入口価格）</ td> </ tr> </ tbody> </ div> </ table> <p> </ p> <p>トロンの価格が上昇すると考えるトレーダーは、先物契約を買います。逆に、価格が下がると考えるトレーダーは先物契約を売ります。</ p> <h4 id = "Margin-and-Leverage"> <a class = "header-anchor" href = "＃Margin-and-Leverage" >マージンとレバレッジ</a> </ h4> <p>すべてのマージンはビットコインで転記されます。つまり、トレーダーはビットコインのみを使用してこの契約を長くしたり短くしたりできます。 TRON先物契約は、最大20倍のレバレッジを備えています。</ p> <p>たとえば、10ビットコイン相当の契約を購入するには、0.5ビットコインの初期マージンのみが必要です。</ p> <h4 id = "Settlement "> <a class="header-anchor" href="#Settlement">決済</a> </ h4> <p>トロン先物契約は、<a href =" / margin-exchange / contracts / indices -data / TRX30M "> TRX30Mインデックス価格</a>。決済は、決済月の最後の金曜日に行われます。</ p> <p> <strong>取引の例</ strong> </ p> <blockquote> <p>トレーダーは、10 BTCのTRON先物契約を長くしたいと考えています。 、0.0200 BTCで取引されます。レバレッジは20倍なので、トレーダーはこの取引に0.5 BTCのマージンしか必要としません。</ p> <p>トレーダーは500契約を購入する必要があります：<strong> 10 BTC /（0.0200 BTC * 1）</ strong> < / p> <p>数日後、価格は0.0250 BTCに上昇し、トレーダーはすべての契約を販売します。</ p> <p>トレーダーの利益は次のようになります。<strong> 500 * 1 *（0.0250-0.0200） = 2.5 BTC </ strong> </ p> </ blockquote> </ div>',
    'title.des.referrence.xrp': '<div class = "staticContent seriesGuideXRP"> <div class = "table-of-contents"> <ul class = "list_link_head clearfix" style = "list-style-type：disc; padding-left：25px;"> <li > <a href="#How-Are-XRP-Futures-Quoted"> XRP先物はどのようにクオートされますか？</a> </ li> <li> <a href="#Margin-and-Leverage">マージンとレバレッジ</a> </ li> <li> <a href="#Settlement">決済</a> </ li> </ ul> </ div> <p> </ p> <h4 id = " How-Are-XRP-Futures-Quoted "> <a class="header-anchor" href="#How-Are-XRP-Futures-Quoted"> XRP先物の見積もり方法</a> </ h4> < p> XRP先物の基礎となるのは、<a href="/margin-exchange/contracts/indices-data/XRP"> XRPインデックス</a>に記録されているXRP / BTC為替レートです。先物はビットコインで利用され、すべてのマージンとPNLの計算はビットコインで行われます。</ p> <div class = "table_detail_contracts"> <table class = "table"> <thead> <tr> <th> </ th> <th>契約計算</ th> </ tr> </ thead> <tbody> <tr> <td>乗数</ td> <td> 1 </ td> </ tr> <tr> <td> BTC契約値</ td> <td>乗数*先物価格* 1 XRP </ td> </ tr> <tr> <td> USD契約値</ td> <td> BTC契約値* BTCUSD </ td> < / tr> <tr> <td> PnL計算</ td> <td>＃契約 *乗数*（出口価格-入口価格）</ td> </ tr> </ tbody> </ table> </ div> <p> </ p> <p> XRPの価格が上昇すると考えるトレーダーは、先物契約を購入します。逆に、価格が下がると考えるトレーダーは先物契約を売ります。</ p> <h4 id = "Margin-and-Leverage"> <a class = "header-anchor" href = "＃Margin-and-Leverage" >マージンとレバレッジ</a> </ h4> <p>すべてのマージンはビットコインで使用されます。つまり、トレーダーはビットコインのみを使用してこの契約を買ったり売ったりすることできます。 XRP先物契約は最大20倍のレバレッジができます。</ p> <p>たとえば、10ビットコイン相当の契約を購入するには、0.5ビットコインの初期マージンのみが必要です。</ p> <h4 id = "Settlement "> <a class="header-anchor" href="#Settlement">決済</a> </ h4> <p> XRP先物契約は、<a href =" / margin-exchange / contracts / indices -data / XRP30M "> XRP30Mインデックス価格</a>。決済は、決済月の最後の金曜日に行われます。</ p> <p> <strong>取引の例</ strong> </ p> <blockquote> <p>トレーダーは、10 BTCのXRP先物契約を長くしたいと考えています。 。 XRPM17（2017年6月に期限が切れるXRP先物契約）は、0.00002 BTCで取引されています。レバレッジは20倍なので、トレーダーはこの取引に0.5 BTCのマージンしか必要としません。</ p> <p>トレーダーは500,000契約を購入する必要があります：<strong> 10 BTC /（0.00002 BTC * 1）</ strong>。< / p> <p>数日後、価格は0.000025 BTCに上昇し、トレーダーはすべての契約を販売します。</ p> <p>トレーダーの利益計算は次のようになります。<strong> 500,000 * 1 *（0.000025-0.00002） = 2.5 BTC </ strong> </ p> </ blockquote> </ div>',
    'title.des.bitcoin_series_bch_guide': '<p> OG Exchangeでは、BCHデリバティブ商品は<a href="{futuresGuide}">  先物契約 </a>の形式であり、トレーダーはBitcoin Cash / Bitcoin（BCH / BTCの将来為替レート価値を推測できます。 ） トレーダーは、Bitcoinをマージンとして必要とするだけで、先物契約を取引するビットコインキャッシュは必要はありません。</ p>',
    'title.des.bitcoin_series_eos_guide': '<p> <a href="https://eos.io/"> EOS.IO </a>のソフトウェアは、分散式アプリケーションの垂直および水平拡張を可能にするように設計された新しいブロックチェーン仕組みを導入しています。これは、アプリケーションを構築できるオペレーティングシステムのような構造を作成することで実現されます。このソフトウェアは数百のCPUコアあるいはグループにわたるアカウント、認証、データベース、非同期通信のスケジューリングを提供します。結果として得られるテクノロジーは、1秒あたり数百万のトランザクションに拡張し、ユーザー料金を削減し、分散アプリケーションの迅速かつ簡単な展開を可能にするブロックチェーンアーキテクチャです。</ p> <p> OG Exchangeでは、EOSデリバティブ商品は<a href="{futuresGuide}">先物契約  </a>により、トレーダーはEOSトークン/ビットコイン（EOS / BTC）の為替レートの将来価値を推測できます。トレーダーは、Bitcoinを証拠金としてのみ必要とするため、先物契約を取引するためにEOSトークンを持っている必要はありません。</ p>',
    'title.des.bitcoin_series_ltc_guide': '<p> LitecoinはBitcoinの代替デジタル通貨ですが、より多くの取引量を処理することができ、通貨コードはLTCです。より頻繁にブロックを生成するため、ネットワークは将来のソフトウェアを変更することなく、より多くのトランザクションをサポートします。その結果、トレーダーは確認時間を短縮することができますが、より大きな契約アイテムを販売する場合は、より多くの確認を待つことができます。LitecoinプロジェクトとLTCの詳細については、<a href="https://litecoin.org/">こちら</a>をご覧ください。</ p> <p>OG Exchangeでは、LTCデリバティブの形式は<a href="{futuresGuide}"> 先物契約</a>により、トレーダーはLitecoin / Bitcoin（LTC / BTC）為替レートの将来価値を推測できます。トレーダーは、Bitcoinを証拠金としてのみ必要とするため、先物契約を取引するためにLitecoinを持っている必要はありません。</ p>',
    'title.des.bitcoin_series_trx_guide': '<p> OG Exchangeでは、TRON派生物は<a href="{futuresGuide}">先物契約</a>の形式であり、トレーダーはTRON / Bitcoin（TRX / BTC）の将来為替レートの価値を推測できます。トレーダーは、マージンとしてBitcoinのみを必要とするため、先物契約を取引するためにTRONを持つ必要はありません。</ p>',
    'title.des.bitcoin_series_xrp_guide': '<p> Rippleは、世界が価値を交換できるようにするグローバルな金融決済解決方案を提供するベンチャー会社です。 Rippleは、通貨コードXRPで表される通貨Rippleも含む分散トランザクションネットワークであるという点で、Bitcoinと異なります。 Bitcoinブロックチェーンを使用しているプロセス量と比較して、反復的なコンセンサスプロセスを使用してネットワークプロセスを簡単化されます。 これにより、RippleはBitcoinよりも速くトランザクションを完了できます。さらに、Rippleネットワークは、Ripple通貨だけでなく、あらゆる種類の情報を追跡できます。 Rippleネットワークと通貨XRPの詳細については、<a href="https://ripple.com/">こちら</a>をご覧ください。</ p> <p>OG Exchangeでは、XRPデリバティブは<a href="{futuresGuide}"> 先物契約 </a>の形式で、トレーダーがRipple / Bitcoin（XRP / BTC）為替レートの将来価値を推測できるようにします。トレーダーはBitcoinを証拠金としてのみ必要とするため、先物契約を取引するためのRippleは必要ありません。</ p>',
    'title.indice_description.ada.paragraphs': '<p class = "pre">OG Exchange ADAインデックスは、カルダノの価格を毎分追跡します。カルダノ価格は、OG Exchange インデックスの最終価格から計算されます。 ADAインデックス価格は、現在のカルダノ価格として多くのページに表示されます。</ p> <p>れは複数のソースから価格が構成される総合インデックスです。構成要素に関する情報については、以下の「総合インデックスの内訳」をご覧ください。取引所がサービスを提供できなくなり、価格非提示時間が15分を超える場合、OG Exchangeは取引が再開されるまで、その構成要素をインデックスから自動的に削除します。</p>',
    'title.indice_description.ada30m.paragraphs': '<p class = "pre">OG Exchange ADA30Mインデックスは12:00 協定世界時に終了するOG Exchange インデックス でのCardano 価格の 30分 TWAP です。<a href="/margin-exchange/contracts/indices-data/ADA"> ADAインデックス</a>。これらの値は、決済に使用されます。 TWAPは、OG Exchange ADAインデックスの値を使用して計算されます。</ p> <p>れは複数のソースから価格が構成される総合インデックスです。構成要素に関する情報については、以下の「総合インデックスの内訳」をご覧ください。取引所がサービスを提供できなくなり、価格非提示時間が15分を超える場合、OG Exchangeは取引が再開されるまで、その構成要素をインデックスから自動的に削除します。</p>',
    'title.indice_description.bch.paragraphs': '<p class = "pre">OG Exchange BCHインデックスは、ビットコインキャッシュ価格を毎分追跡します。ビットコインキャッシュの価格は、OG Exchangeインデックスの最終価格から計算されます。 BCHインデックス価格は、現在のビットコインキャッシュ価格として多くのページに表示されます。</ p> <p>れは複数のソースから価格が構成される総合インデックスです。構成要素に関する情報については、以下の「総合インデックスの内訳」をご覧ください。取引所がサービスを提供できなくなり、価格非提示時間が15分を超える場合、OG Exchangeは取引が再開されるまで、その構成要素をインデックスから自動的に削除します。</p>',
    'title.indice_description.bch30m.paragraphs': '<p class = "pre">OG Exchange BCH30Mインデックスは12:00 協定世界時に終了するOG Exchange インデックス でのBitcoin Cash価格の 30分 TWAP です。 <a href="/margin-exchange/contracts/indices-data/BCH">BCHインデックス</a>。これらの値は、決済に使用されます。 TWAPは、OG Exchange BCHインデックスからの値を使用して計算されます。</ p> <p>れは複数のソースから価格が構成される総合インデックスです。構成要素に関する情報については、以下の「総合インデックスの内訳」をご覧ください。取引所がサービスを提供できなくなり、価格非提示時間が15分を超える場合、OG Exchangeは取引が再開されるまで、その構成要素をインデックスから自動的に削除します。</p>',
    'title.indice_description.eos.paragraphs': '<p class = "pre"> OG Exchange EOSインデックスは、EOSトークンの価格を毎分追跡します。 EOSトークンの価格は、OG Exchange Indexの最終価格から計算されます。 EOSインデックス価格は、現在のEOSトークン価格として多くのページに表示されます。</ p> <p>れは複数のソースから価格が構成される総合インデックスです。構成要素に関する情報については、以下の「総合インデックスの内訳」をご覧ください。取引所がサービスを提供できなくなり、価格非提示時間が15分を超える場合、OG Exchangeは取引が再開されるまで、その構成要素をインデックスから自動的に削除します。</p>',
    'title.indice_description.eos30m.paragraphs': '<p class="pre"><p class = "pre">OG Exchange EOS30Mインデックスは インデックスは12:00 協定世界時に終了するOG Exchange インデックス でのEOS Token 価格の 30分 TWAP です。<a href="/margin-exchange/contracts/indices-data/EOS">EOSインデックス</a>。これらの値は、決済に使用されます。 TWAPは、OG Exchange EOSインデックスの値を使用して計算されます。</ p> <p>れは複数のソースから価格が構成される総合インデックスです。構成要素に関する情報については、以下の「総合インデックスの内訳」をご覧ください。取引所がサービスを提供できなくなり、価格非提示時間が15分を超える場合、OG Exchangeは取引が再開されるまで、その構成要素をインデックスから自動的に削除します。</p>',
    'title.indice_description.ltc.paragraphs': '<p class = "pre"> OG Exchange LTCインデックスは、Litecoinの価格を毎分追跡します。Litecoinの価格は、OG Exchangeインデックスの最終価格から計算されます。 LTCインデックス価格は、現在のLitecoin価格として多くのページに表示されます。</ p> <p>れは複数のソースから価格が構成される総合インデックスです。構成要素に関する情報については、以下の「総合インデックスの内訳」をご覧ください。取引所がサービスを提供できなくなり、価格非提示時間が15分を超える場合、OG Exchangeは取引が再開されるまで、その構成要素をインデックスから自動的に削除します。</p>',
    'title.indice_description.ltc30m.paragraphs': '<p class="pre">OG Exchange LTC30M インデックスは12:00 協定世界時に終了するOG Exchange インデックス での Litecoin価格の 30分 TWAP です。 <a href="/margin-exchange/contracts/indices-data/LTC">LTC Index</a>.これらの値は、決済に使用されます。 TWAPは、OG Exchange LTCインデックスの値を使用して計算されます。</p><p>れは複数のソースから価格が構成される総合インデックスです。構成要素に関する情報については、以下の「総合インデックスの内訳」をご覧ください。取引所がサービスを提供できなくなり、価格非提示時間が15分を超える場合、OG Exchangeは取引が再開されるまで、その構成要素をインデックスから自動的に削除します。</p>',
    'title.indice_description.trx.paragraphs': '<p class = "pre"> OG Exchange TRXインデックスは、毎分Tronの価格を追跡します。Tron価格は、OG Exchangeインデックスの最終価格から計算されます。 TRXインデックス価格は、現在のTron価格として多くのページに表示されます。</ p> <p>これは複数のソースから価格が構成される総合インデックスです。構成要素に関する情報については、以下の「総合インデックスの内訳」をご覧ください。取引所がサービスを提供できなくなり、価格非提示時間が15分を超える場合、OG Exchangeは取引が再開されるまで、その構成要素をインデックスから自動的に削除します。</p>',
    'title.indice_description.trx30m.paragraphs': '<p class = "pre">OG Exchange TRX30Mインデックスは12:00 協定世界時に終了するOG Exchange インデックス での  Tron価格の 30分 TWAP です。<a href="/margin-exchange/contracts/indices-data/TRX">TRXインデックス</a>。これらの値は、決済に使用されます。 TWAPは、OG Exchange TRXインデックスの値を使用して計算されます。</ p> <p>れは複数のソースから価格が構成される総合インデックスです。構成要素に関する情報については、以下の「総合インデックスの内訳」をご覧ください。取引所がサービスを提供できなくなり、価格非提示時間が15分を超える場合、OG Exchangeは取引が再開されるまで、その構成要素をインデックスから自動的に削除します。</p>',
    'title.indice_description.xrp.paragraphs': '<p class = "pre">OG Exchange XRPインデックスは、リップル価格を毎分追跡します。リップル価格は、OG Exchange指数の最終価格から計算されます。 XRPインデックス価格は、現在のリップル価格として多くのページに表示されます。</ p> <p>これは複数のソースから価格が構成される総合インデックスです。構成要素に関する情報については、以下の「総合インデックスの内訳」をご覧ください。取引所がサービスを提供できなくなり、価格非提示時間が15分を超える場合、OG Exchangeは取引が再開されるまで、その構成要素をインデックスから自動的に削除します。</p>',
    'title.indice_description.xrp30m.paragraphs': '<p class = "pre">OG Exchange XRP30Mインデックスは12:00 協定世界時に終了するOG Exchange インデックス での Ripple価格の 30分 TWAP です。 <a href="/margin-exchange/contracts/indices-data/XRP"> XRPインデックス</a>。これらの値は、決済に使用されます。 TWAPは、OG Exchange XRPインデックスの値を使用して計算されます。</ p> <p>これは複数のソースから価格が構成される総合インデックスです。構成要素に関する情報については、以下の「総合インデックスの内訳」をご覧ください。取引所がサービスを提供できなくなり、価格非提示時間が15分を超える場合、OG Exchangeは取引が再開されるまで、その構成要素をインデックスから自動的に削除します。</p>',
    'title.indice_description.btc.paragraphs': '<p class = "pre"> BTCインデックスは、ビットコインの価格を毎分追跡します。ビットコインの価格はインデックスの最終価格から計算されます。 BTCのインデックス価格は、現在のビットコイン価格として多数のページに表示されます。</ p> <p> BTCの価格は、現在、Bitstamp、Coinbase Pro、OKCoin、GEMINI、Krakenの等しい部分から導出されています。この構成は、前例のない為替の不安定性により変更される可能性があります。</ p> <p>これは複数のソースから価格が構成される総合インデックスです。構成要素に関する情報については、以下の「総合インデックスの内訳」をご覧ください。取引所がサービスを提供できなくなり、価格非提示時間が15分を超える場合、OG Exchangeは取引が再開されるまで、その構成要素をインデックスから自動的に削除します。</p>',
    'title.indice_description.btc30.paragraphs': '<p>OG Exchange BTC30インデックスは、ビットコインの価格を毎分追跡します。ビットコインの価格は、OG Exchangeインデックスの最終価格から計算されます。 BTCのインデックス価格は現在の ビットコイン レートとして多数のページに表示されます。</ p> <p> 現在BTCの価格は、Bitstamp、Coinbase Pro、OKCoin、GEMINI、Krakenの等しい部分から導出されています。この構成は、前例のない為替の不安定性により変更される可能性があります。</ p> <p>これは複数のソースから価格が構成される総合インデックスです。構成要素に関する情報については、以下の「総合インデックスの内訳」をご覧ください。取引所がサービスを提供できなくなり、価格非提示時間が15分を超える場合、OG Exchangeは取引が再開されるまで、その構成要素をインデックスから自動的に削除します。</p>',
    'title.indice_description.btc30m.paragraphs': '<p class="pre">BTC30Mインデックスは、12:00 協定世界時に終了するビットコイン 価格の 30分 TWAP です<a href="/margin-exchange/contracts/indices-data/BTC"> BTCインデックス</a>。この値は決済に利用されます。計算には BTCインデックスの値が使用されます。</ p> <p>これは複数のソースから価格が構成される総合インデックスです。構成要素に関する情報については、以下の「総合インデックスの内訳」をご覧ください。取引所がサービスを提供できなくなり、価格非提示時間が15分を超える場合、OG Exchangeは取引が再開されるまで、その構成要素をインデックスから自動的に削除します。</p>',
    'title.indice_description.btcbon.paragraphs': 'アマンプリBTCBONインデックスは、BTC貸出金利を１分毎にアマンプリインデックスで追跡します。マーケットのオーダーブックの枚数、オーダーブックの厚みを基に計算されます。<br> <br>このインデックスは、貸出レートの大幅な変動を理由にBitfinexからは取得しなくなりましたが、一定のレートに設定されています。',
    'title.indice_description.btcbon2h.paragraphs': 'アマンプリBTCBON2Hインデックスは、アマンプリインデックスでのBTCBONプレミアムレートの2時間TWAPです。<a href="{BTCBONIndex}">この値は資金調達率の計算に使用され、2時間前に提供されます。',
    'title.indice_description.btcbon8h.paragraphs': 'OG Exchange BTCBON8HインデックスはOG ExchangeインデックスでのBTCBONプレミアムレートの8時間TWAPです。<a href="/margin-exchange/contracts/indices-data/BTCBON"> BTCBONインデックス</a>この値は資金調達率の計算に使用され、8時間 前に提供されます。',
    'title.indice_description.ethbon.paragraphs': 'アマンプリETHBONインデックスは、ETH貸出金利を１分毎にアマンプリインデックスで追跡します。オーダーブックの枚数、オーダーブックの厚みを基に計算されます。',
    'title.indice_description.ethbon2h.paragraphs': 'OG Exchange ETHBON2Hインデックスは、アマンプリインデックスでのETHBONプレミアムレートの2時間TWAPです。<a href="/margin-exchange/contracts/indices-data/ETHBON"> ETHBONインデックス</a>この値は資金調達率の計算に使用され、2時間 前に提供されます。',
    'title.indice_description.ethbon8h.paragraphs': 'OG Exchange ETHBON8Hインデックスは、アマンプリインデックスでのETHBONプレミアムレートの8時間TWAPです。<a href="/margin-exchange/contracts/indices-data/ETHBON"> ETHBONインデックス</a>この値は資金調達率の計算に使用され、8時間 前に提供されます。',
    'title.indice_description.usdbon.paragraphs': 'アマンプリUSDBONインデックスは、米ドル貸出金利を１分毎にアマンプリインデックスで追跡します。マーケットのオーダーブックの枚数、オーダーブックの厚みを基に計算されます。',
    'title.indice_description.usdbon2h.paragraphs': 'OG Exchange USDBON2Hインデックスは、OG Exchangeインデックス での .USDBON プレミアムレート の 2時間 TWAP です<a href="/margin-exchange/contracts/indices-data/USDBON"> USDBONインデックス</a>この値は資金調達率の計算に使用され、8時間 前に提供されます。',
    'title.indice_description.usdbon8h.paragraphs': 'OG Exchange USDBON8Hインデックスは、OG Exchangeインデックス での .USDBON プレミアムレート の 8時間 TWAP です<a href="/margin-exchange/contracts/indices-data/USDBON"> USDBONインデックス</a>この値は資金調達率の計算に使用され、8時間 前に提供されます。',
    'title.indice_description.btcusdpi.paragraphs': 'アマンプリBTCUSDPIインデックスはアマンプリでBTCUSDプレミアムレートを毎分追跡します。',
    'title.indice_description.btcusdpi2h.paragraphs': 'OG Exchange BTCUSDPI2H インデックスは<a href="/margin-exchange/contracts/indices-data/BTCUSDPI"> BTCUSDPIインデックス</a>でのBTCUSDPIプレミアムレート の 2時間 TWAP です。この値は資金調達率の計算に使用され、2時間 前に提供されます。',
    'title.indice_description.btcusdpi8h.paragraphs': 'OG Exchange BTCUSDPI8Hインデックスは<a href="/margin-exchange/contracts/indices-data/BTCUSDPI"> BTCUSDPIインデックス</a>BTCUSDPI プレミアムレート の 2時間 TWAP です。この値は資金調達率の計算に使用され、2時間 前に提供されます。',
    'title.indice_description.ethbtcpi.paragraphs': 'アマンプリETHBTCPI インデックスは、アマンプリでETHBTCプレミアムレートを毎分追跡します。',
    'title.indice_description.ethbtcpi2h.paragraphs': 'アマンプリETHBTCPI2Hインデックスは、ETHBTCインデックスでのETHBTCプレミアムレートの2時間TWAPです。これらの値は資金調達率の計算に使用され、2時間前に提供されます。',
    'title.indice_description.ethbtcpi8h.paragraphs': 'アマンプリETHBTCPI8Hインデックスは、ETHBTCインデックスでのETHBTCプレミアムレートの8時間TWAPです。これらの値は資金調達率の計算に使用され、8時間前に提供されます。',
    'title.indice_description.ethusdpi.paragraphs': 'アマンプリETHUSDPIインデックスは、アマンプリでETHUSDプレミアムレートを毎分追跡します。',
    'title.indice_description.ethusdpi2h.paragraphs': 'アマンプリETHUSDPI2Hインデックスは、アマンプリETHUSDインデックスでのETHUSDプレミアムレートの2時間TWAPです。これらの値は資金調達率の計算に使用され、2時間前に提供されます。',
    'title.indice_description.ethusdpi8h.paragraphs': 'アマンプリETHUSDPI8Hインデックスは、アマンプリETHUSDインデックスでのETHUSBプレミアムレートの8時間TWAPです。これらの値は資金調達率の計算に使用され、8時間前に提供されます。',
    'title.indice_description.eth.paragraphs': '<p class = "pre"> OG Exchange ETHインデックスは、イーサリアムの価格を 1分 ごとに追跡します。イーサリアムの価格は、 OG Exchangeインデックスの直近レートを基に計算されます。 ETHインデックス価格は、現在のイーサリアム価格として多数のページに表示されます。</ p> <p>これは複数のソースから価格が構成される総合インデックスです。構成要素に関する情報については、以下の「総合インデックスの内訳」をご覧ください。取引所がサービスを提供できなくなり、価格非提示時間が15分を超える場合、OG Exchangeは、取引が再開されるまで、その構成要素をインデックスから自動的に削除します。</p>',
    'title.indice_description.eth_btc.paragraphs': '<p class = "pre">OG Exchange ETHBTCインデックスは、イーサリアムの価格を 1分 ごとに追跡します。イーサリアムの価格は、OG Exchange インデックスの直近レートを基に計算されます。 ETHBTCインデックス価格は、現在のイーサリアム価格として多数のページに表示されます。</ p> <p>これは複数のソースから価格が構成される総合インデックスです。構成要素に関する情報については、以下の「総合インデックスの内訳」をご覧ください。取引所がサービスを提供できなくなり、価格非提示時間が15分を超える場合、OG Exchangeは、取引が再開されるまで、その構成要素をインデックスから自動的に削除します。</p>',
    'title.indice_description.eth30m.paragraphs': '<p class = "pre">OG Exchange ETH30Mインデックスは、12：00 UTCで終わるアマンプリインデックスのイーサリアム価格の30分のTWAPです <a href="/margin-exchange/contracts/indices-data/ETH"> ETHインデックス</a>。 これらの値は、決済に使用されます。 TWAPは、OG Exchange ETHインデックスの値を使用して計算されます。</ p> <p>これは複数のソースから価格が構成される総合インデックスです。構成要素に関する情報については、以下の「総合インデックスの内訳」をご覧ください。取引所がサービスを提供できなくなり、価格非提示時間が15分を超える場合、OG Exchangeは取引が再開されるまで、その構成要素をインデックスから自動的に削除します。</p>',
    'title.symbol_index_detail': '{symbol} インデックスの詳細',
    'title.margin_instruments_using_index': 'このインデックスを使用する商品',
    'title.margin_indices_using_index': 'このインデックスを使用するインデックス',
    'title.symbol_index_historical_values': '{symbol}インデックスの履歴',
    'title.margin_index_breakdown': 'インデックス値',
    'title.margin_composite_index_breakdown': '複合インデックスの詳細',
    'margin.contract.label.price_index_symbol': '価格 {symbol}',
    'margin.contract.label.premium_index_symbol': '{symbol} プレミアム',
    'title.des.funding_history_table': 'このリストには、すべてのシンボル分の過去の資金調達率が網羅されています。',
    'title.des.settlement_history_table': 'このリストには過去の決済が網羅されています。',
    'table.funding_interval': '資金調達間隔',
    'table.funding_rate': '資金調達率',
    'table.funding_rate_daily': '毎日の資金調達率',
    'des.des_margin_leaderboard': '・以下は、OG Exchangeでトップクラスの収益率を誇るトレーダーたちです。<br/>・このリストは匿名ベースであり、名前はそれぞれ同じユーザーを表しますが、身元は特定できません。',
    'des.des_mam_leaderboard': '・以下は、OG Exchangeでトップクラスの収益率を誇るトレーダーたちです。<br/>・このリストは匿名ベースであり、名前はそれぞれ同じユーザーを表しますが、身元は特定できません。',
    'title.Leaderboard': 'リーダーボード',
    'title.Leaderboard.des_title': 'デフォルトでは、リーダーボードにあなたのアカウントが表示されますがアカウント名は特定されません。 変更には最大30分かかります。',
    'leaderboard.show_real_username': '匿名のユーザー名（ニックネーム）を表示しますか？',
    'leaderboard.show_fake_username': '実際のユーザー名を表示しますか？',
    'leaderboard.off_to_show_fake_username': 'オフにすると、リーダーボードに実際のユーザー名が表示されます。',
    'leaderboard.your_fake_name_is': 'あなたのニックネームは：',
    'leaderboard.on_to_show_real_username': 'オンにするとリーダーボードにニックネームが表示されます。',
    'table.rofit': '利益',
    'table.rank': 'ランク',
    'table.is_real_name': '実名です',
    'title.overview': '概要',
    'title.des.overview': '<p> <strong>先物契約</ strong>はデリバティブ商品であり、商品、通貨またはその他の商品を将来指定の時間に所定の価格で売買する契約です。物理的に決済と現金決済両方できます。 OG Exchangeは、現金決済された先物契約の形でいくつかの取引商品を提供しています。</ p> <p>先物契約では、トレーダーは100％の担保を証拠金として取る必要がありません。そのため、 OG Exchangeでいくつかの契約がで最大レバレッジ100倍に取引できます。 OG ExchangeはすべてBitcoinをマージンとして、トレーダーはBitcoinのみを使用して商品の将来価値を推測できます。</ p> <p> OG Exchangeが提供するもう一つデリバティブ製品は、<a href="{perpetualContractsGuide}">無期限契約</a>。 特定の先物契約情報を表示するには、、上部の[<strong>契約</ strong>]タブをクリックします。</ p>',
    'title.mechanics_of_futures_markets': '先物市場の仕組み',
    'title.header_form.perpetual contracts_guide': '無期限契約ガイド',
    'title.des.overview.perpetual_contracts_guide': '<p> <strong>無期限契約</ strong>は、従来の<a href="{futuresGuide}"> 先物契約</a>同様デリバティブ商品ですが、以下のように異なる点もいくつかあります。</ p > <ul style = "list-style-type：disc; padding-left：25px;"> <li>満期や決済がありません。</ li> <li無期限契約は、証拠金をベースとするスポット市場を模倣するものであるため。原資産を参考にするインデックス価格と近い水準で取引されます。<li>これは、<a href="{futuresGuide}">先物契約</a>と対照的な点です。先物契約は、ベーシスを理由に大幅に異なる価格で取引されます</ li> <li>スポット価格と連動するための主な仕組みが<a href="#funding">資金調達</a>です。</ li></ li> </ ul>',
    'title.des.mechanics_of_perpetual_contracts_markets': '<p>無期限契約を取引する際は、この市場の仕組みをいくつか知っておく必要があります。 トレーダーが知っておくべき重要項目は次のとおりです。:</p> <ol style="padding-left: 25px;"> <li><strong>Position Marking</strong>:ポジションマーキング</ strong>：無期限契約は 公正価格マーキング 方法に従ってマーキングされています。 マーク（公正）価格は未実現損益 と 清算価格 を設定します。</ li> <li> <strong>初期証拠金と維持証拠金</ strong>：この 2 つの主な証拠金レベルによって、取引可能なレバレッジサイズと清算の発生地点が決まります。</ li> <li> <strong>資金調達</ strong>:買い手と売り手が 8 時間ごとに交わす支払いです。 レートがプラスの場合は、<em> 買い手が支払い、</ em>、<em> 売り手が受け取ります。</ em>、レートがマイナスの場合は、この逆になります。<li> <strong>資金調達タイムスタンプでポジションを保持している場合のみ、資金の支払いまたは受け取りを行います。</ strong> </ li></ li> <li> <strong>資金調達タイムスタンプ</ strong>：04:00 UTC、12：00 UTC、20：00 UTC。</ li> </ ol> <p>各契約の最新資金調達率は、[契約の詳細]にある[取引]タブの左下でご確認いただけます。また、個別の「契約明細」でもこのレートをご覧いただけます。 過去のレートについては<a href="{fundingHistory}"> 資金調達履歴</a>をご覧ください。</ p>',
    'title.mechanics_of_perpetual_markets': '無期限契約市場の仕組み',
    'title.des.mechanics_of_futures_markets': '<p>先物契約を取引する際は、トレーダーは先物市場についてか知っておく必要があります。 トレーダーが知っておくべき重要項目は次のとおりです。</ p> <ol> <li> <strong>乗数</ strong>：1つの契約の価値はいくらですか？この情報は、各商品の契約仕様で確認できます。</ li> <li> <strong>ポジションマーキング</ strong>：先物契約は、公正価格のマーキング方法に従ってマークされます。マーク価格は未実現損益と清算価格 を決定します。</ li> <li> <strong>初期証拠金および維持証拠金</ strong>：この 2 つの主な証拠金レベルによって、取引可能なレバレッジサイズと清算の発生地点が決まります。</ li> > <li> <strong>決済</ strong>：先物契約がいつに満期するまたはどうやって決済するか、トレーダーに理解していただきたいです。OG Exchangeでは、価格操作を回避するために、決済前の一定期間の平均化を採用しています。この時間枠は商品ごとに異なる場合があり、トレーダーは個々の契約仕様を読んで、いつ期限が切れるか、個々の決済手順を理解する必要があります。</ li> <li> <strong>ベーシス</ strong>：先物取引のプレミアムまたはディスカウントは基礎となるスポット価格価格と比較すると、通常は年率換算の％で見積もられます。先物契約は将来満期する時、その満期の不確定性にポジティブまたはネガティブ時間値要素が存在します。</ li> </ ol>',
    'title.funding': '資金調達',
    'title.des.more_information.futures_guide': '<p>詳細情報は、次の情報ご覧ください。</ p> <ul style = "list-style-type：disc; padding-left：25px;"> <li>先物</ li> <li>毎月のコード</ li > <li>基礎</ li> <li>例</ li> </ ul>',
    'title.des.funding': '<p>資金調達は、8時間ごと (世界協定時の 4:00、12:00、20:00) に行われます。 <strong>資金を授受するのは、このいずれかの時刻にポジションを保有する場合のみです。</ strong>この時刻前にポジションを決済した場合は、資金を授受することはありません。</ p> <p >支払いまたは受け取る資金は次のように計算されます。</p> <pre style="background-color: #d9edf7;"><code style="color: #31708f; background-color: #d9edf7;">資金費用= ポジション値*資金調達率</ code> </ pre> <p>ポジション値はレバレッジとは無関係です。 たとえば、100 BTCUSD契約を保持している場合、資金調達額はこの契約の名目元本で支払い/受領されます。ポジションに課せられる証拠金額を基にすることはありません。</ p> <p> <code> 資金調達率</ code>がプラスの場合、ロングポジションの保有者がショートポジションの保有者に支払います。。 マイナスの場合、ショーツはロングを支払います。 例を参照してください。</ p>',
    'title.funding_rate_calculations': '資金調達率の計算',
    'title.des.funding_rate_calculations': '<p>資金調達率は、<strong>金利</ strong>と<strong>プレミアム/ ディスカウント</ strong>の2つの主要部分で構成されています。 このレートによって、無期限契約の取引価格と原資産の参考価格との整合性が維持されるため、 無期限契約は、契約の買い手と売り手が定期的に金利のやり取りをする証拠金取引市場を追随するようになります。</ p>',
    'title.interest_rate_component': '金利構成要素',
    'title.des.interest_rate_component': '<p>OG Exchangeで取引されるどの契約も、基本通貨と建値通貨の 2 つの商品から成ります。BTCUSDを例にとると、BTCが基本通貨、USD が建値通貨となります。  金利は、この 2 通貨間の金利の関数です。:</p> <pre style="padding-bottom: 0px; padding-top: 20px; color: #31708f; background-color: #d9edf7;"><code>金利 (I) = (建値通貨金利指標 - 基本通貨金利指標) / 資金調達間隔</br>式中： <ol style =“ padding-left：25px; margin-bottom：0; line-height：10px; list- style：none;“> <li>基本通貨金利指標 = 基本通貨の借入金利</ li> <li>建値通貨金利指標 = 建値通貨の借入金利</ li> <li>資金調達間隔 = 3 (資金調達は 8 時間ごとに行われるため)</ li> </ ol> </ code> </ pre> <p> <em注：個別の「契約明細」ページに、各金利指標の情報源となる借入市場が明記されています。 </ em> </ p>',
    'title.premium_discount_component': 'プレミアム/ディスカウント要素',
    'title.des.premium_discount_component': '<p無期限契約は、マーク価格に対して大幅なプレミアムまたはディスカウントで取引される場合があります。 そのような状況では、プレミアムインデックスを使用して、次回資金調達率を引き上げ/引き下げて、無期限取引水準と整合する水準へ調整します。無期限契約のプレミアムインデックスは、特定商品の「契約明細」ページに掲載されています。計算式は以下のとおりです。 計算式は以下のとおりです。プレミアムインデックス (P) = (Max (0, インパクトビッド価格 - マーク価格) - Max(0, マーク価格 - インパクトアスク価格)) / スポット価格 + マーク価格に使用される公正ベーシス</code></p> <p>。インパクトビッド価格とインパクトアスク価格の詳細は、公正価格マーキング をご覧ください。<p>\r\n',
    'title.final_funding_rate_calculation': '最終資金調達額の計算',
    'title.des.final_funding_rate_calculation': '<p> OG Exchangeは、<strong>プレミアムインデックス<code>（P）</ code> </ strong>および<strong>金利<code>（I）</ code> </ strong>毎分計算してから、分レートのシリーズデータで 8 時間時間加重平均価格 (TWAP) を算定しています。</ p> <p>次に、8 時間金利要素と 8 時間プレミアム/ディスカウント要素を使って、資金調達率が計算されます。 A +/-% のバッファも計算要素に加わります。</ p> <p> <code>資金調達率 (F) = プレミアムインデックス (P) + clamp (金利 (I) - プレミアムインデックス (P), 0.05%, -0.05%)</ code> </ p> <p>したがって、(I - P) が +/-0.05% の範囲にある場合は、F = P + (I - P) = I となります。つまり、資金調達率は金利と等しくなります。 </ p> <p>計算された資金調達率をトレーダーのBTC ポジション価額に適用すると、資金調達タイムスタンプに授受される資金調達額が確定します。</ p>',
    'title.funding_rate_caps': '資金調達率の上限',
    'title.des.funding_rate_caps': '<p> OG Exchangeは、最大レバレッジを利用できるように、資金調達率に上限を設けています。 ここで2つの上限をかけられます。:</p> <ol style="padding-left: 25px;"> <li>絶対的な資金調達率は、<em>初期マージン-メンテナンスマージン</ em>の75％ </ em>。 初期マージンが1％で、メンテナンスマージンが0.5％の場合、最大資金調達率は75％*（1％-0.5％）= 0.375％になります。</ li> <li>２回の資金調達の間に、資金調達率はメンテナンスマージンの75％を超えません。</li> </ol>',
    'title.funding_fees': '資金調達料',
    'title.des.funding_fees': '<p> OG Exchangeは資金調達に手数料を請求しません。 直接ピアツーピアで取引されます。</ p>',
    'title.more_information': '補足情報',
    'title.des.more_information': '<p>さらに詳しい情報と資金調達計算の例があります。</ p>',
    'title.bitcoin_series_xbt_guide': 'ビットコイン シリーズ（BTC）ガイド',
    'title.des.bitcoin_series_btc_guide': '<p> OG Exchangeで<a href="{perpetualContractsGuide}">無期限契約</a>と呼ばれる新しい革新的なタイプの契約を通じて、ビットコイン（BTC）を取引できます。強化した レバレッジは特徴です。 この契約には有効期限がなく、さまざまなを介して基礎となる参照<a href="#price_index">価格インデックス</a>を厳密に追跡できます。その主な機能は<a href = "{ perpetualContractsGuide} #funding ">資金調達率</a>。</ p> <p>現在の資金調達を決定するために現在の率をみると計算するには、<a href="{BTCUSDContractSpecifications}">の資金調達計算を参照してください。 BTCUSD契約仕様</a>およびより一般的には<a href="{perpetualContractsGuide}">無期限契約ガイド</a>に記載されています。</ p> <p>この契約は、長期にわたってポジションを保持したいトレーダーに適しており、また大きな価格変動に望まないユーザーです。</ p>',
    'title.how_is_the_XBTUSD_perpetual_contract_quoted': 'BTCUSD 無期限契約はどのようにクォートされますか？',
    'title.des.how_is_the_XBTUSD_perpetual_contract_quoted': 'Contrary to popular belief, Lorem Ipsum is not simply random text.It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old.Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source.Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of "de Finibus Bonorum et Malorum" (The Extremes of Good and Evil) by Cicero, written in 45 BC.This book is a treatise on the theory of ethics, very popular during the Renaissance.The first line of Lorem Ipsum, "Lorem ipsum dolor sit amet..".',
    'title.des.how_is_the_XBTUSD_perpetual_contract_quoted2': 'Going through the cites of the word in classical literature, discovered the undoubtable source.Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of "de Finibus Bonorum et Malorum" (The Extremes of Good and Evil) by Cicero, written in 45 BC.This book is a treatise on the theory of ethics, very popular during the Renaissance.The first line of Lorem Ipsum, "Lorem ipsum dolor sit amet..".',
    'title.price_index': '価格インデックス',
    'title.des.price_index': 'Contrary to popular belief, Lorem Ipsum is not simply random text.It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old.Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature.<br/>Discovered the undoubtable source.Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of "de Finibus Bonorum et Malorum" (The Extremes of Good and Evil) by Cicero, written in 45 BC.This book is a treatise on the theory of ethics, very popular during the Renaissance.The first line of Lorem Ipsum, "Lorem ipsum dolor sit amet..", comes from a line in section 1.10.32.',
    'title.margin_and_leverage': '証拠金とレバレッジ',
    'title.des.margin_and_leverage': 'Contrary to popular belief, Lorem Ipsum is not simply random text.It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old.Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia.',
    'title.marking_and_settlement': 'マーキングと決済',
    'title.des.marking_and_settlement': 'Contrary to popular belief, Lorem Ipsum is not simply random text.It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old.Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source.Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of "de Finibus Bonorum et Malorum" (The Extremes of Good and Evil) by Cicero, written in 45 BC.This book is a treatise on the theory of ethics, very popular during the Renaissance.The first line of Lorem Ipsum, "Lorem ipsum dolor sit amet..".',
    'menu.mam_follower': 'Follower Menu',
    'menu.mam_master': 'Master Menu',
    'menu.mam_exchange': 'MAM Exchange',
    'menu.mam_comissions': '手数料',
    'comomon.current_interval': '現在の間隔',
    'comomon.withdraw_history': '出金履歴',
    'menu.comissions': '手数料',
    'comomon.high_watermark': '高水位線',
    'common.perfomance_fee': '成功報酬',
    'common.management_fee': '管理手数料',
    'common.flat_fee': '均一手数料',
    'common.rate_funding': 'I =金利、B =金利ベース、Q =金利見積もり、T = 1日あたりの資金調達時間<br/> P =プレミアムレート、F =資金調達レート',
    'common.ethusd.rate_funding': 'I =金利、B =金利ベース、Q =金利見積もり、T = 1日あたりの資金調達時間<br/> P =プレミアムレート、F =資金調達レート',
    'common.ethbtc.rate_funding': 'I =金利、B =金利ベース、Q =金利見積もり、T = 1日あたりの資金調達時間<br/> P =プレミアムレート、F =資金調達レート',
    'common.ethu19.rate_funding': 'I =金利、B =金利ベース、Q =金利見積もり、T = 1日あたりの資金調達時間<br/> P =プレミアムレート、F =資金調達レート',
    'common.btcusd.rate_funding': 'I =金利、B =金利ベース、Q =金利見積もり、T = 1日あたりの資金調達時間<br/> P =プレミアムレート、F =資金調達レート',
    'common.btcu19.rate_funding': 'I =金利、B =金利ベース、Q =金利見積もり、T = 1日あたりの資金調達時間<br/> P =プレミアムレート、F =資金調達レート',
    'common.btcz19.rate_funding': 'I =金利、B =金利ベース、Q =金利見積もり、T = 1日あたりの資金調達時間<br/> P =プレミアムレート、F =資金調達レート',
    'common.des.rate_funding': '<span style = "background-color：#ececec; color：＃333333; display：inline-block; padding：0px 3px"> 資金調達レート </ span>は、ユーザー間で交換されるレートです。<br/> <span style = "background-color：#ececec; color：＃333333; display：inline-block; padding：0px 3px"> プレミアムレート</ span>が計算に使用され、金利によって最大0.05％調整されます。',
    'common.curious_formula': 'I = (Q - B) / T<br/>F = P + Clamp(I - P, -0.05%, 0.05%)',
    'common.curious_result': 'I = (0.06% - 0.03%) / 3<br/>F = 1.4240% + Clamp(0.0100% - 1.4240%, -0.05%, 0.05%)',
    'common.view_contract_series_guide': '{root_symbol}シリーズガイドを見る',
    'common.ticker_root': 'ティッカールート',
    'common.expiry': '満期日',
    'common.futures': '先物',
    'common.perpetual': '無期限',
    'account.modal.lost_otp.guide.common': 'Google認証を解除するには、回復コードを入力する必要があります。',
    'server.logs': '30秒内にリクエストが多すぎます。',
    'landing.swiper.amal.title': '4IREネットホールドランキングコンペティション開催！',
    'landing.swiper.amal.time': '2019年12月30日21:00（GMT+9）〜2020年1月31日21：00（GMT+9）',
    "roe_num_ranking_one":"1 位 | 第1名 | 1 位",
    "roe_num_ranking_two":"2 位 | 第2名 | 2 位",
    "roe_num_ranking_three":"3 位 | 第3名 | 3 位",
    "roe_num_ranking_four":"4〜10 位 | 第4〜10名 | 4〜10 位",
    "roe_num_ranking_rate":"各{btc}ずつ",
    "roe_person_info": '{num}人 | {num}人以上 | {num} BTC',
    "roe_activity_tit":"OG Exchange レバレッジ取引ROEコンテスト",
    "roe_activity_subtit":"OG Exchangeは、レバレッジ取引にてエントリー制ROEコンテストを開催します！<br />期間中のROE（自己資本率）を競い上位のトレーダーをリーダーボードでリアルタイムに表示します。",
    "roe_activity_competition_content":"ROEコンテスト概要：",
    "roe_activity_competition_content_desc":"オープンしているコントラクトにて取引を行い、コンテスト期間終了後にROEが高かったユーザー上位には賞金があります。ユーザーは自らエントリーを行うことでコンテストに参加する事ができます。また、賞金はエントリーしたユーザーの総人数によって変動します。",
    "roe_activity_compute2":"証拠金 = エントリー価格  ÷  レバレッジ",    
    "roe_act_time_range":" {fromTime} 〜 {toTime} / UT（UTC）{allDay}週間",
   
   "roe_activity_quil":"参加資格：",     
   "roe_activity_quil_money":"{money}BTC以上の証拠金",     
   "roe_acti_table":"エントリー人数と賞金総額：", 
   "roe_acti_table_person":"参加人数", 
   "roe_acti_table_money":"賞金総額", 
   "roe_acti_rule":"賞金の分配ルール：",
   "roe_acti_rule_ranking":"順位",
   "roe_acti_rule_rate":"獲得する比率",
   "roe_acti_rule_reward":"奨励",
   "roe_act_money_time":"賞金配布時期： <br />コンテスト終了後、不正有無の確認をし正確な順位を{day}日以内に確定し、更に{day_m}日以内に賞金を配布致します。",
   "roe_act_money_time_table":"例：参加人数が{person}人であり賞金総額が{btcNum}BTCの場合",
    "roe_act_desc_tit":"コンテスト補足事項：",
    "roe_act_desc_list":[`エントリー期間中にコンテスト開催最低人数である20人が集まらなかった場合、コンテスト（個人戦）は中止となり、チーム対抗戦のエントリーを開始します。`,
    `エントリー期間に500人が集まりコンテストが開催されたにもかかわらず取引が無かった、または出金をしたなどの原因により確定エントリー人数が500人を下回った場合、期間中でもノーコンテストとなり、賞金もなくなります。`,
    `エントリー期間中にポジションを持っていて、そのままコンテスト期間に入った場合、コンテスト期間に一度完全にポジションを決済した時点からROEが計算されます。`,
    `エントリー後、証拠金を引き出したり、コンテスト期間中に1トレードもしなかった場合はエントリーを取り消されます。`,
    `コンテスト終了後にエントリー人数、ランキングを確定し、30日以内に配布致します。`,
    `ウォッシュトレードまたは違法な登録アカウント、自己取引、または市場操作と見なされるトレードを失格にする権利を有します。`,
    `当社独自の裁量により、コンテストまたはコンテストルールを取り消しまたは修正する権利を有します。`,
    `コンテスト期間中の手数料収入が賞金総額を下回った場合は、コンテスト期間中の手数料利益の7割を賞金総額の上限といたします。`],
    "roe_act_desc_cancel":"エントリーが取り消される条件について： ",
    "roe_act_desc_cancel_list1":" エントリー期間中にポジションを持っており、コンテスト前に証拠金が{btc}BTCを下回った場合：エントリーは取り消されます。(再エントリー可能)",
    "roe_act_desc_cancel_list2":" エントリー期間中にポジションを持っており、コンテスト開始日をそのまま跨いだ場合：決済後からランキングを計測します。またその決済時に証拠金が{btc}BTCを下回った場合はエントリー取り消されます。 ",
    "roe_act_desc_cancel_list3":" エントリー期間中にポジションを持っており、コンテスト開始日をそのまま跨いだ場合：エントリーは取り消されます。",
    "roe_act_desc_cancel_list4":" コンテスト期間中に1トレードもしなかった場合は、エントリーは取り消されます。",
    "roe_act_warn":"リスク警告：仮想通貨の取引は急激な価格変動などのリスクが高いため、リスク許容度の内で合理的に判断し慎重に投資してください。",
   "roe_act_about_money_tit":"ボーナス証拠金についての注意：",
   "roe_act_about_money_list":["エントリー時にMargin Balanceにある資金の100%をボーナス証拠金としてプレゼントします。(上限なし)","ボーナスはMargin Balanceと合わせて証拠金として使用可能です。","出金をすることはできません。","Margin Balanceより資金を動かした場合はボーナスは消滅します。","取引手数料、ファンディング手数料はMargin Balanceから引かれます。","取引による損失はMargin Balanceから引かれます。","ボーナスだけになった場合は取引不可になります。（Margin Balanceを追加することで取引可能になります。)","ロスカットはMargin Balanceの範囲で執行されます。","コンテスト終了と共にボーナスは消滅します。","コンテスト終了時にボーナスを使用してのポジションを持っている場合は、ポジション解消と同時にボーナス消滅します。（次回エントリー時にボーナスを使ったポジションを保有していた場合、エントリーはできるがボーナスは付与されません。）"],
   roe_competition_conten:[{
    tit:'ROEコンテスト概要',
    desc: `オープンしているコントラクトにて取引を行い、コンテスト期間終了後にROEが高かったユーザー上位には賞金があります。ユーザーは自らエントリーを行うことでコンテストに参加する事ができます。また、賞金はエントリーしたユーザーの総人数によって変動します。<br />
    コンテストはROEを競うためユーザーの資金量に影響されません。<br />
    例：証拠金0.05BTCのユーザーと証拠金5BTCのユーザーのROEは平等に計算されます。`
  },{
    tit:'ROEの計算方法',
    desc:'ROE(全期間) = [(ROE(1日目)+1) * (ROE(2日目)+1) * (ROE(3日目)+1) * …（終了日まで続く）] - 1<br />* 1日のROE計算方式は下記を参照'
  },{
    tit:'当日（1日）のROEの計算方法',
    desc:`ROE(当日のROE) = 証拠金残高(当日の終了時) ÷ 証拠金残高(当日の開始時) – 1    <br />
    * 1日は日本時間では12：00〜翌日11：59までとします。<br />  * 当日の終了時の証拠金残高の計算方式は下記を参照`
  },{
    tit:'証拠金残高（当日の終了時）の計算方法',
    desc:'証拠金残高(当日の終了時) = 証拠金残高(当日の開始時) + 実現損益(当日の取引時) + 未実現損益(当日の終了時)<br /> - 未実現損益(当日の開始時) '
  },{
    tit:'ROEコンテストエントリー期間',
    desc: `8/2 10:00 ～ 8/12 17:59（GMT+9）<br />
    ＊エントリー期間以外はエントリーできません。またコンテスト途中からの参加はできません。`
  },{
    tit:'ROEコンテスト期間',
    desc:'8/12 18:00 ～ 8/30 17:59（GMT+9）'
  },{
    tit:'参加資格',
    desc:'0.02 BTC以上の証拠金'
  }],
  "profit_ranking_contest_time": {
    "banner": "まもなく開催！",
    "activity": "現在エントリーは受け付けていません。",
    "contest": "現在ROEコンテストは開催されていません。",
  },

  'coin_information_btn_link': 'コインの情報',
  'profit_ranking_contest_tit': 'プロフィットランキングコンテスト（ROE）',

  'profit_ranking_contest_btnTxt': 'レバレッジ取引',
  'deposit_bonus_tit': '入金ボーナス',
  'deposit_bonus_subtit': 'デポジットするだけで入金ボーナスが貰えます！',
  'deposit_bonus_time': '3月20日～3月26日',
  'amal_campaign_tit': '4IRE取引ボリュームコンテスト＆<br />4IRE TRADING BONUS',
  'amal_campaign_time': '活動時間 : 3月11日～3月22日',
  'amal_campaign_btctxt': '賞金2BTC',
  'btc_campaign_tit': 'BTC <br /> TRADING BONUS <br /> Campaign GO',
  'btc_campaign_time': '3月24日～3月26日',
  'btc_campaign_btctxt': '賞金総額10BTC',
  'index_cooperative_partner': 'パートナー',
  'index_cooperative_plan': '募集計画',
  'index_buyback_fund': '買戻し資金',
  'index_insurance': 'ハッカー保険基金',

  'cooperation_tit': '世界中の国と地域のパートーナーを募集しています。',
  'cooperation_tit_bonus': ' 毎日配当が貰えます。（※<span style=\'color:#2DAC91;\'>10,0004IRE</span>以上を保有した場合）',
  'cooperation_privilege_reward': 'パートーナーへの報酬制度',
  'cooperation_privilege_payment': 'リアルタイム決済システム',
  'cooperation_privilege_manage': 'コミッション管理システム',
  'cooperation_choose': 'パートーナーラベルプログラムを選ぶ',
  'cooperation_choose_media': 'メディア／ブロガー',
  'cooperation_choose_internet': 'インフルエンサー／アフィリエーター',
  'cooperation_choose_manage': 'コミュニティマネージャー',
  'cooperation_invite_become': 'OG Exchangeのパートーナーになろう！',
  'cooperation_privilege': 'パートナーの特権',
  'cooperation_invite': '招待報酬',
  'cooperation_first': '1位',
  'cooperation_second': '2位',
  'cooperation_three': '3位',
  'cooperation_four': '4位',
  'cooperation_bonus': 'ボーナスをゲット',
  'invite_recommend_id': '私のおすすめID',
  'invite_recommend_scale': '現在の還付比率',
  'invite_recommend_link': '推薦リンク',
  'invite_recommend_share': '共有する',
  'invite_recommend_person': 'おすすめの友達',
  'invite_recommend_money': '獲得した推定コミッション',
  'invite_recommend_record': '獲得した推定コミッション',
  'invite_recommend_entry': '輸出する',
  'invite_recommend_email': 'メールボックス',
  'invite_recommend_time': '時間',
  'invite_recommend_none': 'リベートレコードはありません',
  'invite_recommend_history': '最近のリベート',
  'joinUs_tit': 'Join Us',
  'joinUs_subtit': 'TOGETHER WE CREATE, BUILD AND MAKE A DIFFERENCE',
  'joinUs_duty': '責任と義務',
  'joinUs_sen': '資格',
  'contract_time': '2020/03/27 OG Exchangeのレバレッジ取引がついにリリースされます。',
  'contract_explain': 'ここでは、レバレッジ取引について説明をします。',
  'contract_release': 'リリースされる契約',
  'contract_btc': 'BTC/USD 無期限契約',
  'contract_eth': 'ETH/USD 無期限契約',
  'contract_month_3': 'BTC/USD 3 months Future Contract',
  'contract_month_6': 'BTC/USD 6 months Futur',
  'contract_release_time': 'リリース日時',
  'contract_release_time_txt': '2020年3月27日 05:00 (UTC)',
  'contract_release_trait_tit': 'OG Exchangeレバレッジ取引の特徴',
  'contract_release_trait_tit_desc': 'OG Exchangeのレバレッジ取引にはOG Exchangeならではのユニークな特徴がいくつもあります。',
  'contract_times': '最大レバレッジが100倍までかけられます。',
  'contract_services': 'プラットフォームトークンである＄4IREを利用して支払う手数料を半額にできます。',
  'contract_mam': 'MAM口座を利用する事ができます。',
  'contract_api': 'APIを利用したシステムトレードに対応しています。',
  'contract_transition': '10,0004IRE以上保有する事により取引所の利益の一部を受け取ることができます。',
  'contract_explain_tit': 'レバレッジ取引の説明',
  'contract_explain_subtit': 'OG Exchangeレバレッジ取引プラットフォームは、ビットコインを証拠金として売買されるレバレッジ商品を取引する事ができるプラットフォームです。',
  'contract_explain_li_1': 'OG Exchangeでは、現在ビットコインのみを証拠金として扱っています。全ての損益はをビットコイン建てで計算します。アルトコインでコントラクトを売買した場合も同様にビットコインで損益を計算します。OG Exchangeでは法定通貨は扱っていません。',
  'contract_explain_li_2': 'OG Exchangeでは最大100倍までのレバレッジをかける事ができます。',
  'contract_contract_tit': 'OG Exchangeの契約',
  'contract_contract_subtit': 'OG Exchangeでは、無期限契約と先物を取引する事ができます。',
  'contract_contract_li_1': '無期限契約は先物と異なり、満期日がなく決済期限がありません。',
  'contract_contract_li_2': '無期限契約では8時間ごとに資金調達料金（Funding Rate）が発生します。資金調達のタイムスタンプを超えてポジションを持つ場合、資金調達料金が発生します。',
  'contract_contract_li_3': '先物契約の決済時にポジションは契約の決済価格で決済されます。',
  'contract_contract_subtit_2': 'これらを売買する事により、”契約をロング、またはショート”することができます。また、契約を保有していなくとも空売りをすることができるので、OG Exchangeは”現物を持たない”空売り目的での有益な取引プラットフォームと言えるでしょう。',
  'contract_transition_tit': '証拠金取引',
  'contract_transition_subtit': 'OG Exchangeでは一部の契約で最大100倍のレバレッジを提供しています。',
  'contract_transition_li_1': '例えば、１BTCを証拠金に最大100BTCの契約を購入することができます。また、高レバレッジは利益を大きくする事ができますが、同時に損失も大きくなることがあります。',
  'contract_transition_li_2': 'OG Exchangeではレバレッジの自動解消という仕組みを取り入れています。これによりマーケットで清算注文を成行（マーケットオーダー）で執行できない場合、含み益のあるレバレッジのかかったポジションがある特定の期間中は減額される事があります。',
  'contract_methods_tit': 'レバレッジ取引の始め方',
  'contract_methods_subtit': 'OG Exchangeでは、残高WalletよりBTCをメイン口座からレバレッジ口座に振替える事ができます。',
  'contract_methods_li_1': 'OG Exchangeの残高にアクセスしBTCの振替をクリックし、メイン口座からレバレッジ残高にBTCを移動させて下さい。',
  'contract_methods_li_2': 'レバレッジ取引所にアクセスし、レバレッジ取引を行って下さい。',
  "recruit":[{
    tit:'海外ブランディングディレクター',
    duty:["アマンプリの海外マーケティング戦略計画の実行を担当し、会社の全体的なマーケティング戦略計画を策定し、マーケティングの促進、ブランディング、広報、イベントなどの具体的な方向と実施計画を提案します。","プロモーションシステムを構築し、リソースパートナー、メディア、マーケティングの開発と保守を担当するマーケティングリソースを開発します。","会社のグローバルな広報戦略と広報対応を策定します。","事業開発およびマーケティング活動を担当します。","マーケットと競合他社を比較し、マーケットの拡大効果をまとめて分析し、意思決定の基礎を会社の上級管理職に提案します。"],
    need:["インターネットまたは国際金融業界での3〜5年以上のブランディング関連の実務経験。日本、韓国、ヨーロッパ、アメリカ、ブロックチェーン業界、暗号通貨での経験が望ましい。","大卒以上、ビジネス英語、留学または実務経験がある方。英語のネイティブスピーカーと流暢ににコミュニケーションできる能力がある方。"]
},{
    tit:'リスクおよび内部統制マネージャー',
    duty:["進行中の内部統制に対するビジネス全体の関与とサポートを率先します。運用プロセスのリスク管理を担当します。","ユーザーの取引行動、アカウントステータスを分析し、リスクを特定し、効果的なリスク管理手段を設計します。","主要なデーターの追跡、監視、管理、既存の制御ソリューションの分析と最適化、ユーザーエクスペリエンスの向上を提案します。","新しいプロジェクト、新しいユーザー、ユーザートランザクションおよび送金を監視し、潜在的なリスクを分析および識別し、リスク管理を設計および実装します。","	各部門のコーチングおよびトレーニング資料の開発、およびリスク情報の定期的な報告をします。","リスク管理プロセスのさらなる開発と他の関連作業を担当します。"],
    need:["大卒以上、金融、経済学、法律、コンピューターなどを専攻。","1〜3年の実務経験、金融機関のリスク管理、ブロックチェーン業界、暗号通貨の実務経験が望ましい","関連する法律、規制、規制ポリシーを理解し、暗号通貨機能、運用方法、リスク管理ツールに精通している。","強力な論理的思考能力と分析能力を持ち、独立した思考と思慮深い思考ができる者。","責任感があり、コミュニケーションとチームワークが得意で、仕事への熱意に満ち、プロジェクトを強力に推進できる能力がある者。"],
},{
    tit:'オペレーター（英語、韓国語、日本語、ロシア語、ベトナム語）',
    duty:["コミュニティレベルの目標と計画を策定し、ユーザーの管理と運用の目的を果たすために、ユーザーの海外コミュニティ（Facebook、BitcoinTalk、Twitter、Telegram、Mediumなどを含むがこれらに限定されない）の構築と管理を担当します","ユーザーのニーズを収集し、製品、技術、および運営の改善を促進します。","ユーザーの問題の解決を手伝います。"],
    need:["大卒以上、海外留学または実務経験が望ましい。","コミュニティの運営における1〜3年の経験。主流の金融メディア、ブロックチェーン、またはデジタル資産垂直メディアで2年以上の実務経験があることが望ましい。","Facebook、Twitter、Telegram、メディアなどの海外のソーシャルメディアプラットフォームに精通している。","ブロックチェーン業界をある程度理解している方が望ましい。","英語または中国語の専門知識が必要です。オペレーターには韓国語、日本語、ロシア語の専門知識が必要です。"],
},{
    tit:'プラットフォーム運用スペシャリスト',
    duty:['プラットフォームの毎日のデータの分析を担当。',"トークン/コインのリスト作成作業と、プロジェクト担当者と事業部門の結合を担当します。","部門内の目標を達成するために、さまざまな部門と部門（たとえば、顧客サービス、マーケティング部門）に関連する活動を達成するためのサポートをします。","プロセスの改善を開発、推奨、実装して、効率とサービスを改善し、必要に応じて部門間の連絡役を務めます。","提案された解決策を明確かつ簡潔な方法で提示します。","管理者によって割り当てられた追加の職責と関連する職務。"],
    need:["関連分野の経験が必要です。海外留学または実務経験が望ましいです。","1〜3年の実務経験が必要です。主流の金融メディア、ブロックチェーン、または暗号資産のメディアでの2年以上の実務経験が望ましい。","優れた組織力と学習能力および実行能力がある方。"]     
}],
  'contract_perpetual_tit': '<span style=\'letter-spacing:16px;\'>無期限契約</span>',
  'contract_perpetual_subtit': 'OG Exchangeのレバレッジ取引がついにリリース',
  'contract_perpetual_time': '2020 年 3 月 27 日 05:00 (UTC+00)',
  'contract_perpetual_btnText': '詳しく',
  'tranding_bonus_tit': ' TRADING BONUS',
  'tranding_bonus_time': '2020年2月29日16：00（UTC+00）〜2020年3月4日16：00（UTC+00）',
  'tranding_bonus_btnText': '300,0004IRE',
  'btc_tranding_bonus_tit': 'BTC TRADING BONUS',
  'btc_tranding_bonus_time': '2020年3月7日00：00（UTC+00）〜2020年3月9日23：59（UTC+00）',
  'btc_tranding_bonus_btnText': '10 BTC',
  'symbol_detail_left':
    [{ title_txt: 'ビットコイン（BTC）', id: 'btc' },
    { title_txt: 'イーサリアム（ETH）', id: 'eth' },
    { title_txt: 'リップル（XRP）', id: 'xrp' },
    { title_txt: 'ビットコインキャッシュ（BCH）', id: 'bch' },
    { title_txt: 'ライトコイン（LTC）', id: 'ltc' },
    { title_txt: 'イオス（EOS）', id: 'eos' },
    { title_txt: 'カルダノ（ADA）', id: 'ada' },
    { title_txt: 'アマル（4IRE）', id: '4ire' }],
  'symbol_detail_article':
    {
      'btc':
        {
          article_tit: 'ビットコイン（BTC）',
          article_detail: 'ビットコインはサトシ・ナカモト(Satoshi Nakamoto) を名乗る人物によって投稿された論文に基づき、2009年に運用が開始されました。ビットコインの取引単位はBTCと表記され、ドルや円などの法定通貨とも交換することができます。 ビットコインはインターネット上で流通する電子データです。日本円や米ドルなどの法定通貨と違い、中央銀行や公的な発行体が存在しません。ブロックチェーン技術を使ってインターネット上で管理される分散型（P2P※）通貨なので、特定の発行機関に限定されることなく、自由に取引することが可能です。 特に自国通貨に不安のある人々にとっては、ビットコインと法定通貨の交換がリスク回避にもなり世界中へ安全・低コストで、短期間に送金することが可能です。',
          article_link: ["https://bitcoin.org/ja/",`https://www.blockchain.com/explorer`,`https://bitcoin.org/bitcoin.pdf`]
        },
      eth:
        {
          article_tit: 'イーサリアム（ETH）',
          article_detail: 'イーサリアム（表記: ETH）は2013年にロシア人のVitalik Buterin 氏によって考案・開発され、2014年に販売が開始されました。2018年12月現在はビットコイン、リップルの次に時価総額が大きい仮想通貨です。 ビットコインと違い、イーサリアムは通貨というよりは「分散型アプリケーション」（Decentralized Applications、略称DApps ※）のプラットフォームを目的に開発されました。このプラットフォームを実現させたのが「スマートコントラクト」技術です。',
          article_link: [`https://ethereum.org/ja/`,`https://etherscan.io/`,`https://github.com/ethereum/wiki/wiki/%5BJapanese%5D-Ethereum-TOC`]
        },
      xrp:
        {
          article_tit: 'リップル（XRP）',
          article_detail: 'リップル（表記：XRP）とは、リップル社が開発した仮想通貨で、2018年12月現在はビットコインに続き、時価総額第2位の仮想通貨となっています。従来、銀行経由の国際送金には、高い送金手数料や送金速度が問題となっていましたが、これらの問題をリップルの分散台帳技術によって解決しようとしています。 XRPは具体的にはブリッジ通貨とシステム手数料という2つの重要な役割と以下の特徴があります。 特徴： １．リアルタイムで世界中の銀行間の支払いを実行。 ２．ブロック生成時間が5秒。',
          article_link: ["https://ripple.com/", "https://xrpcharts.ripple.com/#/graph", ""]
        },
      bch:
        {
          article_tit: 'ビットコインキャッシュ（BCH）',
          article_detail: 'ビットコインキャッシュ（表記: BCH）はビットコインのハードフォークにより2017年8月1日に誕生しました。 ビットコインよりも１つのブロックサイズを大きくすることでスケーラビリティ問題を解決しようとした通貨です。ブロックチェーンの分裂で生まれ、当時のビットコインと同じ量発行されました。',
          article_link: [`https://www.bitcoinabc.org/`]
        },
      ltc:
        {
          article_tit: 'ライトコイン（LTC）',
          article_detail: 'ライトコイン（表記: LTC）は、2011年に従来のビットコインをベースに開発が始まった通貨で、実用化を重視してビットコインの欠点である処理速度を解消しました。ビットコインにはマイニングに機材が必要ですが、ライトコインは必要な機材を簡略化して、送金もより早くなりました。ビットコインと並び利用者の多い暗号通貨です。 総発行枚数はビットコインの4倍の8400万枚と設計されています。',
          article_link: [`https://litecoin.com/en/`,`http://explorer.litecoin.net/chain/Litecoin`]
        },
      eos:
        {
          article_tit: 'イオス（EOS）',
          article_detail: '分散型アプリケーションに特化したプラットフォーム\n                        イオスの通貨単位は「EOS」、発行枚数の上限は10億枚です。\n                        分散型アプリケーションを構築するためのプラットフォームであり、企業の間で広く利用されること想定して開発されました。\n                        イオスは、2017年6月に公開されてまもなく時価総額でトップ10入りを果たすなど、大きな反響を呼んだ仮想通貨です。\n\n                        トランザクションの速さが売り\n                        イオスの特徴は「トランザクションのスピード」にあります。トランザクションとは、データベース内で情報が処理される速さのことです。つまり、コマンドを入力してから実行されるまでの間隔が短いことを意味します。例えば、仮想通貨ではありませんが、Googleの場合、１秒あたり４万のトランザクションを実行すると言われています。イオスは１秒あたり何百万単位のトランザクションを実行しており、仮想通貨の中でもかなり高速です。\n                        ',
          article_link: [`https://eos.io/`,`https://bloks.io/`,``]
        },
      ada:
        {
          article_tit: 'カルダノ（ADA）',
          article_detail: 'カルダノ（ADA）は、イーサリアム（Ethereum／ETH）の開発に携わったとされるチャールズ・ホスキンソン氏によって生み出された仮想通貨です。2016年10月に取引がスタートし、通貨単位は「ADA」、発行枚数の上限は450億枚となっています。\n                    元々「Cardano（カルダノ）」というオンラインゲームやオンラインカジノを扱うプラットフォームがあり、そこでの通貨が「ADA（エイダ）」でした。\n                    カルダノはレイヤーによって構築されているため、柔軟な使い方が可能です。大きな特徴は、イーサリアムと同様スマートコントラクトです。カルダノのスマートコントラクト「Plutus」は、より複雑で高度な契約内容も瞬時に記録することができると言われています。\n                    ',
          article_link: [`https://www.cardano.org/en/home/`,`https://cardanoexplorer.com/`,``]
        },
      amal:
        {
          article_tit: 'アマル（4IRE）',
          article_detail: 'アマルはOG Exchangeを代表するプラットフォームトークンであり、使用用途は主に、配当、手数料の割引、投票権などがあります。\n                    発行枚数の上限2.1億枚であり、そのうちの60％が二次流通市場で取引されます。\n                    ',
          article_link: [`https://demo.io/spot-exchange/basic?coin=4ire&currency=usdt`,``,``]
        }
    },
  'symbol_detail_introduction': '通貨紹介',
  'symbol_detail_org': '公式サイト：',
  'symbol_detail_block': 'ブロックチェーンのアドレス：',
  'symbol_detail_book': 'ホワイトペーパー：',
  'mam.transfer.success': '振込成功しました',
  'mam.transfer.fail': '振込失敗しました',
  'mam.confirm.disable': '資金を無効にしますか？',
  'mam.confirm.out': '終了しますか？',
  'mam.status.approve': '承認する',
  'mam.status.reject': '拒否する',
  'mam.status.pending': '保留する',
  'mam.status.cancel': 'キャンセルする',
  'mam.status.out': '終了する',
  'mam.empty.investor_list': '投資家がいません',
  'mam.empty.assigned_history': '指定された履歴はありません',
  'system.title': 'メンテナンス中',
  'system.des': 'メンテナンスのダウンタイムまたは容量の問題のため、サーバーは一時的にリクエストを処理できません。なるべく早く対応いたします。',
  'account.wallet_fee': 'ウォレット手数料',
  'account.wallet_fee_description': '各取引で手数料を支払う4IREウォレットを選択できます。',
  'account.api.create_fail': 'このAPIキーを作成できません',
  'client_connection.fail': '接続に失敗しました！',
  'common.datatable.data_empty.approved': '承認されていません',
  'common.datatable.data_empty.out': '終了していません',
  'common.datatable.data_empty.assigned_history': '指定した履歴がありません',
  'common.datatable.data_empty.current_interval': '現在の間隔はありません',
  'common.datatable.data_empty.commissions_history': 'コミッションの履歴はありません',
  'common.datatable.data_empty.commissions_setting': 'コミッションを設定していません。',
  "common.datatable.data_empty.reward": "No vouchers",
  'common.datatable.empty_data.stop': '止まっていません',
  'common.datatable.empty_data.fill': 'You have no fill.',
  'common.datatable.empty_data.positions': 'ポジションがありません',
  'common.order_id': 'オーダーID',
  'common.order_status.new': 'New',
  'common.action.apply': '申し込む',
  'amal.amal_main_balance': 'ウォレット残高',
  'amal.lock_by_admin': 'Dividend Perpetual Balance',
  'amal.lock_by_user': 'Dividend Balance',
  'amal.amal_spot_balance': '現物残高',
  'amal.amal_margin_balance': '証拠金残高',
  "funds.balances.available_margin_balance": "Future Available Balance",
  'funds.balances.available_amount': '利用可能な金額',
  'funds.balances.my_invesment': '自分の投資',
  'funds.balances.revokeable_amount': '取消し可能な金額',
  'order.open_order.cancel_market_price_message': 'すべての成行注文をキャンセルしますか？\r\n',
  "order.open_order.cancel_market_order_price_message":
  "Once you confirm, all open stop market orders will be cancelled",
"order.open_order.cancel_market_order_price_title":"Cancel All Stop Market Orders",
  'order.order_form.all': 'すべて',
  'google_recaptcha.errors': 'Google recaptchaフィールドは記入必須です',
  'server.errors': '30秒後に再度登録して下さい',
  'mam.investor_list': '投資家リスト',
  'mam.assigned_history': ' 指定した履歴',
  'mam.out': '終了する',
  'mam.btn.request_to_join': '参加のリクエスト',
  'funds.balances.my_investment': '自分の投資',
  'orders.open_order.exec_type': '実行タイプ',
  'margin.insurance.wallet_balance': '{balance} {symbol}',
  'margin.weight': '比率',
  'margin.partially_filled': '部分約定',
  'margin.contract.call_option': 'コール・オプション',
  'margin.contract.put_option': 'プット・オプション',
  'margin.profit_loss.notice': 'すべての通貨単位は BTCベースで',
  'table.instrument_symbol': '商品銘柄',
  'table.exec_type': '実行タイプ',
  'table.exec_type.buy': '買',
  'table.exec_type.sell': '売',
  'table.side.buy': '買',
  'table.side.sell': '売',
  'table.text': 'テキスト',
  'table.note': '注意',
  'table.order_id': '注文番号',
  'title.perpetual contracts': '無期限契約',
  'title.desc.perpetual contracts': '<p>現在、アマンプリは証拠金としてビットコインのみを受け入れています。 つまり、マージン、利益、および損失は、ビットコインで支払いまたは受領する必要があります。 ただし、金融エンジニアニングの使用により、OG ExchangeはQuantoと呼ばれる金融派生商品を使用して、ユーザーに基になる価格を提供できます。</ p> <p> Bitcoin Quanto ETH / USD契約には、USDETHの価格に関係なく、固定のBitcoin乗数があります。これにより、トレーダーはETHまたはUSDに触れることなく、ETH / USD為替レートをロングまたはショート取引できます。 トレーダーはビットコインでマージンを転記し、ETH / USDの為替レートが変化するとビットコインを増減します。</ p>',
  'title.futures_contracts': '先物契約',
  'title.desc.futures_contract': '<p>アマンプリでは、ETH Futures Contractにより、トレーダーはEther / Bitcoin（ETH / BTC）為替レートの将来価値を推測できます。 トレーダーは、ビットコインをマージンとして必要とするだけであるため、先物契約を取引するためにイーサーが必要ではありません。</ p>',
  'des.des_page_leaderboard': '・以下は、OG Exchangeでトップクラスの収益率を誇るトレーダーたちです。<br/>・このリストは匿名ベースであり、名前はそれぞれ同じユーザーを表しますが、身元は特定できません。',
  'table.interest_base': '基軸通貨金利',
  'table.interest_quote': '決済通貨金利',
  'table.premium': 'プレミアム',
  'title.view_btc_guide': 'BTCシリーズガイドを見る',
  'title.des.ethusd.description': '<a href="#"> ETHUSD </a>は、<a href="/margin-exchange/contracts/indices-data/ETH"> ETHインデックス</a>で価格が形成されるETHUSDの無期限契約です。各契約はイーサリアムに対して1ドルの価値があります。<br/> <br/>資金調達は8時間ごとに時間ごとに発生します。次回は、UTC + 7の午後7時です。<br/> <br/> <a href="#"> ETHUSD </a>は、プレミアムインデックスを使用して資金調達率を計算します。原資産の金利は、<a href="/margin-exchange/contracts/indices-data/ETHBON8H"> ETHBON8Hインデックス </a>および<a href = "/ margin-exchange / contracts / indices- data / USDBON8H "> USDBON8Hインデックス</a>を使用して計算し、プレミアムレートは<a href="/margin-exchange/contracts/indices-data/ETHUSDPI8H"> ETHUSDPI8Hインデックス</a>を使用して計算します。これらは最終資金調達率の計算に使用されます。<br/> <br/>本日、ロングは0.3750％を支払い、ショートは7:00 PM UTC + 7で0.3750％を受け取ります。アマンプリは、資金調達の支払いと受け取りに手数料を徴収しません。',
  'title.des.ethbtc.description': '<a href="#"> ETHBTC </a>は、<a href="/margin-exchange/contracts/indices-data/ETH"> ETHインデックス</a>で価格設定されているETH / BTC無期限契約です。各契約にはイーサリアムの1 BTCの価値があります。<br/> <br/>資金は8時間ごとに支払われ、受領されます。次の支払いは、UTC + 7 7:00 PMです。<br/> <br/> <a href="#"> ETHBTC </a>は、プレミアムインデックスを使用して資金調達率を計算します。基礎金利は、<a href="/margin-exchange/contracts/indices-data/ETHBON8H"> ETHBON8H Index </a>および。<a href = "/ margin-exchange / contracts / indices- data / BTCBON8H "> BTCBON8Hインデックス</a>、プレミアムレートは。<a href="/margin-exchange/contracts/indices-data/ETHBTCPI8H"> ETHBTCPI8Hインデックス</a>使用して計算します。これらは、最終的な資金調達率を計算するために使用されます。<br/> <br/>今日、ロングは0.3750％を支払い、ショートは7:00 PM UTC + 7で0.3750％を受け取ります。OG Exchangeは、資金の支払いに手数料を請求しません。',
  'title.des.ethu19.description': '<a href="#"> ETHU19 </a>は、<a href="/margin-exchange/contracts/indices-data/ETH"> ETHインデックス</a>で価格設定されているETH / U19無期限契約です。各契約はイーサリアムの1 U19の価値があります。<br/> <br/>資金は8時間ごとに支払われ、受領されます。次の支払いは、UTC + 7の午後7時です。<br/> <br/> <a href="#"> ETHU19 </a>は、プレミアムインデックスを使用して資金調達率を計算します。基礎金利は、。<a href="/margin-exchange/contracts/indices-data/ETHBON8H"> ETHBON8H インデックス </a>および。<a href = "/ margin-exchange / contracts / indices- data / U19BON8H "> U19BON8Hインデックス</a>、プレミアムレートは。<a href="/margin-exchange/contracts/indices-data/ETHU19PI8H"> ETHU19PI8Hインデックス</a>を使用して計算します。これらは、最終的な資金調達率を計算するために使用されます。<br/> <br/>今日、ロングは0.3750％を支払い、ショートは7:00 PM UTC + 7で0.3750％を受け取ります。OG Exchangeは、資金の支払いに手数料を請求しません。',
  'title.des.btcusd.description': '<a href="#"> BTCUSD </a>は、<a href="/margin-exchange/contracts/indices-data/BTC"> BTCインデックス</a>で価格設定されたBTC / USD無期限契約です。各契約には1米ドルのビットコインの価値があります。<br/> <br/>資金は8時間ごとに支払われ、受領されます。次の支払いは、UTC + 7 7:00 PMです。<br/> <br/> <a href="#"> BTCUSD </a>は、プレミアムインデックスを使用して資金調達率を計算します。基礎金利は、。<a href="/margin-exchange/contracts/indices-data/BTCBON8H"> BTCBON8Hインデックス </a>および。<a href = "/ margin-exchange / contracts / indices- data / USDBON8H "> USDBON8Hインデックス</a>、プレミアムレートは。<a href="/margin-exchange/contracts/indices-data/BTCUSDPI8H"> BTCUSDPI8Hインデックス</a>を使用して計算します。これらは、最終的な資金調達率を計算するために使用されます。<br/> <br/>今日、ロングは0.3750％を支払い、ショートは7:00 PM UTC + 7で0.3750％を受け取ります。OG Exchangeは、資金の支払いに手数料を請求しません。 ',
  'title.des.btcu19.description': '<a href="#"> BTCU19 </a>は、<a href="/margin-exchange/contracts/indices-data/BTC"> BTCインデックス</a>で価格設定されているBTC / U19無期限契約です。各契約はビットコインの1 U19の価値があります。<br/> <br/>資金は8時間ごとに支払われ、受領されます。次の支払いは、UTC + 7午後7時です。<br/> <br/> <a href="#"> BTCU19 </a>は、プレミアムインデックスを使用して資金調達率を計算します。基礎金利は、。<a href="/margin-exchange/contracts/indices-data/BTCBON8H"> BTCBON8Hインデックス </a>および。<a href = "/ margin-exchange / contracts / indices- data / U19BON8H "> U19BON8Hインデックス</a>、プレミアムレートは<a href="/margin-exchange/contracts/indices-data/BTCU19PI8H"> BTCU19PI8Hインデックス</a>を使用して計算します。これらは、最終的な資金調達率を計算するために使用されます。<br/> <br/>今日、ロングは0.3750％を支払い、ショートは7:00 PM UTC + 7で0.3750％を受け取ります。OG Exchangeは、資金の支払いに手数料を請求しません。',
  'title.des.btcz19.description': '<a href="#"> BTCZ19 </a>は、<a href="/margin-exchange/contracts/indices-data/BTC"> BTCインデックス</a>で価格設定されたBTC / Z19無期限契約です。各契約にはビットコインの1 Z19の価値があります。<br/> <br/>資金は8時間ごとに支払われ、受領されます。次の支払いは、UTC + 7の午後7時です。<br/> <br/> <a href="#"> BTCZ19 </a>は、プレミアムインデックスを使用して資金調達率を計算します。基礎金利は、。<a href="/margin-exchange/contracts/indices-data/BTCBON8H"> BTCBON8Hインデックス </a>および。<a href = "/ margin-exchange / contracts / indices- data / Z19BON8H "> Z19BON8Hインデックス</a>。プレミアムレートは。<a href="/margin-exchange/contracts/indices-data/BTCZ19PI8H"> BTCZ19PI8Hインデックス</a>を使用して計算します。これらは、最終的な資金調達率を計算するために使用されます。<br/> <br/>今日、ロングは0.3750％を支払い、ショートは7:00 PM UTC + 7で0.3750％を受け取ります。OG Exchangeは、資金の支払いに手数料を請求しません。 ',
  'title.how_are_the_futures_contract_quoted': '{symbol}先物契約のクォート方法',
  'title.des.how_are_the_futures_contract_quoted': '{symbol}先物はどのように見積もられますか？',
  'title.eth.price_index.desc': '一般的な信念に反して、Lorem Ipsumは単なるランダムなテキストではありません。ルーツは紀元前45年からの古典的なラテン文学の一部であり、2000年以上の歴史があります。バージニア州ハンプデン・シドニー大学のラテン語教授であるリチャード・マクリントックは、Lorem Ipsumの一節から、ある曖昧なラテン語"consectetur”を調べ、古典文学でのその語の引用を研究しました。<br/>疑う余地のないソースを発見しました。 Lorem Ipsumは、紀元前45年に書かれたCiceroの「de Finibus Bonorum et Malorum」（善と悪の極限）のセクション1.10.32と1.10.33から来ています。この本は、ルネサンス時代に非常に人気のある、倫理理論に関する論文です。 Lorem Ipsumの最初の行、「Lorem ipsum dolor sit amet ..」は、セクション1.10.32の行から来ています。 ',
  'title.symbol_future_contract_example': '{symbol} 先物契約の例',
  'title.des.ethusd.funding_calculation': '資金調達率の詳細については、<a href="{perpetualGuide}">無期限契約ガイド</a>をご覧ください。',
  'title.des.ethbtc.funding_calculation': '資金調達率の詳細については、<a href="{perpetualGuide}">無期限契約ガイド</a>をご覧ください。',
  'title.des.ethu19.funding_calculation': '資金調達率の詳細については、<a href="{perpetualGuide}">無期限契約ガイド</a>をご覧ください。',
  'title.des.btcusd.funding_calculation': '資金調達率の詳細については、<a href="{perpetualGuide}">無期限契約ガイド</a>をご覧ください。',
  'title.des.btcu19.funding_calculation': '資金調達率の詳細については、<a href="{perpetualGuide}">無期限契約ガイド</a>をご覧ください。',
  'title.des.btcz19.funding_calculation': '資金調達率の詳細については、<a href="{perpetualGuide}">無期限契約ガイド</a>をご覧ください。',
  'menu.mam_investment': '投资',
  'menu.mam_investor': '投資者',
  'menu.mamcommissions': 'コミッション',
  'menu.mam_leaderboard': 'リーダーボード',
  'common.current_interval': '現在のインターバル',
  'common.commissions_history': 'コミッション履歴',
  'common.commissions_setting': 'コミッション設定',
  'common.withdraw_history': '出金履歴',
  'menu.commissions': 'コンミッション',
  'common.high_watermark': 'ハイウォーター・マーク',
  'admin.change_password_admin_success': '管理者パスワードが変更されました。 もう一度ログインしてください！ ',
  'common.order_status.stop_price': 'ストップ価格',
  'common.order_status.untriggered': 'トリガーされていない',
  'emails.unlock_airdrop_fail.text1': '申し訳ありません',
  'emails.unlock_airdrop_fail.text2': 'これは、ロック解除が失敗した通知です',
  'emails.unlock_airdrop_fail.text3': '配当残高の4IREをキャンセルし、次の期間に試すます。',
  'emails.unlock_airdrop_fail.title': '【{APP_NAME}】エアドロップのロック解除に失敗しました',
  'emails.received_liquid_position.subject': '【アマンプリ】清算通知：あなたの：symbolポジションは清算されました',
  'emails.liquid_position_line_1': 'あなたの売り：current_qty契約の：symbolポジションは清算されました。 ',
  'emails.liquid_position_line_2': '：symbolのマーク価格は最近：mark_priceに上昇しました。 あなたのポジションの清算価格は：liquidation_priceでした。 ポジションは清算エンジンに引き継がれました。',
  'emails.liquid_position_line_3': ':symbolポシションの詳細',
  'emails.liquid_position_line_4': 'レバレッジレバレッジでのXBTUSDの短期：current_qty契約でした。',
  'emails.liquid_position_line_5': '：maint_margin％Maintenance Marginの場合、清算価格は：liquidation_priceであり、破産価格は：bankrupt_price (i.e. 0% margin)でした。',
  'emails.liquid_position_line_6': '清算時に：symbolインデックスの価格は：index_priceに上昇しました。 あなたが取引していた契約：symbolのマーク価格は：mark_priceで、これはこのインデックスに基づいています。 ',
  'emails.liquid_position.side': 'サイド',
  'emails.liquid_position.qty': '数量',
  'emails.liquid_position.lev': 'Lev.',
  'emails.liquid_position.mark_price': '表示価格',
  'emails.liquid_position.liq_price': '決算価格',
  'emails.unlock_airdrop_fail_alert.title': ' Airdropのロック解除に失敗しました',
  'emails.unlock_airdrop_fail_alert.text1': 'システムは、ユーザーの配当ウォレットで4IREのロックを解除できませんでした。',
  'emails.unlock_airdrop_fail_alert.text2': '詳細ロック解除',
  'emails.unlock_airdrop_fail_alert.email': 'メールアドレス',
  'emails.unlock_airdrop_fail_alert.amount': '数量',
  'emails.withdrawal_canceled.subject': '【OG Exchange】引き出し中止',
  'emails.withdrawal_canceled.dear_name': '親愛なる<strong>：email </ strong>、',
  'emails.withdrawal_canceled.line_1': '下記の引き出しリクエストは、OG Exchangeシステムによってキャンセルされました。',
  'emails.withdrawal_canceled.line_2': '通貨',
  'emails.withdrawal_canceled.line_3': '数量',
  'emails.withdrawal_canceled.line_4': '出金アドレス',
  'emails.withdrawal_canceled.line_5': '作成日',
  'emails.withdrawal_canceled.line_6': 'リクエストをキャンセルするには2つの原因があります。',
  'emails.withdrawal_canceled.line_7': '原因1：管理者が何かの理由でリクエストをキャンセルします',
  'emails.withdrawal_canceled.line_8': '原因2：リクエストの有効期限が切れています。 ',
  'emails.withdrawal_canceled.line_9': 'ありがとうございます。',
  'emails.change_coldWallet_setting.subject': '【OG Exchange】コールドウォレットの設定変更完了',
  'emails.change_coldWallet_setting.line_1': 'コールドウォレットの設定が変更されたため、このメールを受け取りました。',
  'emails.change_coldWallet_setting.line_2': '設定変更の詳細：',
  'emails.change_coldWallet_setting.line_3': 'coinアドレスが：oldAddressから：newAddressに変更されました',
  'emails.change_coldWallet_setting.line_4': 'コールドウォレットホルダーのメールが：oldEmailから：newEmailに変更されました',
  'emails.register_completed.subject': '【OG Exchange】登録完了',
  'emails.register_completed.hello': 'こんにちは<strong>：メール</ strong>、',
  'emails.register_completed.line_1': 'おめでとうございます、登録が完了しました。',
  'emails.register_completed.line_2': '：APP_NAMEにログインして取引を開始してください。',
  'emails.margin_deleverage.title': '【OG Exchange】マージンデレバレッジ通知',
  'emails.margin_deleverage.body1': 'レバレッジが解除されました。',
  'emails.margin_deleverage.body2': 'Margin Exchangeページでポジションをもう一度入ることできます',
  'emails.register_beta_tester.subject': '【OG Exchange】ベータテスター登録リクエスト',
  'emails.register_beta_tester.dear_name': 'Dear',
  'emails.register_beta_tester.line_1': 'ベータテスターの登録リクエストがあります。',
  'emails.register_beta_tester.email': 'Email:',
  'emails.beta_tester_active.subject': 'β版へのご参加有難う御座います。',
  'emails.beta_tester_active.dear_name': 'β版へのご参加有難う御座います。',
  'emails.beta_tester_active.line_1': '本バージョンはβ版のため、予期せぬ不具合が起こる可能性があります。不具合またはバグを見つけた場合、管理人（<a href = \'mailto: :email\'>:email</a>）まで不具合またはバグの再現手順、スクリーンショット等を合わせて送信下さい。',
  'beta_tester.block_trading': '取引するベータテスターになってください',
  'messages.error.spot.balance_insufficient': '為替残高が十分ではありません ',
  'messages.error.airdrop.balance_insufficient': 'エアドロップのバランスが十分ではありません',
  'messages.error.margin.balance_insufficient': '証拠金残高が十分ではありません',
  'messages.error.main.available_balance_insufficient': '利用可能な残高が不足しています ',
  'messages.error.spot.available_balance_insufficient': '利用可能な交換残高が十分ではありません。',
  'messages.error.airdrop.available_balance_insufficient': '利用可能なエアドロップバランスが十分ではありません。',
  'messages.error.margin.available_balance_insufficient': '利用可能な証拠金残高が十分ではありません。\r\n',
  'messages.error.order_child.existing': '既存の注文にアクセスできます ',
  'messages.error.device.existing': '既存のデバイス認証はすべて削除できます',
  'order.open_order.cancel_limit_order': '指値注文のキャンセル',
  'sales_point.clear': 'クリア',
  'validation.messages.airdrop.airdrop_check_payout_amount': '支払い額はこの通貨額より大きくなることはありません。',
  'airdrop.cannot_find_email': 'そのメールアドレスを持つユーザーが見つかりません。',
  'airdrop.user_was_exist': 'アカウントはすでに存在しています。',
  'validation.user_id_coin_wallet_xpr_eos': '出金アドレス又はタグ/メモ/...が既に存在しています。',
  'validation.message.join_funds': '投資家は利用できません。 もう一度やり直してください',
  'validation.message.amount_join_funds': '合計金額は注文数量と等しくなければなりません',
  'validation.message.unique_interval': '間隔が存在します',
  'validation.message.max_deposit_fund': '利用可能な残高が十分ではありません。',
  'validation.message.max_withdraw_fund': '取り消し可能な残高では不十分です。',
  'validation.message.account_log_for_transaction': '数分後に試してください',
  'validation.instrument_check_difficult_than': 'attributeはベースとは異なる必要があります。',
  'validation.instrument_check_small_than_init_margin': 'attributeは、初期マージンより小さくなければなりません。',
  'validation.instrument_check_small_than_risk_limit': 'attributeはリスク制限より小さくなければなりません。',
  'validation.fee_condition': 'エラー：メーカー手数料とテイカー手数料の合計は0以上である必要があります。 ',
  'validation.settlement_fee_condition': '決済手数料の値は0より大きくなければなりません。 ',
  'validation.instrument_check_refe_index': 'attributeの入力は必須です。',
  'validation.instrument_check_funding_base': 'attributeの入力は必須です。',
  'validation.instrument_check_funding_quote': 'attributeの入力は必須です。',
  'validation.instrument_check_require': 'attributeの入力は必須です。',
  'validation.not_zero': '金額の値は0より大きい必要があります',
  'validation.instrument_check_require_future': 'attributeの入力は必須です。',
  'validation.instrument_check_require_perpetual': 'attributeの入力は必須です。',
  'validation.ip-active': '秒内にリクエストが多すぎます。',
  'validation.ip-active-count': '1分内でリクエストが多すぎます',
  'user.enable_fee.enable': '有効にする',
  'user.enable_fee.disable': '無効にする',
  'orders.open_order.search_by_coin': 'コインで検索',
  'circuit_breaker_setting.title': 'サーキットブレーカーの設定',
  'circuit_breaker_setting.select_market': '市場を選択',
  'circuit_breaker_setting.enable_circuit_breaker': 'サーキットブレーカーを有効にする',
  'circuit_breaker_setting.coin': 'コイン',
  'circuit_breaker_setting.range_listen_time': '範囲待機時間（時間）',
  'circuit_breaker_setting.range_percent': '範囲パーセント（％）',
  'circuit_breaker_setting.block_time': 'ブロック時間（時間）',
  'circuit_breaker_setting.enable_column': 'ステータス',
  'circuit_breaker_setting.enabled': '設定',
  'circuit_breaker_setting.disabled': '無効',
  'circuit_breaker_setting.update_confirm': 'このレコードを変更しますか？',
  'circuit_breaker_setting.update_success_msg': '更新されました。',
  'circuit_breaker_setting.update_enable_confirm': 'ステータスを変更しますか？',
  'circuit_breaker_setting.validation.block_trading': '取引ペアがブロックされています！',
  'circuit_breaker_setting.validation.block_market_order': '成行注文はサーキットブレーカーによってブロックされています！',
  'circuit_breaker_setting.validation.block_stop_market_order': '逆指値注文はサーキットブレーカーによってブロックされています！',
  'circuit_breaker_setting.validation.price_too_low': '注文価格が低すぎます。',
  'circuit_breaker_setting.validation.price_too_high': '注文価格が高すぎます。',
  'circuit_breaker_setting.validation.block_time': 'ブロック時間の入力は必須です',
  'circuit_breaker_setting.validation.range_listen_time': '待機時間の入力は必須です',
  'circuit_breaker_setting.validation.circuit_breaker_percent': 'パーセント範囲の入力は必須です',
  'circuit_breaker_setting.validation.range_listen_time.empty_value': '範囲待機時間の値は0より大きくなければなりません。',
  'circuit_breaker_setting.validation.circuit_breaker_percent.empty_value': '範囲パーセントの値は0より大きくなければなりません',
  'circuit_breaker_setting.validation.block_time.empty_value': 'ブロック時間の値は0より大きくなければなりません。',
  'circuit_breaker_setting.update_fail_msg': '更新に失敗しました！',
  'user_setting.total_users': 'すべてのユーザー:',
  'enable_fee.user_setting.confirm_off': '料金設定を無効にしますか？',
  'enable_fee.user_setting.confirm_on': '料金設定を有効にしますか？',
  'enable_fee.user_setting.update_success': 'ユーザーの料金有効化の設定を更新しました！',
  'enable_fee.user_setting.update_fail': 'ユーザーの料金有効化の設定に失敗しました',
  'enable_fee.title': 'ユーザーの料金設定を有効化',
  'enable_fee.remove_success': 'ユーザーが削除されました！',
  'enable_fee.remove_fail': 'ユーザーの削除に失敗しました！',
  'enable_fee.currency': '通貨',
  'enable_fee.coin': 'コイン',
  'enable_fee.no': 'No.',
  'enable_fee.status': 'ステータス',
  'enable_fee.fee_charge': '手数料',
  'enable_fee.user_was_exist': 'アカウントはすでに存在しています。',
  'enable_fee.user_not_exist': 'アカウントが存在しません。',
  'enable_withdrawal.user_setting.confirm_off': '引き出し設定を無効にしますか？',
  'enable_withdrawal.user_setting.confirm_on': '引き出し設定を有効にしますか？',
  'enable_withdrawal.user_setting.update_success': 'ユーザーの引き出し有効化設定を更新しました！',
  'enable_withdrawal.user_setting.update_fail': 'ユーザーの引き出し有効化設定を失敗しました！',
  'enable_withdrawal.title': 'ユーザー引き出し設定',
  'enable_withdrawal.remove_success': 'ユーザーが削除されました！',
  'enable_withdrawal.remove_fail': 'ユーザーの削除に失敗しました！',
  'enable_withdrawal.currency': '通貨',
  'enable_withdrawal.coin': 'コイン',
  'enable_withdrawal.no': 'No.',
  'enable_withdrawal.status': 'ステータス',
  'enable_withdrawal.user_was_exist': 'アカウントはすでに存在しています。',
  'enable_withdrawal.user_not_exist': 'アカウントが存在しません。',
  'enable_withdrawal.validate.withdraw_is_blocking': '出金がブロックされました。',
  'enable_trading.user_setting.confirm_off': '取引設定を無効にしますか？',
  'enable_trading.user_setting.confirm_on': '取引設定を有効にしますか？',
  'enable_trading.user_setting.update_success': 'ユーザーの取引有効化に更新しました！',
  'enable_trading.user_setting.update_fail': 'ユーザーの取引有効化の更新を失敗しました！',
  'enable_trading.title': '取引設定',
  'enable_trading.remove_success': 'ユーザーが削除されました！',
  'enable_trading.remove_fail': 'ユーザーの削除に失敗しました！',
  'enable_trading.currency': '通貨',
  'enable_trading.coin': 'コイン',
  'enable_trading.no': 'No.',
  'enable_trading.status': 'ステータス',
  'enable_trading.user_was_exist': 'アカウントはすでに存在しています。',
  'enable_trading.user_not_exist': 'アカウントが存在しません。',
  'enable_trading.validation.block_trading': 'このペアを取引する権限がありません。 詳細については、管理者にお問い合わせください。',
  'withdrawal_information.fee_percent': '手数料％',
  'margin.date': '日付',
  'margin.settlement_type': '決済タイプ',
  'margin.order_history.date': '日付',
  'margin.order_history.symbol': '銘柄',
  'margin.order_history.type': '種別',
  'margin.order_history.side': 'サイド',
  'margin.order_history.average': '平均',
  'margin.order_history.price': '価格',
  'margin.order_history.fill_price': '約定価格',
  'margin.order_history.order_price': '注文価格',
  'margin.order_history.filled': '約定',
  'margin.order_history.amount': '数量',
  'margin.order_history.qty': '数量',
  'margin.order_history.total': '合計',
  'margin.order_history.order_value': 'オーダー价值',
  'margin.order_history.trigger_conditions': 'トリガー条件',
  'margin.order_history.status': 'ステータス',
  'margin.order_history.text': 'テキスト',
  'margin.order_history.note': '注意',
  'margin.order_history.order_id': 'オーダーID',
  'margin.instrument_symbol': '銘柄',
  'margin.trade_type': 'サイド',
  'margin.fee': '手数料',
  'exception.invalid_transaction': '無効なトランザクション',
  'exception.deposit_non_exist': '存在しないアドレスへの入金：：address',
  'exception.unconfirm_transaction': '取引の未確認',
  'exception.invalid_wallet_id': 'coinのウォレットIDが無効です',
  'exception.unknown_conversion': 'コインの不明なコンバージョン率：：coin',
  'exception.transaction_executed_canceled': 'トランザクションの実行またはキャンセル',
  'exception.row_not_found': '：tableの行が見つかりません',
  'exception.device_invalid': 'デバイスが無効です',
  'exception.user_not_found': 'ユーザーが見つかりません',
  'exception.table_not_found': 'Table：tableが見つかりません',
  'exception.empty_address': '空のアドレスプール',
  'exception.cannot_calculate': '価格を計算できません。',
  'exception.unknown_order_type': '不明な注文タイプ：：type',
  'exception.amal_price_change': '価格が変更されました。新しい価格を入力してください。',
  'exception.amal_not_enough': '4IREの使用できる残高が足りません',
  'exception.amal_remaining_not_enough': '4IREの使用できる残高が足りません',
  'exception.amal_payment_not_enough': '支払いできる残高が足りません',
  'exception.account_mismatch': 'アカウントの不一致',
  'exception.bank_account_in_use': '使用中の銀行口座',
  'exception.invalid_account': '無効なアカウント',
  'exception.cannot_remove_super_admin': 'SuperAdminアカウントを削除することはできません。',
  'exception.not_setting_phone_admin': 'Adminの電話番号の設定がありません。',
  'exception.amal_empty_or_invalid': '4IRE設定が空または通貨が無効です',
  'exception.otp_verified': 'Otp 確認済み',
  'exception.transaction_not_found': 'トランザクションが見つかりません',
  'exception.unconfirmed_transaction': '未確認のトランザクション :transactionId',
  'exception.not_found': '見つかりません',
  'exception.cannot_change_admin_password': '今回は管理者パスワードを変更できません。更新してもう一度お試しください！',
  'exception.max_deposit_fund': '利用可能な残高が十分ではありません。',
  'exception.fund_balance': '残高を変更するため、もう一度お試しください。更新してもう一度お試しください！',
  'exception.investor_not_valid': 'ファンドの投資家は変更しています。更新してもう一度お試しください！',
  'exception.unique_join_fund': 'このファンドには、参加または参加のリクエストがあります。',
  'google.recaptcha.errors': 'Recaptchaの検証に失敗しました',
  'margin.order.error.instrument.expired': '注文できません。：名前の有効期限が切れています！',
  'margin.order.error.side.required': 'サイドフィールドの入力は必須です。',
  'margin.order.error.type.required': 'タイプの入力は必須です。',
  'margin.order.error.quantity.required': '数量の入力は必須です。',
  'margin.order.error.quantity.too.high': '注文できません：数量が多すぎます。',
  'exception.inactive': 'tableが無効です',
  'exception.max_decimal_msg': '最大小数位は：max_decimalです',
  'exception.join_new_fund': '新しい資金は来月に追加する必要があります',
  'margin.change_leverage.error': 'あなたのポジションはすぐに清算されるため、レバレッジを変更することはできません',
  'margin.add_margin.error': 'クロス位置のため、マージンを追加できません。',
  'margin.sub_margin.error': 'ポシションに最小額が必要なため、サブマージンできません',
  'margin.risk_limit.error': 'レバレッジが高いため、リスク制限を変更できません。',
  'margin.risk_limit_down.error': '価値が高いため、リスク制限を変更できません。',
  'margin.position.is_liquid': '注文できません：あなたのポジションは清算中です。',
  'margin.order.error.reduce_only': 'reduce_only_error',
  'margin.order.error.price.required': '注文できません：価格が必要です。',
  'margin.order.error.price.too.high': '注文できません：価格が高すぎます。',
  'margin.order.error.stop_price.required': '注文できません：ストップ価格が必要です。',
  'margin.order.error.stop_price.gt_market_price': '注文できません：ストップ価格は市場価格より高くてはいけません。',
  'margin.order.error.stop_price.lt_market_price': '注文できません：ストップ価格は市場価格以上でなければなりません。',
  'margin.order.error.trail_value.not_negative': '注文できません：証跡の値は負数ではありません。',
  'margin.order.error.trigger_price.gt_market_price': '注文できません：トリガー価格の値は市場価格を超えてはなりません。',
  'margin.order.error.trigger_price.lt_market_price': '注文できない：トリガー価格の値は市場価格以上でなければなりません。',
  'margin.order.error.trigger_price.required': '注文できない：トリガー価格は0より大きくなければなりません。',
  'margin.order.error.limit.gt_market_price': '注文できません：トリガー価格の値は市場価格を超えてはなりません。',
  'margin.order.error.limit.lt_market_price': '注文できない：トリガー価格の値は市場価格以上でなければなりません。',
  'margin.order.error.trigger.not_valid': '注文できません：トリガー条件が無効です。',
  'margin.order.error.index.not_exist': '注文できません：インデックスが存在しません',
  'exception.geetest.invalid': 'キャプチャが無効です',
  "btc_trading_rebate_tit": "BTC Trading リベート",
 "Fee_withdraw": "The amount you withdraw is more than once allowed",
 "over_one_time_limit": "The amount you withdraw is more than once allowed",
  "btc_trading_rebate_subtit": "BTC / USD ペア（無期限コントラクト）<br />{btc} BTC毎の取引に{btc_m} BTCが還元されます。",
  "btc_trading_rebate_time": "取引へ",

  "mam_tit": "MAM",
  "mam_subtit": "業界初の極めて透明性の高いmultiple account managerを開発搭載！<br />投資家はリスクを限定して、安全にcapital gainを得ることが可能になりました。",
  "mam_btnTxt": "詳しく",


  "mam_detail_whatis_tit": "MAMとは?",
  "mam_detail_whatis": "MAMとは：",
  "mam_detail": "MULTI<br />ACCOUNT<br />MANAGER",
  "mam_detail_whatis_tip": "1人のマネーマネージャーが同時に複数のインベスター口座を管理できるプラットフォームです。",
  "mam_detail_whatis_desc": "MAMに参加するユーザーは自身のアカウント内の資金をマネーマネージャーに運用を委託することができます。<br /> マネーマネージャーは参加ユーザーの資金を出金や送金、転送を行うことできません。",
  "mam_detail_methods": "参加方法：",
  "mam_detail_methods_tip": "ユーザーはプラットフォームの”MAM”より好きなマネーマネージャーを選択することができます。<br />まずは、マネーマネージャーの成績、最大ドローダウン、運用手数料などを確認して下さい。",
  "mam_detail_methods_desc": "エントリー(参加)、assign(資金追加)のリクエストはいつでも可能ですが、運用がスタートするのは毎月の決算(月末)を終えた1日からになります。<br />FreezeTime後に出されたリクエストは次期決算後からの運用になります。",
  "mam_revoke_list": ["基本的に決算前にRevokeはできません。", "決算日の24時間前(FreezeTime)までにリクエストをすることで決算後にRevokeできます。", "FreezeTime後に出されたリクエストは次回決算まで待たなければなりません。", "決算前でもマネーマネージャーが早期Revoke許可することで、利用可能な残高が十分に足りている場合に決算まで待たずに、特定の投資家のrevokeを許可します。", "決算時にマネーマネージャーがポジションを保有中で利用可能な残高がない場合はRevokeのリクエストが優先されます。", "投資家が資金の一部か全部を引き出すように申し込んだ場合、決算時にopen positions/open ordersが存在している場合、システムが自動でRevoke処理を以下の順番で実施します。"],
  "mam_revoke_numlist": ["①システムがファンドの利用可能な残高を自動的に、投資家の引出し申込を実施します。", "②全投資家が引出したい合計金額が多く、システムが利用可能な残高の80%を使用したが、足らない場合、システムはファンドの注文をすべてキャンセルして、投資家に支払うための利用可能な残高を作ります。", "③全投資家が引出したい合計金額が多く、システムが注文をキャンセルしたが、足らない場合、次にシステムがオープンポジションの一部を成行でクローズして、投資家に支払う金額を作ります。順番としては、未実現損益が高いポジションから先にクローズします。", "④全投資家が引出したい合計金額が多く、未実現損益が20%以上のポジションをクローズしたが、足りない場合は引出し申込の残額をキャンセルします。"],
  "mam_computed_profitloss_list": ["損益はハイウォーターマーク方式で行います。", "ファンドに参加しているそれぞれの投資家は、それぞれの自分のハイウォーターマークを持ちます。", "決算して、損益配分を完了して、投資家の新残高が分かった時、この新残高をハイウォーターマークと照合して、マネーマネージャーの手数料を計算します。"],
  "mam_computed_profitloss_demolist": ["例：<br />", "1期の開始時に投資家Aが１BTCを投資したとし、1期の終了時に0.5BTCの損失が出て、0.5BTCが残高として残ったとします。2期に0.5BTCの利益が出て、投資家Aの資金が１BTCになる場合、前期の損失分を補充し、マネーマネージャーは手数料を得られません。", "もし、マネーマネージャーが1BTCの利益を作り、投資家Aの資金が1.5BTCになった場合、マネーマネージャーはperformance fee * 0.5BTCの手数料を得ることができます。", "もし、2期にマネーマネージャーが利益を作れずにさらに0.4BTCの損失をもたらした場合、投資家Aの資金は0.1BTCになり、3期にマネーマネージャーは0.9BTC以上の利益を作れないと手数料を得られません。", "*MAMは利益を保証するものではありません。いかなる損失が生じた場合も取引所は責任を負いかねます。"],
  "mam_revoke_tit": "Revoke(資金の引き出し)：",
  "mam_computed_tit": "損益の計算方法：",
  // "mam_becomeMam":"になる<span style='color: #ed7232;'>MAMトレーダー</span><br />(資金管理者)",
  "mam_becomeMam": "マネ一マネ一ジャ一になるには",

  "mam_becomeMam_desc": "トレーダーとして一定の審査基準を満たすことで、マネーマネージャーとして投資家の資産を運用することが可能になります。",
  "mam_reward_tit": "報酬",
  "mam_reward_desc": "Performance fee:利益の5%~50%(マネーマネージャー自身で設定することができます。)<br />例） Performance feeを10%に設定した場合100人の投資家から合計100BTCのファンドをトレードし20%の利益(100BTC×20%)×10%=2BTC(報酬)",
  "mam_require_tit": "資格",
  "mam_require_desc": "・LeaderboardのROEランキングにてTop25以内に入っている<br />・トラックレコードを提出できること<br />マネーマネージャーになるためには取引所による一定の審査があります。<br />マネーマネジャーを希望される方はこちらよりお問い合わせください。<br /><a style='color: #ed7232;' href='https://forms.gle/rnv5oBDuYUt8aSLG6' target='_blank'>https://forms.gle/rnv5oBDuYUt8aSLG6</a>",
  "slide_expand": "Expand",
  "slide_collapse": "Collapse",

  
  "high_rebate_banner": {
    "rebate_tit": "リファラルプログラム",
    "rebate_subtit": "友達を紹介して取引手数料の還元を貰おう",
    "rebate_step": [{
      num: 1,
      step_desc: "ユーザー登録して専用 <br />リンクとリファラルコードを作る"
    }, {
      num: 2,
      step_desc: "友達に専用リンクを通<br />じてユーザー登録して貰う"
    }, {
      num: 3,
      step_desc: "最大40％の取引手数料を貰える"
    }],
    "rebate_btn": "Sign up to invite friends immediately"
  },
  "high_rebate_detail": {
    "rebate_tit": "あなたの声を収益につなげることができます。",
    "rebate_subtit": "アマンプリのコミュニティユーザーになり、業界一のリファラルプログラムに参加しよう。",
    "rebate_rate": "最大<span>40%</span>の手数料還元となります",
    "rebate_joinin": "登録する",
    "rebate_register_step": [{
      "step_img": '/images/rebate/number-one.png',
      "step_num": 'ステップ①：登録しよう',
      "step_desc": 'アマンプリのコミュニティユーザーになろう。分からないことがあればコミュニティで聞いてみよう。'
    }, {
      "step_img": '/images/rebate/number-two.png',
      "step_num": 'ステップ②：活動しよう',
      "step_desc": '自分のリファラルコードをあなたのコミュニティや友達に紹介しよう。登録した友達は自分のページ（https://demo.io/referral）で確認することができます。'
    }, {
      "step_img": '/images/rebate/number-three.png',
      "step_num": 'ステップ③：手数料還元を受けよう',
      "step_desc": 'あなたのユーザーが取引した手数料の一部が毎日あなたのアカウントに入ります。ユーザーが手数料を支払ったコインやトークンがアカウントに反映され出金することもできます。'
    }],
    "rebate_five_tit": '最大5層のリファラルプログラム',
    "rebate_five_subdesc": '業界一のリファラルシステム',
    "rebate_five_desc": 'コミュニティユーザーとして、5層より最大40％のリファラルフィーが還元されます。彼らがアマンプリで取引を続ける限りこのリファラルプログラムは続きます。',
    "rebate_five_become": "コミュニティユーザーになる",
    "rebate_five_tips": "アナウンスを読む",
    "rebale_article_link": 'https://demo-exchange.zendesk.com/hc/ja/articles/360039635991',
    "rebate_explain": [{
      tit: '最大5層からのリファラルシステム　',
      'desc': 'Aユーザー（1層目）から10％の手数料還元＋2層目以下から合計10％の手数料還元<br /> ＊100人以上の紹介でAユーザー（1層目）から20％の手数料還元＋2層目以下から合計20％の手数料還元となり合計最大40％の手数料還元となります。'
    }, {
      tit: 'パートナーへのサポート',
      'desc': 'アマンプリのパートナーになることで更に多くの配当を受けられるチャンスが広がります。'
    }, {
      tit: '管理システム',
      'desc': 'あなたのページで紹介したユーザーから還元されたデーターを確認することができます。'
    }, {
      tit: 'リアルタイム還元システム',
      'desc': '手数料還元はリアルタイムでBTCやUSDT等ユーザーの支払ったコインやトークンで受け取ることができます。'
    }],
    "rebate_unique_tit": 'アマンプリには下記の様な特徴があります。',
    "rebate_unique": [{
      tit: '親切なユーザーインターフェイス',
      subtit: '新しいユーザーでも直感でトレードができる親切なユーザーインターフェイス'
    }, {
      tit: '保証金はビットコイン',
      subtit: 'レバレッジ取引ではビットコインを保証金に取引を行うことができます。'
    }, {
      tit: '高い流動性',
      subtit: 'アマンプリは高い流動性と豊富なオーダー方法を提供します。'
    }, {
      tit: 'セキュリティ性',
      subtit: 'ユーザーの資産は全てコールドウォレットに保管されます。'
    }, {
      tit: '最大100倍のレバレッジ',
      subtit: '無期限契約で最大レバレッジ100倍での取引が可能です。'
    }, {
      tit: '多言語でのカスタマーサポート',
      subtit: 'アマンプリではリアルタイムチャットとサポートデスクを完備しています。ユーザーの問題に対しサポートセンターが丁寧に回答します。'
    }, {
      tit: '業界最安値の取引手数料',
      subtit: '業界内で最も安い手数料と資金調達率を誇ります。<br />4IREトークンで手数料を支払うことにより手数料の半額を受けられます。'
    }, {
      tit: 'パートナーラベルプログラム',
      subtit: '世界中に分散したコミュニティやパートナーの意見に率先して耳を傾けいいアイデアは積極的に採用します。'
    }],
  },
  "coopeartion_d":{
    'banner':{
      tit:'アマンプリのパートナーになり',
      subtit:'仲間と共に協力し、アマンプリと成長しよう！',
      // login:'パートナー登録',
      login:"申し込み",
      manage_login:'アカウントを管理します',
      partner:'アカウントを管理します',
      manage_partner:'三分間で口座を登録します',
      'detail':'OG Exchange についてもっと知りたいです',
      main:'概要',
      main_step:'OG Exchange > 概要',
      plan:"アマンプリではパートナーラベルプログラムというユニークな特徴を持った制度があります。この制度は自身の得意なフィールドで活躍するパートナーとなり自分自身とアマンプリを成長させていきます。<br />ユーザーはパートナーになることでアマンプリエコシステムの大切な一員となり、アマンプリより配当用の4IREトークンを付与されます。",
    },
    'step':[{
      step_img:'/images/rebate/high_d_register.png',
      step_num:'ステップ①',
      step_desc:'パートナーラベルプログラムに申請して下さい。<br />審査を通過するとパートナーコミュニティのリンクが送信されるので加入して下さい。'
    },{
      step_img:'/images/rebate/high_d_promote.png',
      step_num:'ステップ②',
      step_desc: `パートナーとして活動します。<br />
      パートナーとなり自分の力を発揮できるフィールドで活躍して下さい。`
    },{
      step_img:'/images/rebate/high_d_rebate.png',
      step_num:'ステップ③',
      step_desc: `パートナー限定のプログラムに参加することができます。<br />
      アマンプリでは定期的にパートナー向けにタスクを公開します。<br />
      タスクを達成した成績の上位入賞者には4IREやアマンプリの限定グッズが貰えます。`
    }],
    'reward':{
      tit:'パートナーへの報酬は3つの部分から構成されます',
      step:[`アマンプリより支給されるPerpetual Dividend 4IRE<br />パートナーになることで付与されパートナー期間中、付与される4IREと自身の4IREを合計して、10,0004IRE以上保有することで毎日の報酬をBTCで受け取ることができます。また付与される4IREはパートナー期間が終了すると消滅します。（自身で手に入れた4IREは消滅しません。）`,`パートナーとしてあなたが招待したユーザーの取引手数料の一部（最大40％）<br />あなたが招待したユーザー最大5階層から最大40％の手数料の還元を受け取ることができます。還元されたBTC、USDT、4IREなどのコイン、トークンはロックアップなどの制限を受けずに、自由に取引、出金をすることができます。（手数料の還元は条件を達成するまで最大20％となります。条件を達成することで40％にまで引き上げられます。）`,`パートナー限定タスクの達成<br/>アマンプリでは、パートナーを限定に定期的に公開タスクを用意しています。これによりパートナーは、Perpetual Dividend 4IREやUSDT、アマンプリ限定グッズを手に入れることができます。`]
    },
    'func':{
      tit:'パートナーが利用できる機能',
      step:[{
        step_num:'リアルタイム決済システム',
        step_desc:'招待したユーザーの支払った手数料の還元はリアルタイムにあなたのウォレットに還元されます。'
      },{
        step_num:'コミッション管理システム',
        step_desc:'招待したユーザーの人数、受け取った手数料を管理するシステムが完備されています。またこれらは、CSVファイルとしてダウンロードすることができます。'
      },{
        step_num:'SNS投稿機能',
        step_desc:'パートナーは自分のリファラルコードをTwitterやFacebook等に投稿する機能を利用できます。'
      }]
    },
    'partner':{
      tit:'パートナーを探す',
      maintit:'現在アマンプリでは下記のパートナーを募集しています。',
      step:['KOL','メディア','アフィリエイター']
    }
  },
  'cooperation_banner_tit': 'アマンプリのパートナーになり',
  'cooperation_banner_subtit': '仲間と共に協力し、アマンプリと成長しよう！',
  'cooperation_banner_btntxt': '詳細',
  "roe_personal_team_slide":{
    tit:`OG Exchange<br />無期限コントラクトROEコンテスト`,
    subtit:`OG Exchange の個人／チーム戦トレードコンテストに参加しよう!<br />このコンテストはコンテスト終了時のROEを競います。
    `,
    personal_btn:`個人戦詳細`,
    team_btn:`チーム戦詳細`,
    bonus: `最大賞金<br />200BTC`
  },
  "roe_team":{
    header_txt:{
      personal:{
        tit: `OG Exchange<br />レバレッジ取引ROEコンテスト`,
        subtit:`OG Exchangeは、レバレッジ取引にてエントリー制ROEコンテストを開催します！
        期間中のROE（自己資本率）を競い上位のトレーダーをリーダーボードでリアルタイムに表示します。`
      },
      team:{
        tit: `OG Exchange<br />チーム対抗レバレッジ取引ROEコンテスト`,
        subtit:`OG Exchangeは、レバレッジ取引にてチーム対抗ROEコンテストを開催します！
        このコンテストは、コンテスト終了後のチーム平均ROE（自己資本率）を競います。`
      },
    },
    outline_list:[{
      tit:'ROEコンテスト概要(チーム戦)',
      subtit: `オープンしているコントラクトにて取引を行い、コンテスト期間終了後にチーム平均のROEが高かったチーム上位には賞金があります。全てのユーザーがチームリーダーになることができます。<br />
      またチーム戦参加最低人数を集められなかったチームはエントリー取り消しとなります。賞金はエントリーしたチームの数によって変動します。<br />
      またROEでの成績だけではなく、チーム全体で取引をしたボリュームに対しても賞金があります。<br />
      ROEを競うためユーザーの資金量に影響されません。<br />
      例：証拠金0.05BTCのユーザーと証拠金5BTCのユーザーのROEは平等に計算されます。`
    },{
      tit:'ROEの計算方法',
      subtit: `ROE(全期間) = [(ROE(1日目)+1) * (ROE(2日目)+1) * (ROE(3日目)+1) * …（終了<br />日まで続く）] - 1
      <br />* 1日のROE計算方式は下記を参照`
    },{
      tit:'当日（1日）のROEの計算方法',
      subtit: `ROE(当日のROE) = 証拠金残高(当日の開始時) ÷ 証拠金残高(当日の終了時) – 1<br />
      * 1日は日本時間では12：00〜翌日11：59までとします。<br />* 当日の終了時の証拠金残高の計算方式は下記を参照`
    },{
      tit:'証拠金残高（当日の終了時）の計算方法',
      subtit:`証拠金残高(当日の終了時) = 証拠金残高(当日の開始時) + 実現損益(当日の取引時) + 未実現損益(当日の終了時)<br /> - 未実現損益(当日の開始時) `
    },{
      tit:'ROEコンテストエントリー期間(チーム戦)',
      subtit: `2020 / 07 / 03 &nbsp;&nbsp;18:00 ~ 07 / 12 &nbsp;&nbsp;08:59 (GMT+9)`
    },{
      tit:'ROEコンテスト期間(チーム戦)',
      subtit:'2020 / 07 / 12&nbsp;&nbsp; 09:00 ~ 08 / 02  &nbsp;&nbsp;08:59 (GMT+9)'
    },{
      tit:'参加資格',
      subtit:'1チーム最低 3 人 （最大 20 人）'
    }],
    team_bonus:{
      tit:'コンテスト期間中の最低ボリューム',
      money: `1チーム{btc} BTC<br />
      1メンバー0.05BTC以上の証拠金`
    },
    team_txt: {
      teamAndAllMoney:'エントリーチーム数と賞金総額',
      team:'参加チーム数',
      all_money:'賞金総額',
      teamtxt:'チーム',
      trading_txt:'ボリュームランキング',
      roe_txt:'ROEランキング'
    },
    bonus_rules:'賞金の分配ルール',
    bonus_rate:'獲得する比率',
    bonus_dis_demo:[{tit:'賞金の分配の例   (ROE)',subtit:`例：参加チームが10チームであり賞金総額が2 BTCの場合 <br />
    1位&nbsp;  1.4BTC &nbsp;&nbsp;&nbsp;&nbsp;
    2位&nbsp;  0.2BTC &nbsp;&nbsp;&nbsp;&nbsp;
    3位&nbsp;  0.1BTC &nbsp;&nbsp;&nbsp;&nbsp;
    4~10位&nbsp;  0.042BTC<br />
    例：参加チームが1000チームであり賞金総額が100 BTCの場合<br />
    1位&nbsp; 70 BTC &nbsp;&nbsp;&nbsp;&nbsp;
    2位&nbsp;   10 BTC &nbsp;&nbsp;&nbsp;&nbsp;
    3位&nbsp;  10 BTC &nbsp;&nbsp;&nbsp;&nbsp;
    4~10位&nbsp;   2.1 BTC
     `},{
      tit:'賞金の分配の例  （ボリューム）',
      subtit:`例：参加チームが10チームであり賞金総額が1 BTCの場合<br />
      1位&nbsp;  0.7BTC &nbsp;&nbsp;&nbsp;&nbsp;
      2位&nbsp;  0.1BTC &nbsp;&nbsp;&nbsp;&nbsp;   
      3位&nbsp;  0.05BTC &nbsp;&nbsp;&nbsp;&nbsp;
      4~10位&nbsp;  0.021BTC<br />
      例：参加チームが1000チームであり賞金総額が100 BTCの場合<br />
      1位&nbsp; 70BTC &nbsp;&nbsp;&nbsp;&nbsp; 
      2位&nbsp;   10BTC &nbsp;&nbsp;&nbsp;&nbsp;      
      3位&nbsp;  5BTC &nbsp;&nbsp;&nbsp;&nbsp;     
      4~10位&nbsp;   2.1BTC`
    }],
    bonus_dis_demo_time:{
      tit:'賞金配布時期',
      subtit:`コンテスト終了後、不正有無の確認をし正確な順位を20 日以内に確定し、更に10 日以内に賞金を配布致します。`
    },
    complement:{
      tit:'コンテスト補足事項',
      list:[`エントリー後、証拠金を引き出したり、コンテスト期間中に1トレードもしなかった場合はエントリーを取り消されます。`,
     ` コンテスト終了後にエントリー人数、ランキングを確定し、30日以内に配布致します。`,
     `違法な登録アカウント、または市場操作と見なされるトレードを失格にする権利を有します。`,
     ` 当社独自の裁量により、コンテストまたはコンテストルールを取り消しまたは修正する権利を有します。`,
     ` エントリー期間中にポジションを持っており、そのままコンテスト期間を跨いだ場合は、ポジションが100%決済された時よりROE、ボリュームがカウントされます。`,
     ` 賞金は獲得チームのメンバーへ均等に振り分けられます。`,
      `チームに参加するにはチームリーダーの承認が必要です。`,
      `複数のチームにエントリーすることはできません。`,
     ` チームにエントリーするときにユーザーIDはチームリーダーへ公開されます。`,
      `リーダーボードには暫定的なチーム数と、コンテスト終了後に確定される確定チーム数が表示されます。`,
     ` 確定エントリーチーム数が10チーム未満になった場合、期間中でもノーコンテストとなり、コンテストは成立しません。`,`コンテスト期間中の手数料収入が賞金総額を下回った場合は、コンテスト期間中の手数料純利益の7割を賞金総額の上限といたします。`]
    },
    cancel:{
      tit:'エントリーが取り消される条件について',
      list:[` エントリー期間中にポジションを持っており、コンテスト前に証拠金が0.05BTCを下回った場合：エントリーは取り消されます。(再エントリー可能)`,
     ` コンテスト期間中に1トレードもしなかった場合は、エントリーは取り消されます。`,
     ` コンテスト期間中に最低ボリュームを満たさなかったチームはエントリーを取り消されます。`,]
    }
  },
  license: {
    legal:"法律とライセンスについて",
    license_tit: "概要",
    license_footer:'ライセンス',
    license_subtit: `アマンプリは各国の法律に準じた営業をしています。一部の国の法律では利用を制限されることがあります。自国の法律をよく理解した上で利用を行って下さい。<br />OG Exchange US CO.,LTDは、米国財務省のFinCENに登録されているマネーサービスビジネス（MSB）ライセンスを保有しており、ライセンス上に記載された米国の管轄区域でマネーサービスビジネスを行う業者として認可されています。 特定の州の居住者は、当社のサービスに関する懸念または苦情に関連する特定の権利を有している可能性があります。 以下のライセンスをクリックして、州を確認することができます。<br />
    質問やお問い合わせはサポートチームまでメールを送信してください。<span>contact@demo.io</<span> `,
    certificate_tit:'ライセンス',
    fincen: 'FinGEN'
  },
  "account.otp.back": "Previous",
  "account.otp.backup_text3": "This Key will allow you to recover your Authenticator in case you lost your phone. Otherwise, resetting Google Authenticator will take at least 7 days.",
  "account.otp.backup_title": "Backup Key",
  "account.otp.enable_des": "Google Authenticator",
  "account.otp.enable_title": "Enable Google Authentication",
  "account.otp.install_gg_authen": "Download and install the Google Authentication app",
  "account.otp.scan_qrcode": "Scan this QR code in the Authenticator app",
  "account.otp.save_key": "Save this Backup Key in a secure location",
  "account.otp.install_title": "Download App",
  "account.otp.next": "Next",
  "account.otp.qr_text":"If you are unable to scan the QR code, please enter this code manually into the app.",
  "account.otp.qt_title": "Scan QR Code",
  "account.text_install_gg_authen": "To begin, you will need to install an <span class='text-gg'>Google Authenticator</span> application.",
  "change_password_form.palaceholder_new_password": "Please enter the new password",
  "change_password_form.palaceholder_old_password": "Please enter the old password",
  "change_password_form.confirm_new_password": "Confirm New Password",
  "change_password_form.palaceholder_confirm_new_password": "Please confirm the new password again",
  "change_password_form.palaceholder_authen_code" : "Google Authentication Code",
  "coming_soon":"Coming Soon",
 "account.email.required": "Please enter a correct email address",


 sidebar:{
    open_order:"Open Orders",
    order_history:"Order History",
    trade_history:"Trade History"
  },
  about: {
    title: "Welcome to MONAS",
    sub_title: "The beginning of the finance, with Sotatek",
    information: "MONAS is a cryptocurrency exchange established in 2023 with the goal of being the first exchange to be operated more fairly and transparently than anyone else with a name that means number 1 and first in Greek.\n\n Anyone can easily and conveniently experience cryptocurrency, such as spot, futures, and various derivatives markets (Staking, Saving, Lending), and block chain by allowing cryptocurrency to be recognized as a stable alternative investment rather than a risky investment method. We have a grand vision to develop and be recognized as a virtual asset industry and one finance.\n\n We aim to become an exchange that is faithful to the basics by harmonizing the rapidly changing virtual currency market and the blockchain industry. The basics defined by MONAS will be the first step and leap to transparently show all our values, such as user experience and interface, excellent security, prompt response and communication, various benefits enjoyed equally by everyone, and convenient accessibility.",
    title_vision: "Our Vision",
    sub_title_vision: "The world's leading global cryptocurrency exchange.",
    information_vision: "In the fast-changing financial market, we want to lead transparent and innovative changes so that cryptocurrency can be recognized as one of finance and become a stable investment destination.",
    title_mission: "Our Mission",
    information_mission: "By providing the best infrastructure and technology, we create a cryptocurrency market where anyone can freely and equally trade cryptocurrency anywhere in the world.",
    title_transparency: "Transparency",
    title_stable: "Stable & Secure",
    title_convenient: "Convenient",
    title_value: "Our Value",
    title_reasons: "Reasons to choose MONAS",
    title_security: "Top-notch security system",
    des_security: "By introducing a powerful security solution, we keep our customers' assets safe through 24/7 monitoring.",
    title_ratio: "100% reserve ratio",
    des_ratio: "Store cryptocurrency in hot and cold wallets to maintain 100% reserve ratio at all times.",
    title_smart: "Smart and intuitive platform",
    des_smart: "Store cryptocurrency in hot and cold wallets to maintain 100% reserve ratio at all times.",
    title_customer: "24/7 customer center operation",
    des_customer: "By introducing a powerful security solution, we keep our customers' assets safe through 24/7 monitoring.",
  },
  policy: {
    title: "Privacy Policy",
    text_bold_1: "Dear Sotatek users:",
    sub: "Please read the Privacy Policy carefully.",
    text_bold_2: "Parties",
    list_policy: {
      parties_1: "Sotatek operates the Website https://www.monas.exchange (hereinafter referred to as 'this Website' or 'the Website'), which is a platform dedicated to the transaction of digital assets and the provision of related services (hereinafter referred to as 'the Service'). For the convenience of wording in this Agreement, the Company and the Website are referred to collectively as 'we' or other applicable forms of first person pronouns in this Agreement." ,
      parties_2: "All natural persons or other subjects who log onto this Website shall be users of this Website. For the convenience of wording in this Agreement, the users are referred to as 'you' or any other applicable forms of the second-person pronouns.",
      parties_3: "For the convenience of wording in this Agreement, you and we are collectively referred to as “both parties”, and individually as “one party”."
    },
    text_bold_3: "Purposes of the Privacy Policy",
    list_purposes: "The Privacy Policy stipulates the types of information of yours that we may collect through your log into this Website, your registration with this Website, and/or use the services we offer, as well as how we shall use and protect the information so collected.",
    text_bold_4: "Your consent",
    list_consent: {
      consent_1: "To ensure that you have full confidence in our handling of personal data, you are advised to read and understand the terms of this Privacy Policy in detail. In particular, upon your log into our Website, regardless of whether you register with this Website, you shall be deemed to accept, agree, undertake and confirm that:",
      consent_2: "You, on the basis of your own free will and your requisite consent, agree to disclose your personal information to us;",
      consent_3: "You will comply with all the terms and limitations of this Privacy Policy;",
      consent_4: "You agree that we may collect your information through your log into this Website, your registration with this Website, and/or your using the Services offered by us; you agree to any changes and modifications that we may make to our Privacy Policy in the future;",
      consent_5: "You agree that our branches, affiliates and employees may contact you in connection with the products and services that you may be interested in (unless you have indicated that you do not want to receive such information).",
    },
    text_bold_5: "Information Collected",
    list_collect: {
      collect_1: "When you use this Website, you agree to permit us to use cookies to track each of your actions and collect and keep all the information that you leave on this Website, including but not limited to your IP address, location, and other information.",
      collect_2: "If you are willing to use the services offered by this Website, you will be required to fill in and provide the following two categories of information:",
      collect_3: "Identity Information：Such information can help us verify whether you are eligible to be registered as a member of this Website. It includes but is not limited to your name, residence address, mailing address, other certificates and corresponding numbers thereof that are issued by your country or government to certify your identity information, as well as all other information that can help us to verify your identity (hereinafter referred to as 'identity information').",
      collect_4: "Service information. Such information helps us to contact you and provide you with the services, including but not limited to your phone number, fax number, valid email address, mailing address, and information concerning your debit card and/or other accounts (hereinafter collectively referred to as 'service information').",
      collect_5: "When you use this Website or the services this Website offers, we may collect more information necessary from our exclusive mailboxes or in other manners that we consider as in compliance with relevant requirements, for the purpose of improving the functions of this Website, enhancing your experience of using this Website and its services as well as the security thereof, or as is required by any court order, any applicable law, administrative regulation or any order of any other competent government agency.",
      collect_6: "If you visit any of links to third-party websites as are listed on this Website or any link of any of our third-party partners, you shall agree to and comply with the separate and independent Privacy Policy of such third party website. We will not bear any liability for the contents and activities of such websites or the partners.",
    },
    text_bold_6: "Cookies",
    list_cookies: {
      cookies_1: "When you visit our Website, we use Google stats via cookies to record our performance and check the effect of online advertising. Cookies are a small amount of data that is sent to your browser and stored on your computer hard drive. Only when you use your computer to access our Website can the cookies be sent to your computer hard drive.",
      cookies_2: "Cookies are usually used to record the habits and preferences of visitors in browsing the items on our Website. The information collected by cookies is non-registered and collective statistical data and does not involve personal data.",
      cookies_3: "Cookies, which enable the Website or service provider system to recognize your browser and capture and recall information, cannot be used to obtain data on your hard drive, your email address, or your personal data. Most browsers are designed to accept cookies. You can opt to set your browser to reject cookies, or to notify you as soon as possible if you are loaded on cookies. However, if you set your browser to disable cookies, it is possible that you may not be able to launch or use some functions of our Website.",
    }
  },
  terms: {
    title_terms: 'Terms of Use',
    sub: "Please read the Terms of Use carefully.",
    des: "Sotatek exchange (hereinafter referred to as 'the Company') is a company incorporated in Cayman Islands under the laws of Cayman Islands. It is a platform for users to conduct digital asset transactions and provide related services (hereinafter referred to as 'the service' or 'service'). The company operates the website https://www.monas.exchange (hereinafter referred to as 'this website') Or 'website'). For the convenience of this Agreement, the Company and the Website collectively use 'we' or other first-person names in this Agreement. As long as the natural person or other subject who visits the website is a user of this website, the convenience of this agreement is as follows, using 'you' or other second person. For the convenience of this Agreement, we and you are collectively referred to as “the parties” in this Agreement, and we or you are referred to as the “Party”. All contents of this website are for the convenience of users and may be available in multiple languages. In case of conflict or omission, the English content shall prevail.",
    terms_bold_1: "Important reminder",
    sub_1: "We hereby remind you that:",
    list_reminder: {
      reminder_1: "The digital assets themselves are not offered by any financial institution, corporation or this Website;",
      reminder_2: "The digital asset market is new and unconfirmed, and will not necessarily expand;",
      reminder_3: "Digital assets are primarily used by speculators, and are used relatively less on retail and commercial markets; digital asset transactions are highly risky, due to the fact that they are traded throughout the day without limits on the rise or fall in price, and market makers and global government policies may cause major fluctuations in their prices;",
      reminder_4: "The Company may suspend or terminate your account or use of the Service, or the processing of any digital asset transaction, at any time if it determines in its sole discretion that you have violated this Agreement or that its provision or your use of the Service in your jurisdiction is unlawful.",
    },
    para_1: "Digital assets trading is highly risky and therefore not suitable for the vast majority of people. You acknowledge and understand that investment in digital assets may result in partial or total loss of your investment and therefore you are advised to decide the amount of your investment on the basis of your loss-bearing capacity. You acknowledge and understand that digital assets may generate derivative risks. Therefore, if you have any doubt, you are advised to seek assistance from a financial adviser first. Furthermore, aside from the above-mentioned risks, there may also be unpredictable risks. Therefore, you are advised to carefully consider and use clear judgment to assess your financial position and the abovementioned risks before making any decisions on buying and selling digital assets; any and all losses arising therefrom will be borne by you and we shall not be held liable in any manner whatsoever.",
    sub_2: "You are hereby informed that:",
    list_inform: {
      inform_1: "You understand that this Website is only intended to serve as a venue for you to obtain digital asset information, find trading counterparties, hold negotiations on and effect transactions of digital assets. This Website does not participate in any of your transactions, and therefore you shall, at your sole discretion, carefully assess the authenticity, legality and validity of relevant digital assets and/or information, and solely bear the responsibilities and losses that may arise therefrom.",
      inform_2: "All opinions, information, discussions, analyses, prices, advice and other information on this Website are general market reviews and do not constitute any investment advice. We do not bear any loss arising directly or indirectly from reliance on the abovementioned information, including but not limited to, any loss of profits.",
      inform_3: "The content of this Website may be changed from time to time and at any time without notice, and we have taken reasonable measures to ensure the accuracy of the information on the Website; however, we do not and cannot guarantee the degree of such accuracy, or bear any loss arising directly or indirectly from the information on this Website or from any delay or failure caused by failure to link up with the internet, transmit or receive any notice and information.",
      inform_4: "Using internet-based trading systems also involves risks, including but not limited to failures in software, hardware or Internet links, etc. In view of the fact that we cannot control the reliability and availability of the Internet, we will not be responsible for any distortion, delay and link failure.",
      inform_5: "Sotatek.exchange ,is theonly official external information release platform for monas;",
      inform_6: "No service on this Website may be paid for by credit card;",
      inform_7: "It is prohibited to use this Website to engage in any illegal transaction activities, such as money laundering, smuggling and commercial bribery. In the event that any of such activities is uncovered, this Website will adopt all available measures, including but not limited to freezing the offender’s account, notifying relevant authorities, etc., and we will not assume any of the responsibilities arising therefrom and reserve the right to hold relevant persons accountable;",
      inform_8: "It is prohibited to use this Website for the purpose of malicious manipulation of the market, improper transactions or any other illicit trading activities. Where any of such illicit trading activities is uncovered, this Website will adopt such preventive and protective measures as warning, restricting trading and closing accounts against any and all such malicious manipulation of prices, maliciously influencing the trading system and any otherillicit behaviour; we do not assume any of the responsibilities arising therefrom and reserve the right to hold relevant persons accountable.",
    },
    terms_bold_2: "General Provisions",
    list_general: {
      general_1: "The User Agreement (hereinafter referred to as 'this Agreement' or 'these terms and conditions') consists of the main body, Terms of Privacy, Understanding Your client and Anti-money-laundering Policy, as well as any rules, statements, instructions, etc. that this Website has published or may publish in the future.",
      general_2: "Before using the services offered by this Website, you shall read this Agreement carefully, and consult a professional lawyer if you have any doubt or as may be otherwise necessary. If you do not agree to the terms and conditions of this Agreement and/or any change made thereto from time to time and at any time, please immediately stop using the service provided by this Website or stop logging onto this Website. Upon your logging into this Website or using any service offered by this Website or engaging in any other similar activity, it shall be deemed as having understood and fully agreeing to all terms and conditions of this Agreement, including any and all changes, modifications or alterations that this Website may make to this Agreement from time to time and at any time.",
      general_3: "After filling in the relevant information in accordance with the requirements of this Website, and going through other relevant procedures, you will successfully register yourself as a member of this Website (hereinafter referred to as 'Member'); in the process of registration, if you click on the 'I Agree', it shall be deemed that you have reached an agreement with the Company by way of electronic signature; or when you use this Website, you click on the “I Agree” button or a similar button, or if you use the services offered by this Website in any of the ways allowed by this Website, it shall be deemed that you fully understand, agree to and accept all the terms and conditions under this Agreement, and in this case, the absence of your handwritten signature will not affect the legal binding force that this Agreement may have on you.",
      general_4: "After you become a member of this Website, you will receive a member account and corresponding password, which shall be properly kept by you as a member of this Website; Members shall be liable for all activities and events carried out through their accounts",
      general_5: "You cannot engage in trading on the digital asset trading platform provided by this Website and gain access to the services that are exclusively available to members in accordance with the rules and regulations of this Website, unless and until you become a member of this Website; if you are not a member of this Website, you can only longin to browse the Website and have access to other services as are permitted by the rules and regulations of this Website.",
      general_6: "Upon registering yourself as a member of this Website and using any of the services and functions offered by this Website, it shall be deemed that you have read, understood this Agreement, and:",
      general_7: "1) Accepted to be bound by all terms and conditions of this Agreement;",
      general_8: "2) You confirm that you have attained the age of 18, or another statutory age for entering into contracts as is required by a different applicable law, and your registration with this Website, purchase or sale via this Website, release information on this Website and other behaviours indicating your acceptance of the Services offered by this Website shall comply with the relevant laws and regulations of the sovereign state or region that has jurisdiction over you, and you confirm having sufficient capacity to accept these terms and conditions, enter into transactions and to use this Website for digital asset transactions.",
      general_9: "3) You undertake that all your digital assets involved in transactions hereunder are legally acquired and owned by you.",
      general_10: "4) You agree to undertake any and all liabilities for your own transaction and non-transaction activities as well as any and all profits and losses therefrom.",
      general_11: "5) You confirm that the information provided at the time of registration is true and accurate.",
      general_12: "6) You agree to comply with any and all relevant laws, including the reporting of any transaction profits for tax purposes.",
      general_13: "7) This Agreement is only binding on the rights and obligations between you and us, and does not involve legal relations and legal disputes arising from and relating to the transaction of digital assets between the users of this Website, and between other websites and you.",
    },
    sub_3: "Amendment of this Agreement",
    sub_4: "We reserve the right to amend this Agreement from time to time, and disclose such amendment by way of announcement on the Website without sending a separate notice to you on your rights. The date when the amendment is made will be indicated on the first page of the amended agreement. The amended agreement will take effect immediately upon announcement on the Website. You shall browse this Website from time to time and follow information on the time and content of amendments, if any, made to this Agreement. If you do not agree with the amendments, you shall stop using the services offered by this Website immediately; if you continue to use the services offered by this Website, it shall be deemed that you accept and agree to be bound by the amended agreement.",
    sub_5: "Registration",
    terms_bold_3: "Eligibility for Registration",
    sub_6: "You confirm and promise that: you shall be a natural person, legal person or other organization with the ability to sign this Agreement and the ability to use the services of this Website, as is provided by applicable laws, when you complete the registration process or when you use the services offered by this Website in any other manner as is otherwise permitted by this Website. Upon clicking on the button indicating that you agree to register, it shall be deemed that you yourself or your authorized agent agrees to the content of this Agreement and your authorized agent will register with this Website and use the services offered by this Website on your behalf. If you are not a natural person, legal person or organization with the abovementioned ability, you and your authorized agent shall bear all the consequences of that, and the company reserves the right to cancel or permanently freeze your account and to hold you and your authorized agent accountable.",
    sub_7: "Meanwhile, by accessing and using the services, you represent and warrant that you are not on FATF (Financial Action Task Force) list, or OFAC (Office of Foreign Assets Control of the U.S. Treasury Department) designated “Specially Designated National” list or any other trade or economic sanctions lists, such as the UN Security Council Sanctions list. We maintain the right to select its markets and jurisdictions to operate and may restrict or deny the Services in certain countries at its discretion.",
    terms_bold_4: "Purpose of Registration",
    sub_8: "You confirm and promise that you do not register with this Website for the purpose of violating any of the applicable laws or regulations or undermining the order of digital asset transactions on this Website.",
    terms_bold_5: "Registration Process",
    list_process: {
      process_1: "You agree to provide a valid email address, a mobile phone number and other information in accordance with the requirements on the user registration page of this Website. You can use the email address, mobile phone number or any other manner permitted by this Website to log in to this Website. Where it is necessary and in accordance with the requirements of applicable laws and regulations of relevant jurisdictions, you shall provide your real name, identity card and other information required by applicable laws, regulations, the Terms of Privacy, and anti-money-laundering terms, and constantly update your registration data so that they will be timely, detailed and accurate as is required. All of the original typed data will be referenced as registration information. You shall be responsible for the authenticity, integrity and accuracy of such information and bear any direct or indirect loss and adverse consequences arising out of it.",
      process_2: "If any of the applicable laws, regulations, rules, orders and other regulatory documents of the sovereign country or region in which you are based requires that mobile phone accounts must be based on real names, you hereby confirm that the mobile phone number you provide for registration purposes has gone through the real-name registration procedure. If you cannot provide such a mobile phone number as is required, any direct or indirect losses and adverse consequences arising therefrom and affecting you shall be borne by you.",
      process_3: "After you provide the required registration information in a legal, complete and valid manner and such information passes relevant verification, you shall have the right to obtain an account and a password of this Website. Upon obtaining such account and password, your registration shall be deemed as successful and you can log into this Website as a member thereof.",
      process_4: "You agree to receive emails and/or short messages sent by this Website related to the management and operation thereof.",
      process_5: "You acknowledge and understand that you will be required to provide further materials and information for merchant registration if you want to become a verified merchant by us after you complete your registration of general users. The further materials and information we may ask for include but not limited to your telephone number, WeChat account, telegram account, proof of revenue, previous experience of dealing on this Website or in any other OTC exchanges, risk control strategies and other information and materials that we consider necessary to be provided and the applicable laws may require. Also, to register as a verified merchant, a part of digital assets will be locked in your OTC account as a security deposit to safeguard the security of transactions you involve in and you are unable to transfer and withdraw during your transactions. You acknowledge and agree that if you, as a verified merchant, are proved to be liable for any damages, losses, and any other payments during any transactions but you refuse to pay, we may process your security deposit to cover any third parties’ damages, losses, and any other payments you should have paid subject to applicable laws. After you complete the registration of the verified merchant, we will provide you with the verified merchant logo so as to distinguish from other users who do not complete the registration of verified merchants. You may submit a cancellation application to this Website to cancel your verification, and then this Website will proceed your application within 3 business days and unlock your security deposit if there are no any records of pending disputes with any third parties or previous negative records.",
    },
    sub_9: "Services",
    sub_10: "This Website only provides online transaction platform services for you to engage in digital asset trading activities through this Website (including but not limited to the digital asset transactions etc.). This Website does not participate in the transaction of digital assets as a buyer or seller; This Website does not provide any services relating to the replenishment and withdrawal of the legal currency of any country.",
    sub_11: "Content of Services",
    sub_12: "1) You have the right to browse the real-time quotes and transaction information of digital asset products on this Website, to submit digital asset transaction instructions and to complete the digital asset transaction through this Website.",
    sub_13: "2) You have the right to view information under the member accounts on this Website and to apply the functions provided by this Website.",
    sub_14: "3) You have the right to participate in the website activities organized by this Website in accordance with the rules of activities posted on this Website.",
    sub_15: "4) Other services that this Website promises to offer to you.",
    sub_16: "Service Rules",
    sub_17: "You undertake to comply with the following service rules of this Website:",
    sub_18: "You shall comply with the provisions of applicable laws, regulations, rules, and policy requirements, and ensure the legality of the source of all digital assets in your account, and shall refrain from engaging in any illegal activities or other activities that damages the rights and interests of this Website or any third party, such as sending or receiving information that is illegal, illicit or infringes on the rights and interests of any other person, sending or receiving pyramid scheme information or information or remarks causing other harms, unauthorized use or falsification of the email header information of this Website, inter alia.",
    sub_19: "You shall comply with applicable laws and regulations and properly use and keep your account in this Website and login password, password of your financial transactions, and the mobile phone number bound with your account that you provide upon registration of your account, as well as the security of the verification codes received via your mobile phone. You shall be solely responsible for any and all your operations carried out using your account with this Website and login password, financial transaction password, verification codes sent to your mobile phone, as well as all consequences of such operations. When you find that your account with this Website, your login password, financial transaction password, or mobile phone verification codes is used by any unauthorized third party, uncover any other problem relating to the security of your account, you shall inform this Website in a prompt and effective manner, and request this Website to temporarily suspend the services to your account with this Website. This Website shall have the right to take action on your request within a reasonable time; nonetheless, this Website does not bear any liability for the consequences that have arisen before such action is taken, including but not limited to any loss that you may sustain. You may not assign your account with this Website to any other person by way of donation, lending, leasing, transfer or otherwise without the consent of this Website.",
    sub_20: "You agree to take responsibility for all activities (including but not limited to information disclosure, information release, online click-approving or submission of various agreements on rules, online renewal of agreements or purchase service) using your account and password with this Website.",
    sub_21: "In your digital asset transactions on this Website, you may not maliciously interfere with the normal proceeding of the digital asset transaction or disrupt the transaction order; you may not use any technical means or other means to interfere with the normal operation of this Website or interfere with the other users’ use of the services; you may not maliciously defame the business goodwill of this Website on the ground of falsified fact.",
    sub_22: "If any dispute arises between you and any other user in connection with online transaction, you may not resort to any means other than judicial or governmental means to request this Website to provide relevant information.",
    sub_23: "All taxes payable as well as all fees relating to hardware, software and services that are incurred by you in the course of using the services provided by this Website shall be solely borne by you.",
    sub_24: "You shall abide by this Agreement and other terms of service and operating rules that this Website may release from time to time, and you have the right to terminate your use of the services provided by this Website at any time.",
    sub_25: "Product Rules",
    sub_26: "1) Rules for trading products",
    sub_27: "You undertake that in the process in which you log into this Website and engage in transactions with other users through this Website, you will properly comply with the following transaction rules.",
    sub_28: "All taxes payable as well as all fees relating to hardware, software and services that are incurred by you in the course of using the services provided by this Website shall be solely borne by you.",
    sub_29: "You shall abide by this Agreement and other terms of service and operating rules that this Website may release from time to time, and you have the right to terminate your use of the services provided by this Website at any time.",
    sub_30: "When you browse the transaction information on this Website, you should carefully read all the content in the transaction information, including but not limited to the price, consignment, handling fee, buying or selling direction, and you shall accept all the contents contained in the transaction information before you may click on the button to proceed with the transaction.",
    sub_31: "Browsing transaction information",
    sub_32: "Submission of Commission",
    sub_33: "After browsing and verifying the transaction information, you may submit your transaction commissions. After you submit the transaction commission, it shall be deemed that you authorize this Website to broker you for the corresponding transactions, and this Website will automatically complete the matchmaking operation when there is a transaction proposal that meets your price quotation, without prior notice to you.",
    regis_18: "Accessing transaction details",
    regis_18_1: "You can check the corresponding transaction records in the transaction statements by the Management Center, and confirm your own detailed transaction records.",
    regis_19: "Revoking/modifying transaction commission. You have the right to revoke or modify your transaction commission at any time before the transaction is concluded.",
    regis_20: "Rights and Obligations of this Website",
    regis_20_1: "If you do not have the registration qualifications agreed on in this Agreement, this Website shall have the right to refuse to allow you to register; if you have already registered, this Website shall have the right to revoke your member account, and this Website reserves the right to hold you or your authorized agent accountable. Furthermore, this Website reserves the right to decide whether to accept your application for registration under any other circumstances.",
    regis_21: "When this Website finds out that the user of an Account is not the initial registrant of that Account, it shall have the right to suspend or terminate the user’s access to that Account.",
    regis_22: "Where by means of technical testing or manual sampling, among others, this Website reasonably suspects that the information you provide is wrong, untrue, invalid or incomplete, this Website shall have the right to notify you to correct or update the information, or suspend or terminate its supply of the services to you.",
    regis_23: "This Website shall have the right to correct any information displayed on this Website when it uncovers any obvious error in such information.",
    regis_24: "This Website reserves the right to modify, suspend or terminate the Services offered by this Website, at any time, and the right to modify or suspend the Service without prior notice to you; if this Website terminates one or more of the Services offered by this Website, such termination by this Website will take effect on the date of announcement of such termination on the Website.",
    regis_25: "This Website shall take necessary technical means and management measures to ensure the normal operation of this Website, and shall provide a necessary and reliable trading environment and transaction services, and shall maintain the order of digital assets trading.",
    regis_26: "If you fail to log into this Website using your member account number and password for an uninterrupted period of one year, this Website shall have the right to revoke your account. After your account is revoked, this Website shall have the right to offer the member name represented by such account to other applicants for membership.",
    regis_27: "This Website shall ensure the security of your digital assets by strengthening technical input and enhancing security precautions, and is under the obligation to notify you in advance of the foreseeable security risks in your account.",
    regis_28: "This Website shall have the right to delete all kinds of content and information which does not conform to laws and regulations or the rules of this Website at any time, and exercise of this right by this Website is not subject to a prior notice to you.",
    regis_29: "This Website shall have the right to, in accordance with the applicable laws, administrative regulations, rules, orders and other regulatory documents of the sovereign country or region where you are based, request to you for more information or data, and to take reasonable measures to meet the requirements of the local standards, and you have the obligation to provide proper assistance to such measures; this Website shall have the right to suspend or permanently terminate your access to this Website as well as part or all of the services offered by this Website.",
    regis_imde: "Indemnity",
    regis_30: "Under any circumstance, our liability for your direct damage will not exceed the total cost incurred by your three (3) months’ use of services offered by this Website.",
    regis_31: "Shall you breach this Agreement or any applicable law or administrative regulation, you shall pay to us at least US$ Two million in compensation and bear all the expenses in connection with such breach (including attorney's fees, among others). If such compensation cannot cover the actual loss, you shall make up for the difference.",
    terms_bold_7: "The Right to Injunctive Relief",
    sub_34: "Both you and we acknowledge that common law remedies for breach of agreement or possible breach of contract may be insufficient to cover all the losses that we sustain; therefore, in the event of a breach of contract or a possible breach of contract, the non-breaching party shall have the right to seek injunctive relief as well as all other remedies that are permitted under common law or equity.",
    terms_bold_8: "Limitation and Exemption of Liability",
    limitation_1: "You understand and agree that under no circumstance will we be held liable for any of the following events:",
    limitation_1_1: "Loss of income",
    limitation_1_2: "Loss of transaction profits or contractual losses",
    limitation_1_3: "Disruption of the business",
    limitation_1_4: "Loss of expected currency losses",
    limitation_1_5: "Loss of information",
    limitation_1_6: "Loss of opportunity, damage to goodwill or reputation",
    limitation_1_7: "Damage or loss of data",
    limitation_1_8: "Cost of purchasing alternative products or services",
    limitation_1_9: "Any indirect, special or incidental loss or damage arising from any infringement (including negligence), breach of contract or any other cause, regardless of whether or not such loss or damage may reasonably be foreseen by us, and regardless of whether or not we are notified in advance of the possibility of such loss or damage.",
    limitation_1_10: "Items 8.1.1 to 8.1.9 are independent of each other.",
    limitation_2: "You understand and agree that we shall not be held liable for any damages caused by any of the following events:",
    limitation_2_1: "Where we are properly justified in believing that your specific transactions may involve any serious violation or breach of law or agreement",
    limitation_2_2: "Where we are reasonably justified in believing that your conduct on this Website is suspected of being illegal or immoral",
    limitation_2_3: "The expenses and losses arising from the purchase or acquisition of any data, information or transaction, etc. through the services offered by this Website",
    limitation_2_4: "Your misunderstanding of the Services offered by this Website",
    limitation_2_5: "Any other losses related to the services provided by this Website, which cannot be attributed to us",
    limitation_3: "Where we fail to provide the Services or delay in providing such Services due to information network equipment maintenance, information network connectivity failures, errors in computer, communications or other systems, power failures, weather conditions, unexpected accidents, industrial actions, labour disputes, revolts, uprisings, riots, lack of productivity or production materials, fires, floods, storms, explosions, wars, failure on the part of banks or other partners, collapse of the digital asset market, actions by government, judicial or administrative authorities, other acts that are not within our control or beyond our inability to control, or due to causes on the part of third parties, we shall not assume any responsibility for such failure to provide service or delay in providing services, or for the resultant loss you may sustain as a result of such failure or delay.",
    limitation_4: "We cannot guarantee that all the information, programs, texts, etc. contained in this Website are completely safe, free from the interference and destruction by any malicious programs such as viruses, trojans, etc., therefore, your log-into this Website or use of any services offered by this Website, download of any program, information and data from this Website and your use thereof are your personal decisions and therefore you shall bear the any and all risks and losses that may possibly arise.",
    limitation_5: "We do not make any warranties and commitments in connection with any of the information, products and business of any third party websites linked to this Website, as well as any other forms of content that do not belong to us; your use any of the services, information, and products provided by a third party website is your personal decision and therefore you shall assume any and all the responsibilities arising therefrom.",
    limitation_6: "We do not make any explicit or implicit warranties regarding your use of the Services offered by this Website, including but not limited to the applicability, freedom from error or omission, consistency, accuracy, reliability, and applicability to a specific purpose, of the services provided by this Website. Furthermore, we do not make any commitment or guarantee in connection with the validity, accuracy, correctness, reliability, quality, stability, integrity and timeliness of the technology and information covered by the services offered by this Website. Whether to log in this Website or use the services provided by this Website is your personal decision and therefore you shall bear all the risks and possible losses arising from such decision. We do not make any explicit or implicit warranties in connection with the market, value and price of digital assets; you understand and acknowledge that the digital asset market is unstable, that the price and value of assets may fluctuate or collapse at any time, and that the transaction of digital assets is based on your personal free will and decision and therefore you shall assume any and all risks and losses that may possible arise therefrom.",
    limitation_7: "The guarantees and undertakings specified in this Agreement shall be the only guarantee and statements that we make in connection with the Services provided by us under this Agreement and through this Website, and shall supersede any and all the warranties and commitments arising in any other way and manner, whether in writing or in words, express or implied. All these guarantees and statements represent only our own commitments and undertakings and do not guarantee any third party's compliance with the guarantees and commitments contained in this Agreement.",
    limitation_8: "We do not waive any of the rights not mentioned in this Agreement and to the maximum extent permitted by the applicable law, to limit, exempt or offset our liability for damages.",
    limitation_9: "Upon your registration of your account with this Website, it shall be deemed that you approve any and all operations performed by us in accordance with the rules set forth in this Agreement, and any and all risks arising from such operations shall be assumed by you.",
    sub_35: "Termination of Agreement",
    limitation_10: "This Website shall have the right to cancel your account with this Website in accordance with this Agreement, and this Agreement shall be terminated on the date of the cancellation of your account.",
    limitation_11: "This Website shall have the right to terminate all Service offered by this Website to you in accordance with this Agreement, and this Agreement shall terminate on the date of termination of all services offered by this Website to you.",
    limitation_12: "After the termination of this Agreement, you do not have the right to require this Website to continue to provide you with any service or perform any other obligation, including, but not limited to, requesting this Website to keep or disclose to you any information in your former original account, or to forward to you or any third party any information therein that is not read or sent.",
    limitation_13: "The termination of this Agreement shall not prevent the observant party from demanding the breaching party to assume other liabilities.",
    sub_36: "Intellectual Property",
    limitation_14: "All intellectual achievements included in this Website, including, but not limited to, website logos, databases, website design, text and graphics, software, photos, videos, music, sounds and any combinations of the aforementioned files, and the intellectual property rights of software compilation, associated source code and software (including small applications and scripts) shall be owned by this Website. You may not copy, modify, transmit or use any of the foregoing materials or content for commercial purposes.",
    limitation_15: "All rights contained in the name of this Website (including but not limited to business goodwill and trademarks, logos) shall be owned by the Company.",
    limitation_16: "Upon accepting this Agreement, it shall be deemed that you, on the basis of your own free will, have transferred and assigned exclusively and free of charge to this Website all copyright of any form of information that you publish on this Website, including, but not limited to copyrights, distribution rights, lease rights, exhibition rights, performance rights, projection rights, broadcasting rights, information network dissemination rights, shooting rights, adaptation rights, translation rights, compilation rights and other transferable rights that copyright owners are entitled to, and this Website shall have the right to sue for any infringement on such copyright and obtain full compensation for such infringement. This Agreement shall apply to any content that is published by you on this Website and is protected by copyright law, regardless of whether the content is generated before or after the signing of this Agreement.",
    limitation_17: "You shall not illegally use or dispose of the intellectual property rights of this Website or any other person during your use of the services offered by this Website. For any information that you publish on this Website, you may not publish or authorize other websites (or media) to use such information in any manner whatsoever.",
    limitation_18: "Your log into this Website or use of any of the services offered by this Website shall not be deemed as our transfer of any intellectual property to you.",
    terms_bold_9: "Calculation",
    des_calculation: "All the transaction calculations are verified by us, and all the calculation methods have been posted on the Website, but we cannot ensure that your use of this Website will not be disturbed or free from errors.",
    terms_bold_10: "Export Control",
    des_control: "You understand and acknowledge that in accordance with relevant laws, you shall not export, re-export, import or transfer any material (including software) on this Website; therefore, you hereby undertake that you will not voluntarily commit or assist or participate in any of the above export or related transfer or other violations of applicable laws and regulations; if you uncover any of the aforementioned events, you will report to us and assist us in handling them.",
    terms_bold_11: "Transfer",
    des_trasfer: "The rights and obligations agreed in this Agreement shall be equally binding on the assignees, the heirs, executors and administrators of the parties hereto who benefit from the rights and obligations. Without our consent, you may not transfer to any third party any of your rights or obligations hereunder, provided, however, we may, at any time, assign our rights and obligations under this Agreement to any third party with thirty (30) days' notice to you.",
    terms_bold_12: "Severability",
    des_severability: "If any provision of this Agreement is found unenforceable, invalid or illegal by any court of competent jurisdiction, validity of the remaining provisions of this Agreement shall not be affected.",
    terms_bold_13: "No Agency",
    des_agency: "Nothing in this Agreement shall be deemed to have created, implied or otherwise treated us as your agent, trustee or other representative, unless it is provided otherwise in this Agreement.",
    terms_bold_14: "Waiver",
    des_waiver: "Our or your waiver of the right to hold the other party liable for breaches of agreement or any other liability as is agreed upon in this Agreement shall not be construed or deemed as a waiver of the right to hold the other party for other breaches of contract; a failure to exercise any right or remedy shall not be construed in any way as a waiver of such right or remedy.",
    terms_bold_15: "Headings",
    des_headings: "All headings herein are exclusively for the convenience of wording and are not intended to expand or limit the content or scope of the terms and conditions of this Agreement.",
    terms_bold_16: "Entry into Force and Interpretation of the Agreement",
    entry_1: "This Agreement shall enter into force when you click through the registration page of this Website, complete the registration procedures, obtain your account number and password of this Website, and shall be binding on you and this Website.",
    entry_2: "The ultimate power of interpretation of this Agreement shall be vested in this Website.",
    entry_3: "Our assets are 100% sufficient and backed up. We will not use any asset to earn any type of interest.",

  },
  title_balance: "Estimated Balance",
  sidebar_spot_order: "Spot Order",
  sidebar_futures_order: "Futures Order",
  app_google: "Google Play",
  app_apple: "App Store",
  app_android: "Android APK",
  app_api: "API",
  app_mac: "Mac OS",
  app_win: "Windows",
  install_ios: "IOS Application",
  install_android: "Android Application",
  install_text: "Scan to download",
  "wallet.navi_overview": "Overview",
  "wallet.navi_spot": "Spot",
  "wallet.navi_futures": "Futures",
  "wallet.navi_transaction": "Transaction History",
  'withdrawal_usd.minimum':'Minimum Withdrawal',
  key_id: "Key ID"
}
